const rootUrlWithoutSlash = window.routes?.rootUrlWithoutSlash
const cartUrl = window.routes?.cartUrl

function openDrawer() {
  const headerSearchDrawer = document.getElementById('header-search')
  const header = document.querySelector(".shopify-section.section-announcement-bar")
  const headerWrapper = document.querySelector('.Header__Wrapper')
  const announcementHeader = document.getElementById('shopify-section-header')
  const stickyHeader = document.querySelector(".menu-bottom__wrap.menu-header--desktop")
  const mobileStickyHeader = document.querySelector(".menu-bottom__wrap.menu-header--mobile")
  const headerSearchDiv = document.getElementById('shopify-section-header-search')
	const headerSection = document.querySelector(".header-search.shopify-section")

  if (headerSearchDrawer) {
    headerSearchDrawer.setAttribute('aria-hidden', 'false')
  }

  if (headerSearchDiv) {
		headerSearchDiv.style.display = 'block'
		setTimeout(() => headerSearchDiv.classList.add('header-search-open'))
  }

  if (announcementHeader) {
    announcementHeader.classList.add('hidden')
  }

  if (headerWrapper) {
    headerWrapper.classList.add('hidden')
  }

  if (header) {
    header.classList.add('hidden')
  }

  if (document.documentElement) {
    document.documentElement.classList.add('no-scroll')
  }

  if (stickyHeader) {
    stickyHeader.classList.add('hidden')
  }

  if (mobileStickyHeader) {
    mobileStickyHeader.classList.add('hidden')
  }

  if (headerSection) {
    headerSection.style.zIndex = "100"
  }

	// Because our search input is using react we have to expose a function and call it here
		const ssInstantSearch = document.getElementById('ss-instant-search')
		if (ssInstantSearch) {
			window.focusSearchInput()
		}
}

function closeDrawer() {
  const headerSearchDrawer = document.getElementById('header-search')
  const header = document.querySelector(".shopify-section.section-announcement-bar")
  const headerWrapper = document.querySelector('.Header__Wrapper')
  const announcementHeader = document.getElementById('shopify-section-header')
  const stickyHeader = document.querySelector(".menu-bottom__wrap.menu-header--desktop")
  const mobileStickyHeader = document.querySelector(".menu-bottom__wrap.menu-header--mobile")
  const headerSearchDiv = document.getElementById('shopify-section-header-search')
	const headerSection = document.querySelector(".header-search.shopify-section")

  if (headerSearchDrawer) {
    headerSearchDrawer.setAttribute('aria-hidden', 'true')
  }

  if (headerSearchDiv) {
    headerSearchDiv.classList.remove('header-search-open')
		setTimeout(() => headerSearchDiv.style.display = 'none', 1000)
  }

  if (announcementHeader) {
    announcementHeader.classList.remove('hidden')
  }

  if (headerWrapper) {
    headerWrapper.classList.remove('hidden')
  }

  if (header) {
    header.classList.remove('hidden')
  }

  if (document.documentElement) {
    document.documentElement.classList.remove('no-scroll')
  }

  if (stickyHeader) {
    stickyHeader.classList.remove('hidden')
  }

  if (mobileStickyHeader) {
    mobileStickyHeader.classList.remove('hidden')
  }

  if (headerSection) {
    headerSection.style.zIndex = "20"
  }
}

window.openDrawer = openDrawer
window.closeDrawer = closeDrawer

let cartilageProductHasOptions = true
;(function (factory) {
	typeof define === 'function' && define.amd ? define('index', factory) : factory()
})(function () {
	'use strict'

	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError('Cannot call a class as a function')
		}
	}

	function _lazyVideoObserve() {
		var lazyVideos = [].slice.call(document.querySelectorAll('video.lazyVideo'))

		if ('IntersectionObserver' in window) {
			var lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
				entries.forEach(function (video) {
					if (video.isIntersecting) {
						video.target.classList.remove('lazyVideo')
						for (var source in video.target.children) {
							var videoSource = video.target.children[source]
							if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
								videoSource.src = videoSource.dataset.src
							}
						}
						video.target.load()
						lazyVideoObserver.unobserve(video.target)
					}
				})
			})

			lazyVideos.forEach(function (lazyVideo) {
				lazyVideoObserver.observe(lazyVideo)
			})
		}
	}

	function _defineProperties(target, props) {
		for (var i = 0; i < props.length; i++) {
			var descriptor = props[i]
			descriptor.enumerable = descriptor.enumerable || false
			descriptor.configurable = true
			if ('value' in descriptor) descriptor.writable = true
			Object.defineProperty(target, descriptor.key, descriptor)
		}
	}

	function _createClass(Constructor, protoProps, staticProps) {
		if (protoProps) _defineProperties(Constructor.prototype, protoProps)
		if (staticProps) _defineProperties(Constructor, staticProps)
		return Constructor
	}

	function _defineProperty(obj, key, value) {
		if (key in obj) {
			Object.defineProperty(obj, key, {
				value: value,
				enumerable: true,
				configurable: true,
				writable: true,
			})
		} else {
			obj[key] = value
		}

		return obj
	}

	function _inherits(subClass, superClass) {
		if (typeof superClass !== 'function' && superClass !== null) {
			throw new TypeError('Super expression must either be null or a function')
		}

		subClass.prototype = Object.create(superClass && superClass.prototype, {
			constructor: {
				value: subClass,
				writable: true,
				configurable: true,
			},
		})
		if (superClass) _setPrototypeOf(subClass, superClass)
	}

	function _getPrototypeOf(o) {
		_getPrototypeOf = Object.setPrototypeOf
			? Object.getPrototypeOf
			: function _getPrototypeOf(o) {
					return o.__proto__ || Object.getPrototypeOf(o)
			  }
		return _getPrototypeOf(o)
	}

	function _setPrototypeOf(o, p) {
		_setPrototypeOf =
			Object.setPrototypeOf ||
			function _setPrototypeOf(o, p) {
				o.__proto__ = p
				return o
			}

		return _setPrototypeOf(o, p)
	}

	function _isNativeReflectConstruct() {
		if (typeof Reflect === 'undefined' || !Reflect.construct) return false
		if (Reflect.construct.sham) return false
		if (typeof Proxy === 'function') return true

		try {
			Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}))
			return true
		} catch (e) {
			return false
		}
	}

	function _construct(Parent, args, Class) {
		if (_isNativeReflectConstruct()) {
			_construct = Reflect.construct
		} else {
			_construct = function _construct(Parent, args, Class) {
				var a = [null]
				a.push.apply(a, args)
				var Constructor = Function.bind.apply(Parent, a)
				var instance = new Constructor()
				if (Class) _setPrototypeOf(instance, Class.prototype)
				return instance
			}
		}

		return _construct.apply(null, arguments)
	}

	function _isNativeFunction(fn) {
		return Function.toString.call(fn).indexOf('[native code]') !== -1
	}

	function _wrapNativeSuper(Class) {
		var _cache = typeof Map === 'function' ? new Map() : undefined

		_wrapNativeSuper = function _wrapNativeSuper(Class) {
			if (Class === null || !_isNativeFunction(Class)) return Class

			if (typeof Class !== 'function') {
				throw new TypeError('Super expression must either be null or a function')
			}

			if (typeof _cache !== 'undefined') {
				if (_cache.has(Class)) return _cache.get(Class)

				_cache.set(Class, Wrapper)
			}

			function Wrapper() {
				return _construct(Class, arguments, _getPrototypeOf(this).constructor)
			}

			Wrapper.prototype = Object.create(Class.prototype, {
				constructor: {
					value: Wrapper,
					enumerable: false,
					writable: true,
					configurable: true,
				},
			})
			return _setPrototypeOf(Wrapper, Class)
		}

		return _wrapNativeSuper(Class)
	}

	function _assertThisInitialized(self) {
		if (self === void 0) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
		}

		return self
	}

	function _possibleConstructorReturn(self, call) {
		if (call && (typeof call === 'object' || typeof call === 'function')) {
			return call
		}

		return _assertThisInitialized(self)
	}

	function _createSuper(Derived) {
		var hasNativeReflectConstruct = _isNativeReflectConstruct()

		return function _createSuperInternal() {
			var Super = _getPrototypeOf(Derived),
				result

			if (hasNativeReflectConstruct) {
				var NewTarget = _getPrototypeOf(this).constructor

				result = Reflect.construct(Super, arguments, NewTarget)
			} else {
				result = Super.apply(this, arguments)
			}

			return _possibleConstructorReturn(this, result)
		}
	}

	var Responsive = /*#__PURE__*/ (function () {
		function Responsive() {
			var _this = this

			_classCallCheck(this, Responsive)

			this.currentBreakpoint = Responsive.getCurrentBreakpoint()
			this.currentAspect = Responsive.getCurrentAspectRatio()

			window.addEventListener('resize', function () {
				var newBreakpoint = Responsive.getCurrentBreakpoint()
				var newAspectRatio = Responsive.getCurrentAspectRatio()

				if (_this.currentBreakpoint === newBreakpoint && _this.currentAspect === newAspectRatio) {
					return
				}

				if (_this.currentBreakpoint !== newBreakpoint) {
					document.dispatchEvent(
						new CustomEvent('breakpoint:changed', {
							detail: {
								previousBreakpoint: _this.currentBreakpoint,
								currentBreakpoint: newBreakpoint,
							},
						}),
					)
					_this.currentBreakpoint = newBreakpoint
				}

				if (_this.currentAspect !== newAspectRatio) {
					document.dispatchEvent(
						new CustomEvent('aspect:changed', {
							detail: {
								previousBreakpoint: _this.currentAspect,
								currentBreakpoint: newAspectRatio,
							},
						}),
					)
					_this.currentAspect = newAspectRatio
				}
			})
		}

		_createClass(Responsive, null, [
			{
				key: 'matchesBreakpoint',
				value: function matchesBreakpoint(breakpoint) {
					switch (breakpoint) {
						case 'phone':
							return window.matchMedia('screen and (max-width: 767px)').matches

						case 'tablet':
							return window.matchMedia('screen and (min-width: 768px) and (max-width: 1023px)')
								.matches

						case 'tablet-and-up':
							return window.matchMedia('screen and (min-width: 768px)').matches

						case 'pocket':
							return window.matchMedia('screen and (max-width: 1023px)').matches

						case 'lap':
							return window.matchMedia('screen and (min-width: 1024px) and (max-width: 1279px)')
								.matches

						case 'lap-and-up':
							return window.matchMedia('screen and (min-width: 1024px)').matches

						case 'desk':
							return window.matchMedia('screen and (min-width: 1200px)').matches

						case 'widescreen':
							return window.matchMedia('screen and (min-width: 1600px)').matches

						case 'supports-hover':
							return window.matchMedia('(hover: hover) and (pointer: fine)').matches
					}
				},
			},
			{
				key: 'getCurrentBreakpoint',
				value: function getCurrentBreakpoint() {
					if (window.matchMedia('screen and (max-width: 767px)').matches) {
						return 'phone'
					}

					if (window.matchMedia('screen and (min-width: 768px) and (max-width: 1023px)').matches) {
						return 'tablet'
					}

					if (window.matchMedia('screen and (min-width: 1024px) and (max-width: 1279px)').matches) {
						return 'lap'
					}

					if (window.matchMedia('screen and (min-width: 1200px)').matches) {
						return 'desk'
					}
				},
			},
			{
				key: 'getCurrentAspectRatio',
				value: function getCurrentAspectRatio() {
					if (window.matchMedia('screen and (min-aspect-ratio: 3/2)')) {
						return 'landscape'
					} else {
						return 'portrait'
					}
				},
			},
		])

		return Responsive
	})()

	var Carousel = /*#__PURE__*/ (function () {
		function Carousel(element) {
			if (!element) return
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}
			var overrideSettings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}

			_classCallCheck(this, Carousel)

			this.element = element
			this.initialConfig = Object.assign(
				JSON.parse(element.getAttribute('data-flickity-config')),
				overrideSettings,
			)
			this.options = options

			this._attachListeners()

			this._build()
		}

		_createClass(Carousel, [
			{
				key: 'destroy',
				value: function destroy() {
					this.flickityInstance.destroy()

					if (this.initialConfig['breakpoints'] !== undefined) {
						document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener)
					}
				},
			},
			{
				key: 'getFlickityInstance',
				value: function getFlickityInstance() {
					return this.flickityInstance
				},
			},
			{
				key: 'selectCell',
				value: function selectCell(index) {
					var shouldPause =
						arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false
					var shouldAnimate =
						arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true

					if (shouldPause) {
						this.flickityInstance.pausePlayer()
					}

					this.flickityInstance.select(index, false, !shouldAnimate)
				},
			},
			{
				key: 'next',
				value: function next() {
					this.flickityInstance.next()
				},
			},
			{
				key: 'previous',
				value: function previous() {
					this.flickityInstance.previous()
				},
			},
			{
				key: 'pausePlayer',
				value: function pausePlayer() {
					this.flickityInstance.pausePlayer()
				},
			},
			{
				key: 'unpausePlayer',
				value: function unpausePlayer() {
					this.flickityInstance.unpausePlayer()
				},
			},
			{
				key: 'resize',
				value: function resize() {
					this.flickityInstance.resize()
				},
			},
			{
				key: 'getSelectedIndex',
				value: function getSelectedIndex() {
					return this.flickityInstance.selectedIndex
				},
			},
			{
				key: 'getSelectedCell',
				value: function getSelectedCell() {
					return this.flickityInstance.selectedCell.element
				},
			},
			{
				key: '_attachListeners',
				value: function _attachListeners() {
					if (this.initialConfig['breakpoints'] !== undefined) {
						this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this)
						document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener)
					}
				},
				/**
				 * Create the carousel instance
				 */
			},
			{
				key: '_build',
				value: function _build() {
					var _this = this

					var config = this._processConfig()
					this.flickityInstance = new Flickity(this.element, config)

					this._validateDraggable()

					this.selectedIndex = this.flickityInstance.selectedIndex
					this.flickityInstance.on('resize', this._validateDraggable.bind(this))

					if (this.options['onSelect']) {
						this.flickityInstance.on('select', function () {
							// Flickity will send the "select" event whenever the window resize (even on mobile...), as a consequence we need to check
							// first if the slide index have changed or not (cf: https://github.com/metafizzy/flickity/issues/529)
							if (_this.selectedIndex !== _this.flickityInstance.selectedIndex) {
								_this.options['onSelect'](
									_this.flickityInstance.selectedIndex,
									_this.flickityInstance.selectedCell.element,
								)

								_this.selectedIndex = _this.flickityInstance.selectedIndex
							}
						})
					}

					if (this.options['onSettle']) {
						this.flickityInstance.on('settle', function (index) {
							_this.options['onSettle'](index, _this.flickityInstance.selectedCell.element)
						})
					}

					if (this.options['onClick']) {
						this.flickityInstance.on('staticClick', function (event, pointer, cell, index) {
							_this.options['onClick'](cell, index)
						})
					}
				},
				/**
				 * By default, Flickity does not disable draggable automatically if there is nothing to slide. We therefore manually do the check here by checking
				 * if the displayed elements equals to the amount of elements
				 */
			},
			{
				key: '_validateDraggable',
				value: function _validateDraggable() {
					var isActive = this.flickityInstance.isActive || false
					if (!isActive || !this.flickityInstance.options['draggable']) {
						return // Not draggable, so nothing to do
					}

					if (
						undefined === this.flickityInstance.selectedElements ||
						this.flickityInstance.selectedElements.length === this.flickityInstance.cells.length
					) {
						this.flickityInstance.unbindDrag()
					} else {
						this.flickityInstance.bindDrag()
					}
				},
				/**
				 * Flickity is a CSS driven library and hence it is hard to setup some stuff in pure JS
				 */
			},
			{
				key: '_processConfig',
				value: function _processConfig() {
					var config = Object.assign({}, this.initialConfig)
					delete config['breakpoints']

					if (this.initialConfig['breakpoints'] === undefined) {
						return config // No change, we simply return the config as it is
					}

					var breakpoints = this.initialConfig['breakpoints']
					breakpoints.forEach(function (breakpoint) {
						if (Responsive.matchesBreakpoint(breakpoint['matches'])) {
							config = Object.assign(config, breakpoint['settings'])
						}
					})
					return config
				},
				/**
				 * Verify if the breakpoint has changed, and optionally update the carousel
				 */
			},
			{
				key: '_onBreakpointChanged',
				value: function _onBreakpointChanged() {
					// The breakpoint may have changed, so we delete the carousel and rebuild it
					this.flickityInstance.destroy()

					this._build()
				},
			},
		])

		return Carousel
	})()

	var Animation = /*#__PURE__*/ (function () {
		function Animation() {
			_classCallCheck(this, Animation)
		}

		_createClass(Animation, null, [
			{
				key: 'slideUp',
				value:
					/**
					 * Slide up aims to close an element. To do that, we take the height of the element, and set it to 0 to
					 * force an animation
					 */
					function slideUp(element) {
						element.style.height = ''.concat(element.scrollHeight, 'px') // Force previous height to allow CSS transition

						element.offsetHeight // Force redraw

						element.style.height = 0
					},
				/**
				 * Slide down aims to open an element. To do that, you must make sure that the element you are trying to open
				 * is set with height: 0; overflow: hidden in the CSS, and does not contain any padding nor margin.
				 */
			},
			{
				key: 'slideDown',
				value: function slideDown(element) {
					if (element.style.height === 'auto') {
						return
					} // To do the animation we temporarily hide it, check the height, and transition to it

					element.style.height = ''.concat(element.firstElementChild.scrollHeight, 'px')

					var transitionEnded = function transitionEnded(event) {
						if (event.propertyName === 'height') {
							element.style.height = 'auto' // Allows the content to grow normally

							element.removeEventListener('transitionend', transitionEnded)
						}
					}

					element.addEventListener('transitionend', transitionEnded)
				},
			},
		])

		return Animation
	})()

	/**
	 * Various DOM helper
	 */
	var Dom = /*#__PURE__*/ (function () {
		function Dom() {
			_classCallCheck(this, Dom)
		}

		_createClass(Dom, null, [
			{
				key: 'getSiblings',
				value:
					/**
					 * Get all the previous and next siblings, optionally filtered by a selector
					 */
					function getSiblings(element, filter) {
						var includeSelf =
							arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false
						var siblings = []
						var currentElement = element // Do the previous first

						while ((currentElement = currentElement.previousElementSibling)) {
							if (!filter || currentElement.matches(filter)) {
								siblings.push(currentElement)
							}
						}

						if (includeSelf) {
							siblings.push(element)
						} // Then the next side

						currentElement = element

						while ((currentElement = currentElement.nextElementSibling)) {
							if (!filter || currentElement.matches(filter)) {
								siblings.push(currentElement)
							}
						}

						return siblings
					},
				/**
				 * By default, NodeList object are only iterable with forEach on newest browsers. To support it cross-browser,
				 * we need to normalize it
				 */
			},
			{
				key: 'nodeListToArray',
				value: function nodeListToArray(nodeList, filter) {
					var items = []

					for (var i = 0; i !== nodeList.length; ++i) {
						if (!filter || nodeList[i].matches(filter)) {
							items.push(nodeList[i])
						}
					}

					return items
				},
				/**
				 * Calculate an element width with its margin
				 */
			},
			{
				key: 'outerWidthWithMargin',
				value: function outerWidthWithMargin(element) {
					var width = element.offsetWidth,
						style = getComputedStyle(element)
					width += parseInt(style.marginLeft) + parseInt(style.marginRight)
					return width
				},
				/**
				 * Calculate an element height with its margin
				 */
			},
			{
				key: 'outerHeightWithMargin',
				value: function outerHeightWithMargin(element) {
					var height = element.offsetHeight,
						style = getComputedStyle(element)
					height += parseInt(style.marginTop) + parseInt(style.marginBottom)
					return height
				},
			},
		])

		return Dom
	})()

	var Collapsible = /*#__PURE__*/ (function () {
		function Collapsible() {
			_classCallCheck(this, Collapsible)

			this.domDelegate = new domDelegate.Delegate(document.body)

			this._attachListeners()
		}

		_createClass(Collapsible, [
			{
				key: '_attachListeners',
				value: function _attachListeners() {
					this.domDelegate.on(
						'click',
						'[data-action="toggle-collapsible"]',
						this._toggleCollapsible.bind(this),
					)
				},
				/**
				 * Toggle a given collapsible
				 */
			},
			{
				key: '_toggleCollapsible',
				value: function _toggleCollapsible(event, target) {
					var _this = this

					// If this is an auto-expand and that it reaches the needed breakpoint, we do nothing
					var parentCollapsible = target.closest('.Collapsible')

					if (
						parentCollapsible.classList.contains('Collapsible--autoExpand') &&
						Responsive.matchesBreakpoint('tablet-and-up')
					) {
						return
					}

					var isOpen = target.getAttribute('aria-expanded') === 'true'

					if (isOpen) {
						this._close(parentCollapsible, target)
					} else {
						this._open(parentCollapsible, target)
					} // We make sure to close any siblings collapsible as well

					Dom.getSiblings(parentCollapsible).forEach(function (collapsibleToClose) {
						return _this._close(collapsibleToClose)
					})
					event.preventDefault()
				},
				/**
				 * Open a given collapsible
				 */
			},
			{
				key: '_open',
				value: function _open(collapsible) {
					var toggleButton = collapsible.querySelector('.Collapsible__Button'),
						collapsibleInner = collapsible.querySelector('.Collapsible__Inner')

					if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'true') {
						return // It's already open
					}

					if (toggleButton.classList.contains('Tier1')) {
						var prevItemTier = '.Collapsible__Button.Tier1'
						var newItemTier = '.Collapsible__Button.Tier2'
					} else if (toggleButton.classList.contains('Tier2')) {
						var prevItemTier = '.Collapsible__Button.Tier2'
						var newItemTier = '.Collapsible__Button.Tier3'
					}

					if (
						collapsible.classList.contains('PaginatedCollapsible') &&
						prevItemTier &&
						newItemTier &&
						Responsive.matchesBreakpoint('pocket')
					) {
						var openTimeline = new TimelineLite()
						var timeOffset = 0
						Dom.nodeListToArray(collapsible.parentElement.querySelectorAll(prevItemTier)).forEach(
							function (element, idx, array) {
								if (idx === array.length - 1) {
									openTimeline.fromTo(
										element,
										0.2,
										{
											opacity: 1,
											x: '0px',
										},
										{
											opacity: 0,
											x: '-10px',
											onComplete: function () {
												toggleButton.setAttribute('aria-expanded', 'true')
											},
										},
										'<',
									)
								} else {
									openTimeline.fromTo(
										element,
										0.2,
										{
											opacity: 1,
											x: '0px',
										},
										{
											opacity: 0,
											x: '-10px',
										},
										'<',
									)
								}
							},
						)

						Dom.nodeListToArray(collapsibleInner.querySelectorAll(newItemTier)).forEach(function (
							element,
						) {
							openTimeline.fromTo(
								element,
								0.2,
								{
									opacity: 0,
									x: '10px',
								},
								{
									opacity: 1,
									x: '0px',
								},
								'>-0.1',
							)
						})
					} else {
						toggleButton.setAttribute('aria-expanded', 'true')
						collapsibleInner.style.overflow = 'visible'
						Animation.slideDown(collapsibleInner)
						setTimeout(function () {
							collapsible.style.overflow = 'visible'
						}, 350)
					}
				},
				/**
				 * Close a given collapsible
				 */
			},
			{
				key: '_close',
				value: function _close(collapsible) {
					var toggleButton = collapsible.querySelector('.Collapsible__Button'),
						collapsibleInner = collapsible.querySelector('.Collapsible__Inner')

					if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'false') {
						return // It's already closed
					}

					if (toggleButton.classList.contains('Tier1')) {
						var prevItemTier = '.Collapsible__Button.Tier2'
						var newItemTier = '.Collapsible__Button.Tier1'
					} else if (toggleButton.classList.contains('Tier2')) {
						var prevItemTier = '.Collapsible__Button.Tier3'
						var newItemTier = '.Collapsible__Button.Tier2'
					}

					if (
						collapsible.classList.contains('PaginatedCollapsible') &&
						prevItemTier &&
						newItemTier &&
						Responsive.matchesBreakpoint('pocket')
					) {
						var openTimeline = new TimelineLite()
						Dom.nodeListToArray(collapsibleInner.querySelectorAll(prevItemTier)).forEach(function (
							element,
							idx,
							array,
						) {
							if (idx === array.length - 1) {
								openTimeline.fromTo(
									element,
									0.2,
									{
										opacity: 1,
										x: '0px',
									},
									{
										opacity: 0,
										x: '-10px',
										onComplete: function () {
											toggleButton.setAttribute('aria-expanded', 'false')
										},
									},
									'<',
								)
							} else {
								openTimeline.fromTo(
									element,
									0.2,
									{
										opacity: 1,
										x: '0px',
									},
									{
										opacity: 0,
										x: '-10px',
									},
									'<',
								)
							}
						})
						Dom.nodeListToArray(collapsible.parentElement.querySelectorAll(newItemTier)).forEach(
							function (element) {
								openTimeline.fromTo(
									element,
									0.2,
									{
										opacity: 0,
										x: '10px',
									},
									{
										opacity: 1,
										x: '0px',
									},
									'>-0.1',
								)
							},
						)
					} else {
						toggleButton.setAttribute('aria-expanded', 'false')
						collapsibleInner.style.overflow = 'hidden'
						collapsible.style.overflow = 'hidden'
						Animation.slideUp(collapsibleInner)
					}
				},
			},
		])

		return Collapsible
	})()

	var Accessibility = /*#__PURE__*/ (function () {
		function Accessibility() {
			_classCallCheck(this, Accessibility)
		}

		_createClass(Accessibility, null, [
			{
				key: 'trapFocus',
				value:
					/**
					 * Traps the focus in a particular container
					 */
					function trapFocus(container, namespace) {
						this.listeners = this.listeners || {} // We check if there is an element with the attribute "autofocus"

						var elementToFocus = container.querySelector('[autofocus]') || container
						container.setAttribute('tabindex', '-1')
						elementToFocus.focus()

						this.listeners[namespace] = function (event) {
							if (container !== event.target && !container.contains(event.target)) {
								container.focus()
							}
						}

						document.addEventListener('focusin', this.listeners[namespace])
					},
				/**
				 * Removes the trap of focus in a particular container
				 */
			},
			{
				key: 'removeTrapFocus',
				value: function removeTrapFocus(container, namespace) {
					if (container) {
						container.removeAttribute('tabindex')
					}

					if (this.listeners && this.listeners[namespace]) {
						document.removeEventListener('focusin', this.listeners[namespace])
					}
				},
				/**
				 * Reset any previous trap focus
				 */
			},
			{
				key: 'clearTrapFocus',
				value: function clearTrapFocus() {
					for (var key in this.listeners) {
						if (this.listeners.hasOwnProperty(key)) {
							document.removeEventListener('focusin', this.listeners[key])
						}
					}

					this.listeners = {}
				},
			},
		])

		return Accessibility
	})()

	var Drawer = /*#__PURE__*/ (function () {
		function Drawer(element) {
			this.options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}

			_classCallCheck(this, Drawer)

			this.element = element
			this.delegateElement = new domDelegate.Delegate(this.element)
			this.delegateBody = new domDelegate.Delegate(document.body)

			this.onOpen = this.options['onOpen'] || function () {}
			this.onClose = this.options['onClose'] || function () {}
			this.scrollY = 0

			this.isOpen = false
			this.direction = this.element.classList.contains('Drawer--fromLeft')
				? 'fromLeft'
				: 'fromRight'
			this.pageOverlayElement = document.querySelector('.PageOverlay')
			this.shopifyAnnouncementBar = document.querySelector('#shopify-section-announcement')
			this._attachListeners()
		}

		_createClass(Drawer, [
			{
				key: 'destroy',
				value: function destroy() {
					this.delegateBody.off(
						'click',
						'[data-action="open-drawer"][data-drawer-id="'.concat(this.element.id, '"]'),
					)
					this.delegateBody.off(
						'click',
						'[data-action="close-drawer"][data-drawer-id="'.concat(this.element.id, '"]'),
					)
					window.removeEventListener('resize', this._calculateMaxHeightListener)
				},
			},
			{
				key: '_preventDefault',
				value: function _preventDefault(event) {
					event.preventDefault()
				},
			},
			{
				key: 'toggle',
				value: function toggle(event) {
					if (
						window.theme.pageType == 'cart' &&
						event.target.getAttribute('href') == window.routes.cartUrl
					) {
						return
					}

					this.isOpen ? this.close(event) : this.open(event)
				},
			},
			{
				key: 'open',
				value: function open(event) {
					var _this = this
					
					if (this.isOpen) {
						return
					} // Make sure that the search is closed whenever a drawer is opened
					if (event) {
						event.preventDefault()
					}

					// Ensure all other overlays are closed
					if (!this.options['leaveOverlaysOpen']) {
						this.element.dispatchEvent(
							new CustomEvent('drawer:close', {
								bubbles: true,
							}),
						)
					}

					this.element.dispatchEvent(
						new CustomEvent('search:close', {
							bubbles: true,
						}),
					)

					this.element.addEventListener('pointermove', this._preventDefaultListener)

					if (
						document.querySelector(
							'[data-action="toggle-drawer"][data-drawer-id="'.concat(this.element.id, '"]'),
						)
					) {
						document
							.querySelector(
								'[data-action="toggle-drawer"][data-drawer-id="'.concat(this.element.id, '"]'),
							)
							setTimeout(function() {
								document.querySelector('.button__close').style.opacity = '1'
							}, 550)
							
					}

					this.element.classList.remove('hidden')
					setTimeout(() => {
						this.element.setAttribute('aria-hidden', 'false')
						
						document.body.classList.add(`${this.element.id}-open`)
						
						this._calculateMaxHeight()
						
						this.touchStartTimer = setTimeout(function () {
							_this.scrollY = window.scrollY
							document.documentElement.classList.add('no-scroll')
						}, 500)
						// This prevent the body to scroll on iOS. This is honestly a bit hacky, but until the platform supports "touch-action: none" like
						// other browsers, this is the only way to achieve that
						//disableBodyScroll(true, '[data-scrollable]');
						
						Accessibility.trapFocus(this.element, 'drawer')
						document.querySelector('#shopify-section-header').style.zIndex = '' // Ugly hack
						// We attach an event to the page overlay to close it
						
						this.pageOverlayElement.classList.add('is-visible')
						this.pageOverlayElement.addEventListener('click', this._closeListener)
						this.isOpen = true
						this.onOpen() // Call the callback to allow other code to hook their logic
						return false
					})
				},
			},
			{
				key: 'close',
				value: function close(event) {
					if (!this.isOpen) {
						return
					}

					if (event) {
						event.preventDefault()
					}

					if (this.touchStartTimer) {
						clearTimeout(this.touchStartTimer)
					}

					this.element.removeEventListener('pointermove', this._preventDefaultListener)

					if (
						document.querySelector(
							'[data-action="toggle-drawer"][data-drawer-id="'.concat(this.element.id, '"]'),
						)
					) {
						document
							.querySelector(
								'[data-action="toggle-drawer"][data-drawer-id="'.concat(this.element.id, '"]'),
							)
							.setAttribute('aria-expanded', 'false')
						setTimeout(function() {
							document.querySelector('.button__close').style.opacity = '0'

						}, 500)
					}

					document.documentElement.classList.remove('no-scroll')
					window.scrollTo(0, this.scrollY)
					this.element.setAttribute('aria-hidden', 'true')
					document.body.classList.remove(`${this.element.id}-open`)

					Accessibility.removeTrapFocus(this.element, 'drawer')
					this.pageOverlayElement.classList.remove('is-visible')
					this.pageOverlayElement.removeEventListener('click', this._closeListener)
					this.isOpen = false
					this.onClose() // Call the callback to allow other code to hook their logic

					setTimeout(() => this.element.classList.add('hidden'), 1000)
				},
			},
			{
				key: '_attachListeners',
				value: function _attachListeners() {
					this._openListener = this.open.bind(this)
					this._closeListener = this.close.bind(this)
					this._toggleListener = this.toggle.bind(this)
					this._calculateMaxHeightListener = this._calculateMaxHeight.bind(this)

					this._preventDefaultListener = this._preventDefault.bind(this)

					this.delegateBody.on(
						'click',
						'[data-action="open-drawer"][data-drawer-id="'.concat(this.element.id, '"]'),
						this._openListener,
					)
					this.delegateBody.on(
						'click',
						'[data-action="close-drawer"][data-drawer-id="'.concat(this.element.id, '"]'),
						this._closeListener,
					)
					this.delegateBody.on(
						'click',
						'[data-action="toggle-drawer"][data-drawer-id="'.concat(this.element.id, '"]'),
						this._toggleListener,
					)
					this.element.addEventListener('keyup', this._handleKeyboard.bind(this))
					window.addEventListener('resize', this._calculateMaxHeightListener)
					window.addEventListener('drawer:close', this._closeListener)
				},
				/**
				 * Make sure that we force a max-height so that the drawer always stays on screen
				 */
			},
			{
				key: '_calculateMaxHeight',
				value: function _calculateMaxHeight() {
					const drawerEl = this.element.querySelector('.Drawer')
					const drawerCartEl = this.element.querySelector('#sidebar-cart .Drawer')

					if (drawerEl) {
						drawerEl.style.maxHeight = window.innerHeight + 'px'
					}

					if (drawerCartEl && window.innerWidth >= 1024) {
						drawerCartEl.style.height = '714px'
						drawerCartEl.style.maxHeight = '100%'
					}
				},
			},
			{
				key: '_handleKeyboard',
				value:
					/**
					 * Handle a11y events
					 */
					function _handleKeyboard(event) {
						if (this.isOpen && event.keyCode === 27) {
							this.close()
						}
					},
			},
		])

		return Drawer
	})()

	var Modal = /*#__PURE__*/ (function () {
		function Modal() {
			_classCallCheck(this, Modal)

			this.domDelegate = new domDelegate.Delegate(document.body)
			this.activeModal = null // Keep track of the active modal

			this.wasLocked = false
			this.pageOverlayElement = document.querySelector('.PageOverlay')

			this._attachListeners()

			this._checkOpenByHash()
		}

		_createClass(Modal, [
			{
				key: '_attachListeners',
				value: function _attachListeners() {
					this._closeListener = this._closeModal.bind(this)
					this._handleKeyboardListener = this._handleKeyboard.bind(this)
					this.domDelegate.on(
						'click',
						'[data-action="open-modal"]',
						this._openModalEvent.bind(this),
					)
					this.domDelegate.on('click', '[data-action="close-modal"]', this._closeModal.bind(this))
				},
			},
			{
				key: '_openModalEvent',
				value: function _openModalEvent(event, target) {
					this._openModal(document.getElementById(target.getAttribute('aria-controls')))

					event.preventDefault()
					event.stopPropagation()
				},
			},
			{
				key: '_openModal',
				value: function _openModal(modal) {
					var _this = this

					if (this.activeModal || !modal) {
						return // If there is already an open modal, we return as we only allows one modal at a time
					}

					this.activeModal = modal
					this.domDelegate.on('keyup', this._handleKeyboardListener)

					if (document.documentElement.classList.contains('no-scroll')) {
						this.wasLocked = true
					}

					fastdom.mutate(function () {
						Accessibility.clearTrapFocus() // Needed as the modal can be open on top of a popover

						_this._onTransitionEndedListener = _this._onTransitionEnded.bind(_this)

						_this.activeModal.addEventListener('transitionend', _this._onTransitionEndedListener)

						_this.activeModal.setAttribute('aria-hidden', 'false')

						document.documentElement.classList.add('no-scroll') // If the modal is not a fullscreen modal, then we also display the overlay

						if (!_this.activeModal.classList.contains('Modal--fullScreen')) {
							_this.pageOverlayElement.classList.add('is-visible')

							_this.pageOverlayElement.addEventListener('click', _this._closeListener)
						}
					})
				},
			},
			{
				key: '_closeModal',
				value: function _closeModal() {
					var _this2 = this

					if (!this.activeModal) {
						return // If no modal are open, we return immediately
					}

					this.activeModal.removeEventListener('keyup', this._handleKeyboardListener)
					this.domDelegate.off('keyup')
					fastdom.mutate(function () {
						// If the modal is of video type, we need to remove the iframe to stop the video
						if (_this2.activeModal.classList.contains('Modal--videoContent')) {
							_this2._resetVideoListener = _this2._resetVideo.bind(_this2)

							_this2.activeModal.addEventListener('transitionend', _this2._resetVideoListener)
						}

						Accessibility.removeTrapFocus(_this2.activeModal, 'modal')

						if (!_this2.activeModal.classList.contains('Modal--fullScreen')) {
							_this2.pageOverlayElement.classList.remove('is-visible')

							_this2.pageOverlayElement.removeEventListener('click', _this2._closeListener)
						}

						_this2.activeModal.setAttribute('aria-hidden', 'true')

						_this2.activeModal = null

						if (!_this2.wasLocked) {
							document.documentElement.classList.remove('no-scroll')
						}
					})
				},
			},
			{
				key: '_onTransitionEnded',
				value: function _onTransitionEnded(event) {
					if (event.propertyName !== 'visibility') {
						return
					}

					Accessibility.trapFocus(this.activeModal, 'modal') // Trap the focus first (as this trigger reflows)

					this.activeModal.removeEventListener('transitionend', this._onTransitionEndedListener)
				},
			},
			{
				key: '_resetVideo',
				value: function _resetVideo(event) {
					if (event.propertyName !== 'visibility') {
						return // We check the visibility property as it's the one LazySizes uses for triggering lazyloading
					}

					var iframe = event.target.querySelector('iframe')
					iframe.parentNode.innerHTML = '<iframe class="Image--lazyLoad" data-src='.concat(
						iframe.getAttribute('data-src'),
						' frameborder="0" allowfullscreen>',
					)
					event.target.removeEventListener('transitionend', this._resetVideoListener)
				},
				/**
				 * Some forms needs to be open inside a modal, and on page reload we must make sure to properly open the modal again
				 */
			},
			{
				key: '_checkOpenByHash',
				value: function _checkOpenByHash() {
					var hash = window.location.hash,
						modal = document.getElementById(hash.replace('#', ''))

					if (modal && modal.classList.contains('Modal')) {
						this._openModal(modal)
					}
				},
				/**
				 * Handle a11y events
				 */
			},
			{
				key: '_handleKeyboard',
				value: function _handleKeyboard(event) {
					if (null !== this.activeModal && event.keyCode === 27) {
						this._closeModal()
					}
				},
			},
		])

		return Modal
	})()

	var Popover = /*#__PURE__*/ (function () {
		function Popover(element, options) {
			_classCallCheck(this, Popover)

			this.element = element
			this.delegateElement = new domDelegate.Delegate(this.element)
			this.activator =
			options['activator'] ||
			document.querySelector('[aria-controls="'.concat(element.getAttribute('id'), '"]'))
			this.preferredPosition = options['preferredPosition'] || 'bottom'
			this.preferredAlignment = options['preferredAlignment'] || undefined
			this.threshold = options['threshold'] || 20
			
			this.isOpen = false
			
			this.onValueChanged = options['onValueChanged'] || function () {}
			
			this.onOpen = options['onOpen'] || function () {}
			
			this.onClose = options['onClose'] || function () {}
			
			this.showOverlay = options['showOverlay'] === undefined ? true : options['showOverlay']
			this.pageOverlayElement = document.querySelector('.PageOverlay')
			this._attachListeners()
		}

		_createClass(Popover, [
			{
				key: 'destroy',
				value: function destroy() {
					this.element.removeEventListener('keyup', this._handleKeyboardListener)
					this.delegateElement.off('click')
					this.activator.removeEventListener('click', this._toggleListener)
				},
			},
			{
				key: 'toggle',
				value: function toggle() {
					this.isOpen ? this.close() : this.open()
				},
			},
			{
				key: 'open',
				value: function open() {
					var _this = this

					// Note: the additional check on the aria-controls is used here so that a given activator can be used on different
					//       popovers and be modified dynamically in JavaScript
					if (this.isOpen || this.activator.getAttribute('aria-controls') !== this.element.id) {
						return
					}

					this.element.classList.remove('hidden')
					setTimeout(() => {
						this.element.setAttribute('aria-hidden', 'false')
						this.activator.setAttribute('aria-expanded', 'true')
						disableBodyScroll(true, '[data-scrollable]')
						document.documentElement.classList.add('no-scroll') // Prevent scrolling when popover is open
						
						if (Responsive.matchesBreakpoint('lap-and-up')) {
							document.body.addEventListener('click', this._clickOutsideListener)
							
							if (this.showOverlay) {
								this.pageOverlayElement.classList.add('is-visible')
								this.pageOverlayElement.addEventListener('click', this._closeListener)
							}
							
							this._position()
							
							this.element.setAttribute('tabindex', '-1')
							this.element.addEventListener(
								'transitionend',
								function () {
									_this.element.focus()
								},
								{
									once: true,
								},
							)
						} else {
							this.element.removeAttribute('style')
							
							if (this.showOverlay) {
								this.pageOverlayElement.classList.add('is-visible')
								this.pageOverlayElement.addEventListener('click', this._closeListener)
							}
						}
						
						this.onOpen(this) // Call the callback to allow other code to hook their logic
						
						this.isOpen = true
					})
				},
			},
			{
				key: 'close',
				value: function close() {
					if (!this.isOpen) {
						return
					}

					this.element.setAttribute('aria-hidden', 'true')
					this.activator.setAttribute('aria-expanded', 'false')
					disableBodyScroll(false, '[data-scrollable]')
					document.documentElement.classList.remove('no-scroll')

					if (Responsive.matchesBreakpoint('lap-and-up')) {
						document.body.removeEventListener('click', this._clickOutsideListener)

						if (this.showOverlay) {
							this.pageOverlayElement.classList.remove('is-visible')
							this.pageOverlayElement.removeEventListener('click', this._closeListener)
						}
					} else if (this.showOverlay) {
						this.pageOverlayElement.classList.remove('is-visible')
						this.pageOverlayElement.removeEventListener('click', this._closeListener)
					}

					this.element.removeAttribute('tabindex')
					this.activator.focus()
					this.onClose(this) // Call the callback to allow other code to hook their logic

					this.isOpen = false
				},
			},
			{
				key: '_attachListeners',
				value: function _attachListeners() {
					this._handleKeyboardListener = this._handleKeyboard.bind(this)
					this._clickOutsideListener = this._clickOutside.bind(this)
					this._closeListener = this.close.bind(this)
					this._toggleListener = this.toggle.bind(this)
					this.element.addEventListener('keyup', this._handleKeyboardListener)
					this.activator.addEventListener('click', this._toggleListener)
					this.delegateElement.on('click', '[data-action="close-popover"]', this.close.bind(this))
					this.delegateElement.on(
						'click',
						'[data-action="select-value"]',
						this._valueChanged.bind(this),
					)

					if (this.element.hasAttribute('id')) {
						this.delegateElement.on(
							'focusout',
							'#'.concat(this.element.getAttribute('id')),
							this._onFocusOut.bind(this),
						)
					}
				},
				/**
				 * Whenever a value is selected, it can notify a callback so that the calling code can do its own logic in response
				 * of the value change
				 */
			},
			{
				key: '_valueChanged',
				value: function _valueChanged(event) {
					Dom.getSiblings(event.target, '.is-selected').forEach(function (item) {
						return item.classList.remove('is-selected')
					})
					event.target.classList.add('is-selected') // If there is a callback in option we call it with the value

					this.onValueChanged(event.target.getAttribute('data-value'), event.target, this.activator)
					this.close()
				},
			},
			{
				key: '_onFocusOut',
				value: function _onFocusOut(event) {
					if (
						!this.element.contains(event.relatedTarget) &&
						event.relatedTarget !== this.activator
					) {
						this.close()
					}
				},
				/**
				 * Callback that is called to decide if we should close the popover when a click is captured outside
				 */
			},
			{
				key: '_clickOutside',
				value: function _clickOutside(event) {
					if (
						!event.target.closest('.Popover') &&
						!event.target.closest('.Modal') &&
						event.target !== this.activator &&
						!this.activator.contains(event.target)
					) {
						this.close()
					}
				},
				/**
				 * On desktop, we reposition the popover in JavaScript by doing some smart logic to detect the most appropriate area
				 */
			},
			{
				key: '_position',
				value: function _position() {
					var _this2 = this

					var topPosition = 0,
						rightPosition = 0,
						position = '',
						alignment = '',
						threshold = this.threshold
					fastdom.measure(function () {
						var windowHeight = window.innerHeight,
							activatorBoundingRect = _this2.activator.getBoundingClientRect(),
							halfHeight = windowHeight / 2

						if (_this2.preferredPosition === 'bottom') {
							alignment = 'right'

							if (
								_this2.element.clientHeight <=
									windowHeight - (activatorBoundingRect.bottom + threshold) ||
								windowHeight - activatorBoundingRect.bottom >= halfHeight
							) {
								position = 'bottom'
							} else {
								position = 'top'
							}
						} else if (_this2.preferredPosition === 'top') {
							alignment = 'right'

							if (
								_this2.element.clientHeight <= activatorBoundingRect.top - threshold ||
								activatorBoundingRect.top >= halfHeight
							) {
								position = 'top'
							} else {
								position = 'bottom'
							}
						} else {
							position = 'left' // Is there enough space to use the center alignment (which is preferred)?

							var halfElementHeight = _this2.element.clientHeight / 2

							if (
								activatorBoundingRect.top >= halfElementHeight &&
								windowHeight - activatorBoundingRect.bottom >= halfElementHeight
							) {
								alignment = 'center'
							} else if (windowHeight - activatorBoundingRect.bottom >= halfElementHeight) {
								alignment = 'bottom'
							} else {
								alignment = 'top'
							}
						}

						if (_this2.preferredAlignment) {
							alignment = _this2.preferredAlignment
						}

						if (position === 'top') {
							topPosition = activatorBoundingRect.top - _this2.element.clientHeight - threshold

							if (alignment === 'center') {
								rightPosition =
									window.innerWidth -
									activatorBoundingRect.right -
									_this2.element.clientWidth / 2 +
									3
							} else {
								rightPosition = window.innerWidth - activatorBoundingRect.right
							}
						} else if (position === 'bottom') {
							topPosition = activatorBoundingRect.bottom + threshold

							if (alignment === 'center') {
								rightPosition =
									window.innerWidth -
									activatorBoundingRect.right -
									_this2.element.clientWidth / 2 +
									3
							} else {
								rightPosition = window.innerWidth - activatorBoundingRect.right
							}
						} else {
							rightPosition = window.innerWidth - activatorBoundingRect.left + threshold

							if (alignment === 'center') {
								topPosition =
									activatorBoundingRect.top -
									_this2.element.clientHeight / 2 +
									_this2.activator.clientHeight / 2
							} else if (alignment === 'top') {
								topPosition = activatorBoundingRect.bottom - _this2.element.clientHeight
							} else {
								topPosition = activatorBoundingRect.top
							}
						}
					})
					fastdom.mutate(function () {
						;[
							'Popover--positionBottom',
							'Popover--positionTop',
							'Popover--positionCenter',
							'Popover--alignTop',
							'Popover--alignCenter',
							'Popover--alignBottom',
						].map(function (item) {
							return _this2.element.classList.remove(item)
						})

						_this2.element.classList.add(
							'Popover--position'.concat(position.charAt(0).toUpperCase() + position.slice(1)),
						)

						_this2.element.classList.add(
							'Popover--align'.concat(alignment.charAt(0).toUpperCase() + alignment.slice(1)),
						)

						_this2.element.setAttribute(
							'style',
							'top: '
								.concat(parseInt(topPosition), 'px; right: ')
								.concat(parseInt(rightPosition), 'px;'),
						)
					})
				},
				/**
				 * Handle a11y events
				 */
			},
			{
				key: '_handleKeyboard',
				value: function _handleKeyboard(event) {
					if (this.isOpen && event.keyCode === 27) {
						this.close()
					}
				},
			},
		])

		return Popover
	})()

	/**
	 * This class will coordinate all the transitions from the website
	 */
	var PageTransition = /*#__PURE__*/ (function () {
		function PageTransition() {
			_classCallCheck(this, PageTransition)

			this.domDelegate = new domDelegate.Delegate(document.body)
			this.pageTransition = document.querySelector('.PageTransition')

			this._attachListeners()
		}

		_createClass(
			PageTransition,
			[
				{
					key: '_attachListeners',
					value: function _attachListeners() {
						this.domDelegate.on(
							'click',
							'a[href]:not([href^="#"]):not([href^="javascript:"]):not([href^="mailto:"]):not([href^="tel:"]):not([target="_blank"])',
							this._onPageUnload.bind(this),
						)
					},
					/**
					 * This callback captures click and transition from one page to another by doing a transition
					 */
				},
				{
					key: '_onPageUnload',
					value: function _onPageUnload(event, target) {
						var _this = this

						if (
							event.defaultPrevented ||
							event.ctrlKey ||
							event.metaKey ||
							!window.theme.showPageTransition ||
							!this.pageTransition
						) {
							return
						}

						event.preventDefault() // Prevent the click to happen

						if (window.theme.showPageTransition && this.pageTransition) {
							var doTransition = function doTransition(event) {
								// Animation is finished, we can transition
								if (event.propertyName === 'opacity') {
									_this.pageTransition.removeEventListener('transitionend', doTransition)

									window.location.href = target.href
								}
							}

							this.pageTransition.addEventListener('transitionend', doTransition)
							this.pageTransition.style.visibility = 'visible'
							this.pageTransition.style.opacity = '1'
						}
					},
				},
			],
			[
				{
					key: 'getInstance',
					value: function getInstance() {
						if (!this.instance) {
							this.instance = new PageTransition()
						}

						return this.instance
					},
				},
			],
		)

		return PageTransition
	})()

	/**
	 * Note: this was a feature that was added at the very end and couldn't do something much cleaner without rewriting large parts of the theme...
	 */
	var ProductItemColorSwatch = /*#__PURE__*/ (function () {
		function ProductItemColorSwatch(element) {
			_classCallCheck(this, ProductItemColorSwatch)

			this.element = element
			this.delegateElement = new domDelegate.Delegate(this.element)
			this.delegateElement.on('change', '.ColorSwatch__Radio', this._colorChanged.bind(this))
		}

		_createClass(ProductItemColorSwatch, [
			{
				key: '_colorChanged',
				value: function _colorChanged(event, target) {
					// We need to change the URL of the various links
					var productItem = target.closest('.ProductItem'),
						variantUrl = target.getAttribute('data-variant-url')
					productItem.querySelector('.ProductItem__ImageWrapper').setAttribute('href', variantUrl)
					productItem.querySelector('.ProductItem__Title > a').setAttribute('href', variantUrl) // If we have a custom image for the variant, we change it

					var originalImageElement = productItem.querySelector(
						'.ProductItem__Image:not(.ProductItem__Image--alternate)',
					)

					if (
						target.hasAttribute('data-image-url') &&
						target.getAttribute('data-image-id') !==
							originalImageElement.getAttribute('data-image-id')
					) {
						var newImageElement = document.createElement('img')
						newImageElement.className = 'ProductItem__Image Image--fadeIn Image--lazyLoad'
						newImageElement.setAttribute('data-image-id', target.getAttribute('data-image-id'))
						newImageElement.setAttribute('data-src', target.getAttribute('data-image-url'))
						newImageElement.setAttribute('data-widths', target.getAttribute('data-image-widths'))
						newImageElement.setAttribute('data-sizes', 'auto') // Replace the original node

						if (window.theme.productImageSize === 'natural') {
							originalImageElement.parentNode.style.paddingBottom = ''.concat(
								100.0 / target.getAttribute('data-image-aspect-ratio'),
								'%',
							)
						}

						originalImageElement.parentNode.style.setProperty(
							'--aspect-ratio',
							target.getAttribute('data-image-aspect-ratio'),
						)
						originalImageElement.parentNode.replaceChild(newImageElement, originalImageElement)
					}
				},
			},
		])

		return ProductItemColorSwatch
	})()

	var Image = /*#__PURE__*/ (function () {
		function Image() {
			_classCallCheck(this, Image)
		}

		_createClass(Image, null, [
			{
				key: 'getSizedImageUrl',
				value:
					/**
					 * Create a CDN URL (similar to the img_url filter in Liquid)
					 */
					function getSizedImageUrl(src, size) {
						if (size === null) {
							return src
						}

						if (size === 'master') {
							return src.replace(/http(s)?:/, '')
						}

						var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i)

						if (match) {
							var prefix = src.split(match[0])
							var suffix = match[0]
							return (prefix[0] + '_' + size + suffix).replace(/http(s)?:/, '')
						} else {
							return null
						}
					},
				/**
				 * From a given set of desired sizes and a given image, filter out any unwanted sizes
				 */
			},
			{
				key: 'getSupportedSizes',
				value: function getSupportedSizes(image, desiredSizes) {
					var supportedSizes = [],
						imageWidth = image['width']
					desiredSizes.forEach(function (width) {
						if (imageWidth >= width) {
							supportedSizes.push(width)
						}
					})
					return supportedSizes
				},
			},
		])

		return Image
	})()

	var ProductImageZoom = /*#__PURE__*/ (function () {
		function ProductImageZoom(element, slideshow) {
			_classCallCheck(this, ProductImageZoom)

			this.element = element
			this.delegateElement = new domDelegate.Delegate(this.element)
			this.delegateRoot = new domDelegate.Delegate(document.body)
			this.slideshow = slideshow
			this.pageContainer = document.querySelector('.PageContainer')
			this.thumbnailGalleryEls = document.querySelectorAll('.js-thumbnail-gallery-item')
			this._attachListeners()
		}

		_createClass(ProductImageZoom, [
			{
				key: 'destroy',
				value: function destroy() {
					this.delegateElement.off('click')
				},
			},
			{
				key: '_attachListeners',
				value: function _attachListeners() {
					this.delegateElement.on(
						'click',
						'.Product__SlideItem--image',
						this._initPhotoSwipeFromImageClick.bind(this),
					)
				},
				/**
				 * To save performance, we only initialize PhotoSwipe when it's requested. All high resolution images
				 * are also loaded only on demand. Also, please note that PhotoSwipe is always completely destroyed
				 * whenever it is closed, so it stays super snappy
				 */
			},
			{
				key: '_initPhotoSwipe',
				value: function _initPhotoSwipe() {
					var images = []
					this.slideshow.flickityInstance.cells.forEach(function (item) {
						if (item.element.classList.contains('Product__SlideItem--image')) {
							images.push(item.element.querySelector('img'))
						}
					})

					this._createPhotoSwipeInstance(
						this._createPhotoSwipeItemsFromImages(images),
						parseInt(
							this.slideshow.flickityInstance.selectedElement.getAttribute(
								'data-image-media-position',
							),
						),
					)
				},
				/**
				 * On desktop we do not have the dedicated small icon, instead the zoom is triggered when clicking directly on the image
				 */
			},
			{
				key: '_initPhotoSwipeFromImageClick',
				value: function _initPhotoSwipeFromImageClick(event, target) {
					this.pageContainer &&
						this.pageContainer.parentNode.tagName === 'BODY' &&
						this.pageContainer.parentNode.classList.add('pswp-active')
					// Opening this way is only available on desktop

					var images = Dom.nodeListToArray(
						this.element.querySelectorAll('.Product__SlideItem--image img'),
					)

					this._createPhotoSwipeInstance(
						this._createPhotoSwipeItemsFromImages(images),
						parseInt(target.getAttribute('data-image-media-position')),
					)
				},
				/**
				 * Take a list of images and create a PhotoSwipe array. This is called whenever the gallery is initialized.
				 */
			},
			{
				key: '_createPhotoSwipeItemsFromImages',
				value: function _createPhotoSwipeItemsFromImages(images) {
					return images.map(function (image) {
						var maxWidth = parseInt(image.getAttribute('data-max-width')),
							maxHeight = parseInt(image.getAttribute('data-max-height')),
							maxDimension = Responsive.matchesBreakpoint('phone') ? 1125 : 1875,
							// 1200 is max size for mobile and 1800 for larger devices
							reduceFactor = 1.0

						if (maxWidth >= maxHeight) {
							reduceFactor = Math.max(maxWidth / maxDimension, 1.0)
						} else {
							reduceFactor = Math.max(maxHeight / maxDimension, 1.0)
						}

						var requestedWidth = Math.floor(maxWidth / reduceFactor)
						var requestedHeight = Math.floor(maxHeight / reduceFactor)
						return {
							msrc: image.currentSrc || image.src,
							// For browser that supports srcset, currentSrc is the currently used image
							w: requestedWidth,
							h: requestedHeight,
							initialZoomLevel: 0.65,
							src: Image.getSizedImageUrl(image.getAttribute('data-original-src'), 'master')
						}
					})
				},
				/**
				 * Take a list of nodes containing all images and create a PhotoSwipe array. This is called
				 * whenever the gallery is initialized.
				 */
			},
			{
				key: '_createPhotoSwipeInstance',
				value: function _createPhotoSwipeInstance(items, selectedImageIndex) {
					var _this = this

					var photoswipeContainer = document.querySelector('.pswp')
					this._createThumbnailGalleryInstance()
					this.photoSwipeInstance = new PhotoSwipe(photoswipeContainer, false, items, {
						index: selectedImageIndex,
						showHideOpacity: true,
						showAnimationDuration: 500,
						loop: false,
						history: false,
						closeOnVerticalDrag: false,
						closeOnScroll: false,
						allowPanToNext: false,
						pinchToClose: false,
						maxSpreadZoom: 1,
						errorMsg:
							'<p class="pswp__error-msg">' + window.languages.productImageLoadingError + '</p>',
						scaleMode: 'fit',
						getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
							if (isMouseClick) {
								return 1.6
							} else {
								return item.initialZoomLevel < 0.7 ? 1 : 1.33
							}
						},
						getThumbBoundsFn: function getThumbBoundsFn(index) {
							var thumbnail = _this.element.querySelector(
									'.Product__Slideshow .Product__SlideItem[data-image-media-position="'.concat(
										parseInt(index),
										'"] img',
									),
								),
								pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
								rect = thumbnail.getBoundingClientRect()

							return {
								x: rect.left,
								y: rect.top + pageYScroll,
								w: rect.width,
							}
						},
					}) // We need to patch PhotoSwipe update size to solve iOS 15 issue

					function iOSversion() {
						if (/iP(hone|od|ad)/.test(navigator.platform)) {
							var v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/)
							return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)]
						}
					}

					var ver = iOSversion()

					if (ver && ver[0] >= 15) {
						var originalUpdateSize = this.photoSwipeInstance.updateSize,
							lastWidth = null

						this.photoSwipeInstance.updateSize = function () {
							if (lastWidth === null || lastWidth !== window.innerWidth) {
								originalUpdateSize(this, arguments)
							}

							lastWidth = window.innerWidth
						}
					}

					this.photoSwipeInstance.listen('beforeChange', this._onSlideChanged.bind(this))
					this.photoSwipeInstance.listen('destroy', this._destroyPhotoSwipe.bind(this))
					this.photoSwipeInstance.listen('doubleTap', this._onDoubleTap.bind(this))
					this.photoSwipeInstance.listen('initialZoomIn', this._onInitialZoomIn.bind(this))
					this.photoSwipeInstance.listen('initialZoomOut', this._onInitialZoomOut.bind(this))
					this.delegateRoot.on('pswpTap', '.pswp__scroll-wrap', this._onSingleTap.bind(this))
					this.delegateRoot.on('pswpTap', '.pswp__button--close', this.photoSwipeInstance.close)
					this.delegateRoot.on('pswpTap', '.pswp__button--prev', this.photoSwipeInstance.prev)
					this.delegateRoot.on('pswpTap', '.pswp__button--next', this.photoSwipeInstance.next)
					this.photoSwipeInstance.init()
				},
				/**
				 * Update the nav
				 */
			},
			{
				key: '_createThumbnailGalleryInstance',
				value: function _createThumbnailGalleryInstance() {
					const thumbnailGalleryEl = document.querySelector('.js-thumbnail-gallery')
					const option = {
						"slidesPerView": "auto",
						"freeMode": true,
						"direction": "horizontal",
						"centerInsufficientSlides": true,
						"breakpoints": {
							"1024": {
								"direction": "vertical"
							}
						}
					}

					if (thumbnailGalleryEl) {
						this.thumbnailGalleryCarousel = new Swiper(thumbnailGalleryEl, option)
						this.thumbnailGalleryCarousel.on('click', (swiper, event) => {
							const indexSlide = swiper.clickedIndex

							if (swiper.slides.length > 0) {
								this._removeAllClassActive(swiper.slides, 'is-active')
								swiper.slides[indexSlide] && swiper.slides[indexSlide].classList.add('is-active')
							}
							this.photoSwipeInstance.goTo(indexSlide)
						})
					}
				}
			},
			{
				key: '_onSlideChanged',
				value: function _onSlideChanged() {
					const currentIndex = this.photoSwipeInstance.getCurrentIndex()

					if (currentIndex === 0) {
						this.photoSwipeInstance.scrollWrap
							.querySelector('.pswp__button--prev')
							.setAttribute('disabled', 'disabled')
					} else {
						this.photoSwipeInstance.scrollWrap
							.querySelector('.pswp__button--prev')
							.removeAttribute('disabled')
					}

					if (
						currentIndex + 1 ===
						this.photoSwipeInstance.options.getNumItemsFn()
					) {
						this.photoSwipeInstance.scrollWrap
							.querySelector('.pswp__button--next')
							.setAttribute('disabled', 'disabled')
					} else {
						this.photoSwipeInstance.scrollWrap
							.querySelector('.pswp__button--next')
							.removeAttribute('disabled')
					}
					this.thumbnailGalleryCarousel && this.thumbnailGalleryCarousel.slideTo(currentIndex, 0)
					this.thumbnailGalleryEls.length > 0 && this.thumbnailGalleryEls[currentIndex].classList.add('is-active')
				},
				/**
				 * This event is a bit different and is triggered when the user click somewhere. We use it do allow to zoom in and
				 * zoom out in the image on desktop and use for the UI
				 */
			},
			{
				key: '_removeAllClassActive',
				value: function _removeAllClassActive(items, classActive) {
					if (items.length > 0) {
						items.forEach((item) => {
							item.classList.remove(classActive)
						})
					}
				}
			},
			{
				key: '_onSingleTap',
				value: function _onSingleTap(event) {
					if (!event.detail || event.detail.pointerType === 'mouse') {
						if (event.target.classList.contains('pswp__img')) {
							this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint)
						}
					} else {
						if (event.target.classList.contains('pswp__button')) {
							return
						}
					}
				},
			},
			{
				key: '_onDoubleTap',
				value: function _onDoubleTap(point) {
					var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel

					if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
						this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333)
					} else {
						this.photoSwipeInstance.zoomTo(initialZoomLevel < 0.7 ? 1 : 1.33, point, 333)
					}
				},
			},
			{
				key: '_onInitialZoomIn',
				value: function _onInitialZoomIn() {
					document.querySelector('.pswp__ui').classList.remove('pswp__ui--hidden')
				},
			},
			{
				key: '_onInitialZoomOut',
				value: function _onInitialZoomOut() {
					document.querySelector('.pswp__ui').classList.add('pswp__ui--hidden')
				},
				/**
				 * PhotoSwipe instance is automatically destroyed for us when it's closed. What we need to do is simply re-set
				 * our in-memory instance to null and our own events
				 */
			},
			{
				key: '_destroyPhotoSwipe',
				value: function _destroyPhotoSwipe() {
					this.pageContainer &&
						this.pageContainer.parentNode.tagName === 'BODY' &&
						this.pageContainer.parentNode.classList.remove('pswp-active')
					this.delegateRoot.off('pswpTap')
					this.photoSwipeInstance = null
					this._removeAllClassActive(this.thumbnailGalleryEls, 'is-active')
					this.thumbnailGalleryCarousel.destroy()
					this.thumbnailGalleryCarousel = null
				},
			},
		])

		return ProductImageZoom
	})()

	var ProductModel = /*#__PURE__*/ (function () {
		function ProductModel(element, stackProductImages) {
			_classCallCheck(this, ProductModel)

			this.element = element
			this.delegateElement = new domDelegate.Delegate(this.element)
			this.delegateRoot = new domDelegate.Delegate(document.documentElement)
			this.stackProductImages = stackProductImages

			this._attachListeners()

			var stylesheet = document.createElement('link')
			stylesheet.rel = 'stylesheet'
			stylesheet.href =
				'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css'
			document.head.appendChild(stylesheet)
			window.Shopify.loadFeatures([
				{
					name: 'model-viewer-ui',
					version: '1.0',
					onLoad: this._setupModelViewerUI.bind(this),
				},
				{
					name: 'shopify-xr',
					version: '1.0',
				},
			])
		}

		_createClass(ProductModel, [
			{
				key: 'destroy',
				value: function destroy() {},
			},
			{
				key: '_attachListeners',
				value: function _attachListeners() {
					var _this = this

					this.element
						.querySelector('model-viewer')
						.addEventListener('shopify_model_viewer_ui_toggle_play', function () {
							_this.element.dispatchEvent(
								new CustomEvent('model:played', {
									bubbles: true,
								}),
							)
						})
					this.element
						.querySelector('model-viewer')
						.addEventListener('shopify_model_viewer_ui_toggle_pause', function () {
							_this.element.dispatchEvent(
								new CustomEvent('model:paused', {
									bubbles: true,
								}),
							)
						})
				},
			},
			{
				key: 'hasBeenSelected',
				value: function hasBeenSelected() {
					// As per guidelines, we only need to autoplay when it's not a touch device
					if (Responsive.matchesBreakpoint('supports-hover')) {
						this.modelUi.play()
					}
				},
			},
			{
				key: 'hasBeenDeselected',
				value: function hasBeenDeselected() {
					// In all cases, we just turn it off
					this.modelUi.pause()
				},
			},
			{
				key: '_setupModelViewerUI',
				value: function _setupModelViewerUI() {
					this.modelElement = this.element.querySelector('model-viewer')
					this.modelUi = new window.Shopify.ModelViewerUI(this.modelElement)
				},
			},
		])

		return ProductModel
	})()

	/**
	 * This implementation allows to serialize a form
	 */
	var Form = /*#__PURE__*/ (function () {
		function Form() {
			_classCallCheck(this, Form)
		}

		_createClass(Form, null, [
			{
				key: 'serialize',
				value: function serialize(form) {
					function stringKey(key, value) {
						var beginBracket = key.lastIndexOf('[')

						if (beginBracket === -1) {
							var _hash = {}
							_hash[key] = value
							return _hash
						}

						var newKey = key.substr(0, beginBracket)
						var newValue = {}
						newValue[key.substring(beginBracket + 1, key.length - 1)] = value
						return stringKey(newKey, newValue)
					}

					var hash = {}

					for (var i = 0, len = form.elements.length; i < len; i++) {
						var formElement = form.elements[i]

						if (formElement.name === '' || formElement.disabled) {
							continue
						}

						if (
							formElement.name &&
							!formElement.disabled &&
							(formElement.checked ||
								/select|textarea/i.test(formElement.nodeName) ||
								/hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
									formElement.type,
								))
						) {
							var stringKeys = stringKey(formElement.name, formElement.value)
							hash = Form.extend(hash, stringKeys)
						}
					}

					return hash
				},
			},
			{
				key: 'extend',
				value: function extend() {
					var extended = {}
					var i = 0 // Merge the object into the extended object

					var merge = function merge(obj) {
						for (var prop in obj) {
							if (obj.hasOwnProperty(prop)) {
								// If property is an object, merge properties
								if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
									extended[prop] = Form.extend(extended[prop], obj[prop])
								} else {
									extended[prop] = obj[prop]
								}
							}
						}
					} // Loop through each object and conduct a merge

					for (; i < arguments.length; i++) {
						merge(arguments[i])
					}

					return extended
				},
			},
		])

		return Form
	})()

	var Currency = /*#__PURE__*/ (function () {
		function Currency() {
			_classCallCheck(this, Currency)
		}

		_createClass(Currency, null, [
			{
				key: 'formatMoney',
				value:
					/**
					 * Format money values based on your shop currency settings
					 *
					 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents or 3.00 dollars
					 * @param  {String} format - shop money_format setting
					 * @return {String} value - formatted value
					 */
					function formatMoney(cents, format) {
						if (typeof cents === 'string') {
							cents = cents.replace('.', '')
						}

						var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
							formatString = format || '${{amount}}'

						function defaultTo(value, defaultValue) {
							return value == null || value !== value ? defaultValue : value
						}

						function formatWithDelimiters(number, precision, thousands, decimal) {
							precision = defaultTo(precision, 2)
							thousands = defaultTo(thousands, ',')
							decimal = defaultTo(decimal, '.')

							if (isNaN(number) || number == null) {
								return 0
							}

							number = (number / 100.0).toFixed(precision)
							var parts = number.split('.'),
								dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
								centsAmount = parts[1] ? decimal + parts[1] : ''
							return dollarsAmount + centsAmount
						}

						var value = ''

						switch (formatString.match(placeholderRegex)[1]) {
							case 'amount':
								value = formatWithDelimiters(cents, 2)
								break

							case 'amount_no_decimals':
								value = formatWithDelimiters(cents, 0)
								break

							case 'amount_with_space_separator':
								value = formatWithDelimiters(cents, 2, ' ', '.')
								break

							case 'amount_no_decimals_with_comma_separator':
								value = formatWithDelimiters(cents, 0, ',', '.')
								break

							case 'amount_no_decimals_with_space_separator':
								value = formatWithDelimiters(cents, 0, ' ')
								break

							case 'amount_with_comma_separator':
								value = formatWithDelimiters(cents, 2, '.', ',')
								break
						}

						if (formatString.indexOf('with_comma_separator') !== -1) {
							return formatString.replace(placeholderRegex, value).replace(',00', '')
						} else {
							return formatString.replace(placeholderRegex, value).replace('.00', '')
						}
					},
			},
		])

		return Currency
	})()

	var VariantSelector = /*#__PURE__*/ (function () {
		function VariantSelector(element, parentProductVariants) {
			var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}

			_classCallCheck(this, VariantSelector)

			this.element = element
			this.parentProductVariants = parentProductVariants
			this.delegateElement = new domDelegate.Delegate(this.element)
			this.activator =
				options['activator'] ||
				document.querySelector('[aria-controls="'.concat(element.getAttribute('id'), '"]'))

			this.onValueChangedCallback = options['onValueChanged'] || function () {}

			this.isOpen = false
			this.pageOverlayElement = document.querySelector('.PageOverlay')
			this.variantChoiceList = Dom.nodeListToArray(
				this.element.querySelectorAll('.VariantSelector__Choice'),
			)
			this.variantCarousel = new Carousel(
				this.element.querySelector('.VariantSelector__Carousel'),
				{
					onSelect: this._variantChanged.bind(this),
					onClick: this._variantSelected.bind(this),
				},
			)

			this._attachListeners()
		}

		_createClass(VariantSelector, [
			{
				key: 'destroy',
				value: function destroy() {
					this.element.removeEventListener('keyup', this._handleKeyboardListener)
					this.delegateElement.off('click')
					this.activator.removeEventListener('click', this._toggleListener)
					this.variantCarousel.destroy()
				},
			},
			{
				key: 'toggle',
				value: function toggle() {
					this.isOpen ? this.close() : this.open()
				},
			},
			{
				key: 'open',
				value: function open() {
					if (this.isOpen) {
						return
					}

					this.element.setAttribute('aria-hidden', 'false')
					this.activator.setAttribute('aria-expanded', 'true')
					Accessibility.trapFocus(this.element, 'variant-selector')
					document.documentElement.classList.add('no-scroll') // Prevent scrolling when popover is open

					this.element.setAttribute('style', '')
					this.pageOverlayElement.classList.add('is-visible')
					this.pageOverlayElement.addEventListener('click', this._closeListener)
					this.isOpen = true
				},
			},
			{
				key: 'close',
				value: function close() {
					if (!this.isOpen) {
						return
					}

					this.element.setAttribute('aria-hidden', 'true')
					this.activator.setAttribute('aria-expanded', 'false')
					Accessibility.removeTrapFocus(this.element, 'variant-selector')
					document.documentElement.classList.remove('no-scroll')
					this.pageOverlayElement.classList.remove('is-visible')
					this.pageOverlayElement.removeEventListener('click', this._closeListener)
					this.isOpen = false
				},
			},
			{
				key: '_attachListeners',
				value: function _attachListeners() {
					this._handleKeyboardListener = this._handleKeyboard.bind(this)
					this._closeListener = this.close.bind(this)
					this._toggleListener = this.toggle.bind(this)
					this.element.addEventListener('keyup', this._handleKeyboardListener)
					this.activator.addEventListener('click', this._toggleListener)
					this.delegateElement.on(
						'click',
						'[data-action="select-variant"]',
						this._onVariantSelect.bind(this),
					)
					this.parentProductVariants.delegateElement.on(
						'variant:changed',
						this._onVariantChanged.bind(this),
					)
				},
				/**
				 * Called when the variant is changed (but not yet selected)
				 */
			},
			{
				key: '_variantChanged',
				value: function _variantChanged(selectedIndex) {
					var activeChoice = this.variantChoiceList[selectedIndex]
					activeChoice.classList.add('is-selected')
					Dom.getSiblings(activeChoice, '.is-selected').forEach(function (item) {
						return item.classList.remove('is-selected')
					})
				},
				/**
				 * Called when a variant is clicked or selected
				 */
			},
			{
				key: '_variantSelected',
				value: function _variantSelected(cellElement, cellIndex) {
					if (this.variantCarousel.getSelectedIndex() === cellIndex) {
						this.onValueChangedCallback(
							cellElement.getAttribute('data-option-value'),
							cellElement,
							this.activator,
						)
						this.close()
					} else {
						this.variantCarousel.selectCell(cellIndex)
					}
				},
			},
			{
				key: '_onVariantChanged',
				value: function _onVariantChanged(event) {
					var _this = this

					var selectedVariant = event.detail.variant,
						imageWrapperElements = this.element.querySelectorAll('.VariantSelector__ImageWrapper'),
						found = false

					Dom.nodeListToArray(imageWrapperElements).forEach(function (image) {
						var colorPosition =
								parseInt(image.parentElement.getAttribute('data-option-position')) - 1,
							combinationExcludedColor = ''
						selectedVariant.options.forEach(function (optionValue, index) {
							if (index !== colorPosition) {
								combinationExcludedColor += optionValue
							}
						})

						if (image.getAttribute('data-variant-title') === combinationExcludedColor) {
							image.setAttribute('aria-hidden', 'false')
							found = true
						} else {
							image.setAttribute('aria-hidden', 'true')
						}
					})

					if (!found) {
						imageWrapperElements.children[0].setAttribute('aria-hidden', 'false')
					}

					var foundColorIndex = 0
					Dom.nodeListToArray(
						this.element.querySelectorAll('.VariantSelector__ChoicePrice'),
					).forEach(function (priceElement, index) {
						var colorPosition = parseInt(priceElement.getAttribute('data-color-position')) - 1

						_this.parentProductVariants.productData['variants'].forEach(function (variant) {
							var matchOptionsExcludedColor = true
							variant['options'].forEach(function (option, index) {
								if (index !== colorPosition) {
									if (variant['options'][index] !== selectedVariant['options'][index]) {
										matchOptionsExcludedColor = false
									}
								}
							})

							if (
								matchOptionsExcludedColor &&
								variant['options'][colorPosition] === selectedVariant['options'][colorPosition]
							) {
								if (foundColorIndex++ === index) {
									priceElement.innerHTML = '<span class="Heading Text--subdued">'.concat(
										Currency.formatMoney(variant['price'], window.theme.moneyFormat),
										'</span>',
									)
								}
							}
						})
					})
				},
				/**
				 * Called when the button "choose this variant" is explicitly clicked
				 */
			},
			{
				key: '_onVariantSelect',
				value: function _onVariantSelect() {
					var selectedCell = this.variantCarousel.flickityInstance.selectedCell.element
					this.onValueChangedCallback(
						selectedCell.getAttribute('data-option-value'),
						selectedCell,
						this.activator,
					)
					this.close()
				},
				/**
				 * Handle a11y events
				 */
			},
			{
				key: '_handleKeyboard',
				value: function _handleKeyboard(event) {
					if (this.isOpen && event.keyCode === 27) {
						this.close()
					}
				},
			},
		])

		return VariantSelector
	})()

	var ProductVariants = /*#__PURE__*/ (function () {
		function ProductVariants(container, options) {
			var _this = this

			_classCallCheck(this, ProductVariants)

			this.element = container
			this.delegateElement = new domDelegate.Delegate(this.element)
			this.options = options
			this.allOptionsSet = true
			this.actionWishlist = false
			this.pendantSelected = []
			this.buttonAddPendantEl = this.element.querySelector('.js-add-pendant')
			this.pendantItemEls = this.element.querySelectorAll('.js-pendant-item')
			this.pendantMax = this.buttonAddPendantEl ? Number(this.buttonAddPendantEl.dataset.maximum_pendant) : 0
			this.pendantMin = 1

			var jsonData = JSON.parse(this.element.querySelector('[data-product-json]').innerHTML)
			this.productData = jsonData['product']

			this.variantsInventories = jsonData['inventories'] || {}
			this.masterSelector = this.element.querySelector(
				'#product-select-'.concat(this.productData['id']),
			) // We init value with the first selected variant
			this.productData['variants'].forEach(function (variant) {
				if (variant['id'] === jsonData['selected_variant_id']) {
					_this.currentVariant = variant
					_this.option1 = variant['option1']
					_this.option2 = variant['option2']
					_this.option3 = variant['option3']
				}
			})

			if (this.element.querySelector('.MobileAddToCart')) {
				this.mobileAddToCartHeight = this.element.querySelector('.MobileAddToCart').offsetHeight
			}

			if (this.element.querySelectorAll('[data-cartilage-product-json]').length) {
				var jsonDataCartilage = JSON.parse(
					this.element.querySelector('[data-cartilage-product-json]').innerHTML,
				)
				this.cartilageProductData = jsonDataCartilage['product']
				cartilageProductHasOptions = true
				this.cartilageVariantsInventories = jsonDataCartilage['inventories'] || {}
				this.cartilageMasterSelector = this.element.querySelector(
					'#product-select-'.concat(this.cartilageProductData['id']),
				)
				this.cartilageProductData['variants'].forEach(function (variant) {
					if (variant['id'] === jsonDataCartilage['selected_variant_id']) {
						_this.cartilageCurrentVariant = variant
						_this.cartilageOption1 = variant['option1']
						_this.cartilageOption2 = variant['option2']
						_this.cartilageOption3 = variant['option3']
					}
				})
			}

			if (this.element.querySelectorAll('[data-product-core-single-json]').length) {
				this.pendantValueArray = []
				this.pendantInputPosition = 1 // the number stone or letter is added on pendant

				var jsonDataPendant_Single = JSON.parse(
					this.element.querySelector('[data-product-core-single-json]').innerHTML,
				)
				this.pendant_Single_ProductData = jsonDataPendant_Single['product']
				this.pendant_Single_VariantsInventories = jsonDataPendant_Single['inventories'] || {}
				if (this.productData.id == this.pendant_Single_ProductData.id) {
					this.pendantCount = 1 // the number maximum pendant can added
				}

				this.pendant_Single_MasterSelector = this.element.querySelector(
					'#product-select-'.concat(this.pendant_Single_ProductData['id']),
				)
				this.pendant_Single_ProductData['variants'].forEach(function (variant) {
					if (variant['id'] === jsonDataPendant_Single['selected_variant_id']) {
						_this.pendant_Single_CurrentVariant = variant
						_this.pendant_Single_Option1 = variant['option1']
						_this.pendant_Single_Option2 = variant['option2']
						_this.pendant_Single_Option3 = variant['option3']
					}
				})
			}

			if (this.element.querySelectorAll('[data-product-core-multi-json]').length) {
				var jsonDataPendant_Multi = JSON.parse(
					this.element.querySelector('[data-product-core-multi-json]').innerHTML,
				)
				this.pendant_Multi_ProductData = jsonDataPendant_Multi['product']
				this.pendant_Multi_VariantsInventories = jsonDataPendant_Multi['inventories'] || {}

				this.pendant_Multi_ProductData['variants'].forEach(function (variant) {
					if (variant['id'] === jsonDataPendant_Multi['selected_variant_id']) {
						_this.pendant_Multi_CurrentVariant = variant
						_this.pendant_Multi_Option1 = variant['option1']
						_this.pendant_Multi_Option2 = variant['option2']
						_this.pendant_Multi_Option3 = variant['option3']
					}
				})
				
				if (this.productData.id == this.pendant_Multi_ProductData.id) {
					this.pendantCount = 1
				}
			}
			this.optionSelectorExpanded = false
			this._setNextSelectedValue()

			if ((
				this.productData.tags.includes('From') ||
				this.productData.tags.includes('Template_Same Pair')) &&
				!this.productData.tags.includes('Event_Archive Sale')
			) {
				this._updateAddToCartButton(this.currentVariant, true)
			} else {
				this._updateAddToCartButton(this.currentVariant)
			}

			this._attachListeners()

			this._createSelectors()

			const urlParams = new URLSearchParams(window.location.search)
			const handleVariantParam = urlParams.get('variant')
			const returnToSessionStorage = sessionStorage.getItem('returnTo')

			if (handleVariantParam && returnToSessionStorage?.includes('products')) {
				sessionStorage.removeItem('returnTo')

				const buttonActionError = document.querySelector('[data-action="error-text"]')
				buttonActionError?.click()

				// active option variant
				const listVariantOption = document.querySelectorAll('.ProductForm__Option [type="radio"]')
				const listVariantOptionPersonalised = document.querySelectorAll('.ProductForm__Option_Personalised_Position [type="radio"]')
				const listVariantOptionFontStyle = document.querySelectorAll('.ProductForm__Option_FontStyle [type="radio"]')

				listVariantOption?.forEach(item => {
					if (!this.options['isPair']) {
						if (this.currentVariant.option1 === item.value || this.currentVariant.option2 === item.value || this.currentVariant.option3 === item.value) {
							item.click()
						}
					} else {
						const pairSearchParam = new URLSearchParams(returnToSessionStorage)
						const isPairVariantSelected = pairSearchParam.get('pair') || false

						if (item.value === isPairVariantSelected) {
							item.click()
						}
					}
				})
				listVariantOptionPersonalised?.forEach(item => {
					if (this.currentVariant.option1 === item.value || this.currentVariant.option2 === item.value || this.currentVariant.option3 === item.value) {
						item.click()
					}
				})
				listVariantOptionFontStyle?.forEach(item => {
					if (this.currentVariant.option1 === item.value || this.currentVariant.option2 === item.value || this.currentVariant.option3 === item.value) {
						item.click()
					}
				})

				//open Wishlist Modal
				let loopCount = 0
				const intervalWishlistModal = setInterval(() => {
					let wishlistButtonProduct = null

					wishlistButtonProduct = document.querySelector('.js-button-wishlist-product')
					if (wishlistButtonProduct && loopCount > 1) {
						clearInterval(intervalWishlistModal)
						wishlistButtonProduct.click()
					}

					if (loopCount > 10) clearInterval(intervalWishlistModal)
      		loopCount++
				}, 1000)
			}
		}

		_createClass(ProductVariants, [
			{
				key: 'destroy',
				value: function destroy() {
					this.delegateElement.off('click')
					this.formPopovers.forEach(function (popover) {
						return popover.destroy()
					})
					this.formVariantSelectors.forEach(function (selector) {
						return selector.destroy()
					})

					document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener)
				},
			},
			{
				key: '_attachListeners',
				value: function _attachListeners() {
					this.delegateElement.on(
						'click',
						'[data-action="expand-options"]',
						this._expandOptionSelector.bind(this),
					)
					this.delegateElement.on(
						'click',
						'[data-action="add-to-cart"]',
						this._addToCart.bind(this),
					)
					this.delegateElement.on(
						'click',
						'.js-button-wishlist-product',
						this._addToWishlist.bind(this),
					)
					this.delegateElement.on(
						'click',
						'[data-action="error-text"]',
						this._showErrorText.bind(this),
					)
					this.delegateElement.on(
						'click',
						'[data-action="decrease-quantity"]',
						this._decreaseQuantity.bind(this),
					)
					this.delegateElement.on(
						'click',
						'[data-action="increase-quantity"]',
						this._increaseQuantity.bind(this),
					)
					this.delegateElement.on('change', '[name="quantity"]', this._validateQuantity.bind(this)) // Hook when a radio button change
					this.delegateElement.on(
						'change',
						'.ProductForm__Option [type="radio"]',
						this._onOptionChanged.bind(this),
					)
					this.delegateElement.on(
						'click',
						'.GiftCardForm .ProductForm__Option [type="radio"]',
						this._onOptionChanged.bind(this),
					)
					this.delegateElement.on(
						'click',
						'.ProductForm__Option_Personalised_Position [type="radio"]',
						this._onOptionChanged.bind(this),
					)
					this.delegateElement.on(
						'click',
						'.ProductForm__Option_FontStyle [type="radio"]',
						this._onOptionChanged.bind(this),
					)
					this.delegateElement.on(
						'click',
						'[data-action="add-more-pendant"]',
						this._addMorePendant.bind(this),
					)
					this.delegateElement.on(
						'click',
						'[data-action="remove-pendant"]',
						this._removePendant.bind(this),
					)
					this.delegateElement.on(
						'click',
						'.ProductForm__Option.js-pendant-input-selector [type="checkbox"]',
						this._onOptionChanged.bind(this),
					)
					this.delegateElement.on(
						'click',
						'[data-action="select-pendant"]',
						this._selectPendant.bind(this),
					)
					if ((
						this.productData.tags.includes('from') ||
						this.productData.tags.includes('From') ||
						this.productData.tags.includes('Template_Same Pair')) &&
						!this.productData.tags.includes('Event_Archive Sale')
					) {
						this._onBreakpointChangedListener = this._updateAddToCartButton(this.currentVariant, true)
					} else {
						this._onBreakpointChangedListener = this._updateAddToCartButton(this.currentVariant)
					}
					document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener)
					document.addEventListener('add-wishlist-error', (event) => {
						this._showNoticeError()
					})
				},
				/**
				 * Selectors can either be popovers or dedicated variant selectors. We therefore pre-create them all here
				 */
			},
			{
				key: '_createSelectors',
				value: function _createSelectors() {
					var _this2 = this

					// Create the instances for each selector
					this.formPopovers = []
					this.formVariantSelectors = []
					Dom.nodeListToArray(this.element.querySelectorAll('.OptionSelector')).forEach(function (
						item,
					) {
						var popover = new Popover(item, {
							preferredPosition: 'left',
							onValueChanged: _this2._onOptionChanged.bind(_this2),
						})

						_this2.formPopovers.push(popover)
					})
					Dom.nodeListToArray(this.element.querySelectorAll('.VariantSelector')).forEach(function (
						item,
					) {
						var variantSelector = new VariantSelector(item, _this2, {
							onValueChanged: _this2._onOptionChanged.bind(_this2),
						})

						_this2.formVariantSelectors.push(variantSelector)
					})
				},
				/**
				 * ---------------------------------------------------------------------------------------------------
				 * CODE THAT HANDLE VARIANT CHANGES IN THE FRONT
				 *
				 * Please note that this code is highly dependant on the markup and classes, so make sure to NOT
				 * edit this code
				 * ---------------------------------------------------------------------------------------------------
				 */

				/**
				 * This callback is called whenever the variant changes and allows to update data about the active variant
				 */
			},
			{
				key: '_onVariantChanged',
				value: function _onVariantChanged(previousVariant, newVariant, mode) {
					this.allOptionsSet = true
					this._setNextSelectedValue(mode)

					if (mode != 'pendant') {
						if (this.allOptionsSet) {
							if (mode != 'cartilage') {
								// 1st: the prices
								this._updateProductPrices(newVariant, previousVariant)

								// 2nd: update inventory
								this._updateInventory(newVariant, previousVariant)

								// 3rd: update SKU
								this._updateSku(newVariant, previousVariant)

								// 4th: update the price measurement
								this._updateUnitPrice(newVariant, previousVariant)
							}

							// 5th: the add to cart button
							this._updateAddToCartButton(this.currentVariant)

							// Finally, we send an event so that other system could hook and do their own logic
							this.element.dispatchEvent(
								new CustomEvent('variant:changed', {
									bubbles: true,
									detail: {
										variant: newVariant,
										previousVariant: previousVariant,
										allOptionsSet: this.allOptionsSet
									},
								}),
							)
						} else {
							if (
								this.pendant_Single_CurrentVariant ||
								this.productData.price_varies ||
								this.productData.tags.includes('From') ||
								this.productData.tags.includes('Template_Same Pair')
							) {
							} else {
								this._updateAddToCartButton(newVariant)
							}
						}
					} else {
						if (this.allOptionsSet) {
							this._updateAddToCartButton(newVariant)
							this.element.dispatchEvent(
								new CustomEvent('variant:changed', {
									bubbles: true,
									detail: {
										variant: newVariant,
										previousVariant: previousVariant,
										allOptionsSet: this.allOptionsSet
									},
								}),
							)
						} else {
							if (this.pendantMin == 1) {
								this._updateAddToCartButton(this.pendant_Single_CurrentVariant, true)
							} else {
								this._updateAddToCartButton(this.pendant_Multi_CurrentVariant, true)
							}

							this.element.dispatchEvent(
								new CustomEvent('variant:changed', {
									bubbles: true,
									detail: {
										variant: newVariant,
										previousVariant: previousVariant,
										allOptionsSet: this.allOptionsSet
									},
								})
							)
						}
					}
				},
				/**
				 * Update the prices (optionally showing compare at price)
				 */
			},
			{
				key: '_selectPendant',
				value: function _selectPendant(event, target) {
					if (this.pendantSelected.length >= this.pendantMin) {
						return
					}
					if (this.pendantSelected.length > 0) {
						const bespokeElement = document.querySelector('.main-product-bespoke-js')
						if (bespokeElement) {
							bespokeElement.textContent = bespokeElement.dataset.content
						}
					}
					if (this.pendantSelected.length < this.pendantMin) {
						const swatchPendant = target.getAttribute('data-swatch')
						const	valuePendant = target.value

						this.pendantSelected.push(swatchPendant)
						this.pendantValueArray.push(target.value)
						this.pendantInputPosition += 1
						if (this.pendantSelected.length > 0) {
							this.pendantSelected.forEach((item, index) => {
								if (item !== null) {
									const pendantEl = this.pendantItemEls[index]?.querySelector('.js-pendant')
	
									if (pendantEl && !pendantEl.classList.contains('has-item')) {
										pendantEl.classList.add('has-item')
										pendantEl.setAttribute('data-pendant-name', valuePendant)
										pendantEl.setAttribute('data-pendant-stone', index + 1)

										if (target.dataset.productType === 'letter') {
											if (item === 'Heart') {
												pendantEl.innerHTML = "<svg viewBox='0 0 17 16' fill='none' class='Icon Icon--heart-black' xmlns='http://www.w3.org/2000/svg'><path d='M8.5 13.5C8.5 13.5 2.25 10 2.25 5.75C2.25 4.99868 2.51031 4.27056 2.98664 3.68954C3.46297 3.10851 4.12589 2.71046 4.86262 2.56311C5.59935 2.41577 6.36438 2.52822 7.02754 2.88135C7.6907 3.23449 8.21103 3.80647 8.5 4.5C8.78897 3.80647 9.3093 3.23449 9.97246 2.88135C10.6356 2.52822 11.4006 2.41577 12.1374 2.56311C12.8741 2.71046 13.537 3.10851 14.0134 3.68954C14.4897 4.27056 14.75 4.99868 14.75 5.75C14.75 10 8.5 13.5 8.5 13.5Z' fill='#232323'></path></svg>"
											} else {
												pendantEl.innerHTML = item
											}
										} else {
											pendantEl.innerHTML = `<img src="${item}" class="PendantImage" width="auto" height="auto" alt="pendant image" />`
										}
									}
								}
							})
						}
					}
					if (this.pendantSelected.length >= this.pendantMin) {
						if (this.pendantMin === 1) {
							const previousVariant = this.pendant_Single_CurrentVariant

							this[`pendant_Single_Option${target.getAttribute('data-option-position')}`] = target.value
							this.pendant_Single_CurrentVariant = this._getCurrentVariantFromOptions('pendant')
							this._onVariantChanged(previousVariant, this.pendant_Single_CurrentVariant, 'pendant')
							this._updateInventory(this.pendant_Single_CurrentVariant, previousVariant, 'pendant')
						} else {
							const previousVariant = this.pendant_Multi_CurrentVariant

							this.pendant_Multi_Option3 = this.pendantMin.toString()
							this.pendant_Multi_CurrentVariant = this._getCurrentVariantFromOptions('pendant')
							this._onVariantChanged(previousVariant, this.pendant_Multi_CurrentVariant, 'pendant')
						}
					}
				}
			},
			{
				key: '_containsDifferentCharacters',
				value: function _containsDifferentCharacters(inputString, characterArray) {
					// Convert the characterArray to a Set for faster lookups
					const allowedCharacters = new Set(characterArray);

					// Check if any character in the inputString is not in the allowedCharacters set
					for (let char of inputString) {
						if (!allowedCharacters.has(char)) {
							return true; // String contains a different character
						}
					}

					return false; // String contains only allowed characters
				}
			},
			{
				key: '_onOptionPersonalisedTextIconChanged',
				value: function _onOptionPersonalisedTextIconChanged(previousVariant, value) {
					let iconArray = []
					let inputTextValue = this.element.querySelector('.ProductForm__Option_Personalised_Text_Icon [type="text"]')?.value
					this.element.querySelectorAll('[data-action="add-icon"]')?.forEach(function (item, index) {
						iconArray.push(item.innerHTML.trim())
					})
					if (inputTextValue && !this.productVariants._containsDifferentCharacters(inputTextValue, iconArray)) {
						//make font & style optional
						this.element.querySelector('.ProductForm__Option_FontStyle .ProductForm__Label span').classList.add('isOptional')
					} else {
						//make font & style mandatory
						this.element.querySelector('.ProductForm__Option_FontStyle .ProductForm__Label span').classList.remove('isOptional')
					}
					this.productVariants._onVariantChanged(this.selectedVariant, this.selectedVariant)
				},
				/**
				 * Update the prices (optionally showing compare at price)
				 */
			},
			{
				key: '_updateProductPrices',
				value: function _updateProductPrices(newVariant, previousVariant) {
					var productMetaPrices = this.element.querySelectorAll('.ProductMeta__PriceList'),
						currencyFormat = window.theme.currencyCodeEnabled
							? window.theme.moneyWithCurrencyFormat
							: window.theme.moneyFormat

					if (!productMetaPrices) {
						return
					}

					productMetaPrices.forEach(productMetaPrice => {
						if (!newVariant) {
							productMetaPrice.style.display = 'none'
						} else {
							if (
								previousVariant &&
								previousVariant['price'] === newVariant['price'] &&
								previousVariant['compare_at_price'] === newVariant['compare_at_price'] &&
								!this.options['isGiftCard'] &&
								!this.options['isPair']
							) {
								return // The price do not have changed so let's return to avoid changing the DOM for nothing
							}
	
							productMetaPrice.innerHTML = ''
							
							let newPrice = newVariant['price']
							let priceMoneyFormat = '<span data-money-convertible>' + this.options['isPair'] &&
								this.element.querySelector('[name="pair"]:checked + label') &&
								this.element.querySelector('[name="pair"]:checked + label').textContent ==
									'Matched Pair'
									? Currency.formatMoney(
											newPrice * 2,
											currencyFormat,
									).replace('$', '')
									: Currency.formatMoney(
											newPrice,
											currencyFormat,
									).replace('$', '') + '</span>'
							if (this.options['isGiftCard']) {
								const customAmountInput = document.getElementById("gift-card-custom-amount")
								if (customAmountInput && (customAmountInput.value !== '' && customAmountInput.value !== null && customAmountInput.value !== 0 )) {
									newPrice = parseInt(customAmountInput.value) * 100
								}
								priceMoneyFormat = Currency.formatMoney(newPrice, currencyFormat).replace('$', '')
							}

							if (newVariant['compare_at_price'] > newVariant['price']) {
								let newComparePrice = newVariant['compare_at_price']
								let comparePriceMoneyFormat = this.options['isPair'] &&
									this.element.querySelector('[name="pair"]:checked + label') &&
									this.element.querySelector('[name="pair"]:checked + label').textContent ==
										'Matched Pair'
										? Currency.formatMoney(
												newComparePrice * 2,
												currencyFormat,
										).replace('$', '')
										: Currency.formatMoney(
												newComparePrice,
												currencyFormat,
										).replace('$', '')

								productMetaPrice.innerHTML +=
									'<span class="ProductMeta__Price Price u-h2" data-money-convertible>'.concat(
										priceMoneyFormat,
										'</span>',
									)
								productMetaPrice.innerHTML +=
									'<span class="ProductMeta__Price Price Price--compareAt u-h2" data-money-convertible>'.concat(
										comparePriceMoneyFormat,
										'</span>',
									)
							} else {
								productMetaPrice.innerHTML +=
									'<span class="ProductMeta__Price Price u-h2" data-money-convertible>'.concat(
										priceMoneyFormat,
										'</span>',
									)
							}
	
							productMetaPrice.style.display = ''
						}
					})

				},
				/**
				 * Update the inventory (if needed)
				 */
			},
			{
				key: '_updateInventory',
				value: function _updateInventory(newVariant, previousVariant, mode) {
					if (!this.options['showInventoryQuantity'] || this.options['productionTime'] == '') {
						return
					}

					if (mode == 'pendant') {
						if (this.pendantMin == 1) {
							var productFormInventory = this.element.querySelector('.ProductForm__Inventory'),
								variantInventory = newVariant
									? this.pendant_Single_VariantsInventories[newVariant['id']]
									: null

							if (!productFormInventory)  {
								console.warn("missing variable: productFormInventory")
								return
							}

							productFormInventory.innerHTML = variantInventory['inventory_message']
						}
					} else {
						var productFormInventory = this.element.querySelector('.ProductForm__Inventory'),
							variantInventory = newVariant ? this.variantsInventories[newVariant['id']] : null
						if (!productFormInventory)  {
							console.warn("missing variable: productFormInventory")
							return
						}
						productFormInventory.innerHTML = variantInventory['inventory_message']
					}
				},
				/**
				 * Update the SKU
				 */
			},
			{
				key: '_updateSku',
				value: function _updateSku(newVariant) {
					if (!this.options['showSku'] || !newVariant) {
						return
					}

					var productSkuNumber = this.element.querySelector('.ProductMeta__SkuNumber')

					if (productSkuNumber && newVariant['sku']) {
						productSkuNumber.innerText = newVariant['sku']
					}
				},
				/**
				 * Update the unit price
				 */
			},
			{
				key: '_updateUnitPrice',
				value: function _updateUnitPrice(newVariant) {
					if (!newVariant) {
						return
					}

					var unitPriceMeasurement = this.element.querySelector(
						'.ProductMeta__UnitPriceMeasurement',
					)

					if (!unitPriceMeasurement) {
						return
					}

					if (!newVariant.hasOwnProperty('unit_price')) {
						unitPriceMeasurement.style.display = 'none'
						return
					}

					unitPriceMeasurement.style.display = 'block'
					unitPriceMeasurement.querySelector('.UnitPriceMeasurement__Price').innerHTML =
						Currency.formatMoney(newVariant['unit_price'], window.theme.moneyFormat)
					unitPriceMeasurement.querySelector('.UnitPriceMeasurement__ReferenceUnit').textContent =
						newVariant['unit_price_measurement']['reference_unit']
					var unitPriceReferenceValue = unitPriceMeasurement.querySelector(
						'.UnitPriceMeasurement__ReferenceValue',
					)
					unitPriceReferenceValue.textContent =
						newVariant['unit_price_measurement']['reference_value']
					unitPriceReferenceValue.style.display =
						newVariant['unit_price_measurement']['reference_value'] === 1 ? 'none' : 'inline'
				},
			},
			{
				key: '_addMorePendant',
				value: function _addMorePendant(event, target) {
					const pendantMax = Number(target.dataset.maximum_pendant)

					this.pendantMin++
					this.pendantCount = this.pendantMin

					if (this.pendantMin <= pendantMax) {		
						const pendantWrapper = this.element.querySelector('.PendantInput_Wrapper')
						const htmlPendantInput = document.createElement('div');

						htmlPendantInput.classList.add('PendantInput', 'js-pendant-item')
						htmlPendantInput.setAttribute('data-index', this.pendantMin)
						htmlPendantInput.innerHTML = `
							<span class="PendantImage__wrap js-pendant"></span>
							<span class="PendantInput--remove" data-action="remove-pendant" data-index="${this.pendantMin}"></span>
						`
						pendantWrapper.insertBefore(htmlPendantInput, this.buttonAddPendantEl)
						this.pendantItemEls = this.element.querySelectorAll('.js-pendant-item')
					}
					if (this.pendantItemEls.length > 0) {
						this.pendant_Multi_Option3 = this.pendantMin.toString()

						if (this.pendantMin === 1) {
							const previousVariant = this.pendant_Single_CurrentVariant

							this.pendant_Single_CurrentVariant = this._getCurrentVariantFromOptions('pendant')
							this._onVariantChanged(previousVariant, this.pendant_Single_CurrentVariant, 'pendant')
						} else {
							const previousVariant = this.pendant_Multi_CurrentVariant

							this.pendant_Multi_CurrentVariant = this._getCurrentVariantFromOptions('pendant')
							this._onVariantChanged(previousVariant, this.pendant_Multi_CurrentVariant, 'pendant')
						}
						if (this.pendantMin >= this.pendantMax) {
							this.buttonAddPendantEl && this.buttonAddPendantEl.classList.add('PendantInput--diabled')
						}
					}
				}
			},
			{
				key: '_removePendant',
				value: function _removePendant(event, target) {
					const pendantIndex = target.dataset.index - 1
					const currentPendantEl = target.closest('.js-pendant-item')
					const currentPendantInnerEl = currentPendantEl.querySelector('.js-pendant')
					const currentPendantStoneIndex = currentPendantInnerEl.getAttribute('data-pendant-stone')
					const currentPendantStoneName = currentPendantInnerEl.getAttribute('data-pendant-name')

					var jsonDataPendant = JSON.parse(
						this.element.querySelector('[data-product-pendant-' + currentPendantStoneIndex + '-json]')
							.innerHTML,
					)

					const currentPendantPrice = jsonDataPendant.product.variants.find(variant => variant.option1 === currentPendantStoneName || variant.option2 === currentPendantStoneName || variant.option3 === currentPendantStoneName).price
					const productCompareAtPriceEls = this.element.querySelectorAll('.js-product-compare-at-price')
					const currencyFormat = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat

					if (productCompareAtPriceEls.length > 0) {
						productCompareAtPriceEls.forEach((productCompareAtPrice) => {
							const currentTotalPrice = productCompareAtPrice.querySelector('.money').getAttribute('data-total-price')
							const startTotalPrice = productCompareAtPrice.getAttribute('data-start-price')
							const mainTotalPrice = productCompareAtPrice.getAttribute('data-main-price')
							const startPrice = parseFloat(startTotalPrice)
							const minusPrice = parseFloat(currentTotalPrice) - currentPendantPrice
							if (startPrice && minusPrice && minusPrice !== startPrice) { 
								productCompareAtPrice.innerHTML = `<span class="money" data-total-price="${minusPrice}">${Currency.formatMoney(minusPrice, currencyFormat).replace('$', '')}</span>`
							} else if (minusPrice === startPrice) {
								productCompareAtPrice.innerHTML = `<span class="money" data-total-price="${currentTotalPrice}">${Currency.formatMoney(mainTotalPrice, currencyFormat).replace('$', '')}</span>`
							}
						});
					}

					if (this.pendantMin > 1) {
						this.pendantMin -= 1
						this.pendantInputPosition -= 1
						this.pendantCount = this.pendantMin
						currentPendantEl && currentPendantEl.remove()
					} else {
						this.pendantCount = 1
					}

					this.pendantSelected.splice(pendantIndex, 1)
					this.pendantValueArray.splice(pendantIndex, 1)
					this.buttonAddPendantEl && this.buttonAddPendantEl.classList.remove('PendantInput--diabled')
					this.pendantItemEls = this.element.querySelectorAll('.js-pendant-item')

					if (this.pendantSelected.length < 2) {
						const bespokeElement = document.querySelector('.main-product-bespoke-js')
						if (bespokeElement) bespokeElement.textContent = ""
					}

					if (this.pendantSelected.length >= this.pendantMin) {
						this.allOptionsSet = true
					} else {
						this.allOptionsSet = false
					}
					if (this.pendantMin > 0) {
						this.pendantItemEls.forEach((pendantItem, index) => {
							const pendantRemoveEl = pendantItem.querySelector('.PendantInput--remove')
							const reIndex = index + 1
	
							pendantRemoveEl.setAttribute('data-index', reIndex)
							pendantItem.setAttribute('data-index', reIndex)
							pendantItem.style.order = reIndex
						})
					}

					this._setNextSelectedValue('pendant')

					if (target.previousElementSibling) {
						target.previousElementSibling.classList.remove('has-item')
						target.previousElementSibling.removeAttribute('data-pendant-name')
						target.previousElementSibling.removeAttribute('data-pendant-stone')
						target.previousElementSibling.innerHTML = ''
					}
					if (this.pendantMin === 1) {
						const previousVariant = this.pendant_Single_CurrentVariant
						const productFormInventory = this.element.querySelector('.ProductForm__Inventory')

						if (this.pendantValueArray.length > 0) {
							this.pendant_Single_Option3 = this.pendantValueArray[0]
						} else {
							this.pendant_Single_Option3 = !!this.options.defaultValueStone ? this.options.defaultValueStone : 'Garnet'
						}

						this.pendant_Single_CurrentVariant = this._getCurrentVariantFromOptions('pendant')
						this._onVariantChanged(previousVariant, this.pendant_Single_CurrentVariant, 'pendant')

						if (this.pendantValueArray.length > 0) {
							this._updateInventory(this.pendant_Single_CurrentVariant, previousVariant, 'pendant')
						} else if (productFormInventory) {
							productFormInventory.innerHTML = '';
						}
					} else {
						const previousVariant = this.pendant_Multi_CurrentVariant

						this.pendant_Multi_Option3 = this.pendantMin.toString()
						this.pendant_Multi_CurrentVariant = this._getCurrentVariantFromOptions('pendant')
						this._onVariantChanged(previousVariant, this.pendant_Multi_CurrentVariant, 'pendant')
						this._onVariantChanged(previousVariant, this.pendant_Multi_CurrentVariant, 'pendant')
					}
				},
				/**
				 * Update the add to cart
				 */
			},
			{
				key: '_updateAddToCartButton',
				value: function _updateAddToCartButton(newVariant, includeFrom) {
					const productPriceEls = this.element.querySelectorAll('.js-product-price')
					const productCompareAtPriceEls = this.element.querySelectorAll('.js-product-compare-at-price')
					const currencyFormat = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat
					const pendantValueArray = this.pendantValueArray || []
					let variantPrice = newVariant['price']
					let variantCompareAtPrice = newVariant['compare_at_price'] || 0
					let pendantPrice = 0
					let pendantCompareAtPrice = 0

					if (newVariant instanceof Event) {
						var newVariant = this.currentVariant

						if (
							this.pendant_Single_CurrentVariant ||
							this.productData.price_varies ||
							this.productData.tags.includes('From') ||
							this.productData.tags.includes('Template_Same Pair')
						) {
							return
						}
					}

					if (this.pendantMin > 1) {
						for (let i = 0; i < pendantValueArray.length; i++) {
							var jsonDataPendant = JSON.parse(
								this.element.querySelector('[data-product-pendant-' + (i + 1) + '-json]')
									.innerHTML,
							)
							jsonDataPendant.product['variants'].forEach(function (variant) {
								if (
									variant['option1'] === pendantValueArray[i] ||
									variant['option2'] === pendantValueArray[i] ||
									variant['option3'] === pendantValueArray[i]
								) {
									pendantPrice += variant.price

									if (variant.compare_at_price !== null) {
										pendantCompareAtPrice += variant.compare_at_price
									} else {
										pendantCompareAtPrice += variant.price
									}
								}
							})

							if (this.options['isMultiplePendant']) {
								var jsonDataPendant = JSON.parse(
									this.element.querySelector('[data-product-pendant-stone-' + (i + 1) + '-json]')
										.innerHTML
								)

								jsonDataPendant.product['variants'].forEach(function (variant) {
									if (
										variant['option1'] === pendantValueArray[i] ||
										variant['option2'] === pendantValueArray[i] ||
										variant['option3'] === pendantValueArray[i]
									) {
										pendantPrice += variant.price

										if (variant.compare_at_price !== null) {
											pendantCompareAtPrice += variant.compare_at_price
										} else {
											pendantCompareAtPrice += variant.price
										}
									}
								})
							}
						}
					}

					if (pendantValueArray.length === 0 && newVariant.option3 > 1) {
						if (this.pendantMin > 2) {
							pendantPrice = this.options.necklace_price * this.pendantMin / 2
						} else {
							pendantPrice = this.options.necklace_price
						}
					}

					if (this.pendantMin === 1 && pendantValueArray.length === 1 && this.options.isPendantBuilder) {
						const compareAtPriceEl = this.element.querySelector('.js-product-compare-at-price')
						if (compareAtPriceEl) {
							const startCompareAtPrice = compareAtPriceEl.getAttribute('data-start-price')

							if (startCompareAtPrice) {
								var jsonDataPendant_1 = JSON.parse(
									this.element.querySelector('[data-product-pendant-' + 1 + '-json]')
										?.innerHTML,
								)

								if (jsonDataPendant_1) {
									const pendantFirst = jsonDataPendant_1.product.variants.find((variant) => variant['option1'] === pendantValueArray[0] || variant['option2'] === pendantValueArray[0] || variant['option3'] === pendantValueArray[0])
			
									if (pendantFirst) {
										variantCompareAtPrice += (pendantFirst.compare_at_price || pendantFirst.price || 0) + parseFloat(startCompareAtPrice)
									}	
								}
							}
						}
					}
					
					variantPrice += pendantPrice
					variantCompareAtPrice += pendantCompareAtPrice
					this.currentVariantPrice = variantPrice

					if (this.pendantMin === 1 && pendantValueArray.length === 0 && this.pendant_Single_ProductData && this.options.isPendantBuilder) {
						variantPrice = this.pendant_Single_ProductData.price_min
					}

					if (pendantValueArray.length > 0 && pendantValueArray.length >= this.pendantMin) {
						if (this.options['isGiftCard']) {
							const giftCardCustomAmountValue = document.querySelector('#giftcard-valid-custom-amount')

							variantPrice = giftCardCustomAmountValue.value
						}
					}
					if (productPriceEls.length > 0) {
						let priceMoneyFormat = '<span data-money-convertible>' + this.options['isPair'] &&
							this.element.querySelector('[name="pair"]:checked + label') &&
							this.element.querySelector('[name="pair"]:checked + label').textContent ==
								'Matched Pair'
								? Currency.formatMoney(
										variantPrice * 2,
										currencyFormat,
								  ).replace('$', '')
								: Currency.formatMoney(
										variantPrice,
										currencyFormat,
								  ).replace('$', '') + '</span>'
						productPriceEls.forEach((productPrice) => {
							productPrice.innerHTML = `${includeFrom ? 'From ' : ''}${priceMoneyFormat}`
						});
					}
					
					if (this.options.isPendantBuilder) {
						if (productCompareAtPriceEls.length > 0 && this.pendantMin > 1 && variantCompareAtPrice > variantPrice) {
							productCompareAtPriceEls.forEach((productCompareAtPrice) => {
								productCompareAtPrice.classList.remove('hidden')
								productCompareAtPrice.innerHTML = `<span class="money" data-total-price="${variantCompareAtPrice}">${Currency.formatMoney(variantCompareAtPrice, currencyFormat).replace('$', '')}</span>`
							});
						} else {
							productCompareAtPriceEls.forEach((productCompareAtPrice) => {
								productCompareAtPrice.classList.add('hidden')
							});
						}
					}
					
					const wishlistButtonEls = document.querySelectorAll('.js-wishlist-button')
					if (wishlistButtonEls.length > 0) {
						var ErrorTextMessage =
						this.nextselectedValue && this.nextselectedValue.parentElement
								? this.nextselectedValue.parentElement.textContent
								: ''
						wishlistButtonEls.forEach((wishlistButton) => {
							wishlistButton.setAttribute('disabled', !this.allOptionsSet + '')
							wishlistButton.setAttribute('variant-selected-id', newVariant.id)
							wishlistButton.setAttribute('variant-selected', JSON.stringify(newVariant))
							wishlistButton.setAttribute('error-message', ErrorTextMessage)
						});
					}

					const wishlistButtonMobileEl = document.querySelector('.js-wishlist-button-mobile')
					if (wishlistButtonMobileEl) {
						wishlistButtonMobileEl.setAttribute('disabled', !this.allOptionsSet + '')
						wishlistButtonMobileEl.setAttribute('variant-selected-id', newVariant.id)
						wishlistButtonMobileEl.setAttribute('variant-selected', JSON.stringify(newVariant))

						var ErrorTextMessage =
						this.nextselectedValue && this.nextselectedValue.parentElement
								? this.nextselectedValue.parentElement.textContent
								: ''
						wishlistButtonMobileEl.setAttribute('error-message', ErrorTextMessage)
					}

					const addToCartButtonEls = this.element.querySelectorAll('.ProductForm__AddToCart')

					if (Responsive.matchesBreakpoint('pocket')) {
						var atc = this.element.querySelector('.ProductForm__AddToCart_Mobile')
					} else {
						var atc = this.element.querySelector('.ProductForm__AddToCart_Desktop')
					}

					if (atc?.getAttribute('klaviyo-bis-enabled') === 'true') atc.style.display = 'block'

					var shopifyPaymentButton = this.element.querySelector('.shopify-payment-button'),
						findInStoreButton = this.element.querySelector(
							'[data-drawer-id="find-in-store-drawer"]',
						)
					const brauzFindInStoreButton = this.element.querySelector('#brauz-find-in-store-product-page')
					if (addToCartButtonEls.length > 0 && this.options['templateSuffix'] !== 'engagement') {
						let ErrorTextMessage = ''

						if (this.pendantItemEls.length > 0) {
							ErrorTextMessage = 'Make Selections'
						} else {
							ErrorTextMessage = this.nextselectedValue && this.nextselectedValue.parentElement
							? 'Select ' + this.nextselectedValue.parentElement.textContent.replace(':', '').replace('Choose', '').replace('Select', '').trim()
							: ''
						}
                        
					  const inventoryMessage = document.querySelector('.ProductForm__Inventory.js-inventory-message')
						const buttonNotify = this.element.querySelector('.klaviyo-product-trigger')

					    // if (inventoryMessage) inventoryMessage.style.display = 'none'

						if (!newVariant) {
							addToCartButtonEls.forEach((addToCartButton) => {
								addToCartButton.setAttribute('data-action', 'error-text')
							})
							if (findInStoreButton) {
								findInStoreButton.setAttribute('data-action', 'error-text')
							}
							if (this.nextselectedValue) {
								addToCartButtonEls.forEach((addToCartButton) => {
									addToCartButton.querySelector('.ErrorTextMessage').innerText = this.nextselectedValue.parentElement.innerText
								})
							}
						} else {
							const isPairSelected = this.element.querySelector('[name="pair"]:checked + label') &&
							this.element.querySelector('[name="pair"]:checked + label').textContent ==
								'Matched Pair'
							const quantity = this.options.quantities.find(({id}) => id === newVariant.id)?.quantity

							if (this.allOptionsSet == false && this.options['isAvailable'] == true) {
								addToCartButtonEls.forEach((addToCartButton) => {
									addToCartButton.setAttribute('data-action', 'error-text')
								})
								if (buttonNotify) {
									buttonNotify.setAttribute('data-action', 'error-text')
								}
								if (
									undefined === this.options['showPriceInButton'] ||
									this.options['showPriceInButton']
								) {
									var addToCartHtml = ''
									addToCartHtml += '<div class="AddToCartPriceContentWrapper">'
									addToCartHtml += includeFrom
										? '	<span class="includeFrom">' +
										  window.languages.productFormAddToCart +
										  '</span>'
										: '	<span>' + window.languages.productFormAddToCart + '</span>'
									addToCartHtml +=
										'	<span data-money-convertible>' + this.options['isPair'] &&
										this.element.querySelector('[name="pair"]:checked + label') &&
										this.element.querySelector('[name="pair"]:checked + label').textContent ==
											'Matched Pair'
											? Currency.formatMoney(
													variantPrice * 2,
													window.theme.moneyWithCurrencyFormat,
											  )
											: Currency.formatMoney(
													variantPrice,
													window.theme.moneyWithCurrencyFormat,
											  ) + '</span>'
									addToCartHtml += '</div>'
									addToCartHtml += '<span class="ErrorTextMessage">' + ErrorTextMessage + '</span>'
									addToCartButtonEls.forEach((addToCartButton) => {
										addToCartButton.innerHTML = addToCartHtml
									})
								} else {
									var addToCartHtml = ''
									addToCartHtml += '<div class="AddToCartPriceContentWrapper AddToCartPriceContentWrapper__NoPrice">'
									addToCartHtml += '	<span class="ProductForm_label-atc">' + window.languages.productFormAddToCart + '</span>'
									addToCartHtml += '	<span class="ErrorTextMessage">' + ErrorTextMessage + '</span>'
									addToCartHtml += '</div>'
									addToCartButtonEls.forEach((addToCartButton) => {
										addToCartButton.innerHTML = addToCartHtml
									})

									var buttonNotifyMeHtml = ''
									buttonNotifyMeHtml += '<div class="AddToCartPriceContentWrapper AddToCartPriceContentWrapper__NoPrice">'
									buttonNotifyMeHtml += '	<span class="ProductForm_label-atc">' + 'Notify Me When Available' + '</span>'
									buttonNotifyMeHtml += '	<span class="ErrorTextMessage">' + ErrorTextMessage + '</span>'
									buttonNotifyMeHtml += '</div>'
									if (buttonNotify) {
										buttonNotify.classList.remove('klaviyo-bis-trigger')
										buttonNotify.innerHTML = buttonNotifyMeHtml
									}
								}
								if (findInStoreButton) {
									findInStoreButton.setAttribute('data-action', 'error-text')
								}
							} else if (newVariant['available'] && isPairSelected && (quantity > 1 || newVariant.inventory_policy === 'continue') || newVariant['available'] && !isPairSelected) {
								addToCartButtonEls.forEach((addToCartButton) => {
									addToCartButton.setAttribute('data-action', 'add-to-cart')
									addToCartButton.removeAttribute('disabled')
									addToCartButton.classList.remove('Button--light')
								})
								if(brauzFindInStoreButton) brauzFindInStoreButton.style.display = 'block'
								if(inventoryMessage) inventoryMessage.style.display = 'block'

								if (
									undefined === this.options['showPriceInButton'] ||
									this.options['showPriceInButton']
								) {
									var addToCartHtml = ''
									let customGiftAmountEl = document.querySelector('#gift-card-custom-amount')
									var customGiftAmount = null
									if(customGiftAmountEl?.getAttribute('data-input-active')) {
										customGiftAmount = customGiftAmountEl ? customGiftAmountEl.value * 100 : null
									}
									addToCartHtml += '<div class="AddToCartPriceContentWrapper">'
									addToCartHtml += includeFrom
										? '	<span class="includeFrom">' + window.languages.productFormAddToCart + '</span>'
										: '	<span>' + window.languages.productFormAddToCart + '</span>'
									addToCartHtml += '	<span class="ErrorTextMessage">' + ErrorTextMessage + '</span>'
									addToCartHtml +=
										'	<span data-money-convertible>' + this.options['isPair'] &&
										this.element.querySelector('[name="pair"]:checked + label') &&
										this.element.querySelector('[name="pair"]:checked + label').textContent ==
											'Matched Pair'
											? Currency.formatMoney(
													variantPrice * 2,
													window.theme.moneyWithCurrencyFormat,
												)
											: Currency.formatMoney(
													customGiftAmount ? customGiftAmount : variantPrice,
													window.theme.moneyWithCurrencyFormat,
												) + '</span>'
									addToCartHtml += '</div>'
									addToCartButtonEls.forEach((addToCartButton) => {
										addToCartButton.classList.remove('hidden')
										addToCartButton.innerHTML = addToCartHtml
									})
									if (buttonNotify) buttonNotify.classList.remove('active')
								} else {
									var addToCartHtml = ''
									addToCartHtml += '<div class="AddToCartPriceContentWrapper AddToCartPriceContentWrapper__NoPrice">'
									addToCartHtml += '	<span>' + window.languages.productFormAddToCart + '</span>'
									addToCartHtml += '	<span class="ErrorTextMessage">' + ErrorTextMessage + '</span>'
									addToCartHtml += '</div>'
									addToCartButtonEls.forEach((addToCartButton) => {
										addToCartButton.classList.remove('hidden')
										addToCartButton.innerHTML = addToCartHtml
									})
									if (buttonNotify) buttonNotify.classList.remove('active')
								}
								if (findInStoreButton) {
									Dom.nodeListToArray(
										this.element.querySelectorAll('[data-drawer-id="find-in-store-drawer"]'),
									).forEach(function (item, index) {
										item.setAttribute('data-action', 'toggle-drawer')
									})
								}
							} else {
								if(inventoryMessage) inventoryMessage.style.display = 'none'

								addToCartButtonEls.forEach((addToCartButton) => {
									const data = JSON.parse(document.querySelector('[data-product-json]').innerHTML)
									const isComingSoonProduct =
										addToCartButton.dataset.comingSoon === 'true' ||
										data?.product?.tags?.includes('coming-soon') ||
										!!document.querySelector('.ProductMeta__ComingSoonBadge')
									addToCartButton.setAttribute('disabled', 'disabled')
									addToCartButton.removeAttribute('data-action')
									addToCartButton.classList.add('hidden')
									addToCartButton.innerHTML = window.languages.productFormSoldOut


									if (isComingSoonProduct) {
										addToCartButton.innerHTML = 'Coming Soon'
										addToCartButton.classList.add('Button--light')

										if (inventoryMessage) {
											const nthNumber = (number) => {
												if (number > 3 && number < 21) return 'th'
												switch (number % 10) {
													case 1:
														return 'st'
													case 2:
														return 'nd'
													case 3:
														return 'rd'
													default:
														return 'th'
												}
											}

											const isFutureDate = (dateString) => {
												const today = new Date();
												today.setHours(0, 0, 0, 0);

												const inputDate = new Date(dateString);
												inputDate.setHours(0, 0, 0, 0);

												return inputDate > today;
											}

											const comingSoonDate = data?.coming_soon_date
											const comingSoonDateRaw = data?.coming_soon_date_raw

											if (comingSoonDate && isFutureDate(comingSoonDateRaw)) {
												inventoryMessage.innerHTML = `${MADE_SHIPPING_WORDING} ${comingSoonDate}${nthNumber(comingSoonDate.replace(/[^0-9.]/g, ''))}`
												inventoryMessage.style.display = 'block'

												const inventoryWrap = document.querySelector('.js-inventory-wrap')
												if (inventoryWrap) {
													inventoryWrap.style.display = 'block'
												}
											}
										}
									}
								})

								if(brauzFindInStoreButton) brauzFindInStoreButton.style.display = 'none'
								if (findInStoreButton) {
									Dom.nodeListToArray(
										this.element.querySelectorAll('[data-drawer-id="find-in-store-drawer"]'),
									).forEach(function (item, index) {
										item.setAttribute('data-action', 'toggle-drawer')
									})
								}
								if (buttonNotify) {
									buttonNotify.classList.add('klaviyo-bis-trigger')
									buttonNotify.classList.add('active')
									buttonNotify.setAttribute('data-action', 'notify-me')
								} else {
									addToCartButtonEls.forEach((addToCartButton) => {
										addToCartButton.classList.remove('hidden')
									})
								}
							}
						}
					}

					if (this.options['showPaymentButton'] && shopifyPaymentButton) {
						if (!newVariant || !newVariant['available']) {
							shopifyPaymentButton.style.display = 'none'
						} else {
							shopifyPaymentButton.style.display = 'block'
						}
					}

					let section = document.querySelector('[data-section-type="product"]');
					if (!section) { return }
					let sectionSettings = section.getAttribute('data-section-settings')
					if (!sectionSettings) { return }
					let settingsJson = JSON.parse(sectionSettings);
					if (settingsJson && settingsJson.isGiftCard) {
						document.dispatchEvent(new CustomEvent('giftcard:validate'))
					}

					const personaliseProduct = document.querySelector('[data-action="personalise-product"]')

					if (personaliseProduct) {
						if (personaliseProduct.classList.contains('close')) {
							const button = document.querySelector('[data-action="error-text"]')
							if (!button) {
								this.actionWishlist = true
								this._addToCart()
								this.actionWishlist = false
							}
						}
					} else {
						const buttonErrorAddToCart = document.querySelector('[data-action="error-text"]')
						const enquireDrawer = document.querySelector('[data-drawer-id="enquire-drawer"]')

						if (!buttonErrorAddToCart || enquireDrawer) {
							this.actionWishlist = true
							this._addToCart()
							this.actionWishlist = false
						}
					}
				},
				/**
				 * ---------------------------------------------------------------------------------------------------
				 * INTERNAL CODE THAT HANDLE VARIANT CHANGES
				 * ---------------------------------------------------------------------------------------------------
				 */

				/**
				 * Whenever an option is changed, this code fetch the corresponding active variant
				 */
			},
			{
				key: '_onOptionChanged',
				value: function _onOptionChanged(newValue, target, activator) {
					let customGiftAmountEl = document.querySelector('#gift-card-custom-amount')
					if (customGiftAmountEl) {
						if(!customGiftAmountEl?.getAttribute('data-input-active')) {
							customGiftAmountEl.value = null
							var customGiftAmount = null
						}
					}

					// We change the value associated with the activator, and check if we have a color swatch
					var _this = this
					if (target.closest('.ProductForm__Option--Cartilage')) {
						var isCartilageOption = true
					} else {
						var isCartilageOption = false
					}

					if (target.closest('.ProductForm__Option--Pendant')) {
						var isPendantOption = true
					} else {
						var isPendantOption = false
					}

					if (isPendantOption == false) {
						if (activator) {
							if (isCartilageOption) {
								this['cartilageOption' + target.getAttribute('data-option-position')] = newValue
							} else {
								this['option' + target.getAttribute('data-option-position')] = newValue
							}

							if (target.closest('.PairSelect')) {
								activator.querySelector('.ProductForm__SelectedValue').innerHTML =
									newValue == true ? 'Matched Pair' : 'Single'
							} else {
								activator.querySelector('.ProductForm__SelectedValue').innerHTML = newValue
							}
						} else {
							if (isCartilageOption) {
								this['cartilageOption' + target.getAttribute('data-option-position')] = target.value
							} else {
								this['option' + target.getAttribute('data-option-position')] = target.value
							}
							var selectedValue = target
								.closest('.ProductForm__Option')
								.querySelector('.ProductForm__SelectedValue')

							if (target.closest('.PairSelect')) {
								if (selectedValue) {
									selectedValue.innerHTML = target.value == 'true' ? 'Matched Pair' : 'Single'
								}
							} else {
								if (selectedValue) {
									selectedValue.innerHTML = target.value
								}
							}
						} // Finally, we get the new variant

						if (isCartilageOption) {
							var previousCartilageVariant = this.cartilageCurrentVariant
							this.cartilageCurrentVariant = this._getCurrentVariantFromOptions('cartilage')

							this._onVariantChanged(
								previousCartilageVariant,
								this.cartilageCurrentVariant,
								'cartilage',
							)

							if (this.cartilageCurrentVariant) {
								this.cartilageMasterSelector.querySelector('[selected]').removeAttribute('selected')
								this.cartilageMasterSelector
									.querySelector('[value="'.concat(this.cartilageCurrentVariant['id'], '"]'))
									.setAttribute('selected', 'selected')
								this.cartilageMasterSelector.dispatchEvent(
									new Event('change', {
										bubbles: true,
									}),
								)
							}
						} else {
							var previousVariant = this.currentVariant
							this.currentVariant = this._getCurrentVariantFromOptions()

							this._onVariantChanged(previousVariant, this.currentVariant)

							if (this.currentVariant) {
								if (this.options['enableHistoryState']) {
									this._updateHistoryState(this.currentVariant)
								} // We need to modify the hidden select that contain the id attribute as well

								this.masterSelector.querySelector('[selected]').removeAttribute('selected')
								this.masterSelector
									.querySelector('[value="'.concat(this.currentVariant['id'], '"]'))
									.setAttribute('selected', 'selected')
								this.masterSelector.dispatchEvent(
									new Event('change', {
										bubbles: true,
									}),
								)
							}
						}
					} else {
						if (target.name == 'option-pendants') {
							const pendantValueArray = this.pendantValueArray || []

							if (activator) {
								activator.querySelector('.ProductForm__SelectedValue').innerHTML = newValue
								this.pendantCount = Number(newValue)
								this.pendant_Multi_Option3 = newValue
							} else {
								var selectedValue = target
									.closest('.ProductForm__Option')
									.querySelector('.ProductForm__SelectedValue')
								if (selectedValue) {
									selectedValue.innerHTML = target.value
									this.pendantCount = Number(target.value)
									this.pendant_Multi_Option3 = target.value
								}
							}

							Dom.nodeListToArray(this.element.querySelectorAll('.PendantInputSelector')).forEach(function (
								item
							) {
								item.classList.add('Active')
							})

							Dom.nodeListToArray(this.element.querySelectorAll('.PendantInput')).forEach(function (
								item,
								index,
							) {
								if (index + 1 <= _this.pendantCount) {
									item.style.display = 'block'
								} else {
									item.style.display = 'none'
									item.innerHTML = ''
								}
							})

							if (this.pendantCount < this.pendantInputPosition - 1) {
								this.pendantInputPosition = this.pendantCount + 1
								pendantValueArray.splice(
									this.pendantCount,
									pendantValueArray.length - this.pendantCount,
								)
								this.pendantValueArray = pendantValueArray
							}

							var productFormInventory = this.element.querySelector('.ProductForm__Inventory')

							if (this.pendantCount > 1) {
								var variantInventory =
									this.pendant_Multi_VariantsInventories[
										Object.keys(this.pendant_Multi_VariantsInventories)[0]
									]
								
								if (productFormInventory) {
									productFormInventory.innerHTML = variantInventory['inventory_message']
								}

								var previousVariant = this.pendant_Multi_CurrentVariant
								this.pendant_Multi_CurrentVariant = this._getCurrentVariantFromOptions('pendant')
								this._onVariantChanged(
									previousVariant,
									this.pendant_Multi_CurrentVariant,
									'pendant',
								)
							} else {
								var previousVariant = this.pendant_Single_CurrentVariant
								this.pendant_Single_CurrentVariant = this._getCurrentVariantFromOptions('pendant')
								this._onVariantChanged(
									previousVariant,
									this.pendant_Single_CurrentVariant,
									'pendant',
								)

								if (this.pendantInputPosition > this.pendantCount) {
									this._updateInventory(
										this.pendant_Single_CurrentVariant,
										previousVariant,
										'pendant',
									)
								} else {
									if (productFormInventory) {
										productFormInventory.innerHTML = ''
									}
								}
							}
						} else if (target.closest('.PendantInputSelector')) {
							if (this.pendantInputPosition <= this.pendantCount) {
								if (activator) {
									if (
										target.closest('.PendantInputSelector').getAttribute('data-swatch-mode') ==
										'image'
									) {
										this.element.querySelector(
											'.PendantInput__' + this.pendantInputPosition,
										).innerHTML =
											'<img src="' +
											target.getAttribute('data-swatch') +
											'" class="PendantImage"/>'
									} else {
										const valueText = newValue.replace('Letter ', '')
										if (value.toLowerCase() === 'heart') {
											const label = target.parentNode.querySelector('label')
											valueText = label.innerHTML
										}
										this.element.querySelector(
											'.PendantInput__' + this.pendantInputPosition,
										).innerHTML = valueText
									}
								} else {
									if (
										target.closest('.PendantInputSelector').getAttribute('data-swatch-mode') ==
										'image'
									) {
										this.element.querySelector(
											'.PendantInput__' + this.pendantInputPosition,
										).innerHTML =
											'<img src="' +
											target.getAttribute('data-swatch') +
											'" class="PendantImage"/>'
									} else {
										let valueText = target.value.replace('Letter ', '')
										if (valueText.toLowerCase() === 'heart') {
											const label = target.parentNode.querySelector('label')
											valueText = label.innerHTML
										}
										this.element.querySelector(
											'.PendantInput__' + this.pendantInputPosition,
										).innerHTML = valueText
									}
								}

								this.pendantInputPosition += 1

								if (this.pendantInputPosition == 1) {
									this.element.querySelector('.PendantRemove').style.display = 'none'
								} else {
									this.element.querySelector('.PendantRemove').style.display = 'block'
								}

								if (this.pendantCount == 1) {
									if (activator) {
										this['pendant_Single_Option' + target.getAttribute('data-option-position')] =
											newValue
									} else {
										this['pendant_Single_Option' + target.getAttribute('data-option-position')] =
											target.value
									}

									var productFormInventory = this.element.querySelector('.ProductForm__Inventory')
									if (this.pendantInputPosition > this.pendantCount) {
										var previousVariant = this.pendant_Single_CurrentVariant
										this.pendant_Single_CurrentVariant =
											this._getCurrentVariantFromOptions('pendant')
										this._onVariantChanged(
											previousVariant,
											this.pendant_Single_CurrentVariant,
											'pendant',
										)
										this._updateInventory(
											this.pendant_Single_CurrentVariant,
											previousVariant,
											'pendant',
										)
									} else {
										if (productFormInventory) {
											productFormInventory.innerHTML = ''
										}
									}
								} else {
									if (this.pendantInputPosition == 2) {
										if (activator) {
											this['pendant_Single_Option' + target.getAttribute('data-option-position')] =
												newValue
										} else {
											this['pendant_Single_Option' + target.getAttribute('data-option-position')] =
												target.value
										}
									}

									var productFormInventory = this.element.querySelector('.ProductForm__Inventory')

									if (this.pendantInputPosition > this.pendantCount) {
										var previousVariant = this.pendant_Multi_CurrentVariant
										this.pendant_Multi_CurrentVariant =
											this._getCurrentVariantFromOptions('pendant')
										this._onVariantChanged(
											previousVariant,
											this.pendant_Multi_CurrentVariant,
											'pendant',
										)
									}
								}
							}
						} else {
							if (activator) {
								activator.querySelector('.ProductForm__SelectedValue').innerHTML = newValue
								this['pendant_Single_Option' + target.getAttribute('data-option-position')] =
									newValue
								this['pendant_Multi_Option2'] = newValue
							} else {
								this['pendant_Single_Option' + target.getAttribute('data-option-position')] =
									target.value
								this['pendant_Multi_Option2'] = target.value
								var selectedValue = target
									.closest('.ProductForm__Option')
									.querySelector('.ProductForm__SelectedValue')

								if (selectedValue) {
									selectedValue.innerHTML = target.value
								}
							}

							var productFormInventory = this.element.querySelector('.ProductForm__Inventory')

							if (this.pendantCount > 1) {
								var previousVariant = this.pendant_Multi_CurrentVariant
								this.pendant_Multi_CurrentVariant = this._getCurrentVariantFromOptions('pendant')
								this._onVariantChanged(
									previousVariant,
									this.pendant_Multi_CurrentVariant,
									'pendant',
								)
							} else {
								if (this.pendantInputPosition > this.pendantCount) {
									var previousVariant = this.pendant_Single_CurrentVariant
									this.pendant_Single_CurrentVariant = this._getCurrentVariantFromOptions('pendant')
									this._onVariantChanged(
										previousVariant,
										this.pendant_Single_CurrentVariant,
										'pendant',
									)
									this._updateInventory(
										this.pendant_Single_CurrentVariant,
										previousVariant,
										'pendant',
									)
								} else {
									if (productFormInventory) {
										productFormInventory.innerHTML = ''
									}
								}
							}
						}
					}
				},
				/**
				 * Get the active variant based on the options
				 */
			},
			{
				key: '_setNextSelectedValue',
				value: function _setNextSelectedValue(mode) {
					var _this = this
					Dom.nodeListToArray(this.element.querySelectorAll('.ProductForm__SelectedValue:not(.isOptional)')).every(
						function (selectedValue, index) {
							if (mode == 'pendant') {
								if (selectedValue.closest('.PendantInputSelector')) {
									if (_this.pendantSelected.length >= _this.pendantMin) {
										return true
									} else {
										_this.allOptionsSet = false
										_this.nextselectedValue = selectedValue
										return false
									}
								} else if (selectedValue.innerHTML.length == 0) {
									_this.allOptionsSet = false
									_this.nextselectedValue = selectedValue
									return false
								} else {
									return true
								}
							} else {
								if (selectedValue.innerHTML.length == 0) {
									_this.allOptionsSet = false
									_this.nextselectedValue = selectedValue
									return false
								} else {
									return true
								}
							}
						},
					)
				},
			},
			{
				key: '_showErrorText',
				value: function _showErrorText(event) {
					event.preventDefault() // Prevent form to be submitted

					var _this = this

					if (this.nextselectedValue) {
						var _nextselectedValue = this.nextselectedValue.parentElement

						// if (!this.optionSelectorExpanded) {
						// 	this._expandOptionSelector()
						// }

						this.nextselectedValue.parentElement.classList.add('ErrorText')
						if (this.nextselectedValue.parentElement.getAttribute('aria-expanded') == 'false') {
							this.nextselectedValue.parentElement.click()
						}

						setTimeout(function () {
							_nextselectedValue.classList.remove('ErrorText')
						}, 1500)
					}
				},
			},
			{
				key: '_showNoticeError',
				value: function _showNoticeError() {
					var _this = this

					if (this.nextselectedValue) {
						var ErrorTextMessage =
							this.nextselectedValue && this.nextselectedValue.parentElement
								? this.nextselectedValue.parentElement.textContent.replace(':', '').replace('Choose', '').replace('Select', '').trim().toLowerCase()
								: ''

						var _nextselectedValue = this.nextselectedValue.parentElement
						this.nextselectedValue.parentElement.classList.add('ErrorTextWishlist')

						const noticeErrorWishlist = document.querySelector('.NoticeErrorWishlist')
						if (!noticeErrorWishlist) {
							const noticeEl = `<div class="NoticeErrorWishlist input-error">Please select a ${ErrorTextMessage} before adding to wishlist</div>`

							if (this.nextselectedValue?.parentElement?.parentElement) {
								this.nextselectedValue?.parentElement?.parentElement.insertAdjacentHTML('afterend', noticeEl);
							}

							setTimeout(() => {
								const newNotice = document.querySelector('.NoticeErrorWishlist')
								if (newNotice) {
									newNotice.remove()
								}
								_nextselectedValue.classList.remove('ErrorTextWishlist')
							}, 1500)
						}
					}
				},
			},
			{
				key: '_expandOptionSelector',
				value: function _expandOptionSelector() {
					var _this = this

					const scrollingOptions = document.querySelector(".MobileAddToCart > .Container")
					scrollingOptions.classList.add("container-scroll")

					const isGiftCard = document.querySelectorAll('[data-is-gift-card="true"]')
					const radioSelector = isGiftCard ? '.SizeSwatchList [type="radio"]' : '[type="radio"]'
					document.querySelectorAll(radioSelector).forEach(optionEl => optionEl.checked = false)

					this.optionSelectorExpanded = true

					window.scrollTo({
						top: 0,
						behavior: 'smooth',
					})

					if (
						this.element.querySelector('.optionsSelectExpander-1') &&
						this.element.querySelector('.optionsSelectExpander-2')
					) {
						gsap
							.timeline()
							.to('.optionsSelectExpander-1', 0.2, {
								right: '30px',
								onComplete: function () {
									this._targets[0].classList.add('Active')
								},
							})
							.to(
								'.optionsSelectExpander-2',
								0.2,
								{
									right: '30px',
								},
								'<',
							)
							.to('.optionsSelectExpander-1', 0.2, {
								rotation: '45',
							})
							.to(
								'.optionsSelectExpander-2',
								0.2,
								{
									rotation: '-45',
								},
								'<',
							)
					}

					if (
						this.options['isPendantBuilder'] ||
						this.options['isEngraved'] ||
						this.options['isGiftCard'] ||
						cartilageProductHasOptions
					) {
						this.element.querySelector('.MobileAddToCart').classList.add('Active')
					}

					this.expandTimeline = gsap
						.timeline()
						.to(this.element.querySelectorAll('.HiddenOptionWrapper'), {
							height: 'auto',
						})

					if (this.options['isPendantBuilder'] || this.options['isEngraved']) {
						this.expandTimeline.to(
							'.MobileAddToCart',
							{
								height: window.innerHeight + 'px',
							},
							'<',
						)
					}

					this.expandTimeline
						.fromTo(
							this.element.querySelectorAll('.ProductForm__SelectOptions'),
							{
								autoAlpha: 1,
							},
							{
								autoAlpha: 0,
							},
							'<',
						)
						.fromTo(
							this.element.querySelectorAll('.HiddenOptionWrapper'),
							{
								autoAlpha: 0,
							},
							{
								autoAlpha: 1,
							},
						)
				},
			},
			{
				key: '_closeOptionSelector',
				value: function _closeOptionSelector() {
					var _this = this

					// removes scroll lock on close of product options
					document.body.classList.remove("no-scroll");
					const scrollingOptions = document.querySelector(".MobileAddToCart > .Container")
					scrollingOptions.classList.remove("container-scroll")

					this.optionSelectorExpanded = false

					if (
						this.element.querySelector('.optionsSelectExpander-1') &&
						this.element.querySelector('.optionsSelectExpander-2')
					) {
						gsap
							.timeline()
							.to('.optionsSelectExpander-1', 0.2, {
								rotation: '0',
							})
							.to(
								'.optionsSelectExpander-2',
								0.2,
								{
									rotation: '0',
								},
								'<',
							)
							.to('.optionsSelectExpander-1', 0.2, {
								right: '50%',
								onComplete: function () {
									this._targets[0].classList.remove('Active')
								},
							})
							.to(
								'.optionsSelectExpander-2',
								0.2,
								{
									right: '50%',
								},
								'<',
							)
					}

					this.collapseTimeline = gsap
						.timeline()
						.fromTo(
							this.element.querySelector('.HiddenOptionWrapper'),
							{
								autoAlpha: 1,
							},
							{
								autoAlpha: 0,
							},
						)
						.to(this.element.querySelector('.HiddenOptionWrapper'), {
							height: '0',
						})

					if (this.options['isPendantBuilder'] || this.options['isEngraved']) {
						this.collapseTimeline.to(
							this.element.querySelector('.MobileAddToCart'),
							{
								height: this.mobileAddToCartHeight,
							},
							'<',
						)
					}

					this.collapseTimeline.fromTo(
						this.element.querySelector('.ProductForm__SelectOptions'),
						{
							autoAlpha: 0,
						},
						{
							autoAlpha: 1,
							onComplete: function () {
								if (
									_this.options['isPendantBuilder'] ||
									_this.options['isEngraved'] ||
									_this.options['isGiftCard'] ||
									cartilageProductHasOptions
								) {
									if (this._targets[0]?.closest('.MobileAddToCart')) {
										this._targets[0].closest('.MobileAddToCart').classList.remove('Active')
									}
								}
							},
						},
						'<',
					)
				},
			},
			{
				key: '_getCurrentVariantFromOptions',
				value: function _getCurrentVariantFromOptions(mode) {
					var _this3 = this

					var found = false

					if (mode == 'cartilage') {
						this.cartilageProductData['variants'].forEach(function (variant) {
							if (
								variant['option1'] === _this3.cartilageOption1 &&
								variant['option2'] === _this3.cartilageOption2 &&
								variant['option3'] === _this3.cartilageOption3
							) {
								found = variant
							}
						})
					} else if (mode == 'pendant') {
						if (this.pendantMin == 1) {
							this.pendant_Single_ProductData['variants'].forEach(function (variant) {
								if (
									variant['option1'] === _this3.pendant_Single_Option1 &&
									variant['option2'] === _this3.pendant_Single_Option2 &&
									variant['option3'] === _this3.pendant_Single_Option3
								) {
									found = variant
								}
							})

							if (this.options['isMultiplePendant']) {
								var jsonDataPendant_Single = JSON.parse(
									this.element.querySelector('[data-product-core-single-stone-json]').innerHTML,
								)
								jsonDataPendant_Single['product']['variants'].forEach(function (variant) {
									if (
										variant['option1'] === _this3.pendant_Single_Option1 &&
										variant['option2'] === _this3.pendant_Single_Option2 &&
										variant['option3'] === _this3.pendant_Single_Option3
									) {
										found = variant
									}
								})
							}
						} else {
							this.pendant_Multi_ProductData['variants'].forEach(function (variant) {
								if (
									variant['option1'] === _this3.pendant_Multi_Option1 &&
									variant['option2'] === _this3.pendant_Multi_Option2 &&
									variant['option3'] === _this3.pendant_Multi_Option3
								) {
									found = variant
								}
							})
						}
					} else {
						this.productData['variants'].forEach(function (variant) {
							if (
								variant['option1'] === _this3.option1 &&
								variant['option2'] === _this3.option2 &&
								variant['option3'] === _this3.option3
							) {
								found = variant
							}
						})
					}

					return found || null
				},
				/**
				 * Update the history state for browsers that support it
				 */
			},
			{
				key: '_updateHistoryState',
				value: function _updateHistoryState(variant) {
					if (!history.replaceState) {
						return
					}

					var newUrl = ''
						.concat(window.location.protocol, '//')
						.concat(window.location.host)
						.concat(window.location.pathname, '?variant=')
						.concat(variant.id)
					window.history.replaceState(
						{
							path: newUrl,
						},
						'',
						newUrl,
					)
				},
				/**
				 * ---------------------------------------------------------------------------------------------------
				 * INTERNAL CODE THAT HANDLE PRODUCT ADD TO CART
				 * ---------------------------------------------------------------------------------------------------
				 */
			},
			{
				key: '_addToWishlist',
				value: function _addToWishlist(event) {
					event.preventDefault()
					const button = document.querySelector('[data-action="add-to-cart"]')
					if (button) {
						this.actionWishlist = true
						this._addToCart()
						this.actionWishlist = false
					}
				}
			},
			{
				key: '_addToCart',
				value: function _addToCart(event) {
					var _this4 = this
					this.addQueue = []

					if (this.options['isGiftCard']) {
						document.dispatchEvent(new CustomEvent('giftcard:validate'))
						// check if theres a custom amount otherwise set gift card custom amount to variant amount
						let value = 0
						const customAmountInput = document.getElementById("gift-card-custom-amount")
						if (customAmountInput && (customAmountInput.value !== '' && customAmountInput.value !== null && customAmountInput.value !== 0 )) {
							value = customAmountInput.value
						} else {
							let productVariantsRadios = document.querySelectorAll('ul.SizeSwatchList .HorizontalList__Item')
							for (const VariantRadio of productVariantsRadios) {
								let radioEl = VariantRadio.querySelector('.SizeSwatch__Radio')
								if (radioEl && radioEl.checked) {
									value = radioEl.value.replace('$','').replace('.00', '')
								}
							}
						}
						let giftCardCustomAmountValue = document.querySelector('#giftcard-valid-custom-amount')
						if (giftCardCustomAmountValue) {
							giftCardCustomAmountValue.value = value
							giftCardCustomAmountValue.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }))
						}

            if (document.querySelector('#type-physical')?.checked) {
							const checksumEl = document.querySelector('input[name="properties[_gcp_checksum]"]')
							checksumEl && checksumEl.remove()
						}
					}

					let invalidForm = false
					const addToCartButtons = document.querySelectorAll('.ProductForm__AddToCart')
					addToCartButtons.forEach((button) => {
						if (button.getAttribute('gift-card-disabled')) {
							invalidForm = true
						}
					})
					if (invalidForm) {
						document.dispatchEvent(new CustomEvent('giftcard:error'))
						return
					}

					if (!this.options['useAjaxCart']) {
						return // When using a cart type of page, we just simply redirect to the cart page
					}

					event?.preventDefault() // Prevent form to be submitted
					this.addToCartButtonEls = this.element.querySelectorAll('.ProductForm__AddToCart[data-action="add-to-cart"]')
					if (this.addToCartButtonEls.length > 0 && event && !event?.target?.parentElement?.classList.contains('js-button-wishlist-product') && !event?.target?.classList.contains('js-button-wishlist-product') && !event?.target?.classList.contains('SizeSwatch__Radio') && !event?.target?.classList.contains('SizeSwatch') && !event?.target?.classList.contains('engravingRadio') && !event?.target?.classList.contains('Form__Input')) {
						this.addToCartButtonEls.forEach((addToCartButton) => {
							addToCartButton.setAttribute('disabled', 'disabled')
							addToCartButton.classList.add('AddingToCart')
							addToCartButton.innerHTML = '•••'
						});
					}

					document.dispatchEvent(new CustomEvent('theme:loading:start')) // Then we add the product in Ajax
					var formElement = this.element.querySelector('form[action*="/cart/add"]')
					var formJSON = Form.serialize(formElement)
					if (!formJSON.id || formJSON.id.toString() !== this.currentVariant.id.toString()) {
						formJSON.id = this.currentVariant.id.toString()
					}
					var properties = {}

					if (this.element.querySelector('#Front-Image')) {
						properties['Front-Image'] = this.element.querySelector('#Front-Image').value
					}

					if (this.element.querySelector('#Back-Image')) {
						properties['Back-Image'] = this.element.querySelector('#Back-Image').value
					}

					if (
						this.options['isPair'] &&
						this.element.querySelector('[name="pair"]:checked + label') &&
						this.element.querySelector('[name="pair"]:checked + label').textContent ==
							'Matched Pair'
					) {
						formJSON['quantity'] = 2
						properties['pairId'] = Date.now()
						properties['pairType'] = 'Same'
					} else if (this.cartilageProductData) {
						if (
							this.cartilageCurrentVariant.inventory_quantity >
								this.options['stock_status_threshold'] &&
							this.currentVariant.inventory_quantity > this.options['stock_status_threshold']
						) {
							var stockStatus = 'ReadyToShip'
						} else {
							var stockStatus = 'MadeToOrder'
						}
						properties['_uniqueTimeStamp'] = Date.now()
						properties['CartilageComponent'] = 'Pendant'
						properties['StockStatus'] = stockStatus
						properties['Post Length'] = this.cartilageCurrentVariant.option2
						cartilageProductHasOptions = true
						var backingProperties = {
							CartilageComponent: 'Backing',
							CartilageId: this.productData.id,
							_uniqueTimeStamp: properties._uniqueTimeStamp,
							StockStatus: stockStatus,
						}
					} else if (this.options['isPendantBuilder']) {
						if (this.pendantMin == 1) {
							formJSON['id'] = this.pendant_Single_CurrentVariant.id
							formJSON['quantity'] = 1
							properties['_uniqueTimeStamp'] = Date.now()
						} else {
							var parentProperties = {
								_uniqueTimeStamp: Date.now(),
							}

							parentProperties[this.options['pendantType']] = this.pendantValueArray.join(', ')

							var pendantProperties = {
								Necklace: this.pendant_Multi_CurrentVariant.title,
								NecklaceId: this.pendant_Multi_CurrentVariant.id,
								_uniqueTimeStamp: parentProperties._uniqueTimeStamp,
							}

							formJSON['id'] = this.pendant_Multi_CurrentVariant.id
							formJSON['quantity'] = 1
							properties = parentProperties
							for (let i = 0; i < this.pendantValueArray.length; i++) {
								var jsonDataPendant = JSON.parse(
									this.element.querySelector('[data-product-pendant-' + (i + 1) + '-json]')
										.innerHTML
								)

								jsonDataPendant.product['variants'].forEach(function (variant) {
									if (
										variant['option1'] === _this4.pendantValueArray[i] ||
										variant['option2'] === _this4.pendantValueArray[i] ||
										variant['option3'] === _this4.pendantValueArray[i]
									) {
										_this4.addQueue.push({
											form_type: 'product',
											properties: pendantProperties,
											quantity: 1,
											id: variant.id,
											utf8: '✓',
										})
									}
								})

								if (this.options['isMultiplePendant']) {
									var jsonDataPendant = JSON.parse(
										this.element.querySelector('[data-product-pendant-stone-' + (i + 1) + '-json]')
											.innerHTML
									)

									jsonDataPendant.product['variants'].forEach(function (variant) {
										if (
											variant['option1'] === _this4.pendantValueArray[i] ||
											variant['option2'] === _this4.pendantValueArray[i] ||
											variant['option3'] === _this4.pendantValueArray[i]
										) {
											_this4.addQueue.push({
												form_type: 'product',
												properties: pendantProperties,
												quantity: 1,
												id: variant.id,
												utf8: '✓',
											})
										}
									})
								}
							}
							this.addQueue.reverse()
						}
					} else if (formElement.querySelectorAll('.PersonalisedFields').length) {
						var isPersonalised = false

						Dom.nodeListToArray(
							this.element.querySelectorAll('.PersonalisedFields input[type="text"]'),
						).forEach(function (item) {
							if (item.value.length) {
								var propertyName = item.getAttribute('aria-label')
								properties[propertyName] = item.value
								isPersonalised = true
							}
						})

						if (isPersonalised) {
							Dom.nodeListToArray(
								this.element.querySelectorAll('.PersonalisedFields input[type="radio"]:checked'),
							).forEach(function (item) {
								if (item.value.length) {
									var propertyName = item.getAttribute('aria-label')
									properties[propertyName] = item.value
									isPersonalised = true
								}
							})

							properties['_uniqueTimeStamp'] = Date.now()
							properties['_addOnParent'] = true
							properties['_EstimatedDispatch'] = window.dispatchDate
						} else {
							properties = {}
						}

						var personalisedConfig = JSON.parse(
							this.element
								.querySelector('.PersonalisedWrapper')
								.getAttribute('data-personalised-config'),
						)

						if (personalisedConfig.billingProduct && isPersonalised) {
							var engravingProps = {
								_uniqueTimeStamp: properties._uniqueTimeStamp,
								_engravedProduct: properties._uniqueTimeStamp,
							}

							this.addQueue.push({
								id: personalisedConfig.billingProduct.variants[0].id,
								properties: engravingProps,
								form_type: 'product',
								utf8: '✓',
							})
						}

						formJSON['quantity'] = 1
					} else {
						formJSON['quantity'] = 1
					}

					const productJson = document.querySelector('[data-product-json]')?.innerHTML
					const currentProduct = JSON.parse(document.querySelector('[data-product-json]').innerHTML ?? '{}')?.product
					if (currentProduct?.tags.includes('Production Type_Bespoke') && (properties['Letters'] || properties['Stones'])) {
						properties['Bespoke Item'] = 'Cannot be returned for change of mind'
					}

          formJSON['properties'] = {
            ...formJSON['properties'],
            ...properties
          };

					if (this.cartilageProductData) {
						delete formJSON.cartilageId

						this.addQueue.push(formJSON)

						var backingFormJson = {
							form_type: 'product',
							properties: backingProperties,
							id: this.cartilageCurrentVariant.id,
							utf8: '✓',
						}

						this.addQueue.push(backingFormJson)

						this._addAlong()
					} else {
						this.addQueue.push(formJSON)
						this._addAlong()
					}
				},
			},
			{
				key: '_getGiftCardVariant',
				value: function _getGiftCardVariant(type) {
					let currentProduct = JSON.parse(document.querySelector('[data-product-json]').innerHTML).product
					let giftcardProduct
					let currentGiftcardProductVariants
					if (type === 'Digital') {
						giftcardProduct = JSON.parse(document.querySelector('[data-giftcard-product-json]').innerHTML)
						currentGiftcardProductVariants = giftcardProduct.variants.filter(item => item.option2.includes(currentProduct.title))
					} else { // physical cards
						giftcardProduct = JSON.parse(document.querySelector('[data-alt-giftcard-product-json]').innerHTML)
						currentGiftcardProductVariants = giftcardProduct.variants.filter(item => true)
					}

					// this will fiter out to only show variants with the same type as the current product page.
					let productVariantsRadios = document.querySelectorAll('ul.SizeSwatchList .HorizontalList__Item .SizeSwatch__Radio')
					if (!productVariantsRadios) {
						return
					}
					let selectedAmount
					for (const VariantRadio of productVariantsRadios) {
						if (VariantRadio.checked) {
							selectedAmount  = VariantRadio.value
						}
					}
					currentGiftcardProductVariants = currentGiftcardProductVariants.filter(item => item.option1 === selectedAmount)
					if (currentGiftcardProductVariants.length > 0) {
						return currentGiftcardProductVariants[0]
					}
					return null
				},
			},
			{
				key: '_addAlong',
				value: function _addAlong() {
					var _this = this

					if (this.actionWishlist) {
						this.actionWishlist = false

						if (customElements.get('wishlist-button')) {
							const event = new CustomEvent('product:addToWishlist', {
								bubbles: true,
								detail: {
									addQueue: this.addQueue
								},
							})
							document.dispatchEvent(event)
						} else {
							customElements.whenDefined('wishlist-button').then(() => {
								setTimeout(() => {
									const event = new CustomEvent('product:addToWishlist', {
										bubbles: true,
										detail: {
											addQueue: this.addQueue
										},
									})
									document.dispatchEvent(event)
								}, 500)
							})
						}
						return
					}
					var request = {
						items: this.addQueue,
					}

					if (request.items[0]['gift-card']) {
						let giftcardType = request.items[0]['gift-card'].type

						let giftcard = this._getGiftCardVariant(giftcardType)
						if (giftcard) {
							// console.warn('this is the gift card we have found: ', giftcard, giftcard.id, giftcard.option1, giftcard.option2)
							request.items[0].id = giftcard.id
              // BUG: here the type is coming up as null. Is the option 2 set as its meant to be like we had in DEV?
							// request.items[0].properties['Giftcard Type'] = giftcard.option2
							if (giftcardType === 'Physical') {
                // console.warn('no longer deleing this message property if its physical...')
								// delete request.items[0].properties['Message']
                request.items[0].properties['Giftcard Type'] = 'Physical'
								const isThisGiftCheckbox = document.getElementById("gift_option")
								isThisGiftCheckbox.checked = false
								isThisGiftCheckbox.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }))
							} else {
                request.items[0].properties['Giftcard Type'] = giftcard.option2
              }
						} else {
							console.error('gift card not found', giftcard)
						}

						// Unsure why this is not updated in gcf-custom-fields.liquid so manually attaching for request.
						// Ideally this will happen before or at the add to cart event so that we dont have to edit
						// the request information here
						if (window.giftcard && window.giftcard.templateID) {
							request.items[0].properties['_template'] = window.giftcard.templateID
							let templateID = document.querySelector('#template_id')
							if (templateID) {
								templateID.value = window.giftcard.templateID
								templateID.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }))
							} else {
								console.warn('The template input was not found. Checksum isnt updated with Klaviyo information')
							}
							let checksum = document.querySelector('input[name="properties[_gcp_checksum]"]')
							if (checksum) {
								let checksumVal = checksum.value
								request.items[0].properties['_gcp_checksum'] = checksumVal
							}
						}
					}

          let checksum = request.items[0].properties['_gcp_checksum']
          if(checksum) {
            let info = JSON.parse( atob(checksum) )
            let message = info['message']
            if (message) {
              request.items[0].properties['Message'] = message
            }
          }
					if (request) {
						fetch(''.concat(window.routes.cartAddUrl, '.js'), {
							body: JSON.stringify(request),
							credentials: 'same-origin',
							method: 'POST',
							headers: {
								'Content-Type': 'application/json',
								'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
							},
						}).then(function (response) {
							if (response.ok) {
								// _this.addToCartButton.removeAttribute('disabled') // We simply trigger an event so the mini-cart can re-render
								if (_this.addToCartButtonEls.length > 0) {
									_this.addToCartButtonEls.forEach((addToCartButton) => {
										addToCartButton.classList.remove('AddingToCart')
										addToCartButton.classList.add('AddedToCart')
										addToCartButton.innerHTML = 'Added To bag'
									})
								}
								_this._closeOptionSelector()
								let customGiftAmount = null
								let customGiftAmountEl = document.querySelector('#gift-card-custom-amount')
								if(customGiftAmountEl?.getAttribute('data-input-active')) {
									customGiftAmount = customGiftAmountEl ? customGiftAmountEl.value * 100 : null
								}

								setTimeout(function () {
									if (
										undefined === _this.options['showPriceInButton'] ||
										_this.options['showPriceInButton']
									) {
										var addToCartHtml = ''
										addToCartHtml += '<div class="AddToCartPriceContentWrapper">'
										addToCartHtml += '	<span>' + window.languages.productFormAddToCart + '</span>'
										addToCartHtml +=
											'	<span data-money-convertible>' + _this.options['isPair'] &&
											_this.element.querySelector('[name="pair"]:checked + label') &&
											_this.element.querySelector('[name="pair"]:checked + label').textContent ==
												'Matched Pair'
												? Currency.formatMoney(
														_this.currentVariantPrice * 2,
														window.theme.moneyWithCurrencyFormat,
												  )
												: Currency.formatMoney(
														customGiftAmount ? customGiftAmount : _this.currentVariantPrice,
														window.theme.moneyWithCurrencyFormat,
												  ) + '</span>'
										addToCartHtml += '</div>'
										addToCartHtml += '<span class="ErrorTextMessage"></span>'
										if (_this.addToCartButtonEls.length > 0) {
											_this.addToCartButtonEls.forEach((addToCartButton) => {
												addToCartButton.innerHTML = addToCartHtml
											})
										}
									} else {
										var addToCartHtml = ''
										addToCartHtml += '<div class="AddToCartPriceContentWrapper AddToCartPriceContentWrapper__NoPrice">'
										addToCartHtml += '	<span>' + window.languages.productFormAddToCart + '</span>'
										addToCartHtml += '</div>'
										addToCartHtml += '<span class="ErrorTextMessage"></span>'
										if (_this.addToCartButtonEls.length > 0) {
											_this.addToCartButtonEls.forEach((addToCartButton) => {
												addToCartButton.innerHTML = addToCartHtml
											})
										}
									}
									if (_this.addToCartButtonEls.length > 0) {
										_this.addToCartButtonEls.forEach((addToCartButton) => {
											addToCartButton.classList.remove('AddedToCart')
											addToCartButton.removeAttribute('disabled')
										})
									}
								}, 1500)

								if (_this.options['isPendantBuilder']) {
									if (_this.pendantCount == 1) {
										_this.element.dispatchEvent(
											new CustomEvent('product:added', {
												bubbles: true,
												detail: {
													variant: _this.pendant_Single_CurrentVariant,
													quantity: 1,
													pair: false,
												},
											}),
										)
									} else {
										_this.element.dispatchEvent(
											new CustomEvent('product:added', {
												bubbles: true,
												detail: {
													variant: _this.pendant_Multi_CurrentVariant,
													quantity: 1,
													pair: false,
												},
											}),
										)
									}
								} else {
									_this.element.dispatchEvent(
										new CustomEvent('product:added', {
											bubbles: true,
											detail: {
												customGiftAmount: customGiftAmount ? customGiftAmountEl.value : null, // dont want to pass in the cents amount so just pass the vaild custom amount
												variant: _this.currentVariant,
												quantity:
													_this.options['isPair'] &&
													_this.element.querySelector('[name="pair"]:checked + label') &&
													_this.element.querySelector('[name="pair"]:checked + label')
														.textContent == 'Matched Pair'
														? 2
														: 1,
												pair:
													_this.options['isPair'] &&
													_this.element.querySelector('[name="pair"]:checked + label') &&
													_this.element.querySelector('[name="pair"]:checked + label')
														.textContent == 'Matched Pair'
														? true
														: false,
											},
										}),
									)
								}
								document.dispatchEvent(new CustomEvent('theme:loading:end'))
							} else {
								response.json().then(function (content) {
									setTimeout(function () {
										if (
											undefined === _this.options['showPriceInButton'] ||
											_this.options['showPriceInButton']
										) {
											var addToCartHtml = ''
											addToCartHtml += '<div class="AddToCartPriceContentWrapper">'
											addToCartHtml += '	<span>' + window.languages.productFormAddToCart + '</span>'
											addToCartHtml +=
												'	<span data-money-convertible>' + _this.options['isPair'] &&
												_this.element.querySelector('[name="pair"]:checked + label') &&
												_this.element.querySelector('[name="pair"]:checked + label').textContent ==
													'Matched Pair'
													? Currency.formatMoney(
															_this.currentVariantPrice * 2,
															window.theme.moneyWithCurrencyFormat,
														)
													: Currency.formatMoney(
															customGiftAmount ? customGiftAmount : _this.currentVariantPrice,
															window.theme.moneyWithCurrencyFormat,
														) + '</span>'
											addToCartHtml += '</div>'
											addToCartHtml += '<span class="ErrorTextMessage"></span>'
											if (_this.addToCartButtonEls.length > 0) {
												_this.addToCartButtonEls.forEach((addToCartButton) => {
													addToCartButton.innerHTML = addToCartHtml
												})
											}
										} else {
											var addToCartHtml = ''
											addToCartHtml += '<div class="AddToCartPriceContentWrapper AddToCartPriceContentWrapper__NoPrice">'
											addToCartHtml += '	<span>' + window.languages.productFormAddToCart + '</span>'
											addToCartHtml += '</div>'
											addToCartHtml += '<span class="ErrorTextMessage"></span>'
											if (_this.addToCartButtonEls.length > 0) {
												_this.addToCartButtonEls.forEach((addToCartButton) => {
													addToCartButton.innerHTML = addToCartHtml
												})
											}
										}
										if (_this.addToCartButtonEls.length > 0) {
											_this.addToCartButtonEls.forEach((addToCartButton) => {
												var errorMessageElement = document.createElement('span')
												errorMessageElement.className = 'ProductForm__Error Alert Alert--error'
												errorMessageElement.innerHTML = content['description']

												addToCartButton.insertAdjacentElement('afterend', errorMessageElement)
												addToCartButton.classList.remove('AddedToCart')
												addToCartButton.removeAttribute('disabled')

												setTimeout(function () {
													errorMessageElement.remove()
												}, 2500)
											})
										}
									}, 1500)
								})
							}
							if (_this.options['isGiftCard']) {
								let customGiftAmountEl = document.querySelector('#gift-card-custom-amount')
								customGiftAmountEl?.removeAttribute('data-input-active')
								let form = document.querySelector('form[action="/cart/add"]')
								if (form) {
									form.reset()
								}
								let selectors = [
									'properties[_gift_option]',
									'properties[Recipient name]',
									'properties[Recipient email]',
									'properties[Message]',
									'properties[Scheduled At]',
									'schedule[date]'
								]

								selectors.forEach((selector) => {
									let removeEl = document.querySelector(`[type="hidden"][name="${selector}"]`)
									if(removeEl) {
										removeEl.remove()
									}
								})

								document.querySelector('.gcp-form-fields #gift-card-recipents-name').style.display = 'flex'
								document.querySelector('.gcp-form-fields #gift-card-recipents-email').style.display = 'flex'
								// document.querySelector('.line-item-property__field.send-to').style.display = 'flex'
								document.querySelector('.gcp-input-row.send-date').style.display = 'flex'
								document.querySelector('.gcp-input-row.gift-card-add-message-btn').style.display = 'none'
								document.querySelector('.gcp-input-row.message').classList.add('active')
								document.querySelector('.gcp-form-fields .fine-text#remaining-char').classList.add('active')
								document.getElementById("gift_option").checked = true
								let sendDateEl = document.querySelector('#send-date-now')
								if ( !sendDateEl.checked) {
									document.querySelector('#gift-card-scheduling').style.display = 'flex'
								}
								document.querySelector('.gcp-input-row.gift-card-add-message-btn .property-option').innerHTML = 'add personal message'

								const productForm = document.querySelector('form[action="/cart/add"]')
								const hiddenInputs = productForm.querySelectorAll('input[type="hidden"][name=""]')
								hiddenInputs.forEach((selector) => {
									selector.remove()
								})
								document.dispatchEvent(new CustomEvent('giftcard:added'))
							}
						})
					}
				},
			},
			{
				key: '_decreaseQuantity',
				value: function _decreaseQuantity(event, target) {
					target.nextElementSibling.value = Math.max(
						parseInt(target.nextElementSibling.value) - 1,
						1,
					)
				},
				/**
				 * When using the quantity selector, this can be used to increase the quantity
				 */
			},
			{
				key: '_increaseQuantity',
				value: function _increaseQuantity(event, target) {
					target.previousElementSibling.value = parseInt(target.previousElementSibling.value) + 1
				},
				/**
				 * Make sure the quantity does not go below when manually changed
				 */
			},
			{
				key: '_validateQuantity',
				value: function _validateQuantity(event, target) {
					target.value = Math.max(parseInt(target.value) || 1, 1)
				},
			},
		])

		return ProductVariants
	})()

	var ProductVideo = /*#__PURE__*/ (function () {
		function ProductVideo(element, stackProductImages, enableVideoLooping) {
			_classCallCheck(this, ProductVideo)

			this.element = element
			this.delegateElement = new domDelegate.Delegate(this.element)
			this.stackProductImages = stackProductImages
			this.enableVideoLooping = enableVideoLooping
			this.player = null

			switch (this.element.getAttribute('data-media-type')) {
				case 'video':
					var stylesheet = document.createElement('link')
					stylesheet.rel = 'stylesheet'
					stylesheet.href =
						'https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css'
					document.head.appendChild(stylesheet)
					window.Shopify.loadFeatures([
						{
							name: 'video-ui',
							version: '1.0',
							onLoad: this._setupHtml5Video.bind(this),
						},
					])
					break

				case 'external_video':
					this._setupExternalVideo()

					break
			}
		}

		_createClass(ProductVideo, [
			{
				key: 'destroy',
				value: function destroy() {
					if (this.player) {
						this.player.destroy() // Both Plyr and YouTube API use the same name
					}
				},
			},
			{
				key: 'hasBeenSelected',
				value: function hasBeenSelected() {
					// As per guidelines, we only need to autoplay when it's not a touch device
					if (Responsive.matchesBreakpoint('supports-hover')) {
						this.play()
					}
				},
			},
			{
				key: 'hasBeenDeselected',
				value: function hasBeenDeselected() {
					this.pause()
				},
			},
			{
				key: 'play',
				value: function play() {
					switch (this.element.getAttribute('data-media-type')) {
						case 'video':
							this.player.play()
							break

						case 'external_video':
							this.player.playVideo()
							break
					}
				},
			},
			{
				key: 'pause',
				value: function pause() {
					switch (this.element.getAttribute('data-media-type')) {
						case 'video':
							this.player.pause()
							break

						case 'external_video':
							this.player.pauseVideo()
							break
					}
				},
			},
			{
				key: '_setupHtml5Video',
				value: function _setupHtml5Video() {
					var _this = this

					this.player = new Shopify.Plyr(this.element.querySelector('video'), {
						controls: ['play', 'progress', 'mute', 'volume', 'play-large', 'fullscreen'],
						loop: {
							active: this.enableVideoLooping,
						},
						hideControlsOnPause: true,
						clickToPlay: true,
						iconUrl: '//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg',
						tooltips: {
							controls: false,
							seek: true,
						},
					})
					this.player.on('play', function () {
						_this.element.dispatchEvent(
							new CustomEvent('video:played', {
								bubbles: true,
							}),
						)
					})
					this.player.on('pause', function () {
						_this.element.dispatchEvent(
							new CustomEvent('video:paused', {
								bubbles: true,
							}),
						)
					})
				},
			},
			{
				key: '_setupExternalVideo',
				value: function _setupExternalVideo() {
					if (this.element.getAttribute('data-video-host') === 'youtube') {
						this._loadYouTubeScript().then(this._setupYouTubePlayer.bind(this))
					}
				},
			},
			{
				key: '_setupYouTubePlayer',
				value: function _setupYouTubePlayer() {
					var _this2 = this

					var playerLoadingInterval = setInterval(function () {
						if (window.YT !== undefined && window.YT.Player !== undefined) {
							_this2.player = new YT.Player(_this2.element.querySelector('iframe'), {
								videoId: _this2.element.getAttribute('data-video-id'),
								events: {
									onStateChange: function onStateChange(event) {
										if (event.data === window.YT.PlayerState.PLAYING) {
											_this2.element.dispatchEvent(
												new CustomEvent('video:played', {
													bubbles: true,
												}),
											)
										} else if (event.data === YT.PlayerState.PAUSED) {
											_this2.element.dispatchEvent(
												new CustomEvent('video:paused', {
													bubbles: true,
												}),
											)
										}

										if (event.data === window.YT.PlayerState.ENDED && _this2.enableVideoLooping) {
											event.target.seekTo(0)
										}
									},
								},
							})
							clearInterval(playerLoadingInterval)
						}
					}, 50)
				},
			},
			{
				key: '_loadYouTubeScript',
				value: function _loadYouTubeScript() {
					return new Promise(function (resolve, reject) {
						var script = document.createElement('script')
						document.body.appendChild(script)
						script.onload = resolve
						script.onerror = reject
						script.async = true
						script.src = '//www.youtube.com/iframe_api'
					})
				},
			},
		])

		return ProductVideo
	})()

	/**
	 * This code has been heavily inspired by this: https://kitaitimakoto.gitlab.io/scrollspy-example/index.en.html#whatsthis
	 */
	var ScrollSpy = /*#__PURE__*/ (function () {
		function ScrollSpy(container, elementsToSpy, observerOptions) {
			var _this = this

			_classCallCheck(this, ScrollSpy)

			this.container = container
			this.targets = []
			this.targetIndices = {}
			this.indicesInViewPort = []
			this.observer = new IntersectionObserver(
				this._onIntersectionChange.bind(this),
				observerOptions,
			)
			elementsToSpy.forEach(function (elementToSpy, index) {
				_this.targets.push(elementToSpy)

				_this.targetIndices[elementToSpy.id] = index

				_this.observer.observe(elementToSpy)
			})
		}

		_createClass(ScrollSpy, [
			{
				key: 'destroy',
				value: function destroy() {
					this.observer.disconnect()
				},
				/**
				 * Called whenever there is a change of visibility
				 */
			},
			{
				key: '_onIntersectionChange',
				value: function _onIntersectionChange(changes) {
					var oldTargetIndex = this.indicesInViewPort[0] || 0

					for (var i = changes.length - 1; i >= 0; i--) {
						this._updateIndicesInViewPort(changes[i], oldTargetIndex)
					} // Firefox generates duplicates so make sure to remove

					this.indicesInViewPort = this.indicesInViewPort.filter(function (value, index, self) {
						return self.indexOf(value) === index
					})

					if (this.indicesInViewPort.length === 0 || oldTargetIndex === this.indicesInViewPort[0]) {
						return
					}

					var event = new CustomEvent('scrollspy:target:changed', {
						detail: {
							newTarget: this.targets[this.indicesInViewPort[0]],
							oldTarget: this.targets[oldTargetIndex],
						},
					})
					this.container.dispatchEvent(event)
				},
				/**
				 * Update indices visible in the view port
				 */
			},
			{
				key: '_updateIndicesInViewPort',
				value: function _updateIndicesInViewPort(change, oldTargetIndex) {
					var index = this.targetIndices[change.target.id]

					if (change.intersectionRatio === 0) {
						var indexInViewPort = this.indicesInViewPort.indexOf(index)

						if (indexInViewPort !== -1) {
							this.indicesInViewPort.splice(indexInViewPort, 1)
						}
					} else {
						if (index < oldTargetIndex) {
							this.indicesInViewPort.unshift(index)
						} else if (index > this.indicesInViewPort[this.indicesInViewPort.length - 1]) {
							this.indicesInViewPort.push(index)
						} else {
							this.indicesInViewPort.push(index)
							this.indicesInViewPort.sort()
						}
					}
				},
			},
		])

		return ScrollSpy
	})()

	var SearchBar = /*#__PURE__*/ (function () {
		function SearchBar() {
			_classCallCheck(this, SearchBar)

			this.documentDelegate = new domDelegate.Delegate(document.body)
			this.searchElement = document.getElementById('Search')
			this.searchInputElement = this.searchElement.querySelector('[name="q"]')
			this.searchResultsElement = this.searchElement.querySelector('.Search__Results')
			this.queryMap = {}
			this.isOpen = false
			this.pageOverlayElement = document.querySelector('.PageOverlay')

			this._attachListeners()
		}

		_createClass(SearchBar, [
			{
				key: 'destroy',
				value: function destroy() {
					this.searchInputElement.removeEventListener('keydown', this._preventSubmissionListener)
					this.searchInputElement.removeEventListener('input', this._onInputListener)
					this.documentDelegate.off()
				},
			},
			{
				key: '_attachListeners',
				value: function _attachListeners() {
					this._preventSubmissionListener = this._preventSubmission.bind(this)
					this._onInputListener = this._debounce(this._onInput.bind(this), 250)
					this.searchInputElement.addEventListener('keydown', this._preventSubmissionListener)
					this.searchInputElement.addEventListener('input', this._onInputListener)
					this.documentDelegate.on(
						'click',
						'[data-action="toggle-search"]',
						this._toggleSearch.bind(this),
					)
					this.documentDelegate.on(
						'click',
						'[data-action="open-search"]',
						this._openSearch.bind(this),
					)
					this.documentDelegate.on(
						'click',
						'[data-action="close-search"]',
						this._closeSearch.bind(this),
					)
					this.documentDelegate.on('search:close', this._closeSearch.bind(this)) // Allow for third-party elements to close the bar
				},
				/**
				 * Toggle the search
				 */
			},
			{
				key: '_toggleSearch',
				value: function _toggleSearch(event) {
					if (this.isOpen) {
						this._closeSearch(event)
					} else {
						this._openSearch(event)
					}

					event.preventDefault()
				},
				/**
				 * Open the search form and trap focus
				 */
			},
			{
				key: '_openSearch',
				value: function _openSearch() {
					var _this = this

					this.searchElement.setAttribute('aria-hidden', 'false')
					// BC: CDSD-27166
					// commenting this out may cause other problems.
					// however behind the search element isnt scrolling wiith this disabled.
					// document.documentElement.classList.add('no-scroll')
					Accessibility.trapFocus(
						this.searchElement,
						'search',
						this.searchElement.querySelector('[name="q"]'),
					)

					var onFocusListener = function onFocusListener() {
						_this.searchInputElement.focus()

						_this.searchElement.removeEventListener('transitionend', onFocusListener)
					}

					this.searchElement.addEventListener('transitionend', onFocusListener)
					this.isOpen = true
					this.pageOverlayElement.classList.add('is-visible')
					document.querySelector('#shopify-section-header').style.zIndex = 10
				},
				/**
				 * Close the search form and clear focus
				 */
			},
			{
				key: '_closeSearch',
				value: function _closeSearch() {
					var _this2 = this

					this.searchElement.setAttribute('aria-hidden', 'true')
					// document.documentElement.classList.remove('no-scroll')
					Accessibility.removeTrapFocus(this.searchElement, 'search')
					this.isOpen = false

					var onTransitionEnd = function onTransitionEnd(event) {
						if (event.propertyName === 'visibility') {
							document.querySelector('#shopify-section-header').style.zIndex = ''

							_this2.pageOverlayElement.removeEventListener('transitionend', onTransitionEnd)
						}
					}

					this.pageOverlayElement.addEventListener('transitionend', onTransitionEnd)
					this.pageOverlayElement.classList.remove('is-visible')
				},
				/**
				 * In order to prevent an odd UX where hitting the enter always choose the product results, if the search is set to product + something else,
				 * then we disable submission using enter key
				 */
			},
			{
				key: '_preventSubmission',
				value: function _preventSubmission(event) {
					if (event.keyCode === 13 && window.theme.searchMode !== 'product') {
						event.preventDefault()
					}
				},
				/**
				 * This is called when the user has stopped typing (after debounce delay)
				 */
			},
			{
				key: '_onInput',
				value: function _onInput(event) {
					var _this3 = this

					if (event.keyCode === 13) {
						return
					} // Unfortunately, fetch does not support as of today cancelling a request. As a consequence what we do is that we manually
					// keep track of sent requests, and only use the results of the last one

					this.lastInputValue = event.target.value

					if (this.lastInputValue === '') {
						this._resetSearch()

						return
					}

					var queryOptions = {
						method: 'GET',
						credentials: 'same-origin',
					}
					var queries = [
						fetch(
							''
								.concat(window.routes.searchUrl, '?section_id=predictive-search&q=')
								.concat(encodeURIComponent(this.lastInputValue), '*&type=product'),
							queryOptions,
						),
					]

					if (window.theme.searchMode !== 'product') {
						queries.push(
							fetch(
								''
									.concat(window.routes.searchUrl, '?section_id=predictive-search&q=')
									.concat(encodeURIComponent(this.lastInputValue), '*&type=')
									.concat(window.theme.searchMode.replace('product,', '')),
								queryOptions,
							),
						)
					}

					this.queryMap[this.lastInputValue] = true
					document.dispatchEvent(new CustomEvent('theme:loading:start'))
					Promise.all(queries).then(function (responses) {
						// If we receive the result for a query that is not the last one, we simply do not process the result
						if (_this3.lastInputValue !== event.target.value) {
							return
						}

						delete _this3.queryMap[event.target.value]
						Promise.all(
							responses.map(function (response) {
								return response.text()
							}),
						).then(function (contents) {
							// If we have only one content then we only have product, otherwise we have products and articles
							if (window.theme.searchMode === 'product') {
								_this3.searchResultsElement.innerHTML = contents[0]
							} else {
								_this3.searchResultsElement.innerHTML =
									'<div class="PageLayout PageLayout--breakLap">\n              <div class="PageLayout__Section">'
										.concat(
											contents[0],
											'</div>\n              <div class="PageLayout__Section PageLayout__Section--secondary">',
										)
										.concat(contents[1], '</div>\n            </div>')
							}

							_this3.searchResultsElement.setAttribute('aria-hidden', 'false')
						})
						document.dispatchEvent(new CustomEvent('theme:loading:end'))
					})
				},
			},
			{
				key: '_resetSearch',
				value: function _resetSearch() {
					if (window.theme.searchMode === 'product') {
						this.searchResultsElement.innerHTML = ''
					} else {
						this.searchResultsElement.innerHTML =
							'<div class="PageLayout PageLayout--breakLap">\n              <div class="PageLayout__Section"></div>\n              <div class="PageLayout__Section PageLayout__Section--secondary"></div>\n            </div>'
					}

					this.searchResultsElement.setAttribute('aria-hidden', 'true')
					document.dispatchEvent(new CustomEvent('theme:loading:end')) // Just in case
				},
				/**
				 * Simple function that allows to debounce
				 */
			},
			{
				key: '_debounce',
				value: function _debounce(fn, delay) {
					var _this4 = this

					var timer = null
					return function () {
						for (
							var _len = arguments.length, args = new Array(_len), _key = 0;
							_key < _len;
							_key++
						) {
							args[_key] = arguments[_key]
						}

						clearTimeout(timer)
						timer = setTimeout(function () {
							fn.apply(_this4, args)
						}, delay)
					}
				},
			},
		])

		return SearchBar
	})()

	var CountrySelector = /*#__PURE__*/ (function () {
		function CountrySelector(countrySelect, provinceSelect) {
			_classCallCheck(this, CountrySelector)

			this.countrySelect = countrySelect
			this.provinceSelect = provinceSelect

			if (this.countrySelect && this.provinceSelect) {
				this._attachListeners()

				this._initSelectors()
			}
		}

		_createClass(CountrySelector, [
			{
				key: 'destroy',
				value: function destroy() {
					if (this.countrySelect) {
						this.countrySelect.removeEventListener('change', this._onCountryChangedListener)
					}
				},
			},
			{
				key: '_initSelectors',
				value: function _initSelectors() {
					// Check first the default value of country
					var defaultCountry = this.countrySelect.getAttribute('data-default')

					if (defaultCountry) {
						for (var i = 0; i !== this.countrySelect.options.length; ++i) {
							if (this.countrySelect.options[i].text === defaultCountry) {
								this.countrySelect.selectedIndex = i
								break
							}
						}
					} else {
						this.countrySelect.selectedIndex = 0
					}

					var event = new Event('change', {
						bubbles: true,
					})
					this.countrySelect.dispatchEvent(event) // Then the province

					var defaultProvince = this.provinceSelect.getAttribute('data-default')

					if (defaultProvince) {
						for (var _i = 0; _i !== this.provinceSelect.options.length; ++_i) {
							if (this.provinceSelect.options[_i].text === defaultProvince) {
								this.provinceSelect.selectedIndex = _i
								break
							}
						}
					}
				},
			},
			{
				key: '_attachListeners',
				value: function _attachListeners() {
					this._onCountryChangedListener = this._onCountryChanged.bind(this)
					this.countrySelect.addEventListener('change', this._onCountryChangedListener)
				},
			},
			{
				key: '_onCountryChanged',
				value: function _onCountryChanged() {
					var _this = this

					var selectedOption = this.countrySelect.options[this.countrySelect.selectedIndex],
						provinces = JSON.parse(selectedOption.getAttribute('data-provinces') || '[]') // First remove all options

					this.provinceSelect.innerHTML = ''

					if (provinces.length === 0) {
						this.provinceSelect.parentNode.style.display = 'none'
						return
					} // We need to build the provinces array

					provinces.forEach(function (data) {
						_this.provinceSelect.options.add(new Option(data[1], data[0]))
					})
					this.provinceSelect.parentNode.style.display = 'block'
				},
			},
		])

		return CountrySelector
	})()

	var ShippingEstimator = /*#__PURE__*/ (function () {
		function ShippingEstimator(element) {
			_classCallCheck(this, ShippingEstimator)

			this.element = element
			this.delegateElement = new domDelegate.Delegate(this.element)
			this.countrySelector = new CountrySelector(
				this.element.querySelector('[name="country"]'),
				this.element.querySelector('[name="province"]'),
			)

			this._attachListeners()
		}

		_createClass(ShippingEstimator, [
			{
				key: 'onUnload',
				value: function onUnload() {
					this.delegateElement.off('click')
					this.countrySelector.destroy()
				},
			},
			{
				key: '_attachListeners',
				value: function _attachListeners() {
					this.delegateElement.on(
						'click',
						'.ShippingEstimator__Submit',
						this._fetchRates.bind(this),
					)
				},
			},
			{
				key: '_fetchRates',
				value: function _fetchRates() {
					var _this = this

					var country = this.element.querySelector('[name="country"]').value,
						province = this.element.querySelector('[name="province"]').value,
						zip = this.element.querySelector('[name="zip"]').value
					document.dispatchEvent(new CustomEvent('theme:loading:start'))
					fetch(
						''
							.concat(window.routes.cartUrl, '/shipping_rates.json?shipping_address[zip]=')
							.concat(zip, '&shipping_address[country]=')
							.concat(country, '&shipping_address[province]=')
							.concat(province),
						{
							credentials: 'same-origin',
							method: 'GET',
						},
					).then(function (response) {
						response.json().then(function (result) {
							document.dispatchEvent(new CustomEvent('theme:loading:end'))

							var resultsContainer = _this.element.querySelector('.ShippingEstimator__Results'),
								errorContainer = _this.element.querySelector('.ShippingEstimator__Error')

							if (response.ok) {
								var shippingRates = result['shipping_rates']

								if (shippingRates.length === 0) {
									resultsContainer.innerHTML = '<p>'.concat(
										window.languages.shippingEstimatorNoResults,
										'</p>',
									)
								} else {
									var html = ''

									if (shippingRates.length === 1) {
										html += '<p>'.concat(window.languages.shippingEstimatorOneResult, '</p><ul>')
									} else {
										html += '<p>'.concat(
											window.languages.shippingEstimatorMoreResults.replace(
												'{{count}}',
												shippingRates.length,
											),
											'</p><ul>',
										)
									}

									shippingRates.forEach(function (item) {
										html += '<li>'
											.concat(item['name'], ': ')
											.concat(
												Currency.formatMoney(item['price'], window.theme.moneyFormat),
												'</li>',
											)
									})
									html += '</ul>'
									resultsContainer.firstElementChild.innerHTML = html
								}

								TweenLite.fromTo(
									resultsContainer.firstElementChild,
									0.6,
									{
										autoAlpha: 0,
										y: -15,
									},
									{
										autoAlpha: 1,
										y: 0,
										delay: 0.35,
									},
								)
								errorContainer.style.display = 'none'
								resultsContainer.style.display = 'block'
								Animation.slideDown(resultsContainer)
							} else {
								var errorHtml = ''
								Object.keys(result).forEach(function (key) {
									errorHtml += '<li class="Alert__ErrorItem">'
										.concat(key, ' ')
										.concat(result[key], '</li>')
								})
								errorContainer.innerHTML = '<ul class="Alert__ErrorList">'.concat(
									errorHtml,
									'</ul>',
								)
								resultsContainer.style.display = 'none'
								errorContainer.style.display = 'block'
							}
						})
					})
				},
			},
		])

		return ShippingEstimator
	})()

	var AddressesSection = function AddressesSection() {
		var _this = this

		_classCallCheck(this, AddressesSection)

		this.countrySelectors = []
		Dom.nodeListToArray(document.querySelectorAll('.Modal--address')).forEach(function (modal) {
			_this.countrySelectors.push(
				new CountrySelector(
					modal.querySelector('[name="address[country]"]'),
					modal.querySelector('[name="address[province]"]'),
				),
			)
		})
	}

	var ArticleSection = /*#__PURE__*/ (function () {
		function ArticleSection(container) {
			var _this = this

			_classCallCheck(this, ArticleSection)

			this.element = container
			this.toolbarElement = this.element.querySelector('.ArticleToolbar')
			this.articleNavElement = this.element.querySelector('.ArticleNav')
			var articleImageElement = this.element.querySelector('.Article__Image')
			this.carouselArticleRelated = this.element.querySelector('.js-article-related')
			this.carouselImage = this.element.querySelector('.js-carousel-image')
			this.articleProductsCarousel = this.element.querySelector('.js-article-products-carousel')
			this.buttonToggleIconsEl = this.element.querySelector('.js-toggle-share')
			this.shareButtonsEl = this.element.querySelector('.js-share-button')

			this._initCarousel()
			window.addEventListener('resize', this._initCarousel())

			if (
				articleImageElement &&
				window.matchMedia('(-moz-touch-enabled: 0), (hover: hover)').matches
			) {
				this.parallaxInstance = new Rellax('.Article__Image', {
					speed: -7,
					center: false,
					round: true,
				})
			}

			if (window.theme.showElementStaggering) {
				this.timeline = new TimelineLite({
					delay: window.theme.showPageTransition ? 0.5 : 0,
				})
				this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this))
				Dom.nodeListToArray(this.element.querySelectorAll('.ArticleItem')).forEach(function (item) {
					_this.intersectionObserver.observe(item)
				})
			}

			if(this.buttonToggleIconsEl && this.shareButtonsEl) (
				this._toggleShareButtons()
			)
		}

		_createClass(ArticleSection, [
			{
				key: 'onUnload',
				value: function onUnload() {
					if (this.parallaxInstance) {
						this.parallaxInstance.destroy()
					}
					if (window.theme.showElementStaggering) {
						this.intersectionObserver.disconnect()
						this.timeline.kill()
					}
				},
			},
			{
				key: '_reveal',
				value: function _reveal(results) {
					var _this3 = this

					var toReveal = []
					results.forEach(function (result) {
						if (result.isIntersecting || result.intersectionRatio > 0) {
							// isIntersecting does not exist on Samsung Android browser
							toReveal.push(result.target)

							_this3.intersectionObserver.unobserve(result.target)
						}
					})

					if (toReveal.length === 0) {
						return
					}

					this.timeline.staggerFromTo(
						toReveal,
						0.45,
						{
							autoAlpha: 0,
							y: 30,
						},
						{
							autoAlpha: 1,
							y: 0,
						},
						0.2,
					)
				},
			},
			{
				key: '_initCarousel',
				value: function _initCarousel() {
					const dataOptionsRelated = this.carouselArticleRelated?.getAttribute('data-flickity-config')
					const dataOptionImages = this.carouselImage?.getAttribute('data-swiper-config')

					if (this.articleProductsCarousel) {						
						const dataOptionArticleProducts = this.articleProductsCarousel?.getAttribute('data-swiper-config')
						const articleProducts = new Swiper(this.articleProductsCarousel, JSON.parse(dataOptionArticleProducts))
					}
					if (window.innerWidth < 1023) {
						this.carouselRelated = new Carousel(this.carouselArticleRelated, dataOptionsRelated)
						if (!Object.keys(this.carouselRelated).length) return
						this._handleImage(this.carouselRelated.getFlickityInstance())
						this.selectedIndexInit = this.carouselRelated.getFlickityInstance().selectedIndex

						this.carouselRelated.getFlickityInstance().on('select', () => {
							if (this.carouselRelated.getFlickityInstance().selectedIndex !== this.selectedIndexInit) {
								this._handleImage(this.carouselRelated.getFlickityInstance())
								this.selectedIndexInit = this.carouselRelated.getFlickityInstance().selectedIndex
							}
						})
					} else {
						this.carouselRelated?.destroy()
					}

					if (dataOptionImages) {
						const imageSlider = new Swiper(this.carouselImage, JSON.parse(dataOptionImages))
					}
				}
			},
			{
				key: '_handleImage',
				value: function _handleImage(carousel) {
					if (!carousel) {
						return
					}

					const cells = carousel.cells
					const selectedIndex = carousel.selectedIndex
					const prevIndex = selectedIndex - 1
					const nextIndex = selectedIndex + 1

					cells?.forEach((cell, index) => {
						const cellEl = cells[index].element
						const imageEl = cells[index].element.querySelector('.ArticleItem__ImageWrapper')
						const otherSelectedEl = cells.find((cell, index) => cells[index].element.classList.contains('is-selected'))
						const imageOther = otherSelectedEl.element.querySelector('.ArticleItem__ImageWrapper')
						const translateSpacing = cells[index].size.width - 10 - imageOther?.getBoundingClientRect().width
		
						if (!imageEl) {
							return
						}
		
						if (index === prevIndex) {
							imageEl.style.marginRight = `-${translateSpacing / 2}px`
							imageEl.style.marginLeft = `${translateSpacing / 2}px`
						} else if (index === nextIndex) {
							imageEl.style.marginLeft = `-${translateSpacing / 2}px`
							imageEl.style.marginRight = `${translateSpacing / 2}px`
						} else if (cellEl.classList.contains('is-selected')) {
							imageEl.style.marginRight = '0'
							imageEl.style.marginLeft = '0'
						}
					})
				},
			},
			{
				key: '_toggleShareButtons',
				value: function _toggleShareButtons() {
					this.buttonToggleIconsEl.addEventListener('click', () => {
						this.shareButtonsEl.classList.toggle('active')
						
						if (this.shareButtonsEl.classList.contains('active')) {
							this.shareButtonsEl.style.height = `${this.shareButtonsEl.scrollHeight}px`
						} else {
							this.shareButtonsEl.style.height = 0
						}
					})
				}
			}
		])

		return ArticleSection
	})()

	var CartSection = /*#__PURE__*/ (function () {
		function CartSection(container) {
			_classCallCheck(this, CartSection)

			this.element = container
			this.delegateElement = new domDelegate.Delegate(this.element)
			this.documentDelegate = new domDelegate.Delegate(document.documentElement)
			this.options = JSON.parse(this.element.getAttribute('data-section-settings'))
			this.itemCount = this.options['itemCount']
			this.isCartNoteOpen = false
			this.removeQueue = {}
			this.cartRecommendedItemsEl = this.element.querySelector('.js-cart-recommended-items')
			this.offscreenOverlay = document.querySelector('.OffscreenContainer__Overlay')

			if (this.options['drawer']) {
				this.sidebarDrawer = new Drawer(this.element, {
					onClose: this._onDrawerClosed.bind(this),
				})
			}

			if (this.options['enableGiftWrap']) {
			}

			if (this.options['hasShippingEstimator']) {
				this.shippingEstimator = new ShippingEstimator(
					this.element.querySelector('.ShippingEstimator'),
				)
			}

			this._attachListeners()
		}

		_createClass(CartSection, [
			{
				key: 'onUnload',
				value: function onUnload() {
					if (this.options['hasShippingEstimator']) {
						this.shippingEstimator.destroy()
					}

					this.delegateElement.off()
					document.removeEventListener('product:added', this._onProductAddedListener)
				},
			},
			{
				key: '_attachListeners',
				value: function _attachListeners() {
					this._onProductAddedListener = this._onProductAdded.bind(this)
					this.delegateElement.on('change', '#cart-note', this._updateCartNote.bind(this))

					if (this.options['type'] !== 'page') {
						this.delegateElement.on(
							'click',
							'[data-action="update-item-quantity"], [data-action="remove-item"]',
							this._updateItemQuantity.bind(this),
						)
						this.delegateElement.on(
							'change',
							'.QuantitySelector__CurrentQuantity',
							this._updateItemQuantity.bind(this),
						)
					} else {
						this.delegateElement.on(
							'change',
							'.QuantitySelector__CurrentQuantity',
							this._reloadPageWithQuantity.bind(this),
						)
					} // We have some listeners that are specific to the fact it's a drawer or the dedicated cart page

					if (this.options['drawer']) {
						this.delegateElement.on(
							'click',
							'[data-action="toggle-cart-note"]',
							this._toggleCartNote.bind(this),
						)
					}
					this.delegateElement.on(
						'click',
						'[data-action="add-to-cart"]',
						this._addToCart.bind(this),
					)

					if (this.options['enableGiftWrap']) {
						this.delegateElement.on(
							'click',
							'[data-action="toggle-cart-gift-wrap"]',
							this._toggleCartGiftWrap.bind(this),
						)
						this.delegateElement.on(
							'click',
							'.Drawer__Close ',
							this._emptyGiftWrapAddToCart.bind(this),
						)
						this.delegateElement.on(
							'click',
							'[data-action="gift-wrap-add-to-cart"]',
							this._giftWrapAddToCart.bind(this),
						)
						this.delegateElement.on(
							'click',
							'[data-action="gift-wrap-remove-from-cart"]',
							this._giftWrapRemoveFromCart.bind(this),
						)
						this.delegateElement.on(
							'click',
							'.OffscreenContainer__Overlay',
							this._closeGiftCard.bind(this),
						)
						this.delegateElement.on(
							'click',
							'.OffscreenContainer__Overlay',
							this._emptyGiftWrapAddToCart.bind(this),
						)
						this.delegateElement.on('keyup', '[maxlength]', this._updateCharacterCount.bind(this))
					}

					document.addEventListener('product:added', this._onProductAddedListener) // We attach a listener at page level which allows to re-render the cart

					this.documentDelegate.on('cart:refresh', this._rerenderCart.bind(this, false))
				},
			},
			{
				key: '_updateCharacterCount',
				value: function _updateCharacterCount(event, target) {
					var cntMaxLength = parseInt(target.getAttribute('maxlength'))
					var currentCount = target.value.length
				},
			},
			{
				key: '_updateCartNote',
				value: function _updateCartNote(event, target) {
					fetch(''.concat(window.routes.cartUrl, '/update.js'), {
						body: JSON.stringify({
							note: target.value,
						}),
						credentials: 'same-origin',
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
						},
					})
				},
			},
			{
				key: '_toggleCartNote',
				value: function _toggleCartNote() {
					var _this = this

					var noteContainer = this.element.querySelector('.Cart__OffscreenNoteContainer'),
						cartNote = this.element.querySelector('#cart-note')
					this.element.classList.toggle('has-note-open')
					this.element.querySelector('.Cart__NoteButton').innerHTML =
						cartNote.value !== '' ? window.languages.cartEditNote : window.languages.cartAddNote
					noteContainer.setAttribute(
						'aria-hidden',
						noteContainer.getAttribute('aria-hidden') === 'true' ? 'false' : 'true',
					)
					this.isCartNoteOpen = noteContainer.getAttribute('aria-hidden') === 'false'

					if (this.element.classList.contains('has-note-open')) {
						var transitionEndListener = function transitionEndListener() {
							_this.element.querySelector('#cart-note').focus()

							noteContainer.removeEventListener('transitionend', transitionEndListener)
						}

						noteContainer.addEventListener('transitionend', transitionEndListener)
					}
				},
			},
			{
				key: '_giftWrapAddToCart',
				value: async function _giftWrapAddToCart(event, target) {
					document.dispatchEvent(new CustomEvent('theme:loading:start'))
					var cartEl = document.querySelector('.Cart')

					var _this = this
					var isGiftWrapSelected =
						this.element.querySelector('#wrapping-option2') &&
						this.element.querySelector('#wrapping-option2').checked
							? 'true'
							: 'false'
					var isGiftMessageSelected =
						this.element.querySelector('#wrapping-option3') &&
						this.element.querySelector('#wrapping-option3').checked
							? true
							: false
					var giftMessage = 'No Message'

					if (isGiftWrapSelected == 'true' && isGiftMessageSelected == 'true') {
						var productId = this.options['giftWrapAndMessageVariantId']
					} else if (isGiftWrapSelected == 'true') {
						var productId = this.options['giftWrapVariantId']
					} else if (isGiftMessageSelected) {
						giftMessage = this.element.querySelector('#gift_message').value.length
							? this.element.querySelector('#gift_message').value
							: 'Blank Card'
						var productId = this.options['giftMessageVariantId']
					} else {
						return false
					}

					var properties = {
						_gift_wrap: isGiftWrapSelected,
						_gift_wrap_item_sku: this.giftWrapSku,
						gift_wrap_item: this.giftWrapName,
						gift_wrap_message: giftMessage,
						_uniqueTimeStamp: this.giftWrapLineId,
					}

					var formJSON = {
						quantity: 1,
						id: productId,
						properties: properties,
					}

					var offscreenWrapper = this.element.querySelector('.OffscreenContainer__Wrapper')
					var offscreenContainer = this.element.querySelector('.Cart__OffscreenContainer')

					offscreenWrapper.setAttribute('aria-hidden', true)
					offscreenContainer.setAttribute('aria-hidden', true)
					this.element.classList.remove('has-gift-wrap-open')
					cartEl.classList.add('loading')

					await fetch(''.concat(window.routes.cartUrl, '.js'), {
						credentials: 'same-origin',
						method: 'GET',
						headers: {
							'Content-Type': 'application/json',
							'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
						},
					})
					.then((response) => response.json())
					.then(async cart => {
						const updates = {}
						cart.items.forEach(item => {
							if (item?.properties?._uniqueTimeStamp === this.giftWrapLineId) {
								updates[item.key] = 0
							}
						})

						await fetch(''.concat(window.routes.cartUpdateUrl, '.js'), {
							body: JSON.stringify({ updates }),
							credentials: 'same-origin',
							method: 'POST',
							headers: {
								'Content-Type': 'application/json',
								'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
							},
						})
					})

					await fetch(''.concat(window.routes.cartAddUrl, '.js'), {
						body: JSON.stringify(formJSON),
						credentials: 'same-origin',
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
						},
					}).then(function (response) {
						document.dispatchEvent(new CustomEvent('theme:loading:end'))
						if (response.ok) {
							document.documentElement.dispatchEvent(
								new CustomEvent('cart:refresh', {
									bubbles: true,
								}),
							)
						} else {
							alert('sold out, sorry!')
						}

						cartEl.classList.remove('loading')
					})
				},
			},
			{
				key: '_giftWrapRemoveFromCart',
				value: function _giftWrapRemoveFromCart(event, target) {
					document.dispatchEvent(new CustomEvent('theme:loading:start'))
					var dataKey = target.getAttribute('data-key')
					if (dataKey) {
						this.removeQueue[dataKey] = 0
					}
					this._removeAlong()
				},
			},
			{
				key: '_toggleCartGiftWrap',
				value: function _toggleCartGiftWrap(event, target) {
					var _this = this

					var offscreenWrapper = this.element.querySelector('.OffscreenContainer__Wrapper')
					var offscreenContainer = this.element.querySelector('.Cart__OffscreenContainer')

					this.element.classList.toggle('has-gift-wrap-open')

					offscreenWrapper.setAttribute(
						'aria-hidden',
						offscreenWrapper.getAttribute('aria-hidden') === 'true' ? 'false' : 'true',
					)
					offscreenContainer.setAttribute(
						'aria-hidden',
						offscreenContainer.getAttribute('aria-hidden') === 'true' ? 'false' : 'true',
					)
					this.isCartGiftWrapOpen = offscreenContainer.getAttribute('aria-hidden') === 'false'
					
					const shouldDisableBodyScroll = window.innerWidth < 1024 && (window.location.href == window.routes.domain + cartUrl)

					if (this.element.classList.contains('has-gift-wrap-open')) {
						if (shouldDisableBodyScroll) document.querySelector('body').style.overflow = 'hidden'
						// UPDATE FORM DATA
						this._updateGiftWrapForm(event, target)

						var transitionEndListener = function transitionEndListener() {
							offscreenContainer.removeEventListener('transitionend', transitionEndListener)
						}

						offscreenContainer.addEventListener('transitionend', transitionEndListener)
					} else {
						document.querySelector('body').style.overflow = 'auto'
					}
				},
			},
			{
				key: '_closeGiftCard',
				value: function _closeGiftCard(event) {
					var offscreenWrapper = this.element.querySelector('.OffscreenContainer__Wrapper')
					var offscreenContainer = this.element.querySelector('.Cart__OffscreenContainer')

					offscreenWrapper.setAttribute('aria-hidden', true)
					offscreenContainer.setAttribute('aria-hidden', true)
					this.element.classList.remove('has-gift-wrap-open')
				}
			},
			{
				key: '_emptyGiftWrapAddToCart',
				value: function _emptyGiftWrapAddToCart(event) {
					this.element.querySelector('[data-action="gift-wrap-add-to-cart"]').click()
				}
			},
			{
				key: '_updateGiftWrapForm',
				value: function _updateGiftWrapForm(event, target) {
					// Clear existing form
					this.element.querySelector('#GiftWrapFormContainer').innerHTML = ''

					// Create new form html
					this.giftWrapLineId = target.getAttribute('data-line-id')
					this.giftWrapId = target.getAttribute('data-id')
					this.giftWrapQuantity = target.getAttribute('data-quantity')
					this.giftWrapName = target.getAttribute('data-name')
					this.giftWrapSku = target.getAttribute('data-sku')
					this.giftWrapMessageValue = target.getAttribute('data-message-value')
					var html = ''

					html += '<div class="Drawer__Container">'
					html += '	<div class="GiftWrap__ItemList">'
					html += '		<div class="GiftWrapItemProduct">'

					html += '<form class="Form Form--spacingTight">'
					html += '	<input type="hidden" name="dataLineId" value="' + this.giftWrapLineId + '">'
					html += '	<input type="hidden" name="dataId" value="' + this.giftWrapId + '">'
					html += '	<input type="hidden" name="dataQuantity" value="' + this.giftWrapQuantity + '">'

					if (this.options['giftWrapType'] == 1) {
						/** Gift Wrap & Message **/
						html += '		<div class="Form__Item GiftWrap__FormItem">'
						html += '			<div class="Form__CheckboxWrapper">'
						html += '				<input id="wrapping-option2" name="gift_wrap_option_2" type="checkbox" class="Form__Checkbox" value="0">'
						html += '				<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 10" class="Icon Icon--checkmark-input">'
						html += '					<path stroke="currentColor" d="M1.313 5.31 4.49 8.49l6.822-6.822"/>'
						html += '				</svg>'
						html += '				<label for="wrapping-option2">Gift Wrap this item</label>'
						html += '			</div>'
						html += '			<div class="Gift__Description">'
						html += '				<p>Complete your gift and have it wrapped with a belly band. $2 from every gift wrap purchased will be donated to the Australian Marine Conservation Society. </p>'
						html += '			</div>'
						html += '		</div>'

						html += '		<div class="Form__Item">'
						html += '			<span class="Heading u-h4">Do you want a complimentary gift message?</span>'
						html += '			<ul class="SizeSwatchList HorizontalList HorizontalList--spacingTight">'
						html += '				<li class="HorizontalList__Item">'
						html +=
							'					<input id="wrapping-option3" name="gift_wrap_option_3" type="radio" class="SizeSwatch__Radio">'
						html += '					<label for="wrapping-option3"  class="SizeSwatch">Yes</label>'
						html += '				</li>'
						html += '				<li class="HorizontalList__Item">'
						html +=
							'					<input id="wrapping-option4" name="gift_wrap_option_3" type="radio" class="SizeSwatch__Radio">'
						html += '					<label for="wrapping-option4" class="SizeSwatch">No</label>'
						html += '				</li>'
						html += '			</ul>'
						html += '		</div>'

						html += '		<div class="Form__Item">'
						html +=
							`			<textarea class="Form__Textarea" cols="30" rows="7" id="gift_message" placeholder="Enter your message here" maxlength="280">${this.giftWrapMessageValue}</textarea>`
						html +=
							'			<label class="Form__FloatingLabel">PERSONAL MESSAGE</span></label>'
						html += '		</div>'
					} else if (this.options['giftWrapType'] == 2) {
						/** Gift Wrap Only **/
						html +=
							'		<input id="wrapping-option2" style="display: none;" name="gift_wrap_option_2" type="checkbox" class="Form__Checkbox" value="1" checked>'
					} else if (this.options['giftWrapType'] == 3) {
						/** Gift Message Only **/
						html += '		<div class="Form__Item" style="display: none;">'
						html +=
							'			<input id="wrapping-option3" name="gift_wrap_option_3" type="checkbox" class="Form__Checkbox" value="1" checked>'
						html += '		</div>'
						html += '		<div class="Form__Item">'
						html +=
							`			<textarea class="Form__Textarea" cols="30" rows="7" id="gift_message" placeholder="Enter your message here" maxlength="280">${this.giftWrapMessageValue}</textarea>`
						html +=
							'			<label class="Form__FloatingLabel">PERSONAL MESSAGE</span></label>'
						html += '		</div>'
					}

					html += '</form>'

					if (this.options['giftWrapType'] == 2) {
						html += `<button type="submit" data-action="gift-wrap-add-to-cart" class="Button Button--tertiary Button--full">${GM_STATE.giftWrap.ctaTextUpdate}</button>`
					} else {
						html += `<button type="submit" data-action="gift-wrap-add-to-cart" class="Button Button--tertiary Button--full">${this.giftWrapMessageValue ? GM_STATE.giftWrap.ctaTextUpdate : GM_STATE.giftWrap.ctaTextAdd}</button>`
					}

					html += '		</div>'
					html += '	</div>'
					html += '</div>'

					this.element.querySelector('#GiftWrapFormContainer').innerHTML = html

					this.giftWrapMessageValue = ''
				},
			},
			{
				key: '_updateItemQuantity',
				value: function _updateItemQuantity(event, target) {
					var _this2 = this
					event.currentTarget.querySelector('.Cart').classList.add('loading')
					var dataKey = target.getAttribute('data-key')
					var dataGiftKey = target.getAttribute('data-gift-key')
					const _uniqueTimeStamp = target.getAttribute('data-timestamp')

					document.dispatchEvent(new CustomEvent('theme:loading:start'))
					var quantity = null,
						elementToAnimate = null

					elementToAnimate = target.closest('.CartItemWrapper')

					fetch(''.concat(window.routes.cartUrl, '.js'), {
						credentials: 'same-origin',
						method: 'GET',
						headers: {
							'Content-Type': 'application/json',
							'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
						},
					}).then(function (response) {
						response.json().then(function (cart) {
							for (var i = 0; i <= cart.items.length; i++) {
								if (cart.items[i]) {
									if (
										cart.items[i].key == dataKey ||
										(cart.items[i].properties?._uniqueTimeStamp && cart.items[i].properties._uniqueTimeStamp.toString() == _uniqueTimeStamp) ||
										(cart.items[i].properties?._uniqueItem && cart.items[i].properties._uniqueItem.toString() == _uniqueTimeStamp)
									) {
										_this2.removeQueue[cart.items[i].key] = 0
										_this2.itemCount -= cart.items[i].quantity
									}
								}
							}
							if (dataGiftKey) {
								_this2.removeQueue[dataGiftKey] = 0
							}
							_this2._removeAlong(elementToAnimate)
						})
					})

					event.preventDefault()
				},
			},
			{
				key: '_removeAlong',
				value: function _removeAlong(elementToAnimate) {
					var _this = this

					var request = {
						updates: this.removeQueue,
					}

					if (Object.keys(this.removeQueue).length) {
						fetch(''.concat(window.routes.cartUpdateUrl, '.js'), {
							body: JSON.stringify(request),
							credentials: 'same-origin',
							method: 'POST',
							headers: {
								'Content-Type': 'application/json',
								'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
							},
						}).then(async function (response) {
							const cart = await response.json()

							if (window.location.href == window.routes.domain + cartUrl) {
								window.location.href = cartUrl
							} else {
								_this._rerenderCart(elementToAnimate)
								document.dispatchEvent(new CustomEvent('theme:loading:end'))
								_this.removeQueue = {}
								
								if (cart.items.length === 0) {
									document.dispatchEvent(
										new CustomEvent('drawer:close', {
											bubbles: true,
										}),
									)

									document.dispatchEvent(
										new CustomEvent('cart:empty', {
											bubbles: true,
										}),
									)
								}
							}
						})
					}
				},
			},
			{
				key: '_reloadPageWithQuantity',
				value: function _reloadPageWithQuantity(event, target) {
					window.location.href = ''
						.concat(window.routes.cartChangeUrl, '?quantity=')
						.concat(parseInt(target.value), '&line=')
						.concat(target.getAttribute('data-line'))
				},
			},
			{
				key: '_onProductAdded',
				value: function _onProductAdded(event) {
					var _this3 = this
					this.itemCount += event.detail.quantity
					this._rerenderCart().then(function () {
						setTimeout(() => {
							_this3.sidebarDrawer.open();
						}, 300)
					});
				},
			},
			{
				key: '_onDrawerClosed',
				value: function _onDrawerClosed() {
					if (this.isCartNoteOpen) {
						this._toggleCartNote()
					}
				},
				/**
				 * This method is called internally to rerender the cart, based on the content returned by Shopify Ajax API.
				 * We could save some performance by updating directly in JavaScript instead of doing a GET call to get the HTML
				 * from Shopify, but by experience, this allows for easier app integration as it allows the Liquid to re-run
				 * all the time and hence having easier logic.
				 */
			},
			{
				key: '_rerenderCart',
				value: function _rerenderCart(elementToAnimate) {
					var _this4 = this

					return fetch(
						''
							.concat(window.routes.cartUrl, '?section_id=')
							.concat(this.options['drawer'] ? 'mini-cart' : 'main-cart'),
						{
							credentials: 'same-origin',
							method: 'GET',
						},
					).then(function (content) {
						// If there is an element to animate, we animate it using a transition
						if (_this4.options['drawer'] && elementToAnimate) {
							var timelineLite = new TimelineLite({
								onComplete: function onComplete() {
									content.text().then(function (html) {
										_this4._replaceContent(html)
									})
								},
							})

							var newHeight = 0

							if (_this4.itemCount === 0) {
								elementToAnimate = _this4.element.querySelector('.Drawer__Content')
								newHeight = '232px'
							}

							timelineLite.to(
								elementToAnimate,
								0.5,
								{
									height: newHeight,
									opacity: 0,
									ease: Cubic.easeOut,
								},
								0,
							)

							if (_this4.itemCount === 0) {
								timelineLite.to(
									_this4.element.querySelector('.Drawer__Footer'),
									0.5,
									{
										y: '100%',
										transition: 'none',
										ease: Cubic.easeInOut,
									},
									0,
								)
							}
						} else {
							content.text().then(function (html) {
								_this4._replaceContent(html)
							})
						}
					})
				},
			},
			{
				key: '_getCart',
				value: function _getCart() {
					return fetch(''.concat(window.routes.cartUrl, '.js'), {
						credentials: 'same-origin',
						method: 'GET',
						headers: {
							'Content-Type': 'application/json',
							'X-Requested-With': 'XMLHttpRequest',
						},
					}).then(function (response) {
						return response.json()
					})
				}
			},
			{
				key: '_getSSProductRecommended',
				value: async function _getSSProductRecommended(payload) {
					const siteId = this.options.ssProductSiteId
					const params = new URLSearchParams()

					if (!siteId.length) {
						return []
					}

					if (payload.productId) {
						params.append('product', payload.productId)
					}
					if (payload.lastViewed) {
						params.append('lastViewed', payload.lastViewed)
					}
					if (payload.tags) {
						params.append('tags', payload.tags)
					}
					if (payload.limits) {
						params.append('limits', payload.limits)
					}
					if (payload.cart) {
						params.append('cart', payload.cart)
					}
					if (payload.shopper) {
						params.append('shopper', payload.shopper)
					}

					const endpoint = `https://${siteId}.a.searchspring.io/boost/${siteId}/recommend?${params}`

					try {
						const response = await fetch(endpoint);
						const result = await response.json()

						return result[0].results
					} catch (error) {
						throw new Error(`call API search spring is error: ${error}`)
					}
				}
			},
			{
				key: '_addToCart',
				value: function _addToCart(event, target) {
					const cartEl = this.element.querySelector('.Cart')
					const variantId = target.dataset.variant_id
					const request = {
						items: [
							{
								id: variantId,
								quantity: 1
							}
						]
					}
					
					document.dispatchEvent(new CustomEvent('theme:loading:start'))
					cartEl && cartEl.classList.add('loading')

					try {
						fetch(''.concat(window.routes.cartAddUrl, '.js'), {
							body: JSON.stringify(request),
							credentials: 'same-origin',
							method: 'POST',
							headers: {
								'Content-Type': 'application/json',
								'X-Requested-With': 'XMLHttpRequest'
							},
						}).then(function (response) {
							document.dispatchEvent(new CustomEvent('theme:loading:end'))
							if (response.ok) {
								document.documentElement.dispatchEvent(
									new CustomEvent('cart:refresh', {
										bubbles: true,
									}),
								)
							}
						})
					} catch (error) {
						throw new Error(`Error ATC Recommended`)
					}
				}
			},
			{
				key: '_replaceContent',
				value: async function _replaceContent(html) {
					var _this5 = this
					var tempElement = document.createElement('div')
					const cartEl = this.element.querySelector('.Cart')

					tempElement.innerHTML = html

					if (this.options.ssEnable) {
						const cart = await this._getCart()

						const skus = cart.items.map(item => item.sku)

						if (skus.length) {
							setCookie({
								name: 'ssCartProducts', 
								value: skus.join(',')
							})
						} else {
							deleteCookie('ssCartProducts')
						}
						
						if (cart.items.length > 0) {
							let recommendedHtml = ''
							let swiperCartRecommended
							const cartRecommended = this.element.querySelector('.cart-recommened')
							const cartRecommendedItemsEls = tempElement.querySelectorAll('.js-cart-recommended-items')
							const limitProduct = GM_STATE.shopify.limitProductCartRecommended
							const payloadSS = {
								productId: cart.items[0].product_id.toString(),
								tags: this.options.ssResultRecommendProfile,
								limit: this.options.ssLimitProduct
							}
							const ssProducts = await this._getSSProductRecommended(payloadSS)
							const productsNonMultiOption = ssProducts.filter((product) => {
								const isMultiOption = product.attributes?.tags?.some((tag) => tag === 'multi-stone' || tag === 'multi-letter') || false

								return !isMultiOption
							})

							if (swiperCartRecommended?.destroy) {
								swiperCartRecommended.destroy()
							}

							if (productsNonMultiOption.length > 0) {
								cartRecommended && cartRecommended.classList.remove('hidden')
								productsNonMultiOption.slice(0, limitProduct).forEach((product) => {
									recommendedHtml += '<div class="swiper-slide">'
										recommendedHtml += '<div class="cart-recommened__item">'
											recommendedHtml += '<div class="cart-recommened__item-image">'
												recommendedHtml += `<a href="${rootUrlWithoutSlash}${product.mappings.core.url}" title="${product.mappings.core.name}">`
													recommendedHtml += `<img src="${product.attributes.ss_image || GM_STATE.shopify.defaultImage}" width="auto" height="auto" alt="${product.mappings.core.name}"`
												recommendedHtml += '</a>'
											recommendedHtml += '</div>'
											recommendedHtml += '<div class="cart-recommened__item-info">'
												recommendedHtml += '<div class="cart-recommened__item-title">'
													recommendedHtml += `<a href="${rootUrlWithoutSlash}${product.mappings.core.url}" title="${product.mappings.core.name}">${product.mappings.core.name}</a>`
												recommendedHtml += '</div>'
												recommendedHtml += `<div class="cart-recommened__item-price">${Currency.formatMoney(product.mappings.core.price * 100, `{{amount}} ${Shopify.currency.active || window.theme.currency}`)} <span class="Price--compareAt">${product.mappings.core.msrp > product.mappings.core.price ? (Currency.formatMoney(product.mappings.core.msrp * 100, `{{amount}} ${Shopify.currency.active || window.theme.currency}`)) : ''}</span></div>`
												recommendedHtml += `<div class="cart-recommened__item-action Button Button--quaternary-dark ${!product.attributes?.variant_id ? 'hidden' : ''}" data-variant_id="${product.attributes?.variant_id?.split('|')[0] || ''}" data-action="add-to-cart">Add to bag</div>`
											recommendedHtml += '</div>'
										recommendedHtml += '</div>'
									recommendedHtml += '</div>'
								})

								if (cartRecommendedItemsEls.length > 0) {
									cartRecommendedItemsEls.forEach((item) => {
										item.innerHTML = recommendedHtml
									})
								}

								setTimeout(() => {
									swiperCartRecommended = new Swiper('.js-carousel-cart-recommended', {
										slidesPerView: 1,
										pagination: {
											el: '.swiper-cart-recommended-pagination',
											enabled: true
										},
										breakpoints: {
											768: {
												slidesPerView: "auto",
												spaceBetween: 12
											},
											1024: {
												slidesPerView: 1,
												spaceBetween: 0
											}
										}
									})
								}, 400)
							} else {
								cartRecommended && cartRecommended.classList.add('hidden')
							}

							document.dispatchEvent(new CustomEvent('cart:rendered', {
								detail: {
									items: cart.items
								}
							}))
						}
					}

					var cartNodeParent = this.element.querySelector('.Cart').parentNode

					if (this.options['drawer'] && window.theme.pageType !== 'cart') {
						var currentScrollPosition = this.element.querySelector('.Drawer__Main').scrollTop
						cartNodeParent.replaceChild(
							tempElement.querySelector('.Cart'),
							this.element.querySelector('.Cart'),
						)
						this.element.querySelector('.Drawer__Main').scrollTop = currentScrollPosition
					} else {
						// For dedicated page we replace the whole section if there is no more product
						if (this.itemCount === 0) {
							this.element.innerHTML =
								tempElement.querySelector('.shopify-section').firstElementChild.innerHTML
						} else {
							cartNodeParent.replaceChild(
								tempElement.querySelector('.Cart'),
								this.element.querySelector('.Cart'),
							)
							//this.element.querySelector('.PageHeader').innerHTML = tempElement.querySelector('.PageHeader').innerHTML;
						}
					} // We can also update the dot and the quantity

					cartEl && cartEl.classList.remove('loading')

					var cartResult = JSON.parse(
						tempElement
							.querySelector('[data-section-type="cart"]')
							.getAttribute('data-section-settings'),
					)
					var cartDot = Dom.nodeListToArray(document.querySelectorAll('.Header__CartDot')),
						cartQuantity = Dom.nodeListToArray(document.querySelectorAll('.Header__CartCount'))
					this.itemCount = cartResult['itemCount']

					// check cart.items to show/hide dot bag
					const cartDotHeaderEls = document.querySelectorAll('.js-bag-dot')

					if (cartDotHeaderEls.length > 0) {
						cartDotHeaderEls.forEach((cartDot) => {
							if (this.itemCount > 0) {
								cartDot.classList.remove('hidden')
							} else {
								cartDot.classList.add('hidden')
							}
						});
					}

					cartDot.forEach(function (item) {
						if (_this5.itemCount === 0) {
							item.classList.remove('is-visible') // IE 11 and lower does not support second attribute of toggle :(
						} else {
							item.classList.add('is-visible')
						}
					})
					cartQuantity.forEach(function (item) {
						if (_this5.itemCount === 0) {
							item.classList.remove('is-visible') // IE 11 and lower does not support second attribute of toggle :(
						} else {
							item.classList.add('is-visible')
						}
					})
				},
			},
		])

		return CartSection
	})()

	var USPsSection = /*#__PURE__*/ (function () {
		function USPsSection(container) {
			_classCallCheck(this, USPsSection)
			this.element = container
			var uspsElement = this.element.querySelector('[data-flickity-config]')
			if (uspsElement) {
				this.carousel = new Carousel(uspsElement)
			}

			if (Responsive.matchesBreakpoint('tablet-and-up') && this.carousel) {
				this.carousel.destroy()
			}

			window.addEventListener('resize', function() {
				if (Responsive.matchesBreakpoint('tablet-and-up') && this.carousel) {
					this.carousel.destroy()
				} else {
					this.carousel = new Carousel(uspsElement)
				}
			})
		}

		_createClass(USPsSection, [
			{
				key: 'onUnload',
				value: function onUnload() {
					if (this.carousel) {
						this.carousel.destroy()
					}
				},
			},
			{
				key: 'onBlockSelect',
				value: function onBlockSelect(event) {
					if (this.carousel) {
						this.carousel.selectCell(
							event.target.getAttribute('data-slide-index'),
							true,
							!event.detail.load,
						)
					}
				},
			},
			{
				key: 'onBlockDeselect',
				value: function onBlockDeselect() {
					if (this.carousel) {
						this.carousel.unpausePlayer()
					}
				},
			},

		])

		return USPsSection
	})()

	/**
	 * This class allows to automatically scrolls within a div when this div does not fit into the visible space
	 */
	var OverflowScroller = /*#__PURE__*/ (function () {
		function OverflowScroller(element) {
			_classCallCheck(this, OverflowScroller)

			if (!element) {
				return
			}

			this.element = element
			this.lastKnownY = window.scrollY
			this.currentTop = 0
			this.initialTopOffset = parseInt(window.getComputedStyle(this.element).top)

			this._attachListeners()
		}

		_createClass(OverflowScroller, [
			{
				key: 'destroy',
				value: function destroy() {
					window.removeEventListener('scroll', this._checkPositionListener)
				},
			},
			{
				key: '_attachListeners',
				value: function _attachListeners() {
					this._checkPositionListener = this._checkPosition.bind(this)
					window.addEventListener('scroll', this._checkPositionListener)
				},
			},
			{
				key: '_checkPosition',
				value: function _checkPosition() {
					var _this = this

					fastdom.measure(function () {
						var bounds = _this.element.getBoundingClientRect(),
							maxTop =
								bounds.top + window.scrollY - _this.element.offsetTop + _this.initialTopOffset,
							minTop = _this.element.clientHeight - window.innerHeight

						if (window.scrollY < _this.lastKnownY) {
							_this.currentTop -= window.scrollY - _this.lastKnownY
						} else {
							_this.currentTop += _this.lastKnownY - window.scrollY
						}

						_this.currentTop = Math.min(
							Math.max(_this.currentTop, -minTop),
							maxTop,
							_this.initialTopOffset,
						)
						_this.lastKnownY = window.scrollY
					})
					fastdom.mutate(function () {
						_this.element.style.top = ''.concat(_this.currentTop, 'px')
					})
				},
			},
		])

		return OverflowScroller
	})()

	var CollectionSection = /*#__PURE__*/ (function () {
		function CollectionSection(element) {
			_classCallCheck(this, CollectionSection)

			this.element = element
			this.delegateElement = new domDelegate.Delegate(this.element)
			this.toolbarElement = this.element.querySelector('.CollectionToolbar')
			this.collectionInnerElement = this.element.querySelector('.CollectionInner__Products')
			this.settings = JSON.parse(this.element.getAttribute('data-section-settings')) // Create the popover if available
			this.lastScrollTop = 0
			var filterDrawerElement = document.getElementById('collection-filter-drawer')

			if (filterDrawerElement) {
				this.filterDrawer = new Drawer(filterDrawerElement)
			} // Create scroller of sidebar

			var sortDrawerElement = document.getElementById('collection-sort-drawer')

			if (sortDrawerElement) {
				this.sortDrawer = new Drawer(sortDrawerElement)
			} // Create scroller of sidebar

			if (this.settings['filterPosition'] === 'sidebar') {
				this.filterInnerSidebarScroller = new OverflowScroller(
					this.element.querySelector('.CollectionInner__Sidebar'),
				)
			} // Setup parallax on image (if any)

			var collectionImageElement = this.element.querySelector('.PageHeader__ImageWrapper')

			if (
				collectionImageElement &&
				window.matchMedia('(-moz-touch-enabled: 0), (hover: hover)').matches
			) {
				this.parallaxInstance = new Rellax('.PageHeader__ImageWrapper', {
					speed: -7,
					center: false,
					round: true,
				})
			} // Setup product item color swatch

			new ProductItemColorSwatch(this.element.querySelector('.ProductList')) // Setup animation

			this.timeline = new TimelineLite({
				delay: window.theme.showPageTransition ? 0.5 : 0,
			})

			this._setupAnimation()

			if (this.settings['showLayoutSwitch']) {
				this._createLayoutSlider()
			}

			this._attachListeners()
		}

		_createClass(CollectionSection, [
			{
				key: 'onUnload',
				value: function onUnload() {
					this.delegateElement.off('click')

					if (this.sortPopover) {
						this.sortPopover.destroy()
					}

					if (this.filterDrawer) {
						this.filterDrawer.destroy()
					}

					if (this.sortDrawer) {
						this.sortDrawer.destroy()
					}

					if (this.filterInnerSidebarScroller) {
						this.filterInnerSidebarScroller.destroy()
					}

					if (this.parallaxInstance) {
						this.parallaxInstance.destroy()
					}

					if (window.theme.showElementStaggering) {
						this.intersectionObserver.disconnect()
						this.timeline.kill()
					}

					if (this.draggableLayoutSwitch) {
						this.draggableLayoutSwitch[0].kill()
					}

					if (this.settings['showLayoutSwitch']) {
						document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener)
					}

					window.removeEventListener('scroll', this._scrollDirectionListener, false)
				},
			},
			{
				key: '_setupAnimation',
				value: function _setupAnimation() {
					var _this = this

					var forceLoadFromTop =
						arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false

					if (!window.theme.showElementStaggering) {
						return
					} // If there is already an observer set up, we remove it first

					if (this.intersectionObserver) {
						this.intersectionObserver.disconnect()
					}

					if (forceLoadFromTop) {
						this.timeline.clear()
						this.timeline.staggerFromTo(
							this.element.querySelectorAll('.ProductList .ProductItem, .ArticleList .ArticleItem'),
							0.25,
							{
								autoAlpha: 0,
								y: 25,
							},
							{
								autoAlpha: 1,
								y: 0,
							},
							0.1,
						)
					} else {
						this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this), {
							threshold: 0.3,
						})
						Dom.nodeListToArray(
							this.element.querySelectorAll('.ProductList .ProductItem, .ArticleList .ArticleItem'),
						).forEach(function (item) {
							_this.intersectionObserver.observe(item)
						})
					}
				},
			},
			{
				key: '_reveal',
				value: function _reveal(results) {
					var _this2 = this

					var toReveal = []
					results.forEach(function (result) {
						if (result.isIntersecting || result.intersectionRatio > 0) {
							// isIntersecting does not exist on Samsung Android browser
							toReveal.push(result.target)

							_this2.intersectionObserver.unobserve(result.target)
						}
					})

					if (toReveal.length === 0) {
						return
					}

					this.timeline.staggerFromTo(
						toReveal,
						0.35,
						{
							autoAlpha: 0,
							y: 25,
						},
						{
							autoAlpha: 1,
							y: 0,
						},
						0.15,
					)
				},
			},
			{
				key: '_createLayoutSlider',
				value: function _createLayoutSlider() {
					if (this.draggableLayoutSwitch) {
						this.draggableLayoutSwitch[0].kill()
					}

					if (Responsive.matchesBreakpoint('phone')) {
						var wrapperElement = document.getElementById('CollectionToolbar__LayoutSwitch_Mobile')
						var draggableElement = document.getElementById(
							'CollectionToolbar__LayoutSwitch_Mobile_Slider',
						)
						var snapRatio = 1
					} else {
						var wrapperElement = document.getElementById('CollectionToolbar__LayoutSwitch_Desktop')
						var draggableElement = document.getElementById(
							'CollectionToolbar__LayoutSwitch_Desktop_Slider',
						)
						var snapRatio = 2
					}

					if (!wrapperElement) {
						console.warn('Could not find wrapperElement in _createLayoutSlider')
						return
					}

					var BB = wrapperElement.getBoundingClientRect()
					var W = BB.width
					var H = BB.height

					gsap.set(draggableElement, {
						left: draggableElement.offsetLeft + 'px',
					})

					this.draggableLayoutSwitch = Draggable.create(draggableElement, {
						type: 'left',
						bounds: wrapperElement,
						throwProps: true,
						maxDuration: 0.5,
						snap: {
							left: function (endValue) {
								return Math.round(endValue / (W / snapRatio)) * (W / snapRatio)
							},
						},
						onDragEnd: function () {
							var snapPoint = Math.round(this.endX / (W / snapRatio))
							if (Responsive.matchesBreakpoint('phone')) {
								document.querySelectorAll('[data-grid-type="mobile"]')[snapPoint].click()
							} else {
								document.querySelectorAll('[data-grid-type="desktop"]')[snapPoint].click()
							}
						},
					})
				},
			},
			{
				key: '_changeLayoutMode',
				value: function _changeLayoutMode(event, target) {
					var _this3 = this

					var layoutType = target.getAttribute('data-grid-type'),
						newCount = parseInt(target.getAttribute('data-count')) // Otherwise we detect the mode, and change all classes

					var productList = this.collectionInnerElement.querySelector('.ProductList')

					if (productList) {
						var previousCount = parseInt(
							productList.getAttribute('data-'.concat(layoutType, '-count')),
						)

						if (previousCount === newCount) {
							return // Nothing has changed so we just return to avoid reflow
						}

						productList.setAttribute('data-'.concat(layoutType, '-count'), newCount)
						Dom.nodeListToArray(productList.querySelectorAll('.Grid__Cell')).forEach(function (
							item,
						) {
							if (item.getAttribute('data-col-span')) {
								if (layoutType === 'mobile') {
									item.classList.remove(
										item.getAttribute('data-col-span') + '/' + previousCount + '--phone',
									)
									if (newCount == 4 || item.getAttribute('data-col-span') == 1) {
										item.classList.add(
											item.getAttribute('data-col-span') + '/' + newCount + '--phone',
										)
									}
								} else {
									var previousNumerator = (
											previousCount === 6
												? item.getAttribute('data-col-span') * 2
												: item.getAttribute('data-col-span')
										).toString(),
										newNumerator = (
											newCount === 6
												? item.getAttribute('data-col-span') * 2
												: item.getAttribute('data-col-span')
										).toString()

									var previousDenominator = (previousCount === 6 ? 12 : previousCount).toString(),
										newDenominator = (newCount === 6 ? 12 : newCount).toString()

									if (_this3.settings['filterPosition'] === 'drawer') {
										item.classList.remove(
											previousNumerator + '/' + previousDenominator + '--lap-and-up',
										)
										item.classList.add(newNumerator + '/' + newDenominator + '--lap-and-up')
									} else {
										item.classList.remove(previousNumerator + '/' + previousDenominator + '--desk')
										item.classList.add(newNumerator + '/' + newDenominator + '--desk')
									}

									item.classList.remove(
										previousNumerator + '/' + previousDenominator + '--tablet-and-up',
									)
									item.classList.add(newNumerator + '/' + newDenominator + '--tablet-and-up')
								}

								if (window.theme.showElementStaggering) {
									item.firstElementChild.style.visibility = 'hidden' // Make it as hidden so we can re-trigger the animation
								}
							} else {
								if (layoutType === 'mobile') {
									item.classList.remove('1/'.concat(previousCount, '--phone')) // IE11 and lower does not support classList.replace
									item.classList.add('1/'.concat(newCount, '--phone'))
								} else {
									var previousNumerator = (previousCount === 6 ? 2 : 1).toString(),
										newNumerator = (newCount === 6 ? 2 : 1).toString()

									var previousDenominator = (previousCount === 6 ? 12 : previousCount).toString(),
										newDenominator = (newCount === 6 ? 12 : newCount).toString()

									if (_this3.settings['filterPosition'] === 'drawer') {
										item.classList.remove(
											previousNumerator + '/' + previousDenominator + '--lap-and-up',
										)
										item.classList.add(newNumerator + '/' + newDenominator + '--lap-and-up')
									} else {
										item.classList.remove(previousNumerator + '/' + previousDenominator + '--desk')
										item.classList.add(newNumerator + '/' + newDenominator + '--desk')
									}

									item.classList.remove(
										previousNumerator + '/' + previousDenominator + '--tablet-and-up',
									)
									item.classList.add(newNumerator + '/' + newDenominator + '--tablet-and-up')
								}

								if (window.theme.showElementStaggering) {
									item.firstElementChild.style.visibility = 'hidden' // Make it as hidden so we can re-trigger the animation
								}
							}
						}) // Force lazy sizes to recalculate item sizes

						lazySizes.autoSizer.checkElems()
					}

					target.classList.add('is-active')

					for (var i = 0; i < Dom.getSiblings(target).length; i++) {
						Dom.getSiblings(target)[i].classList.remove('is-active')
					}

					this._setupAnimation() // In order to prevent reflow and provide better user experience, we save into cart attributes (those are removed before the checkout
					// is submitted) the user choices so they are preserved on page reload, without the need to use JavaScript

					fetch(''.concat(window.routes.cartUrl, '/update.js'), {
						body: JSON.stringify({
							attributes: _defineProperty(
								{},
								'collection_'.concat(layoutType, '_items_per_row'),
								newCount,
							),
						}),
						credentials: 'same-origin',
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
						},
					})
				},
			},
			{
				key: '_changeViewMode',
				value: function _changeViewMode(event, target) {
					var productList = this.collectionInnerElement.querySelector('.ProductList')

					if (productList) {
						var previousView = productList.getAttribute('data-view-type')
						var newView = target.getAttribute('data-view-type')
						if (previousView === newView) {
							return // Nothing has changed so we just return to avoid reflow
						}

						productList.setAttribute('data-view-type', newView)

						Dom.nodeListToArray(productList.querySelectorAll('.ProductItem')).forEach(function (
							item,
						) {
							item.classList.remove(previousView) // IE11 and lower does not support classList.replace
							item.classList.add(newView)

							if (window.theme.showElementStaggering) {
								item.firstElementChild.style.visibility = 'hidden' // Make it as hidden so we can re-trigger the animation
							}
						}) // Force lazy sizes to recalculate item sizes

						lazySizes.autoSizer.checkElems()
					}

					target.classList.add('is-active')

					for (var i = 0; i < Dom.getSiblings(target).length; i++) {
						if (
							Dom.getSiblings(target)[i].hasAttribute('data-action') &&
							Dom.getSiblings(target)[i].getAttribute('data-action') == 'change-view-mode'
						) {
							Dom.getSiblings(target)[i].classList.remove('is-active')
						}
					}

					this._setupAnimation() // In order to prevent reflow and provide better user experience, we save into cart attributes (those are removed before the checkout
					// is submitted) the user choices so they are preserved on page reload, without the need to use JavaScript

					fetch(''.concat(window.routes.cartUrl, '/update.js'), {
						body: JSON.stringify({
							attributes: _defineProperty({}, 'collection_'.concat('view_type'), newView),
						}),
						credentials: 'same-origin',
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
						},
					})
				},
			},
			{
				key: '_sortByChanged',
				value: function _sortByChanged(event) {
					var sortBy = event.target.getAttribute('data-value')
					var currentUrl = new URL(location.href)

					Dom.nodeListToArray(
						this.element.querySelectorAll('[data-action="select-value"]'),
					).forEach(function (sortByElement, index) {
						sortByElement.classList.remove('is-selected')
					})

					this.sortDrawer.close()

					event.target.classList.add('is-selected')

					currentUrl.searchParams.set('sort_by', sortBy)
					currentUrl.searchParams.delete('page')

					this._reloadProducts(currentUrl.toString())
				},
			},
			{
				key: '_onFiltersCleared',
				value: function _onFiltersCleared(event) {
					this._reloadProducts(event.target.getAttribute('data-url'))
				},
			},
			{
				key: '_onFilterChanged',
				value: function _onFilterChanged(event) {
					var formData = new FormData(event.target.closest('form'))
					var searchParamsAsString = new URLSearchParams(formData).toString()

					this._reloadProducts(
						''.concat(window.location.pathname, '?').concat(searchParamsAsString),
					)
				},
			},
			{
				key: '_reloadProducts',
				value: function _reloadProducts(url) {
					var _this4 = this

					if (this.abortController) {
						this.abortController.abort()
					}

					document.dispatchEvent(new CustomEvent('theme:loading:start'))

					if (history.replaceState) {
						window.history.pushState(
							{
								path: url,
							},
							'',
							url,
						)
					}

					var currentUrl = new URL(window.location)
					currentUrl.searchParams.set('section_id', this.settings['sectionId'])

					try {
						this.abortController = new AbortController()
						fetch(currentUrl.toString(), {
							signal: this.abortController.signal,
						}).then(function (response) {
							response.text().then(function (content) {
								var tempElement = document.createElement('div')
								tempElement.innerHTML = content
								if (!tempElement.querySelector('.CollectionInner__Products')) {
									return
								}
								_this4.collectionInnerElement.innerHTML = tempElement.querySelector(
									'.CollectionInner__Products',
								).innerHTML
								var toolbarFilter = tempElement.querySelector(
									'.CollectionToolbar__Item--filter:not([data-action="open-top-filter"])',
								)

								if (toolbarFilter) {
									var newToolbarFilter = _this4.element.querySelector(
										'.CollectionToolbar__Item--filter',
									)

									newToolbarFilter.innerHTML = toolbarFilter.innerHTML
									newToolbarFilter.className = toolbarFilter.className
								} // We also replace the filters

								var toolbarFilterDesktop = tempElement.querySelector(
									'.CollectionToolbar__Item--filter[data-action="open-top-filter"]',
								)

								if (toolbarFilterDesktop) {
									var newToolbarFilterDesktop = _this4.element.querySelector(
										'.CollectionToolbar__Item--filter[data-action="open-top-filter"]',
									)

									newToolbarFilterDesktop.innerHTML = newToolbarFilterDesktop.innerHTML
									newToolbarFilterDesktop.className = newToolbarFilterDesktop.className
								} // We also replace the filters

								var collectionFiltersDrawer = _this4.element.querySelector(
										'#collection-filters-drawer-form',
									),
									collectionFiltersSidebar = _this4.element.querySelector(
										'#collection-filters-sidebar-form',
									),
									collectionFiltersToolbar = _this4.element.querySelector(
										'#collection-filters-top-form',
									)

								if (collectionFiltersDrawer) {
									var newDrawerContent = tempElement.querySelector(
										'#collection-filters-drawer-form',
									)
									Array.from(collectionFiltersDrawer.querySelectorAll('.Collapsible')).forEach(
										function (collapsible) {
											var newCollapsible = newDrawerContent.querySelector(
												'[data-filter-index="'.concat(
													collapsible.getAttribute('data-filter-index'),
													'"]',
												),
											)

											if (collapsible.firstElementChild.getAttribute('aria-expanded') === 'true') {
												newCollapsible.style.overflow = 'visible'
												newCollapsible.firstElementChild.setAttribute('aria-expanded', 'true')
												newCollapsible.lastElementChild.style.height = 'auto'
												newCollapsible.lastElementChild.style.overflow = 'visible'
											}
										},
									)
									collectionFiltersDrawer.innerHTML = newDrawerContent.innerHTML
									new ProductItemColorSwatch(_this4.element.querySelector('.ProductList'))

									_this4.element.querySelector('.FilterResetButton').innerHTML =
										tempElement.querySelector('.FilterResetButton').innerHTML
								}

								if (collectionFiltersSidebar) {
									var newSidebarContent = tempElement.querySelector(
										'#collection-filters-sidebar-form',
									)
									Array.from(collectionFiltersSidebar.querySelectorAll('.Collapsible')).forEach(
										function (collapsible) {
											var newCollapsible = newSidebarContent.querySelector(
												'[data-filter-index="'.concat(
													collapsible.getAttribute('data-filter-index'),
													'"]',
												),
											)

											if (collapsible.firstElementChild.getAttribute('aria-expanded') === 'true') {
												newCollapsible.style.overflow = 'visible'
												newCollapsible.firstElementChild.setAttribute('aria-expanded', 'true')
												newCollapsible.lastElementChild.style.height = 'auto'
												newCollapsible.lastElementChild.style.overflow = 'visible'
											}
										},
									)
									collectionFiltersSidebar.innerHTML = newSidebarContent.innerHTML
								}

								if (collectionFiltersToolbar) {
									var newToolbarContent = tempElement.querySelector('#collection-filters-top-form')
									Array.from(collectionFiltersToolbar.querySelectorAll('.Collapsible')).forEach(
										function (collapsible) {
											var newCollapsible = newToolbarContent.querySelector(
												'[data-filter-index="'.concat(
													collapsible.getAttribute('data-filter-index'),
													'"]',
												),
											)

											if (collapsible.firstElementChild.getAttribute('aria-expanded') === 'true') {
												newCollapsible.style.overflow = 'visible'
												newCollapsible.firstElementChild.setAttribute('aria-expanded', 'true')
												newCollapsible.lastElementChild.style.height = 'auto'
												newCollapsible.lastElementChild.style.overflow = 'visible'
											}
										},
									)
									collectionFiltersToolbar.innerHTML = newToolbarContent.innerHTML
								}

								document.dispatchEvent(new CustomEvent('theme:loading:end'))

								_this4._setupAnimation(true) // We scroll to the top

								var elementOffset =
									_this4.element.querySelector('.CollectionMain').getBoundingClientRect().top -
									parseInt(document.documentElement.style.getPropertyValue('--header-height'))

								if (
									Responsive.matchesBreakpoint('lap-and-up') &&
									_this4.toolbarElement &&
									_this4.toolbarElement.clientHeight === 0
								) {
									elementOffset -= 50
								}

								if (elementOffset < 0) {
									window.scrollBy({
										top: elementOffset,
										behavior: 'smooth',
									})
								}

								document.documentElement.dispatchEvent(
									new CustomEvent('new:element:loaded', {
										bubbles: true,
										detail: {
											container: _this4.collectionInnerElement,
										},
									}),
								)
							})
						})
					} catch (exception) {}

				},
			},
			{
				key: '_openTopFilter',
				value: function _openTopFilter() {},
			},
			{
				key: '_dispatchToolBarStatusActive',
				value: function _dispatchToolBarStatusActive() {
					document.dispatchEvent(new CustomEvent('toolbar:status:active'))
				},
			},
			{
				key: '_dispatchToolBarStatusInactive',
				value: function _dispatchToolBarStatusInactive() {
					document.dispatchEvent(new CustomEvent('toolbar:status:inactive'))
				},
			},
			{
				key: '_scrollDirection',
				value: function _scrollDirection() {
					var st = window.pageYOffset || document.documentElement.scrollTop
					if (
						st > this.lastScrollTop &&
						!this.element.classList.contains('HideToolbar') &&
						this.element.querySelector('.ProductListWrapper').getBoundingClientRect().top < 0
					) {
						this.element.classList.add('HideToolbar')
					} else if (st < this.lastScrollTop && this.element.classList.contains('HideToolbar')) {
						this.element.classList.remove('HideToolbar')
					}
					this.lastScrollTop = st <= 0 ? 0 : st
				},
			},
			{
				key: '_attachListeners',
				value: function _attachListeners() {
					this._changeLayoutModeListener = this._changeLayoutMode.bind(this)
					this._changeViewModeListener = this._changeViewMode.bind(this)
					this._scrollDirectionListener = this._scrollDirection.bind(this)

					if (this.settings['showLayoutSwitch']) {
						this._onBreakpointChangedListener = this._createLayoutSlider.bind(this)
						document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener)
					}

					this.delegateElement.on(
						'click',
						'[data-action="change-layout-mode"]',
						this._changeLayoutModeListener,
					)
					this.delegateElement.on(
						'click',
						'[data-action="change-view-mode"]',
						this._changeViewModeListener,
					)
					this.delegateElement.on(
						'click',
						'[data-action="open-top-filter"]',
						this._openTopFilter.bind(this),
					)
					this.delegateElement.on(
						'click',
						'[data-action="clear-filters"]',
						this._onFiltersCleared.bind(this),
					)
					this.delegateElement.on('change', '[name^="filter."]', this._onFilterChanged.bind(this))

					this.delegateElement.on(
						'mouseenter',
						'.CollectionToolbar',
						this._dispatchToolBarStatusActive.bind(this),
						true,
					)
					this.delegateElement.on(
						'focusin',
						'.CollectionToolbar',
						this._dispatchToolBarStatusActive.bind(this),
						true,
					)
					this.delegateElement.on(
						'mouseleave',
						'.CollectionToolbar',
						this._dispatchToolBarStatusInactive.bind(this),
						true,
					)

					this.delegateElement.on(
						'click',
						'[data-action="select-value"]',
						this._sortByChanged.bind(this),
						true,
					)

					this.delegateElement.on(
						'click',
						'[data-action="select-value"]',
						this._sortByChanged.bind(this),
						true,
					)

					window.addEventListener('scroll', this._scrollDirectionListener, false)

					this._sortByChanged.bind(this)

					window.addEventListener('popstate', function (event) {
						if (event.state && event.state.path) {
							window.location.href = event.state.path
						}
					})
				},
			},
		])

		return CollectionSection
	})()

	var CollectionTickerSection = /*#__PURE__*/ (function () {
		function CollectionTickerSection(element) {
			_classCallCheck(this, CollectionTickerSection)

			this.element = element
			this.collectionTickerWrapper = this.element.querySelector('#CollectionTicker__Wrapper')
			this.collectionTickerContent = this.element.querySelector('.CollectionTicker__Content')
			this.createTicker()
		}

		_createClass(CollectionTickerSection, [
			{
				key: 'onUnload',
				value: function onUnload() {
					gsap.killTweensOf('.CollectionTicker__Content')
				},
			},
			{
				key: 'createTicker',
				value: function createTicker() {
					for (let i = 0; i < 2; i++) {
						var CollectionTicker__Content = this.collectionTickerContent.cloneNode(true)
						this.collectionTickerWrapper.appendChild(CollectionTicker__Content)
					}
					gsap.to('.CollectionTicker__Content', {
						x: -CollectionTicker__Content.offsetWidth,
						repeat: -1,
						ease: 'linear',
						duration: CollectionTicker__Content.offsetWidth * 0.02,
					})
				},
			},
		])

		return CollectionTickerSection
	})()

	var FaqSection = /*#__PURE__*/ (function () {
		function FaqSection(element) {
			_classCallCheck(this, FaqSection)

			this.element = element
			this.delegateElement = new domDelegate.Delegate(this.element)

			this._attachListeners()
		}

		_createClass(FaqSection, [
			{
				key: 'onUnload',
				value: function onUnload() {
					this.delegateElement.off()
				},
			},
			{
				key: 'onBlockSelect',
				value: function onBlockSelect(event) {
					this._openItem(event.target)
				},
			},
			{
				key: 'onBlockDeselect',
				value: function onBlockDeselect(event) {
					this._closeItem(event.target)
				},
			},
			{
				key: '_attachListeners',
				value: function _attachListeners() {
					this.delegateElement.on('click', '.Faq__Question', this._toggleItem.bind(this))
					this.delegateElement.on('click', '.FaqSummary__Item', this._switchToCategory.bind(this))
				},
			},
			{
				key: '_switchToCategory',
				value: function _switchToCategory(event, target) {
					target.classList.add('is-active')
					Dom.getSiblings(target, '.is-active').forEach(function (item) {
						item.classList.remove('is-active')
					})
				},
			},
			{
				key: '_toggleItem',
				value: function _toggleItem(event, target) {
					var item = target.closest('.Faq__Item')

					if (item.getAttribute('aria-expanded') === 'true') {
						this._closeItem(item)
					} else {
						this._openItem(item)
					}
				},
			},
			{
				key: '_openItem',
				value: function _openItem(item) {
					var answerWrapper = item.querySelector('.Faq__AnswerWrapper')
					item.setAttribute('aria-expanded', 'true')
					answerWrapper.setAttribute('aria-hidden', 'false')
					Animation.slideDown(answerWrapper, true)
					Dom.getSiblings(item, '[aria-expanded="true"]').forEach(function (siblingItem) {
						var siblingAnswerWrapper = siblingItem.querySelector('.Faq__AnswerWrapper')
						siblingItem.setAttribute('aria-expanded', 'false')
						siblingAnswerWrapper.setAttribute('aria-hidden', 'true')
						Animation.slideUp(siblingAnswerWrapper)
					})
				},
			},
			{
				key: '_closeItem',
				value: function _closeItem(item) {
					var answerWrapper = item.querySelector('.Faq__AnswerWrapper')
					item.setAttribute('aria-expanded', 'false')
					answerWrapper.setAttribute('aria-hidden', 'true')
					Animation.slideUp(answerWrapper)
				},
			}
		])

		return FaqSection
	})()

	var GiftCardSection = /*#__PURE__*/ (function () {
		function GiftCardSection(container) {
			_classCallCheck(this, GiftCardSection)

			this.element = container

			this._createQrCode()

			this._setupPrint()
		}

		_createClass(GiftCardSection, [
			{
				key: '_createQrCode',
				value: function _createQrCode() {
					var qrCodeElement = document.getElementById('QrCode')
					new QRCode(qrCodeElement, {
						text: qrCodeElement.getAttribute('data-identifier'),
						width: 120,
						height: 120,
					})
				},
			},
			{
				key: '_setupPrint',
				value: function _setupPrint() {
					var printElement = document.getElementById('PrintGiftCard')

					if (printElement) {
						printElement.addEventListener('click', function () {
							window.print()
						})
					}
				},
			},
		])

		return GiftCardSection
	})()

	var HeaderSection = /*#__PURE__*/ (function () {
		function HeaderSection(container) {
			var _this = this

			_classCallCheck(this, HeaderSection)

			this.element = container
			this.delegateElement = new domDelegate.Delegate(this.element)
			this.options = JSON.parse(this.element.getAttribute('data-section-settings'))
			this.lastScrollPosition = -1
			this.isTouch = window.matchMedia('(-moz-touch-enabled: 1), (hover: none)').matches
			this.pageTemplate = this.element.dataset.pageTemplate

			if (this.options['isSticky']) {
				Stickyfill.addOne(this.element.parentNode)
			} // Set up the search bar

			// this.searchBar = new SearchBar();

			this._attachListeners()

			this._verifyNavigationOverlap() // We set again some CSS variables that are used for some calculations in CSS

			var mainLogo = this.element.querySelector('.Header__LogoImage--primary')

			if (mainLogo && !mainLogo.complete) {
				mainLogo.addEventListener('load', function () {
					fastdom.measure(function () {
						document.documentElement.style.setProperty(
							'--header-is-not-transparent',
							_this.options['hasTransparentHeader'] ? 0 : 1,
						)
					})
				})
			} else {
				fastdom.measure(function () {
					document.documentElement.style.setProperty(
						'--header-is-not-transparent',
						_this.options['hasTransparentHeader'] ? 0 : 1,
					)
				})
			}

			window.addEventListener('pageshow', this._checkTransparentHeader.bind(this))

			this._setupLocalizationPopovers()
		}

		_createClass(HeaderSection, [
			{
				key: 'onUnload',
				value: function onUnload() {
					this.element.removeEventListener('mouseleave', this._closeNavigationListener)
					this.element.removeEventListener('mouseenter', this._focusNavigationListener)
					this.element.removeEventListener('focusin', this._focusNavigationListener)
					this.delegateElement.off()
					window.removeEventListener('scroll', this._checkTransparentHeaderListener)
					window.removeEventListener('resize', this._verifyNavigationOverlapListener)

					if (this.options['isSticky']) {
						Stickyfill.removeOne(this.element.parentNode)
					}

					// this.searchBar.destroy();
					this.localizationPopovers.forEach(function (localizationPopover) {
						localizationPopover.destroy()
					})
				},
			},
			{
				key: 'onSelect',
				value: function onSelect() {
					this._checkTransparentHeader()
				},
			},
			{
				key: 'onBlockSelect',
				value: function onBlockSelect(event) {
					var _this2 = this

					var listItem = event.target.closest('.HorizontalList__Item')
					fastdom.mutate(function () {
						event.target.setAttribute('aria-hidden', 'false')

						if (listItem) {
							listItem.classList.add('aria-haspopup')
							Dom.getSiblings(listItem, '.is-expanded').forEach(function (item) {
								item.classList.remove('is-expanded')
							})
						}

						_this2.element.classList.remove('Header--transparent') // This is needed to make sure everything is visible
					})
				},
			},
			{
				key: 'onBlockDeselect',
				value: function onBlockDeselect(event) {
					var listItem = event.target.closest('.HorizontalList__Item')
					fastdom.mutate(function () {
						event.target.setAttribute('aria-hidden', 'true')

						if (listItem) {
							listItem.classList.remove('is-expanded')
						}
					})

					this._checkTransparentHeader()
				},
			},
			{
				key: '_attachListeners',
				value: function _attachListeners() {
					var _this25 = this
					this._checkTransparentHeaderListener = this._checkTransparentHeader.bind(this)
					this._closeNavigationListener = this._closeNavigation.bind(this)
					this._focusNavigationListener = this._focusNavigation.bind(this)
					this._verifyNavigationOverlapListener = this._verifyNavigationOverlap.bind(this)
					this.element.addEventListener('mouseleave', this._closeNavigationListener)
					this.delegateElement.on(
						'mouseenter',
						'.Header__MainNav .HorizontalList__Item, [aria-haspopup]',
						this._openMenu.bind(this),
						true,
					)
					this.delegateElement.on('focusin', '[aria-haspopup]', this._openMenu.bind(this), true)
					this.delegateElement.on('focusout', '[aria-haspopup]', this._closeMenu.bind(this), false)
					this.delegateElement.on(
						'click',
						'[data-action="toggle-search"]',
						this._closeNavigationListener,
					)
					this.delegateElement.on(
						'mouseleave',
						'.DropdownMenu [aria-haspopup]',
						this._closeMenu.bind(this),
						true,
					)
					this.delegateElement.on(
						'mouseenter',
						'.DropdownMenu [aria-haspopup]',
						this._adjustDropdownPosition.bind(this),
						true,
					)
					if (this.isTouch) {
						this.delegateElement.on(
							'click',
							'.Header__MainNav [aria-haspopup]',
							this._handleTouchMenu.bind(this),
						)
					}

					if (this.options['hasTransparentHeader']) {
						this.element.addEventListener('mouseenter', this._focusNavigationListener)
						this.element.addEventListener('focusin', this._focusNavigationListener)

						document.addEventListener('toolbar:status:active', this._focusNavigationListener)
						document.addEventListener('toolbar:status:inactive', this._closeNavigationListener)
					}

					if (this.options['isSticky'] && this.options['hasTransparentHeader']) {
						window.addEventListener('scroll', this._checkTransparentHeaderListener)
					}

					if (
						this.options['navigationStyle'] === 'inline' ||
						this.options['navigationStyle'] === 'logoLeft'
					) {
						window.addEventListener('resize', this._verifyNavigationOverlapListener)
					}
				},
			},
			{
				key: '_setupLocalizationPopovers',
				value: function _setupLocalizationPopovers() {
					// Prestige is an extremely complex theme, especially in the header due to the various layouts that power different
					// features. One issue that arises with this is that we output the localization elements twice in the DOM (with the
					// same ID as we're doing a capture in Liquid), and then depending on the screen size one layout is choosen. We therefore
					// have to de-duplicate the ID here. This is honestly not the cleanest code on earth, but I prefer handling this here
					// rather than duplicating too much Liquid
					this.localizationPopovers = []
					Dom.nodeListToArray(document.querySelectorAll('#header-locale-popover')).forEach(
						function (item, index) {
							item.id = ''.concat(item.id, '-').concat(index)
						},
					)
					Dom.nodeListToArray(
						document.querySelectorAll('[aria-controls="header-locale-popover"]'),
					).forEach(function (item, index) {
						item.setAttribute(
							'aria-controls',
							''.concat(item.getAttribute('aria-controls'), '-').concat(index),
						)
					})
					Dom.nodeListToArray(document.querySelectorAll('#header-currency-popover')).forEach(
						function (item, index) {
							item.id = ''.concat(item.id, '-').concat(index)
						},
					)
					Dom.nodeListToArray(
						document.querySelectorAll('[aria-controls="header-currency-popover"]'),
					).forEach(function (item, index) {
						item.setAttribute(
							'aria-controls',
							''.concat(item.getAttribute('aria-controls'), '-').concat(index),
						)
					})
					var localePopoverElement1 = document.getElementById('header-locale-popover-0')

					if (localePopoverElement1) {
						this.localizationPopovers.push(
							new Popover(localePopoverElement1, {
								preferredAlignment: 'center',
								preferredPosition: 'bottom',
								threshold: 12,
							}),
						)
					}

					var localePopoverElement2 = document.getElementById('header-locale-popover-1')

					if (localePopoverElement2) {
						this.localizationPopovers.push(
							new Popover(localePopoverElement2, {
								preferredAlignment: 'center',
								preferredPosition: 'bottom',
								threshold: 12,
							}),
						)
					}

					var currencyPopoverElement1 = document.getElementById('header-currency-popover-0')

					if (currencyPopoverElement1) {
						this.localizationPopovers.push(
							new Popover(currencyPopoverElement1, {
								preferredAlignment: 'center',
								preferredPosition: 'bottom',
								threshold: 12,
							}),
						)
					}

					var currencyPopoverElement2 = document.getElementById('header-currency-popover-1')

					if (currencyPopoverElement2) {
						this.localizationPopovers.push(
							new Popover(currencyPopoverElement2, {
								preferredAlignment: 'center',
								preferredPosition: 'bottom',
								threshold: 12,
							}),
						)
					}
				},
			},
			{
				key: '_focusNavigation',
				value: function _focusNavigation() {
					var _this3 = this

					if (window.clarity && window.innerWidth >= 1024) {
						window.clarity("event", "desktopMenuOpen")
					}

					this.element.parentElement.classList.remove('ToolbarInActive')

					fastdom.mutate(function () {
						if (!_this3.isTouch || Responsive.matchesBreakpoint('desk')) {
							_this3.element.classList.remove('Header--transparent')
							_this3.element.parentElement.classList.remove('Header--transparent-parent')
						}
					})
				},
			},
			{
				key: '_closeNavigation',
				value: function _closeNavigation() {
					var _this4 = this

					fastdom.mutate(function () {
						Dom.nodeListToArray(_this4.element.querySelectorAll('.is-expanded')).forEach(function (
							item,
						) {
							item.classList.remove('is-expanded')
						})
						Dom.nodeListToArray(
							_this4.element.querySelectorAll('.Header__MainNav [aria-hidden="false"]'),
						).forEach(function (item) {
							item.setAttribute('aria-hidden', 'true')
						})
					})

					if (this.options['hasTransparentHeader']) {
						this._checkTransparentHeader()
					}
				},
			},
			{
				key: '_openMenu',
				value: function _openMenu(event, target) {
					if (event.type === 'mouseenter' && target !== event.target) {
						return
					}

					fastdom.mutate(function () {
						target.classList.add('is-expanded')
						Dom.nodeListToArray(target.children, '.Header__MainNav [aria-hidden="true"]').forEach(
							function (item) {
								item.setAttribute('aria-hidden', 'false')
							},
						)
						Dom.getSiblings(target, '.is-expanded').forEach(function (item) {
							item.classList.remove('is-expanded')
							Dom.nodeListToArray(item.children, '.Header__MainNav [aria-hidden="false"]').forEach(
								function (item) {
									item.setAttribute('aria-hidden', 'true')
								},
							)
						})
					})
				},
			},
			{
				key: '_closeMenu',
				value: function _closeMenu(event, target) {
					if (event.type === 'mouseleave' && target !== event.target) {
						return
					}

					fastdom.mutate(function () {
						target.classList.remove('is-expanded')
						Dom.nodeListToArray(target.children, '.Header__MainNav [aria-hidden="false"]').forEach(
							function (item) {
								item.setAttribute('aria-hidden', 'true')
							},
						)
					})
				},
			},
			{
				key: '_adjustDropdownPosition',
				value: function _adjustDropdownPosition(event, target) {
					var nestedMenus = Dom.nodeListToArray(target.querySelectorAll('.DropdownMenu')),
						shouldOpenLeft = false
					fastdom.measure(function () {
						var windowWidth = window.innerWidth,
							rightEdge = target.getBoundingClientRect().right
						nestedMenus.forEach(function (item) {
							if (rightEdge + item.offsetWidth > windowWidth) {
								shouldOpenLeft = true
							}
						})
					})
					fastdom.mutate(function () {
						if (shouldOpenLeft) {
							nestedMenus.forEach(function (item) {
								item.classList.add('DropdownMenu--reversed')
							})
						} else {
							nestedMenus.forEach(function (item) {
								item.classList.remove('DropdownMenu--reversed')
							})
						}
					})
				},
				/**
				 * On touch devices where we display the standard menu (like landscape iPad or Surface) we need to do additional code to properly
				 * handle the opening of menu. Especially, what we do is that if an item has a sub-menu, a click does not follow the link but instead open
				 * the sub-menu. If this link is clicked a second twice, then the menu is followed
				 */
			},
			{
				key: '_handleTouchMenu',
				value: function _handleTouchMenu(event, target) {
					if (!target.classList.contains('is-expanded')) {
						event.preventDefault()
					}
				},
			},
			{
				key: '_verifyNavigationOverlap',
				value: function _verifyNavigationOverlap() {
					var _this5 = this

					var isOverlapping = false,
						mainTopMenu = this.element.querySelector('.Header__MainNav')
					fastdom.measure(function () {
						// To detect if the navigation is overlapping, we take the height of a single item and check if its height is taller than the parent
						if (mainTopMenu) {
							// Get the first element
							var firstNavElementHeight = Dom.outerHeightWithMargin(
									mainTopMenu.querySelector('.HorizontalList__Item'),
								),
								mainNavHeight = mainTopMenu.scrollHeight

							if (mainNavHeight > firstNavElementHeight) {
								isOverlapping = true
							}
						}
					})
					this.element.classList.remove('Header--logoLeft', 'Header--inline', 'Header--center')
					this.element.classList.add('Header--'.concat(this.options['navigationStyle']))
					this.element.clientWidth // Forces a reflow

					fastdom.mutate(function () {
						if (isOverlapping) {
							_this5.element.classList.remove('Header--'.concat(_this5.options['navigationStyle']))

							_this5.element.classList.add('Header--center') // Check if still overlapping despite changing the mode

							if (mainTopMenu) {
								// Get the first element
								var itemTopSet = new Set()
								Array.from(mainTopMenu.querySelectorAll('.HorizontalList__Item')).forEach(function (
									item,
								) {
									itemTopSet.add(item.getBoundingClientRect().top)
								})
								isOverlapping = itemTopSet.size > 1
							}
						} else {
							_this5.element.classList.add('Header--'.concat(_this5.options['navigationStyle']))

							_this5.element.classList.remove('Header--center')
						}

						var logo = _this5.element.querySelector('.Header__FlexItem--logo')

						logo.classList.toggle('Header__FlexItem--increaseSpace', isOverlapping)

						_this5.element.classList.add('Header--initialized')
					})
				},
				/**
				 * If the header mode is set to "transparent", we have to do extra work to automatically make it with fill colors when the
				 * user starts scrolling. For performance we are using fastDOM to do that (which relies of requestAnimationFrame instead of
				 * scroll listener)
				 */
			},
			{
				key: '_checkTransparentHeader',
				value: function _checkTransparentHeader() {
					var _this6 = this

					if (this.options['hasTransparentHeaderOnScroll']) {
						this.element.parentElement.classList.add('Header--transparent-parent')
						this.element.classList.add('Header--transparent')
						this.element.parentElement.classList.add('Header_Parent--initialized')
					}

					var scrollThreshold = 10
					fastdom.measure(function () {
						_this6.lastScrollPosition = window.pageYOffset
					})
					fastdom.mutate(function () {
						if (!_this6.options['hasTransparentHeaderOnScroll']) {
							if (_this6.lastScrollPosition <= scrollThreshold) {
								_this6.element.parentElement.classList.add('Header--transparent-parent')
								_this6.element.classList.add('Header--transparent')
							} else {
								_this6.element.parentElement.classList.remove('Header--transparent-parent')
								_this6.element.classList.remove('Header--transparent')
							}
						}
						if (_this6.lastScrollPosition > 0) {
							_this6.element.parentElement.classList.remove('ToolbarActive')
						} else {
							_this6.element.parentElement.classList.add('ToolbarActive')
						}
					})
				},
			},
		])

		return HeaderSection
	})()

	var FooterSection = /*#__PURE__*/ (function () {
		function FooterSection(container) {
			_classCallCheck(this, FooterSection)

			this.element = container
			var localePopoverElement = document.getElementById('footer-locale-popover')

			if (localePopoverElement) {
				this.localePopover = new Popover(localePopoverElement, {
					preferredAlignment: 'center',
					preferredPosition: 'top',
					threshold: 12,
				})
			}

			var currencyPopoverElement = document.getElementById('footer-currency-popover')

			if (currencyPopoverElement) {
				this.currencyPopover = new Popover(currencyPopoverElement, {
					preferredAlignment: 'center',
					preferredPosition: 'top',
					threshold: 12,
				})
			}
		}

		_createClass(FooterSection, [
			{
				key: 'onUnload',
				value: function onUnload() {
					if (this.localePopover) {
						this.localePopover.destroy()
					}

					if (this.currencyPopover) {
						this.currencyPopover.destroy()
					}
				},
			},
		])

		return FooterSection
	})()

	var TextWithImageSection = /*#__PURE__*/ (function () {
		function TextWithImageSection(container) {
			_classCallCheck(this, TextWithImageSection)
			var _this = this
			this.element = container
   
			this.additionalDrawers = []

			Dom.nodeListToArray(this.element.querySelectorAll('.Drawer')).forEach(function (item) {
				var drawer = new Drawer(item)
				_this.additionalDrawers.push(drawer)
			})
		}

		_createClass(TextWithImageSection, [
			{
				key: 'onUnload',
				value: function onUnload() {
					this.additionalDrawers.forEach(function (drawer) {
						return drawer.destroy()
					})
				},
			},
		])

		return TextWithImageSection
	})()

	var FeatureProduct2DBuilderSection = /*#__PURE__*/ (function () {
		function FeatureProduct2DBuilderSection(container) {
			_classCallCheck(this, FeatureProduct2DBuilderSection)
			var _this = this

			this.element = container
			this.additionalDrawers = []

			Dom.nodeListToArray(this.element.querySelectorAll('.Drawer')).forEach(function (item) {
				var drawer = new Drawer(item)
				_this.additionalDrawers.push(drawer)
			})
		}

		_createClass(FeatureProduct2DBuilderSection, [
			{
				key: 'onUnload',
				value: function onUnload() {
					this.additionalDrawers.forEach(function (drawer) {
						return drawer.destroy()
					})
				},
			},
		])

		return FeatureProduct2DBuilderSection
	})()

	var LoginSection = /*#__PURE__*/ (function () {
		function LoginSection(container) {
			_classCallCheck(this, LoginSection)

			this.element = container

			setTimeout(() => {
				this.delegateElement = new domDelegate.Delegate(this.element)
				this.timelineLite = new TimelineLite()
				this.delegateElement.on(
					'click',
					'[data-action="toggle-recover-form"]',
					this._showRecoverPassword.bind(this),
				)
				this._attachListeners()
			}, 500);
		}

		_createClass(LoginSection, [
			{
				key: '_showRecoverPassword',
				value: function _showRecoverPassword() {
					const customerLoginForm = this.element.querySelector('#customer_login')
					const recoverPasswordForm = this.element.querySelector('#recover_customer_password')
					var isLoginActive = customerLoginForm.style.display === 'block'

					if (isLoginActive) {
						this.timelineLite
							.fromTo(
								customerLoginForm,
								0.5,
								{
									autoAlpha: 1,
									display: 'block',
									y: 0,
								},
								{
									autoAlpha: 0,
									y: 20,
									display: 'none',
								},
							)
							.fromTo(
								recoverPasswordForm,
								0.5,
								{
									autoAlpha: 0,
									display: 'none',
									y: 20,
								},
								{
									autoAlpha: 1,
									display: 'block',
									y: 0,
									delay: 0.25,
								},
							)
					} else {
						this.timelineLite
							.fromTo(
								recoverPasswordForm,
								0.5,
								{
									autoAlpha: 1,
									display: 'block',
									y: 0,
								},
								{
									autoAlpha: 0,
									y: 20,
									display: 'none',
								},
							)
							.fromTo(
								customerLoginForm,
								0.5,
								{
									autoAlpha: 0,
									display: 'none',
									y: 20,
								},
								{
									autoAlpha: 1,
									display: 'block',
									y: 0,
									delay: 0.25,
								},
							)
					}
				},
			},
			{
				key: '_showRegistration',
				value: function _showRegistration() {
					this.element.style.display = 'none'
					document.querySelector('#shopify-section-main-customers-register').style.display = 'block'
				},
			},
			{
				key: '_attachListeners',
				value: function _attachListeners() {
					this.delegateElement.on(
						'click',
						'[data-action="show-archive-sale-registration"]',
						this._showRegistration.bind(this),
					)
				},
			},
		])

		return LoginSection
	})()

	var NewsletterPopupSection = /*#__PURE__*/ (function () {
		function NewsletterPopupSection(element) {
			_classCallCheck(this, NewsletterPopupSection)

			this.element = element
			this.delegateElement = new domDelegate.Delegate(this.element)
			this.options = JSON.parse(element.getAttribute('data-section-settings')) // If the popup has been already displayed, we do not display it

			try {
				if (window.location.hash === '#newsletter-popup' && window.theme.pageType !== null) {
					this._openPopup()
				} else if (
					!this.options['showOnlyOnce'] ||
					(this.options['showOnlyOnce'] && localStorage.getItem('themePopup') === null)
				) {
					setTimeout(this._openPopup.bind(this), this.options['apparitionDelay'] * 1000)
				}
			} catch (error) {
				// Some browsers (especially in private mode) throw an exception when trying to access local storage, so we protect ourselves here
			}

			this._attachListeners()
		}

		_createClass(NewsletterPopupSection, [
			{
				key: 'onUnload',
				value: function onUnload() {
					this.delegateElement.off()
				},
			},
			{
				key: 'onSelect',
				value: function onSelect() {
					this._openPopup()
				},
			},
			{
				key: 'onDeselect',
				value: function onDeselect() {
					this._closePopup()
				},
			},
			{
				key: '_attachListeners',
				value: function _attachListeners() {
					this.delegateElement.on(
						'click',
						'[data-action="close-popup"]',
						this._closePopup.bind(this),
					)
				},
			},
			{
				key: '_openPopup',
				value: function _openPopup() {
					this.element.setAttribute('aria-hidden', 'false')
					localStorage.setItem('themePopup', 'true')
				},
			},
			{
				key: '_closePopup',
				value: function _closePopup() {
					this.element.setAttribute('aria-hidden', 'true')
				},
			},
		])

		return NewsletterPopupSection
	})()

	var ProductRecommendationsSection = /*#__PURE__*/ (function () {
		function ProductRecommendationsSection(container) {
			_classCallCheck(this, ProductRecommendationsSection)

			this.element = container
			this.options = JSON.parse(this.element.getAttribute('data-section-settings'))

			if (this.options['useRecommendations']) {
				this._loadRecommendations().then(this._createSlideshow.bind(this))
			} else {
				this._createSlideshow()
			}
		}

		_createClass(ProductRecommendationsSection, [
			{
				key: 'onUnload',
				value: function onUnload() {
					this.carousel.destroy()
				},
			},
			{
				key: '_loadRecommendations',
				value: function _loadRecommendations() {
					var _this = this

					var url = ''
						.concat(window.routes.productRecommendationsUrl, '?section_id=')
						.concat(this.element.getAttribute('data-section-id'), '&product_id=')
						.concat(this.options['productId'], '&limit=')
						.concat(this.options['recommendationsCount'])
					return fetch(url).then(function (response) {
						return response.text().then(function (content) {
							var container = document.createElement('div')
							container.innerHTML = content
							_this.element.querySelector('.ProductRecommendations').innerHTML =
								container.querySelector('.ProductRecommendations').innerHTML
						})
					})
				},
			},
			{
				key: '_createSlideshow',
				value: function _createSlideshow() {
					var _this = this
					var flickityElement = this.element.querySelector('[data-flickity-config]')

					if (!flickityElement) {
						return
					}

					this.carousel = new Carousel(flickityElement) // Setup product item color swatch

					new ProductItemColorSwatch(this.element)

					document.documentElement.dispatchEvent(
						new CustomEvent('new:element:loaded', {
							bubbles: true,
							detail: {
								container: _this.element,
							},
						}),
					)
				},
			},
		])

		return ProductRecommendationsSection
	})()

	var ShopTheLookCarouselSection = /*#__PURE__*/ (function () {
		function ShopTheLookCarouselSection(container) {
			_classCallCheck(this, ShopTheLookCarouselSection)

			var _this = this

			this.element = container
			this.delegateElement = new domDelegate.Delegate(this.element)

			const carouselEl = this.element.querySelector('.ShopTheLook__Product--slide')
			const shopTheLookEl = this.element.querySelector('.js-ShopTheLook')
			const shopTheLookProductEl = this.element.querySelector('.js-ShopTheLook__Product')
			const buttonEl = this.element.querySelector('.js-ShopTheLook_Button')
			const buttonCloseEl = this.element.querySelector('.js-ShopTheLook__Button--close')
			const carouselConfig = carouselEl ? JSON.parse(carouselEl.getAttribute('data-options')) : null
			const carouselMobileConfig = carouselEl ? JSON.parse(carouselEl.getAttribute('data-options-mobile')) : null

			const optionsDesktop = {
				...carouselConfig,
				on: {
				  init: () => {
					shopTheLookProductEl.style.transition = 'opacity .3s linear'
				  }
				}
			}

			const optionsMobile = {
				...carouselMobileConfig,
				on: {
				  init: () => {
					shopTheLookProductEl.style.transition = 'opacity .3s linear'
				  }
				}
			}

			if (window.innerWidth < 1440) {
				const swiper = new Swiper(carouselEl, optionsMobile)
				
				if (!swiper.allowSlideNext && !swiper.allowSlidePrev) {
					const paginationBullets = this.element.querySelectorAll('.swiper-pagination-bullet')
					paginationBullets.forEach(bullet => bullet.style.display = 'none')
				}
			} else {
				const swiper1 = new Swiper(carouselEl, optionsDesktop)
			}

			if (buttonEl) {
				buttonEl.addEventListener('click', () => {
					shopTheLookEl.classList.add('active')
				})
			}

			if (buttonCloseEl) {
				buttonCloseEl.addEventListener('click', () => {
					shopTheLookEl.classList.remove('active')
				})
			}
		}

		_createClass(ShopTheLookCarouselSection, [
			{
				key: 'onUnload',
				value: function onUnload() {},
			},
		])

		return ShopTheLookCarouselSection
	})()

	var ProductSection = /*#__PURE__*/ (function () {
		function ProductSection(container) {
			var _this = this

			_classCallCheck(this, ProductSection)

			this.element = container
			this.delegateElement = new domDelegate.Delegate(this.element)
			this.options = JSON.parse(this.element.getAttribute('data-section-settings'))
			this.selectedVariant = this.options['initialVariant']
			this.viewInSpaceElement = this.element.querySelector('[data-shopify-xr]')
			this.productVariants = new ProductVariants(container, this.options)
			this.productGallery = this.element.querySelector('.Product__Gallery')
			this.productGalleryScrollBar = this.element.querySelector('.Product__Gallery_Scrollbar')
			this.currentGalleryProgress = 0
			this.lastScrubY = 0
			this.allOptionsSet = false
			this.isDesktop = true
			this.formAtcSticky = this.element.querySelector('.js-form-atc-sticky')
			this.headerHeight = document.querySelector('.js-header').clientHeight
			this.formAtcStickyHeight = this.isDesktop ? document.querySelector('.js-form-atc-sticky').clientHeight : 0
			
			var sizeChartDrawerElement = document.getElementById('size-chart-drawer')

			if (sizeChartDrawerElement) {
				this.sizeChartDrawer = new Drawer(sizeChartDrawerElement)
			}

			var findInStoreDrawerElement = this.element.querySelector('#find-in-store-drawer')

			if (findInStoreDrawerElement) {
				this.findInStoreDrawer = new Drawer(findInStoreDrawerElement)
				this.findInStoreDrawerElement = findInStoreDrawerElement
			}

			var enquireDrawerElement = this.element.querySelector('#enquire-drawer')

			if (enquireDrawerElement) {
				this.enquireDrawer = new Drawer(enquireDrawerElement)
			}

			this.additionalDrawers = []
			Dom.nodeListToArray(this.element.querySelectorAll('.Drawer')).forEach(function (item) {
				if (
					item.id != 'size-chart-drawer' &&
					item.id != 'find-in-store-drawer' &&
					item.id != 'enquire-drawer'
				) {
					var drawer = new Drawer(item)
					_this.additionalDrawers.push(drawer)
				}
			})

			var productSlideshowElement = this.element.querySelector('.Product__Slideshow') // If there is no image at all, there is nothing to init

			if (
				(!this.options['stackProductImages'] || !this.options['stackProductImagesMobile']) &&
				productSlideshowElement && this.options['enableSlider']
			) {
				this.mediaList = {} // We keep track of a list of media element

				this.previouslySelectedMedia = null // Keep track of the previously selected media
				// For each model and video, we register a media

				// productSlideshowElement.querySelectorAll('[data-media-type="model"]').forEach(function (model) {
				//           _this.mediaList[model.getAttribute('data-media-id')] = new ProductModel(model, _this.options['stackProductImages']);
				//         });
				//         productSlideshowElement.querySelectorAll('[data-media-type="video"], [data-media-type="external_video"]').forEach(function (video) {
				//          _this.mediaList[video.getAttribute('data-media-id')] = new ProductVideo(video, _this.options['stackProductImages'], _this.options['enableVideoLooping']);
				//         });

				if (this.options['stackProductImages']) {
					this.slideshowNavDots = this.element.querySelector('.Product__SlideshowNav--dots')
					this.slideshowNavDotsItems = this.slideshowNavDots
						? Dom.nodeListToArray(this.slideshowNavDots.querySelectorAll('a'))
						: []
				}

				if (this.options['showThumbnails']) {
					this.slideshowNavThumbnails = this.element.querySelector(
						'.Product__SlideshowNav--thumbnails',
					)
					this.slideshowNavThumbnailsItems = this.slideshowNavThumbnails
						? Dom.nodeListToArray(
								this.slideshowNavThumbnails.querySelectorAll('.Product__SlideshowNavImage'),
						  )
						: []
				}

				this.slideshowImages = Dom.nodeListToArray(
					productSlideshowElement.querySelectorAll('.Carousel__Cell'),
				) // Setup the mobile nav

				this._setupSlideshowMobileNav()
			}

			if (this.options['isEngraved']) {
				this.personalisedStatus = false
				this.engravingButtonCopy = ''
				this.prohibitedString = this.options['prohibitedString']
				this.prohibited = this.prohibitedString.split(',')
				this._flexFont()
				this._redrawPersonalisedPreview()
				this.lastFocused = this.element.querySelector('.PersonalisedFields input[type="text"]')
				this.engravingOpen = false
				this.element.querySelector('.ProductForm__Option_Personalised_Position .ProductForm__Label span').classList.add('isOptional')
				this.element.querySelector('.ProductForm__Option_FontStyle .ProductForm__Label span').classList.add('isOptional')
				this.productVariants._onVariantChanged(this.selectedVariant, this.selectedVariant)
			}

			if (this.element.querySelector('.MobileAddToCart')) {
				this.mobileAddToCartHeight = this.element.querySelector('.MobileAddToCart').offsetHeight
			}

			this.productWrapperElement = this.element.querySelector('.Product__Wrapper')
			this.productInfoElement = this.element.querySelector('.Product__Info')
			this.productAsideElement = this.element.querySelector('.Product__Aside')
			this.productGalleryElement = this.element.querySelector('.Product__Gallery')
			this.quickNav = this.element.querySelector('.Product__QuickNav')

			if (this.options['enableImageZoom']) {
				this.imageZoomInstance = new ProductImageZoom(this.element, productSlideshowElement)
			}

			Stickyfill.addOne(this.productInfoElement) // We have to re-order elements in the DOM

			var offscreenElement = this.element.querySelector('.Product__OffScreen')

			if (offscreenElement) {
				this.element.appendChild(offscreenElement)
			}
			this.optionSelectorExpanded = false
			this.scrollTriggerSlides = this.element.querySelectorAll('.Product__SlideItem')

			this._setupDeviceFeatures()

			if (this.options['uploadery']) {
				if (window.Shoppad != null && window.Shoppad.apps.uploadery._initialized) {
					window.Shoppad.apps.uploadery.init()
				}
			}

			this._attachListeners()
		}

		_createClass(ProductSection, [
			{
				key: 'onUnload',
				value: function onUnload() {
					this.delegateElement.off('click')

					if (this.productVariants) {
						this.productVariants.destroy()
					}

					if (this.productSlideshow) {
						this.productSlideshow.destroy()
					}

					if (this.options['enableImageZoom']) {
						this.imageZoomInstance.destroy()
					}

					if (this.carouselNavScrollSpy) {
						this.carouselNavScrollSpy.destroy()
					}

					if (this.quickNav) {
						window.removeEventListener('scroll', this._checkQuickNavListener)
					}

					if (this.productInfoScroller) {
						this.productInfoScroller.destroy()
					}

					if (this.productThumbnailsScroller) {
						this.productThumbnailsScroller.destroy()
					}

					if (window.ResizeObserver && this.productInfoResizeObserver) {
						this.productInfoResizeObserver.disconnect()
					}

					if (this.sizeChartDrawer) {
						this.sizeChartDrawer.destroy()
					}

					if (this.findInStoreDrawer) {
						this.findInStoreDrawer.destroy()
					}

					if (this.enquireDrawer) {
						this.enquireDrawer.destroy()
					}

					this.additionalDrawers.forEach(function (drawer) {
						return drawer.destroy()
					})

					if (this.scrollTriggerTimeline) {
						this.scrollTriggerTimeline.kill()
					}

					if (this.scrollTrigger) {
						this.scrollTrigger.kill()
					}

					window.removeEventListener('resize', this._resizeListener)

					if (this.scrollTriggerSlides.length > 1) {
						this.productGallery.removeEventListener('wheel', this._scrubGalleryListener)
						this.productGallery.removeEventListener('touchstart', this._scrubGalleryListener)
						this.productGallery.removeEventListener('touchmove', this._scrubGalleryListener)
					}

					Stickyfill.removeOne(this.productInfoElement)
					document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener)
				},
			},
			{
				key: '_attachListeners',
				value: function _attachListeners() {
					this._onBreakpointChangedListener = this._setupDeviceFeatures.bind(this)
					this._checkQuickNavListener = this._checkQuickNav.bind(this)

					this.delegateElement.on(
						'click',
						'[data-action="toggle-social-share"]',
						this._toggleSocialShare.bind(this),
					)

					this.delegateElement.on(
						'click',
						'[data-action="drawer-scroll-up"]',
						this._drawerScrollUp.bind(this),
					)

					if (this.findInStoreDrawer) {
						this.delegateElement.on(
							'click',
							'[data-action="toggle-drawer"][data-drawer-id="find-in-store-drawer"]',
							this._fetchFindInStoreData.bind(this),
						)
					}

					//this.delegateElement.on('scrollspy:target:changed', this._onScrollTargetChanged.bind(this));
					//this.delegateElement.on('model:played', this._onMediaPlayed.bind(this));
					//this.delegateElement.on('video:played', this._onMediaPlayed.bind(this));
					//this.delegateElement.on('model:paused', this._onMediaPaused.bind(this));
					//this.delegateElement.on('video:paused', this._onMediaPaused.bind(this));
					document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener)
					this._setRecentlyHandleProducts()

					if (this.options['isEngraved']) {
						this.delegateElement.on(
							'change',
							'[name="fontstyle"]',
							this._redrawPersonalisedPreview.bind(this),
						)
						this.delegateElement.on('keydown paste', '[maxlength]', this._typeEngraving.bind(this))
						this.delegateElement.on('paste', '[maxlength]', this._typeEngraving.bind(this))
						this.delegateElement.on(
							'click',
							'[data-action="personalise-product"]',
							this._toggleEngravingOptions.bind(this),
						)
						this.delegateElement.on(
							'focusin',
							'.PersonalisedFields input[type="text"]',
							this._lastFocus.bind(this),
						)
						this.delegateElement.on('click', '[data-action="add-icon"]', this._addIcon.bind(this))
						this.delegateElement.on('change', '.ProductForm__Option_Personalised_Text_Icon [type="text"]', this.productVariants._onOptionPersonalisedTextIconChanged.bind(this))
						this.delegateElement.on('keyup', '.ProductForm__Option_Personalised_Text_Icon [type="text"]', this.productVariants._onOptionPersonalisedTextIconChanged.bind(this))
						this.delegateElement.on('click', '[data-action="add-icon"]', this.productVariants._onOptionPersonalisedTextIconChanged.bind(this))
						this.delegateElement.on('keyup', '[maxlength]', this._stopTypeEngraving.bind(this))
					}

					this._resizeListener = this._resizeListenerFunction.bind(this)
					window.addEventListener('resize', this._resizeListener)

					var _this = this
					document.addEventListener('variant:changed', function (event) {
						_this.selectedVariant = event.detail.variant
						_this.allOptionsSet = event.detail.allOptionsSet
						_this._scrollToImage(event.detail.variant)
						_this._updateStateButtonATC()
					})

					if (this.quickNav) {
						window.addEventListener('scroll', this._checkQuickNavListener)
					}

					if (this.enquireDrawer) {
						this.delegateElement.on(
							'click',
							'[data-action="enquire"]',
							this._klaviyoEvent.bind(this),
						)
					}

					if (this.findInStoreDrawer) {
						this.delegateElement.on(
							'click',
							'[data-action="find-in-store"]',
							this._klaviyoEvent.bind(this),
						)
						this.delegateElement.on(
							'click',
							'[data-action="toggle-find-in-store-form"]',
							this._toggleFindInStoreForm.bind(this),
						)
					}

					if (this.scrollTriggerSlides.length > 1) {
						this._scrubGalleryListener = this._scrubGallery.bind(this)
						this.productGallery.addEventListener('wheel', this._scrubGalleryListener)
						this.productGallery.addEventListener('touchstart', this._scrubGalleryListener)
						this.productGallery.addEventListener('touchend', this._scrubGalleryListener)
						this.productGallery.addEventListener('touchmove', this._scrubGalleryListener)
						this.productGallery.addEventListener('pointermove', this._scrubGalleryListener)
					}

					this.element.removeEventListener('mouseenter', this._focusNavigationListener)

					if (!this.options['stackProductImages'] && this.options['showThumbnails']) {
						this.delegateElement.on(
							'click',
							'.Product__SlideshowNavImage',
							this._switchToImage.bind(this),
						)
					}
					if (this.formAtcSticky) {
						const buttonScrollToPositionEls = document.querySelectorAll('.js-scroll-to-position')
						const positionGiftCartEl = document.querySelector('.js-position-gift-cart')
						const isGiftCard = document.querySelectorAll('[data-is-gift-card="true"]')

						if (buttonScrollToPositionEls.length > 0) {
							buttonScrollToPositionEls.forEach((item) => {
								item.addEventListener('click', this._scrollToPosition.bind(this))
							});
						}
						this._toggleFormATCSticky()
						window.addEventListener('scroll', this._throttle(this._toggleFormATCSticky.bind(this), 50))
					}
				},
			},
			{
				key: '_setRecentlyHandleProducts',
				value: function _setRecentlyHandleProducts() {
					let handles = this._getRecentlyHandleProducts()

					handles = handles.filter((item) => item !== this.options.handle)
					handles.unshift(this.options.handle)

					const newValue = handles.slice(0, 7).join('|')

					localStorage.setItem('recently_product_handle', newValue)
				}
			},
			{
				key: '_getRecentlyHandleProducts',
				value: function _getRecentlyHandleProducts() {
					const localStorageValue = localStorage.getItem('recently_product_handle') || ''
					return localStorageValue.length ? localStorageValue.split('|') : []				
				}
			},
			{
				key: '_scrollToImage',
				value: function _scrollToImage(variantSelected) {
					const isMobile = Responsive.matchesBreakpoint('phone')
					const galleryWrap = this.element.querySelector('.js-product-gallery')
					const isProductTemplate2 = galleryWrap.hasAttribute('data-product_template_2')
					let imageEl = null
					if (variantSelected?.featured_media?.id) {
						imageEl = this.element.querySelector(`.js-product-gallery-item[data-media-id="${variantSelected.featured_media.id}"]`)
					}
					const mediaIds = this.productVariants.productData.variants.reduce((acc, current) => {
						if (!acc.some(item => item.featured_media?.id === current.featured_media?.id)) {
							acc.push(current);
						}
						return acc;
					}, [])

					if (imageEl && mediaIds.length > 1 && galleryWrap) {
						if (isProductTemplate2 && !isMobile) {
							window.scrollTo({
								top: imageEl.offsetTop + this.headerHeight,
								behavior: "smooth"
							})
						} else if (isMobile) {
							imageEl.scrollIntoView({ block: "end", inline: "center", behavior: "smooth" })
						} else {
							galleryWrap.scrollTo({
								top: imageEl.offsetTop,
								behavior: "smooth"
							})
						}
					}
				}
			},
			{
				key: '_updateStateButtonATC',
				value: function _updateStateButtonATC() {
					const addToCartButtonEls = this.element.querySelectorAll('.ProductForm__AddToCart')

					if (addToCartButtonEls.length > 0 && this.allOptionsSet) {
						addToCartButtonEls.forEach((addToCartButton) => {
							if (!addToCartButton.getAttribute('disabled')) {
								addToCartButton.setAttribute('data-action', 'add-to-cart')
							}
						})
					}
				}
			},
			{
				key: '_toggleFormATCSticky',
				value: function _toggleFormATCSticky() {
					let anchorForm = ''
					let anchorGallery = ''

					if (this.isDesktop) {
						anchorForm = this.element.querySelector('.js-form-anchor-desktop')
						anchorGallery = this.element.querySelector('.Product-Gallery__list')
					} else {
						anchorForm = this.element.querySelector('.js-form-anchor-mobile')
					}
					if (anchorForm && this.formAtcSticky) {
						const isInViewPort = this._elInViewPort(anchorForm)
						if (!isInViewPort) {
							this.formAtcSticky.classList.add('is-active')
						} else {
							this.formAtcSticky.classList.remove('is-active')
						}
					}

					if (anchorForm && anchorGallery && this.formAtcSticky) {
						const isFormInViewPort = this._elInViewPort(anchorForm)
						const isGalleryInViewPort = this._elInViewPortGallery(anchorGallery)
						if (!isFormInViewPort && isGalleryInViewPort) {
							this.formAtcSticky.classList.add('is-active')
						} else {
							this.formAtcSticky.classList.remove('is-active')
						}
					}
				}
			},
			{
				key: '_elInViewPortGallery',
				value: function _elInViewPortGallery(el, includeHeader = true) {
					const { bottom } = el.getBoundingClientRect()
					const headerHeight = includeHeader ? this.headerHeight : 0
					const bottomDistance = bottom - headerHeight - this.formAtcStickyHeight

					return bottomDistance > 0
				}
			},
			{
				key: '_drawerScrollUp',
				value: function _drawerScrollUp() {
					const drawerEl = this.element.querySelector('.js-scroll-up-drawer')

					if (window.scrollY <= 40) {
						drawerEl.classList.remove('is-scroll-up')
					}

					const isScrolllUp = drawerEl.classList.contains('is-scroll-up')
					let positionDom = drawerEl.getBoundingClientRect().top + window.scrollY - this.headerHeight

					drawerEl.classList.toggle('is-scroll-up')

					if (isScrolllUp) {
						positionDom = 0
					}
					if (drawerEl) {
						window.scrollTo({
							top: positionDom,
							behavior: "smooth"
						})
					}
				}
			},
			{
				key: '_scrollToPosition',
				value: function _scrollToPosition(forceScroll = false) {
					let positionScrollTo = 0

					if (this.allOptionsSet && !forceScroll) return
					if (this.isDesktop) {
						positionScrollTo = this.element.querySelector('.js-position-anchor-desktop').offsetTop
					} else {
						positionScrollTo = this.element.querySelector('.js-position-anchor-mobile').offsetTop
					}

					window.scrollTo({
						top: positionScrollTo,
						behavior: "smooth"
					});
				}
			},
			{
				key: '_elInViewPort',
				value: function _elInViewPort(el, includeHeader = true) {
					const { top, bottom } = el.getBoundingClientRect()
					const headerHeight = includeHeader ? this.headerHeight : 0
					const topDistance = top - headerHeight
					const bottomDistance = bottom - headerHeight

					return (topDistance > 0 && topDistance < window.innerHeight) && (bottomDistance > 0 && bottomDistance < window.innerHeight)
				}
			},
			{
				key: '_throttle',
				value: function _throttle(mainFunction, delay) {
					let timerFlag = null

					return (...args) => {
						if (timerFlag === null) {
							mainFunction(...args)
							timerFlag = setTimeout(() => {
								timerFlag = null
							}, delay)
						}
					}
				}
			},
			{
				key: '_resizeListenerFunction',
				value: function _resizeListenerFunction() {
					if (this.options['isEngraved']) {
						this._flexFont()
					}

					if (this.scrollTriggerScrollbarTimeline) {
						this.productGalleryScrollBarContainerHeight = this.element
							.querySelector('.Product__Gallery_Scrollbar_Container')
							.getBoundingClientRect().height
						this.productGalleryScrollBarHeight =
							this.productGalleryScrollBar.getBoundingClientRect().height
						this.scrollTriggerScrollbarTimeline.kill()
						this.scrollTriggerScrollbarTimeline = gsap.timeline().pause()

						this.scrollTriggerScrollbarTimeline.fromTo(
							this.productGalleryScrollBar,
							{
								y: 0,
							},
							{
								y: this.productGalleryScrollBarContainerHeight - this.productGalleryScrollBarHeight,
								duration: 1,
								ease: 'none',
							},
						)

						this.scrollTriggerScrollbarTimeline.progress(
							this.currentGalleryProgress / this.totalScrollDistance,
						)
					}
				},
			},
			{
				key: '_addIcon',
				value: function _addIcon(event, target) {
					var cntMaxLength = parseInt(this.lastFocused.getAttribute('maxlength'))
					if (this.lastFocused.value.length === cntMaxLength && event.keyCode != 8) {
						event.preventDefault()
					} else {
						var inputCopy = this.lastFocused.value
						var iconUnicode = target.getAttribute('data-icon-value')

						if (iconUnicode == '0001') {
							this.lastFocused.value = inputCopy + 'ſ'
						}

						if (iconUnicode == '0002') {
							this.lastFocused.value = inputCopy + 'ƀ'
						}

						if (iconUnicode == '0003') {
							this.lastFocused.value = inputCopy + 'Ɓ'
						}

						if (iconUnicode == '0004') {
							this.lastFocused.value = inputCopy + 'Ƃ'
						}

						if (iconUnicode == '0005') {
							this.lastFocused.value = inputCopy + 'ƃ'
						}

						if (iconUnicode == '0006') {
							this.lastFocused.value = inputCopy + 'Ƅ'
						}

						if (iconUnicode == '0007') {
							this.lastFocused.value = inputCopy + 'ƅ'
						}

						if (iconUnicode === '0008') {
							this.lastFocused.value = inputCopy + 'Ɔ'
						}

						var lineId = parseInt(this.lastFocused.getAttribute('lineid'))
						var currentCount = this.lastFocused.value.length

						this.element.querySelector('#CharacterIndicator__' + lineId + ' span').innerText =
							currentCount
						this._redrawPersonalisedPreview()
						this.lastFocused.focus()
					}
				},
			},
			{
				key: '_stopTypeEngraving',
				value: function _stopTypeEngraving(event, target) {
					// Clear non normal charecters
					var enteredValue = target.value.replace(/[^a-zA-Z&0-9ſƀƁƂƃƄƅƆ\s\d]/gi, '')
					// Clear emojis
					enteredValue.replace(/[^\x20-\x7E]/g, '');
					target.value = enteredValue

					var currentCount = target.value.length
					var lineId = parseInt(target.getAttribute('lineid'))

					this.element.querySelector('#CharacterIndicator__' + lineId + ' span').innerText =
						currentCount

					// Redraw Preview
					this._redrawPersonalisedPreview()
				},
			},
			{
				key: '_lastFocus',
				value: function _lastFocus(event, target) {
					this.lastFocused = target
				},
			},
			{
				key: '_toggleEngravingOptions',
				value: function _toggleEngravingOptions(event, target) {
					if (this.engravingOpen) {
						target.classList.remove('open')
						target.classList.add('close')
						Dom.nodeListToArray(
							this.element.querySelectorAll('.PersonalisedFields input[type="text"]'),
						).forEach(function (obj, i) {
							obj.value = ''
						})

						this._redrawPersonalisedPreview()

						gsap
							.timeline()
							.to('.PersonalisedFields', {
								autoAlpha: 0,
							})
							.to('.PersonalisedFields', {
								height: '0',
							})
						window.addingEngraving = false
						this.element.querySelector('.personaliseButtonWrapper span').innerText = 'Add Engraving'

						this.engravingOpen = false
						this.element.querySelector('.ProductForm__Option_Personalised_Position .ProductForm__Label span').classList.add('isOptional')
						this.element.querySelector('.ProductForm__Option_FontStyle .ProductForm__Label span').classList.add('isOptional')
						this.productVariants._onVariantChanged(this.selectedVariant, this.selectedVariant)
						const engravingCount = document.querySelector("#CharacterIndicator__1 span")
						if (engravingCount) {
							engravingCount.innerText = 0
						}
					} else {
						target.classList.remove('close')
						target.classList.add('open')
						gsap
							.timeline()
							.to('.PersonalisedFields', {
								height: 'auto',
							})
							.to('.PersonalisedFields', {
								autoAlpha: 1,
							})
						window.addingEngraving = true
						this.element.querySelector('.personaliseButtonWrapper span').innerText =
							'Cancel Engraving'

						this.engravingOpen = true
						this.element.querySelector('.ProductForm__Option_Personalised_Position .ProductForm__Label span').classList.remove('isOptional')
						this.element.querySelector('.ProductForm__Option_FontStyle .ProductForm__Label span').classList.remove('isOptional')
						this.productVariants._onVariantChanged(this.selectedVariant, this.selectedVariant)
						// Need to change how the display works on mobile to stop elements from going over eachother
						const engravingInstructionsMobile = document.querySelector('.MobileAddToCart.hidden-lap-and-up')
						if (engravingInstructionsMobile && window.innerWidth < 1008) {
							// Some products have 'select options' which adds a div to the screen which takes up the whole screen
							// so we do not want to change the display to contents in this case
							if (!window.theme.productHasOptions) {
								engravingInstructionsMobile.style.display = 'contents'
							}
						}
					}
				},
			},
			{
				key: '_flexFont',
				value: function _flexFont() {
					var divs = document.getElementsByClassName('Product__SlideItem')

					for (var i = 0; i < divs.length; i++) {
						var relFontsize = divs[i].offsetWidth * 0.1
						divs[i].style.fontSize = relFontsize + 'px'
					}
				},
			},
			{
				key: '_blockPaste',
				value: function _blockPaste(event) {
					event.preventDefault()
				},
			},
			{
				key: '_typeEngraving',
				value: function _typeEngraving(event) {
					var _this = this

					if (event.originalEvent.key.match(/[^a-zA-Z&0-9ſƀƁƂƃƄƅ\d]/gi)) {
						event.preventDefault()
					}

					var cntMaxLength = parseInt(target.getAttribute('maxlength'))
					if (target.value.length === cntMaxLength && event.keyCode != 8) {
						event.preventDefault()
					}
				},
			},
			{
				key: '_redrawPersonalisedPreview',
				value: function _redrawPersonalisedPreview() {
					var _this = this

					var personalisedConfig = JSON.parse(
						this.element
							.querySelector('.PersonalisedWrapper')
							.getAttribute('data-personalised-config'),
					)
					var personalisedMediaWrapper = this.element.querySelector(
						'[data-media-position="' +
							personalisedConfig.mediaPostion +
							'"] .PersonalisationPreview',
					)
					var personalisedFontValue = this.element.querySelector('[name="fontstyle"]:checked') ? this.element.querySelector('[name="fontstyle"]:checked').value : 'Serif'
					var personalisedPreviewHtml = ''
					var str = ''

					var personalisedStatus = false
					var prohibitedInput = false
					var characterCount = 0

					Dom.nodeListToArray(
						this.element.querySelectorAll('.PersonalisedFields input[type="text"]'),
					).forEach(function (obj, i) {
						str = obj.value
						characterCount = characterCount + str.length

						if (str.length) {
							for (var i = 0; i < _this.prohibited.length; i++) {
								if (_this.prohibited[i].toLowerCase().trim().length) {
									if (str.toLowerCase().indexOf(_this.prohibited[i].toLowerCase().trim()) > -1) {
										prohibitedInput = true
									}
								}
							}

							str = str.replace(/[ſƀƁƂƃƄƅƆ]/g, (s) => `<span class="personalisedIcon">${s}</span>`)

							personalisedPreviewHtml += '<span>' + str + '</span>'
							if (obj.value) {
								personalisedStatus = true
							}
						}
					})
					if (personalisedMediaWrapper) {
						// if (characterCount == 1 && personalisedConfig.maxLetters > 3) {
							personalisedMediaWrapper.style.fontSize = personalisedConfig.fontSize + '%'
						// }

						if (personalisedFontValue == 'Serif') {
							personalisedMediaWrapper.style.fontFamily = 'serif'
							personalisedMediaWrapper.style.fontStyle = 'normal'
						} else if (personalisedFontValue == 'Sans Serif') {
							personalisedMediaWrapper.style.fontFamily = 'calibre-web-regular-icons'
							personalisedMediaWrapper.style.fontStyle = 'normal'
						} else if (personalisedFontValue == 'Serif Italics') {
							personalisedMediaWrapper.style.fontFamily = 'serif'
							personalisedMediaWrapper.style.fontStyle = 'italic'
						} else {
							personalisedMediaWrapper.style.fontFamily = 'calibre-web-regular-icons'
							personalisedMediaWrapper.style.fontStyle = 'italic'
						}

						;(personalisedMediaWrapper.style.top = personalisedConfig.positionY + '%'),
							(personalisedMediaWrapper.style.left = personalisedConfig.positionX + '%')
					}

					if (prohibitedInput) {
						this.element
							.querySelector('.ProductForm__AddToCart')
							.setAttribute('disabled', 'disabled')
						this.element.querySelector('.ProductForm__AddToCart span').innerText =
							'Your engraving contains a prohibited word.'
					} else {
						this.element.querySelector('.ProductForm__AddToCart').removeAttribute('disabled')
						if (this.element.querySelector('.ProductForm__AddToCart span')) {
							this.element.querySelector('.ProductForm__AddToCart span').innerText = 'Add to Bag'
						}
					}

					// updateProductPrice(); TODO
					personalisedMediaWrapper.innerHTML = personalisedPreviewHtml
				},
			},
			{
				key: '_toggleFindInStoreForm',
				value: function _toggleFindInStoreForm(event, target) {
					var _this = this

					var formContainer = this.findInStoreDrawerElement.querySelector(
						'.FindInStore__OffscreenFormContainer',
					)
					if (this.findInStoreDrawerElement.querySelector('[aria-label="Store"]')) {
						this.findInStoreDrawerElement.querySelector('[aria-label="Store"]').value =
							target.getAttribute('data-store')
					}

					this.findInStoreDrawerElement.classList.toggle('has-note-open')

					formContainer.setAttribute(
						'aria-hidden',
						formContainer.getAttribute('aria-hidden') === 'true' ? 'false' : 'true',
					)
					this.isFindInStoreFormOpen = formContainer.getAttribute('aria-hidden') === 'false'

					if (this.findInStoreDrawerElement.classList.contains('has-note-open')) {
						var transitionEndListener = function transitionEndListener() {
							// _this.element.querySelector('#cart-note').focus();

							formContainer.removeEventListener('transitionend', transitionEndListener)
						}

						formContainer.addEventListener('transitionend', transitionEndListener)
					}
				},
			},
			{
				key: '_klaviyoEvent',
				value: async function _klaviyoEvent(event, target) {
					event.preventDefault()
					var formElement = target.closest('.Form')
					var _this = this

					if (formElement.checkValidity()) {
						this.formSubmitButton = formElement.querySelector('.Form__Submit')
						this.submitCopy = this.formSubmitButton.innerText

						this.formSubmitButton.setAttribute('disabled', 'disabled')

						var eventType = target.getAttribute('data-action')

						window.dataLayer = window.dataLayer || []
						window.dataLayer.push({
							event: 'form_submission',
							formType: eventType,
						})

						var formData = {}

						Dom.nodeListToArray(formElement.querySelectorAll('input, textarea')).forEach(function (
							inputElement,
							index,
						) {
							formData[inputElement.getAttribute('aria-label')] = inputElement.value
						})

						if (eventType == 'enquire') {
							const onSubmitForm = async () => {
								const listId = formElement.dataset.klaviyoSubscriptionListId
								const publicKey = formElement.dataset.klaviyoPublicKey
								const subscriptionUrl = formElement.dataset.klaviyoSubscriptionUrl
								const email = formData.Email

								const url = `${subscriptionUrl}?company_id=${publicKey}`
								const options = {
									method: 'POST',
									headers: { revision: '2024-07-15', 'content-type': 'application/json' },
									body: JSON.stringify({
										data: {
											type: 'subscription',
											attributes: {
												profile: {
													data: {
														type: 'profile',
														attributes: {
															email: formData.Email,
															properties: {
																BespokeEnquiryName: formData['Enter Name'],
																BespokeEnquiryPhone: formData['Enter Phone'],
																BespokeEnquirySize: formData['Enter Preferred Size'],
																BespokeEnquiryProduct: formData['Enter Product Name'],
																BespokeEnquiryNotes: formData['Write Notes'],
																BespokeEnquiryCurrency: formData.Currency,
																BespokeEnquiryItem: formData.Item
															}
														}
													}
												},
												custom_source: "Bespoke Enquiry"
											},
											relationships: { list: { data: { type: 'list', id: listId } } }
										}
									})
								}

								try {
									const response = await fetch(url, options)
									
									this.formSubmitButton.innerText = 'Thank You For Your Submission'
									formElement.querySelectorAll('input, textarea').forEach(function (
										inputElement,
										index,
									) {
										inputElement.value = ''
									})
								} catch(e) {
									this.formSubmitButton.innerText = 'Something went wrong'
									console.error(e)
								} finally {
									setTimeout(function () {
										_this.formSubmitButton.innerText = _this.submitCopy
										_this.formSubmitButton.removeAttribute('disabled')
									}, 3000)
								}
							}

							await onSubmitForm()
							return
						} else if (eventType == 'find-in-store') {
							var _learnq = window._learnq || []

							_learnq.push([
								'identify',
								{
									$email: formData.Email,
								},
							])

							setTimeout(function () {
								_learnq.push(['track', 'Find in Store', formData])
							}, 500)
						}

						this.formSubmitButton.innerText = 'Thank You For Your Submission'
            formElement.querySelectorAll('input, textarea').forEach(function (
              inputElement,
              index,
            ) {
              inputElement.value = ''
            })

						setTimeout(function () {
							_this.formSubmitButton.innerText = _this.submitCopy
							_this.formSubmitButton.removeAttribute('disabled')
						}, 3000)
					} else {
						formElement.reportValidity()
					}
				},
			},
			{
				key: '_fetchFindInStoreData',
				value: function _fetchFindInStoreData() {
					var _this = this

					var findInStoreWrapperElement = this.element.querySelector('.FindInStoreWrapper')
					var findInStoreOptions = JSON.parse(
						findInStoreWrapperElement.getAttribute('data-section-settings'),
					)
					var productAvailableDescription = false

					findInStoreWrapperElement.classList.remove('Active')
					findInStoreWrapperElement.innerHTML = ''
					fetch(
						'https://api.shopify-inventory.jtcinteractive.com/shop/sarah-sebastian.myshopify.com/variant_locations/' +
							this.selectedVariant.id +
							'?lat=0&lon=0',
						{
							credentials: 'same-origin',
							method: 'GET',
						},
					).then((response) => {
						response.json().then((result) => {
							var variantStockLevels = result.locations,
								htmlData = '',
								storeHtmlData = '',
								isPair = false,
								productAvailable = 0

							var additionalStoreData = {
								'SARAH & SEBASTIAN Mosman': {
									State: 'NSW',
									Phone: '1300 050 220',
									Url: '/pages/mosman',
								},
								'SARAH & SEBASTIAN Paddington': {
									State: 'NSW',
									Phone: '1300 050 220',
									Url: '/pages/paddington',
								},
								'SARAH & SEBASTIAN Armadale': {
									State: 'VIC',
									Phone: '1300 050 220',
									Url: '/pages/armadale',
								},
								'SARAH & SEBASTIAN Melbourne City': {
									State: 'VIC',
									Phone: '1300 050 220',
									Url: '/pages/melbourne-city',
								},
								'SARAH & SEBASTIAN Chadstone': {
									State: 'VIC',
									Phone: '1300 050 220',
									Url: '/pages/chadstone',
								},
								'SARAH & SEBASTIAN The Strand': {
									State: 'NSW',
									Phone: '1300 050 220',
									Url: '/pages/the-strand',
								},
								'SARAH & SEBASTIAN Brisbane City': {
									State: 'QLD',
									Phone: '1300 050 220',
									Url: '/pages/brisbane-city',
								},
								'SARAH & SEBASTIAN THE STRAND PIERCING LAB': {
									State: 'NSW',
									Phone: '1300 050 220',
									Url: '/pages/the-strand',
								}
							}

							htmlData += '<div class="FindInStore__ItemList">'
							htmlData +=
								'	<p class="FindInStore__Title Heading u-h4">You Searched For: <span>' +
								_this.selectedVariant.name +
								'</span></p>'

							for (var j = 0; j < variantStockLevels.length; j++) {
								var availableStock = false
								if (isPair) {
									if (variantStockLevels[j].enabled && variantStockLevels[j].stock > 1) {
										availableStock = true
										productAvailable++
									}
								} else {
									if ( variantStockLevels[j].enabled && variantStockLevels[j].stock > 0) {
										availableStock = true
										productAvailable++
									}
								}

								if (availableStock) {
									var locationName = variantStockLevels[j].name
									var state = additionalStoreData[locationName].State
									var phone = additionalStoreData[locationName].Phone
									var storeUrl = rootUrlWithoutSlash + additionalStoreData[locationName].Url

									storeHtmlData += '<div class="FindInStoreItem__Store">'
									storeHtmlData += '	<div class="FindInStoreItem__MetaWrapper">'
									storeHtmlData +=
										'		<a href="' +
										storeUrl +
										'" class="FindInStoreItem__Title Heading u-h4">' +
										locationName +
										'</a>'
									storeHtmlData +=
										'		<p class="FindInStoreItem__Address">' + variantStockLevels[j].address1 + '</p>'
									storeHtmlData +=
										'		<p class="FindInStoreItem__Address">' +
										variantStockLevels[j].city +
										' ' +
										state +
										' ' +
										variantStockLevels[j].zip +
										' Australia</p>'
									storeHtmlData +=
										'		<a href="tel:' + phone + '"class="FindInStoreItem__Address">' + phone + '</a>'
									storeHtmlData += '	</div>'
									storeHtmlData += '	<div class="FindInStoreItem__ContactWrapper">'
									storeHtmlData +=
										'		<div class="Heading u-h4 FindInStoreItem__Contact Link--underline" data-action="toggle-find-in-store-form" data-store="' +
										locationName +
										'">' +
										findInStoreOptions['contactStoreButton'] +
										'</div>'
									storeHtmlData += '	</div>'
									storeHtmlData += '</div>'
								}
							}

							if (productAvailable == 0) {
								productAvailable = findInStoreOptions['availabilityUnavailable']
								productAvailableDescription =
									findInStoreOptions['availabilityUnavailableDescription']
							} else if (productAvailable == 1) {
								productAvailable = findInStoreOptions['availabilitySingleStore']
							} else if (productAvailable > 1) {
								productAvailable = findInStoreOptions['availabilityMultiStore']
							}

							htmlData +=
								'	<p class="FindInStoreAvailability Heading u-h4">' + productAvailable + '</p>'

							if (productAvailableDescription.length) {
								htmlData +=
									'	<p class="FindInStoreAvailability">' + productAvailableDescription + '</p>'
							}

							htmlData += storeHtmlData
							findInStoreWrapperElement.innerHTML = htmlData
							findInStoreWrapperElement.classList.add('Active')

							document.documentElement.dispatchEvent(
								new CustomEvent('new:element:loaded', {
									bubbles: true,
									detail: {
										container: findInStoreWrapperElement,
									},
								}),
							)
						})
					})
				},
			},
			{
				key: '_setupSlideshowMobileNav',
				value: function _setupSlideshowMobileNav() {
					var _this2 = this

					this.slideshowMobileNav = this.element.querySelector('.Product__SlideshowMobileNav')

					if (this.slideshowMobileNav) {
						var slideshowMobileNavDelegate = new domDelegate.Delegate(this.slideshowMobileNav) // Handle the dot

						slideshowMobileNavDelegate.on('click', '.dot', function (event, element) {
							_this2._slideWillChange()

							_this2.productSlideshow.selectCell(parseInt(element.getAttribute('data-index')))
						}) // Handle the buttons

						slideshowMobileNavDelegate.on(
							'click',
							'.Product__SlideshowNavArrow',
							function (event, element) {
								_this2._slideWillChange()

								if (element.getAttribute('data-direction') === 'next') {
									_this2.productSlideshow.next()
								} else {
									_this2.productSlideshow.previous()
								}
							},
						)
					}
				},
				/**
				 * Update the main carousel image
				 */
			},
			{
				key: '_updateSlideshowImage',
				value: function _updateSlideshowImage(event) {
					var variant = event.detail.variant,
						previousVariant = event.detail.previousVariant

					if (!variant || !variant['featured_media']) {
						return
					} // We have two logic here: if we are on pocket mode, we switch using the carousel, otherwise we simulate a link to the anchor

					this._slideWillChange()

					if (Responsive.matchesBreakpoint('pocket') && !this.options['stackProductImagesMobile']) {
						for (var i = 0; i !== this.productSlideshow.flickityInstance.cells.length; ++i) {
							var cellElement = this.productSlideshow.flickityInstance.cells[i].element,
								mediaId = parseInt(cellElement.getAttribute('data-media-id'))

							if (mediaId === variant['featured_media']['id']) {
								this.productSlideshow.selectCell(i)
							}
						}
					} else {
						//document.querySelector("[href=\"#Media".concat(variant['featured_media']['id'], "\"]")).click();

						if (this.scrollTriggerTimeline.labels['Media' + variant['featured_media']['id']]) {
							this.currentGalleryProgress =
								(this.scrollTriggerTimeline.labels['Media' + variant['featured_media']['id']] /
									(this.scrollTriggerSlides.length - 1)) *
								this.totalScrollDistance
							this.currentGalleryProgressPercentage =
								this.scrollTriggerTimeline.labels['Media' + variant['featured_media']['id']] /
								(this.scrollTriggerSlides.length - 1)

							gsap.to(this.scrollTriggerTimeline, {
								duration: 1,
								progress: this.currentGalleryProgressPercentage,
							})

							gsap.to(this.scrollTriggerScrollbarTimeline, {
								duration: 1,
								progress: this.currentGalleryProgressPercentage,
							})
						}

						//document.getElementById(`Media${variant['featured_media']['id']}`).scrollIntoView({behavior: 'smooth'});
					}
				},
				/**
				 * This happens when a media is played
				 */
			},
			{
				key: '_onMediaPlayed',
				value: function _onMediaPlayed(event) {
					// Remove draggability
					this.productSlideshow.getFlickityInstance().options.draggable = false
					this.productSlideshow.getFlickityInstance().unbindDrag() // If there is a previously enabled media, we disable it

					if (this.previouslySelectedMedia && this.previouslySelectedMedia !== event.target) {
						this.mediaList[
							this.previouslySelectedMedia.getAttribute('data-media-id')
						].hasBeenDeselected()
					} // If the slideshow is configured to stack images, the "select" method from the carousel is not called, so we
					// have to keep track of it here

					if (this.options['stackProductImages']) {
						this.previouslySelectedMedia = event.target
					}
				},
				/**
				 * This happens when a given media is paused
				 */
			},
			{
				key: '_onMediaPaused',
				value: function _onMediaPaused() {
					// Enable draggability
					this.productSlideshow.getFlickityInstance().options.draggable =
						!Responsive.matchesBreakpoint('supports-hover')
					this.productSlideshow.getFlickityInstance().bindDrag()
				},
				/**
				 * This method is called when a media changed in the slideshow
				 */
			},
			{
				key: '_handleMedia',
				value: function _handleMedia(item) {
					// First, we need to turn off the previous media (if any)
					if (this.previouslySelectedMedia && this.previouslySelectedMedia !== item) {
						switch (this.previouslySelectedMedia.getAttribute('data-media-type')) {
							case 'video':
							case 'external_video':
							case 'model':
								this.mediaList[
									this.previouslySelectedMedia.getAttribute('data-media-id')
								].hasBeenDeselected()
						} // If the previous media was a model, we need to adjust the "view in space" button to go back to initial value

						if (
							this.previouslySelectedMedia.getAttribute('data-media-type') === 'model' &&
							this.viewInSpaceElement
						) {
							this.viewInSpaceElement.setAttribute(
								'data-shopify-model3d-id',
								this.viewInSpaceElement.getAttribute('data-shopify-model3d-default-id'),
							)
						}
					} // Then, we have to handle the currently selected media

					switch (item.getAttribute('data-media-type')) {
						case 'video':
						case 'external_video':
						case 'model':
							this.mediaList[item.getAttribute('data-media-id')].hasBeenSelected()
							break
					} // If the media is a model, we need to adjust the "view in space" button

					if (item.getAttribute('data-media-type') === 'model' && this.viewInSpaceElement) {
						this.viewInSpaceElement.setAttribute(
							'data-shopify-model3d-id',
							item.getAttribute('data-media-id'),
						)
					} // We set the previously selected media to the currently new one, so that when it changes it can be properly accounted

					this.previouslySelectedMedia = item
				},
				/**
				 * Callback when the target changes
				 */
			},
			{
				key: '_onScrollTargetChanged',
				value: function _onScrollTargetChanged(event) {
					// The scrollspy emit also an "oldTarget", but when scrolling very fast with Firefox or Safari, it prevents the old to be removed, so we
					// manually iterate through all of them to remove it first
					if (this.options['stackProductImages']) {
						this.slideshowNavDotsItems.forEach(function (item) {
							return item.classList.remove('is-selected')
						})
						this.slideshowNavDotsItems[
							parseInt(event.detail.newTarget.getAttribute('data-media-position')) - 1
						].classList.add('is-selected')

						if (this.options['showThumbnails']) {
							this.slideshowNavThumbnailsItems.forEach(function (item) {
								return item.classList.remove('is-selected')
							})
							this.slideshowNavThumbnailsItems[
								parseInt(event.detail.newTarget.getAttribute('data-media-position')) - 1
							].classList.add('is-selected')
						}
					}
				},
			},
			{
				key: '_switchToImage',
				value: function _switchToImage(event, target) {
					event.preventDefault()

					this._slideWillChange()

					for (var i = 0; i !== this.productSlideshow.flickityInstance.cells.length; ++i) {
						var cellElement = this.productSlideshow.flickityInstance.cells[i].element,
							mediaId = parseInt(cellElement.getAttribute('data-media-id'))

						if (mediaId === parseInt(target.getAttribute('data-media-id'))) {
							this.productSlideshow.selectCell(i)
						}
					}
				},
				/**
				 * Check the quick nav
				 */
			},
			{
				key: '_checkQuickNav',
				value: function _checkQuickNav() {
					var _this3 = this

					var showAsideQuickNav = false
					fastdom.measure(function () {
						showAsideQuickNav =
							window.scrollY >=
							_this3.productAsideElement.offsetTop - _this3.productAsideElement.clientHeight
					})
					fastdom.mutate(function () {
						if (showAsideQuickNav) {
							_this3.quickNav.classList.add('is-flipped')
						} else {
							_this3.quickNav.classList.remove('is-flipped')
						}
					})
				},
				/**
				 * Toggle the social share icons
				 */
			},
			{
				key: '_toggleSocialShare',
				value: function _toggleSocialShare(event, target) {
					target.classList.toggle('is-active')
					target.classList.toggle('RoundButton--secondaryState')
					target.setAttribute(
						'aria-expanded',
						target.getAttribute('aria-expanded') === 'true' ? 'false' : 'true',
					)
					target.nextElementSibling.setAttribute(
						'aria-hidden',
						target.nextElementSibling.getAttribute('aria-hidden') === 'true' ? 'false' : 'true',
					)
				},
			},
			{
				key: '_onImageChanged',
				value: function _onImageChanged(event, cell) {
					// If cell is video or model, we hide the action list
					if (Responsive.matchesBreakpoint('pocket')) {
						var productGalleryActionListElement = this.element.querySelector(
							'.Product__Gallery .Product__ActionList',
						)

						if (productGalleryActionListElement) {
							if (cell.classList.contains('Product__SlideItem--image')) {
								productGalleryActionListElement.classList.remove('is-hidden')
							} else {
								productGalleryActionListElement.classList.add('is-hidden')
							}
						}
					} // If we have non-stacked with thumbnails, update it

					if (!this.options['stackProductImages'] && this.options['showThumbnails']) {
						var mediaId = cell.getAttribute('data-media-id')
						this.slideshowNavThumbnailsItems.forEach(function (thumbnail) {
							if (thumbnail.getAttribute('data-media-id') === mediaId) {
								thumbnail.classList.add('is-selected')
							} else {
								thumbnail.classList.remove('is-selected')
							}
						})
					} // If we have the mobile navigation, we also update it

					if (this.slideshowMobileNav) {
						var selectedIndex = parseInt(cell.getAttribute('data-media-position')) - 1 // The -1 is to make it 0 indexed

						Dom.nodeListToArray(this.slideshowMobileNav.querySelectorAll('.dot')).forEach(function (
							item,
							index,
						) {
							if (index <= selectedIndex) {
								item.classList.add('is-selected')
							} else {
								item.classList.remove('is-selected')
							}
						})
					}
				},
			},
			{
				key: '_onImageSettled',
				value: function _onImageSettled(index, cell) {
					// this._handleMedia(cell);

					if (Responsive.matchesBreakpoint('lap-and-up')) {
						var slides = this.element.querySelectorAll('.Product__SlideItem:not(.is-selected)')
						slides.forEach(function (slide) {
							slide.classList.add('Product__SlideItem--hidden')
						})
					}
				},
			},
			{
				key: '_slideWillChange',
				value: function _slideWillChange() {
					if (Responsive.matchesBreakpoint('lap-and-up')) {
						var slides = this.element.querySelectorAll('.Product__SlideItem')
						slides.forEach(function (slide) {
							slide.classList.remove('Product__SlideItem--hidden')
						})
					}
				},
				/**
				 * Verify when the screen size changes to create additional stuff on non pocket mode
				 */
			},
			{
				key: '_blockTouchGallery',
				value: function _blockTouchGallery(blockStatus) {
					if (blockStatus) {
						this.blockTouch = false
					} else {
						this.blockTouch = true
					}
				},
			},
			{
				key: '_scrubGallery',
				value: function _scrubGallery(event) {
					var _this = this

					if (Responsive.matchesBreakpoint('pocket')) {
						if (!this.options['stackProductImagesMobile']) {
							return
						}
					} else {
						if (!this.options['stackProductImages']) {
							return
						}
					}

					if (event.type == 'touchstart') {
						if (this.scrollTriggerTimeline.progress() < 1) {
							document.documentElement.classList.add('no-scroll')
						}
						this.lastScrubY = event.touches[0].clientY
					} else if (event.type == 'touchend') {
						document.documentElement.classList.remove('no-scroll')
					} else if (event.type == 'wheel') {
						if (window.scrollY != 0) {
							return
						}

						var moveAmount = event.deltaY
						this.currentGalleryProgress += moveAmount
						if (this.currentGalleryProgress < 0) {
							this.currentGalleryProgress = 0
						} else if (this.currentGalleryProgress > this.totalScrollDistance) {
							this.currentGalleryProgress = this.totalScrollDistance
						}

						this.timelineProgress = this.currentGalleryProgress / this.totalScrollDistance

						if (this.timelineProgress < 1 && this.timelineProgress >= 0) {
							event.preventDefault()
						}

						if (this.currentGalleryProgress <= this.totalScrollDistance) {
							this.scrollTriggerTimeline.progress(
								this.currentGalleryProgress / this.totalScrollDistance,
							)
							this.scrollTriggerScrollbarTimeline.progress(
								this.currentGalleryProgress / this.totalScrollDistance,
							)
						}
					} else if (event.type == 'touchmove') {
						var currentY = event.touches[0].clientY
						var moveAmount = (currentY - this.lastScrubY) * -1
						this.lastScrubY = event.touches[0].clientY

						if (this.scrollTriggerTimeline.progress() < 1) {
							event.preventDefault()
						}

						if (this.blockTouch) {
							return
						}

						if (
							moveAmount > 5 &&
							this.scrollTriggerTimeline.labels[this.scrollTriggerTimeline.nextLabel()] >
								this.scrollTriggerTimeline.time()
						) {
							var nextLabel = this.scrollTriggerTimeline.nextLabel()
							this._blockTouchGallery()
							this.scrollTriggerTimeline.tweenTo(nextLabel, {
								duration: 0.75,
								ease: Power1.easeOut,
								onComplete: this._blockTouchGallery.bind(this),
								onCompleteParams: [true],
							})
							this.scrollTriggerScrollbarTimeline.tweenTo(
								this.scrollTriggerTimeline.labels[this.scrollTriggerTimeline.nextLabel()] /
									this.scrollTriggerTimeline.totalDuration(),
								{
									duration: 0.75,
									ease: Power1.easeOut,
								},
							)
						} else if (
							moveAmount < -5 &&
							this.scrollTriggerTimeline.labels[this.scrollTriggerTimeline.previousLabel()] <
								this.scrollTriggerTimeline.time()
						) {
							var prevLabel = this.scrollTriggerTimeline.previousLabel()
							this._blockTouchGallery()
							this.scrollTriggerTimeline.tweenTo(prevLabel, {
								duration: 0.75,
								ease: Power1.easeOut,
								onComplete: this._blockTouchGallery.bind(this),
								onCompleteParams: [true],
							})
							this.scrollTriggerScrollbarTimeline.tweenTo(
								this.scrollTriggerTimeline.labels[this.scrollTriggerTimeline.previousLabel()] /
									this.scrollTriggerTimeline.totalDuration(),
								{
									duration: 0.75,
									ease: Power1.easeOut,
								},
							)
						}
					}
				},
			},
			{
				key: '_buildStackGallery',
				value: function _buildStackGallery() {
					if (this.scrollTrigger) {
						this.scrollTrigger.kill(true)
					}

					if (this.scrollTriggerTimeline) {
						this.scrollTriggerTimeline.kill(true)
					}

					if (this.scrollTriggerScrollbarTimeline) {
						this.scrollTriggerScrollbarTimeline.kill(true)
					}

					for (var i = 0; i < this.scrollTriggerSlides.length; ++i) {
						this.scrollTriggerSlides[i].style.transform = ''
					}

					var _this = this
					if (this.element.querySelector('.Product__SlideItem img').complete) {
						this.scrollTriggerSlides[1].classList.add('StackEnabled')
					} else {
						this.element.querySelector('.Product__SlideItem img').onload = function () {
							_this.scrollTriggerSlides[1].classList.add('StackEnabled')
						}
					}

					this.totalScrollDistance = 0
					this.scrollDistance = this.scrollTriggerSlides[0].getBoundingClientRect().height * -1

					this.productGalleryScrollBarContainerHeight = this.element
						.querySelector('.Product__Gallery_Scrollbar_Container')
						.getBoundingClientRect().height
					this.productGalleryScrollBarHeight =
						this.productGalleryScrollBar.getBoundingClientRect().height

					this.scrollTriggerTimeline = gsap.timeline().pause()
					this.scrollTriggerScrollbarTimeline = gsap.timeline().pause()

					this.scrollTriggerScrollbarTimeline.fromTo(
						this.productGalleryScrollBar,
						{
							y: 0,
						},
						{
							y: this.productGalleryScrollBarContainerHeight - this.productGalleryScrollBarHeight,
							duration: 1,
							ease: 'none',
						},
					)

					for (var i = 0; i < this.scrollTriggerSlides.length; ++i) {
						if (i == 0) {
							this.scrollTriggerTimeline
								.fromTo(
									this.scrollTriggerSlides[i],
									{
										y: 0,
									},
									{
										y: '-100%',
										duration: 1,
										ease: 'none',
										onStart: function (element) {
											if (element) {
												element.classList.add('StackEnabled')
											}
										},
										onStartParams: [this.scrollTriggerSlides[i + 1]],
									},
								)
								.addLabel(this.scrollTriggerSlides[i].id, '<')
						} else {
							this.scrollTriggerTimeline
								.fromTo(
									this.scrollTriggerSlides[i],
									{
										webkitFilter: 'brightness(0.5)',
										filter: 'brightness(0.5)',
									},
									{
										webkitFilter: 'brightness(1)',
										filter: 'brightness(1)',
										duration: 1,
										ease: 'none',
										onStart: function (element) {
											if (element) {
												element.classList.add('StackEnabled')
											}
										},
										onStartParams: [this.scrollTriggerSlides[i + 1]],
										onReverseComplete: function (element) {
											if (element) {
												element.classList.remove('StackEnabled')
											}
										},
										onReverseCompleteParams: [this.scrollTriggerSlides[i + 1]],
									},
									'<',
								)
								.addLabel(this.scrollTriggerSlides[i].id)

							if (i < this.scrollTriggerSlides.length - 1) {
								this.scrollTriggerTimeline.fromTo(
									this.scrollTriggerSlides[i],
									{
										y: 0,
									},
									{
										y: '-100%',
										duration: 1,
										ease: 'none',
									},
								)
							}
						}

						this.totalScrollDistance -= this.scrollDistance
					}
				},
			},
			{
				key: '_setupDeviceFeatures',
				value: function _setupDeviceFeatures(event) {
					var _this4 = this

					document.documentElement.classList.remove('no-scroll')

					var currentBreakpoint = event
							? event.detail.currentBreakpoint
							: Responsive.getCurrentBreakpoint(),
						previousBreakpoint = event ? event.detail.previousBreakpoint : null

					if (currentBreakpoint === previousBreakpoint) {
						return // Nothing has changed, no specific setup to do
					}
					if (currentBreakpoint === 'phone') {
						document
							.querySelector('.MobileAddToCart .MobileFormWrapper')
							.appendChild(document.querySelector('.ProductForm'))
						this.isDesktop = false
						document.documentElement.style.setProperty('--form-atc-sticky-height', document.querySelector('.js-form-atc-sticky').clientHeight + 'px');

						if (this.element.querySelector('.ProductForm__SelectOptions')) {
							gsap.set('.ProductForm__SelectOptions', {
								autoAlpha: 1,
							})

							gsap.set('.HiddenOptionWrapper', {
								autoAlpha: 0,
								height: 0,
								opacity: 0,
							})
						}

						if (this.carouselNavScrollSpy) {
							this.carouselNavScrollSpy.destroy()
						}

						if (this.productInfoScroller) {
							this.productInfoScroller.destroy()
						}

						if (this.productThumbnailsScroller) {
							this.productThumbnailsScroller.destroy()
						}

						if (this.productAsideElement) {
							this.productAsideElement.style.minHeight = null
						} else {
							this.productWrapperElement.style.minHeight = null
						}

						this.productInfoElement.parentNode.style.maxHeight = null

						if (this.options['stackProductImagesMobile'] && this.scrollTriggerSlides.length > 1) {
							this._buildStackGallery()
						}

						if (this.productSlideshow) {
							this.productSlideshow.resize()
						}
					} else {
						document
							.querySelector('.Product__InfoWrapper.Right .Product__Info_Top')
							.appendChild(document.querySelector('.ProductForm'))
						this.isDesktop = true
						document.documentElement.style.setProperty('--form-atc-sticky-height', document.querySelector('.js-form-atc-sticky').clientHeight + 'px');

						if (this.element.querySelector('.ProductForm__SelectOptions')) {
							gsap.set('.ProductForm__SelectOptions', {
								autoAlpha: 1,
							})

							gsap.set('.HiddenOptionWrapper', {
								autoAlpha: 0,
								height: 0,
								opacity: 0,
							})
						}

						// 1st: scrollspy for the dots and image
						if (this.slideshowImages && this.slideshowImages.length > 1) {
							var offsetTop = 0

							if (this.options['stackProductImages'] && this.slideshowNavDots) {
								offsetTop = this.slideshowNavDots.firstElementChild.offsetTop
							}

							if (this.options['showThumbnails'] && Responsive.matchesBreakpoint('desk')) {
								offsetTop = 250
							}

							this.carouselNavScrollSpy = new ScrollSpy(this.element, this.slideshowImages, {
								rootMargin: '-'.concat(offsetTop, 'px 0px 0px 0px'),
							})
						}

						if (this.options['stackProductImages'] && this.scrollTriggerSlides.length > 1) {
							this._buildStackGallery()
						}

						var productInfoStyles = window.getComputedStyle(this.productInfoElement),
							productInfoPadding =
								parseInt(productInfoStyles.paddingTop) + parseInt(productInfoStyles.paddingBottom),
							productGalleryHeight = this.productGalleryElement
								? parseInt(this.productGalleryElement.scrollHeight)
								: 0 // 2nd: making sure to set up enough space in aside part

						var calculateMinHeight = function calculateMinHeight() {
							if (_this4.productAsideElement) {
								_this4.productAsideElement.style.minHeight = ''.concat(
									_this4.productInfoElement.scrollHeight -
										productInfoPadding -
										productGalleryHeight,
									'px',
								)
								_this4.productInfoElement.closest('.Product__InfoWrapper').style.maxHeight =
									_this4.productAsideElement.offsetTop +
									_this4.productInfoElement.scrollHeight -
									productInfoPadding +
									'px'
							} else {
								_this4.productWrapperElement.style.minHeight = ''.concat(
									_this4.productInfoElement.scrollHeight - parseInt(productInfoStyles.paddingTop),
									'px',
								)
							}
						}

						calculateMinHeight() // This code actually works well, but if a merchant is using an app that dynamically adds content (such as ReCharge or any other widget-based app), this
						// will mess the min height. There is a clean solution to this issue, which is by using ResizeObserver. However it's only supported in Chrome for now,
						// but I feel it's already good to have a clean fix

						if (window.ResizeObserver) {
							this.productInfoResizeObserver = new ResizeObserver(function () {
								calculateMinHeight() // We currently do not take advantage of the values returned by the observer as our calculation depends on other values
							})
							this.productInfoResizeObserver.observe(this.productInfoElement)
						} // 3rd: let's handle the scroll for the product info

						this.productInfoScroller = new OverflowScroller(this.productInfoElement) // 4th: let's handle the scroll for the thumbnails

						if (this.options['showThumbnails'] && this.slideshowNavThumbnails) {
							this.productThumbnailsScroller = new OverflowScroller(this.slideshowNavThumbnails)
						}
					}
					_this4._updateStateButtonATC()
					_this4._toggleFormATCSticky()
				},
			},
		])

		return ProductSection
	})()

	var RecentlyViewedProductsSection = /*#__PURE__*/ (function () {
		function RecentlyViewedProductsSection(container) {
			_classCallCheck(this, RecentlyViewedProductsSection)

			this.element = container
			this.options = JSON.parse(this.element.getAttribute('data-section-settings')) // Setup product item color swatch

			new ProductItemColorSwatch(this.element)

			this._fetchProducts()
		}

		_createClass(RecentlyViewedProductsSection, [
			{
				key: 'onUnload',
				value: function onUnload() {
					if (this.carousel) {
						this.carousel.destroy()
					}
				},
				/**
				 * In order to get the products to display, we hit the search template with the given IDS
				 */
			},
			{
				key: '_fetchProducts',
				value: function _fetchProducts() {
					var _this = this

					var queryString = this._getSearchQueryString()

					if (queryString === '') {
						return
					} // If we have a non empty query string we do a search query

					fetch(
						''
							.concat(window.routes.searchUrl, '?section_id=')
							.concat(this.element.getAttribute('data-section-id'), '&type=product&q=')
							.concat(queryString),
						{
							credentials: 'same-origin',
							method: 'GET',
						},
					).then(function (response) {
						response.text().then(function (content) {
							var tempElement = document.createElement('div')
							tempElement.innerHTML = content // Set the content

							_this.element.innerHTML = tempElement.querySelector('.Section').innerHTML // Show the section

							_this.element.parentNode.style.display = 'block' // And finally let's create the carousel !

							_this.carousel = new Carousel(_this.element.querySelector('[data-flickity-config]'))

							document.documentElement.dispatchEvent(
								new CustomEvent('new:element:loaded', {
									bubbles: true,
									detail: {
										container: _this.element,
									},
								}),
							)
						})
					})
				},
			},
			{
				key: '_getSearchQueryString',
				value: function _getSearchQueryString() {
					var items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]') // If we are on a product template, we make sure to remove the main product from the related product

					if (items.includes(this.options['productId'])) {
						items.splice(items.indexOf(this.options['productId']), 1)
					}

					return items
						.map(function (item) {
							return 'id:' + item
						})
						.join(' OR ')
				},
			},
		])

		return RecentlyViewedProductsSection
	})()

	/**
	 * This code is extracted from Slate
	 */

	var SectionContainer = /*#__PURE__*/ (function () {
		function SectionContainer() {
			_classCallCheck(this, SectionContainer)

			this.constructors = []
			this.instances = []

			this._attachListeners()
		}

		_createClass(SectionContainer, [
			{
				key: '_attachListeners',
				value: function _attachListeners() {
					document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this))
					document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this))
					document.addEventListener('shopify:section:select', this._onSelect.bind(this))
					document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this))
					document.addEventListener('shopify:section:reorder', this._onReorder.bind(this))
					document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this))
					document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this))
				},
			},
			{
				key: 'register',
				value: function register(type, constructor) {
					var _this = this

					this.constructors[type] = constructor

					Dom.nodeListToArray(
						document.querySelectorAll('[data-section-type='.concat(type, ']')),
					).forEach(function (container) {
						var instance = _this._findInstance(
							_this.instances,
							'id',
							container.getAttribute('data-section-id'),
						)
						if (instance) {
							/** Instance already registered - skipping **/
							return
						}
						_this._createInstance(container, constructor)
					})
				},
				/**
				 * Return an object from an array of objects that matches the provided key and value
				 */
			},
			{
				key: '_findInstance',
				value: function _findInstance(array, key, value) {
					for (var i = 0; i < array.length; i++) {
						if (array[i][key] === value) {
							return array[i]
						}
					}
				},
				/**
				 * Remove an object from an array of objects by matching the provided key and value
				 */
			},
			{
				key: '_removeInstance',
				value: function _removeInstance(array, key, value) {
					var i = array.length

					while (i--) {
						if (array[i][key] === value) {
							array.splice(i, 1)
							break
						}
					}

					return array
				},
			},
			{
				key: '_onSectionLoad',
				value: function _onSectionLoad(event) {
					var container = event.target.querySelector('[data-section-id]')

					if (container) {
						this._createInstance(container)
					}
				},
			},
			{
				key: '_onSectionUnload',
				value: function _onSectionUnload(event) {
					var instance = this._findInstance(this.instances, 'id', event.detail.sectionId)

					if (!instance) {
						return
					}

					if (typeof instance.onUnload === 'function') {
						instance.onUnload(event)
					}
					this.instances = this._removeInstance(this.instances, 'id', event.detail.sectionId)
				},
			},
			{
				key: '_onSelect',
				value: function _onSelect(event) {
					var instance = this._findInstance(this.instances, 'id', event.detail.sectionId)

					if (instance && typeof instance.onSelect === 'function') {
						instance.onSelect(event)
					}
				},
			},
			{
				key: '_onDeselect',
				value: function _onDeselect(event) {
					var instance = this._findInstance(this.instances, 'id', event.detail.sectionId)

					if (instance && typeof instance.onDeselect === 'function') {
						instance.onDeselect(event)
					}
				},
			},
			{
				key: '_onReorder',
				value: function _onReorder(event) {
					var instance = this._findInstance(this.instances, 'id', event.detail.sectionId)

					if (instance && typeof instance.onReorder === 'function') {
						instance.onReorder(event)
					}
				},
			},
			{
				key: '_onBlockSelect',
				value: function _onBlockSelect(event) {
					var instance = this._findInstance(this.instances, 'id', event.detail.sectionId)

					if (instance && typeof instance.onBlockSelect === 'function') {
						instance.onBlockSelect(event)
					}
				},
			},
			{
				key: '_onBlockDeselect',
				value: function _onBlockDeselect(event) {
					var instance = this._findInstance(this.instances, 'id', event.detail.sectionId)

					if (instance && typeof instance.onBlockDeselect === 'function') {
						instance.onBlockDeselect(event)
					}
				},
			},
			{
				key: '_createInstance',
				value: function _createInstance(container, constructor) {
					var id = container.getAttribute('data-section-id'),
						type = container.getAttribute('data-section-type')
					constructor = constructor || this.constructors[type]

					if (typeof constructor === 'undefined') {
						return
					}
					var instance = Object.assign(new constructor(container), {
						id: id,
						type: type,
						container: container,
					})
					this.instances.push(instance)
				},
			},
		])

		return SectionContainer
	})()

	var ShopNowSection = /*#__PURE__*/ (function () {
		function ShopNowSection(container) {
			_classCallCheck(this, ShopNowSection)

			this.element = container
			this.carousel = new Carousel(this.element.querySelector('[data-flickity-config]')) // Setup product item color swatch

			new ProductItemColorSwatch(this.element)
		}

		_createClass(ShopNowSection, [
			{
				key: 'onUnload',
				value: function onUnload() {
					this.carousel.destroy()
				},
			},
		])

		return ShopNowSection
	})()

	var SidebarMenuSection = /*#__PURE__*/ (function () {
		function SidebarMenuSection(container) {
			_classCallCheck(this, SidebarMenuSection)

			this.element = container
			this.delegateElement = new domDelegate.Delegate(this.element)
			this.sidebarDrawer = new Drawer(container, {
				onOpen: this._openSideBarMenu.bind(this),
				onClose: this._closeSideBarMenu.bind(this),
			})
			this.backButton = this.element.querySelector('[data-action="sidebar-back-menu"]')
			this.mainHeader = document.getElementById('shopify-section-header')
			this.mainHeaderLogo = document.querySelector('.Header__FlexItem--logo')
			this.backButtonActive = false
			this.currentOpenTier = 0
			this._attachListeners()
		}

		_createClass(SidebarMenuSection, [
			{
				key: 'onUnload',
				value: function onUnload() {
					this.sidebarDrawer.destroy()
					document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener)
				},
			},
			{
				key: 'onSelect',
				value: function onSelect() {
					this.sidebarDrawer.open()
				},
			},
			{
				key: 'onDeselect',
				value: function onDeselect() {
					this.sidebarDrawer.close()
				},
			},
			{
				key: '_checkSubMenuStatus',
				value: function _checkSubMenuStatus(event, target) {
					if (target && target.classList.contains('Tier1')) {
						this.currentOpenTier = 1
					} else if (target && target.classList.contains('Tier2')) {
						this.currentOpenTier = 2
					} else if (target && target.classList.contains('Tier3')) {
						this.currentOpenTier = 3
					} else if (event == 'openMenu') {
						this.currentOpenTier = 0
					} else {
						this.currentOpenTier -= 1
					}

					if (this.currentOpenTier > 0 && this.backButtonActive == false) {
						this._showBackButton()
					} else if (this.currentOpenTier < 1 && this.backButtonActive) {
						this._hideBackButton()
					}
				},
			},
			{
				key: '_hideBackButton',
				value: function _hideBackButton() {
					var _this = this
					this.backButtonActive = false

					var hideTimeline = new TimelineLite()

					hideTimeline
						.fromTo(
							this.backButton,
							0.5,
							{
								x: 0,
								opacity: 1,
							},
							{
								x: -10,
								opacity: 0,
							},
						)
						.fromTo(
							this.mainHeaderLogo,
							0.5,
							{
								x: 10,
								opacity: 0,
							},
							{
								x: 0,
								opacity: 1,
								onComplete: function () {
									_this.mainHeader.classList.remove('noClick')
								},
							},
						)
				},
			},
			{
				key: '_showBackButton',
				value: function _showBackButton() {
					var _this = this
					this.backButtonActive = true
					var showTimeline = new TimelineLite()

					showTimeline
						.fromTo(
							this.mainHeaderLogo,
							0.5,
							{
								x: 0,
								opacity: 1,
							},
							{
								x: -10,
								opacity: 0,
							},
						)
						.fromTo(
							this.backButton,
							0.5,
							{
								x: 10,
								opacity: 0,
							},
							{
								x: 0,
								opacity: 1,
								onComplete: function () {
									_this.mainHeader.classList.add('noClick')
								},
							},
						)
				},
			},
			{
				key: '_openSideBarMenu',
				value: function _openSideBarMenu() {
					this._checkSubMenuStatus('openMenu')
					document.body.classList.add('openMenu')
				},
			},
			{
				key: '_closeSideBarMenu',
				value: function _closeSideBarMenu() {
					var _this = this

					if (this.backButtonActive) {
						this._hideBackButton()
					}

					document.body.classList.remove('openMenu')

					if (this.element.querySelectorAll('[aria-expanded="true"]').length) {
						Dom.nodeListToArray(this.element.querySelectorAll('.Collapsible__Button')).forEach(
							function (element) {
								element.style = ''
							},
						)

						setTimeout(function () {
							Dom.nodeListToArray(_this.element.querySelectorAll('[aria-expanded="true"]')).forEach(
								function (element) {
									element.setAttribute('aria-expanded', 'false')
								},
							)
						}, 300)
					}
				},
			},
			{
				key: '_closeSubMenu',
				value: function _closeSubMenu(event, target) {
					Dom.nodeListToArray(this.element.querySelectorAll('[aria-expanded="true"]'))
						.slice(-1)[0]
						.click()
					this._checkSubMenuStatus()
				},
			},
			{
				key: '_onBreakpointChanged',
				value: function _onBreakpointChanged(event, target) {
					if (Responsive.matchesBreakpoint('lap-and-up')) {
						this.sidebarDrawer.close()
					}
				},
			},
			{
				key: '_attachListeners',
				value: function _attachListeners() {
					this.delegateElement.on(
						'click',
						'[data-action="sidebar-back-menu"]',
						this._closeSubMenu.bind(this),
						true,
					)
					this.delegateElement.on(
						'click',
						'[aria-expanded="false"]',
						this._checkSubMenuStatus.bind(this),
						true,
					)

					this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this)
					document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener)
				},
			},
		])

		return SidebarMenuSection
	})()

	var MegaMenuSection = /*#__PURE__*/ (function () {
		function MegaMenuSection(container) {
			_classCallCheck(this, MegaMenuSection)

			this.element = container
			this.delegateElement = new domDelegate.Delegate(this.element)
			this.options = JSON.parse(this.element.getAttribute('data-section-settings'))

			this.megamenuDrawer = new Drawer(container)

			this._attachListeners()
		}

		_createClass(MegaMenuSection, [
			{
				key: 'onUnload',
				value: function onUnload() {
					this.megamenuDrawer.destroy()
					document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener)
				},
			},
			{
				key: 'onSelect',
				value: function onSelect() {
					this.megamenuDrawer.open()
				},
			},
			{
				key: '_openSubMenu',
				value: function _openMenu(event, target) {
					if (event.type === 'mouseenter' && target !== event.target) {
						return
					}

					fastdom.mutate(function () {
						target.classList.add('is-expanded')

						Dom.nodeListToArray(target.children, '[aria-hidden="true"]').forEach(function (item) {
							item.setAttribute('aria-hidden', 'false')
						})

						Dom.getSiblings(target, '.is-expanded').forEach(function (item) {
							item.classList.remove('is-expanded')
							Dom.nodeListToArray(item.children, '[aria-hidden="false"]').forEach(function (item) {
								item.setAttribute('aria-hidden', 'true')
							})
						})
					})
				},
			},
			{
				key: 'onDeselect',
				value: function onDeselect() {
					this.megamenuDrawer.close()
				},
			},
			{
				key: '_onBreakpointChanged',
				value: function _onBreakpointChanged() {
					if (Responsive.matchesBreakpoint('pocket')) {
						this.megamenuDrawer.close()
					}
				},
			},
			{
				key: '_attachListeners',
				value: function _attachListeners() {
					if (this.options.subMenuMethod) {
						this.delegateElement.on('click', '[aria-haspopup]', this._openSubMenu.bind(this), true)
					} else {
						this.delegateElement.on(
							'mouseenter',
							'[aria-haspopup]',
							this._openSubMenu.bind(this),
							true,
						)
						this.delegateElement.on(
							'focusin',
							'[aria-haspopup]',
							this._openSubMenu.bind(this),
							true,
						)
					}

					this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this)
					document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener)
				},
			},
		])

		return MegaMenuSection
	})()

	var HeaderSearchSection = /*#__PURE__*/ (function () {
		function HeaderSearchSection(container) {
			_classCallCheck(this, HeaderSearchSection)
			this.element = container
			this.delegateElement = new domDelegate.Delegate(this.element)
			this.searchDrawer = new Drawer(container)
			this._attachListeners()
		}

		_createClass(HeaderSearchSection, [
			{
				key: 'onUnload',
				value: function onUnload() {
					this.searchDrawer.destroy()
					document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener)
				},
			},
			{
				key: 'onSelect',
				value: function onSelect() {
					this.searchDrawer.open()
				},
			},
			{
				key: 'onDeselect',
				value: function onDeselect() {
					this.searchDrawer.close()
				},
			},
			{
				key: '_onBreakpointChanged',
				value: function _onBreakpointChanged() {
					if (Responsive.matchesBreakpoint('pocket')) {
						this.searchDrawer.close()
					}
				},
			},
			{
				key: '_attachListeners',
				value: function _attachListeners() {
					this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this)
					document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener)
				},
			},
		])

		return HeaderSearchSection
	})()

	var StyleguideCarouselSection = /*#__PURE__*/ (function () {
		function StyleguideCarouselSection(element) {
			_classCallCheck(this, StyleguideCarouselSection)

			this.element = element
			this.delegateElement = new domDelegate.Delegate(this.element)

			const carouselEls = this.element.querySelectorAll('[data-flickity-config]')
			carouselEls.forEach(el => {
				new Carousel(el, {})
			})
		}

		_createClass(StyleguideCarouselSection, [])

		return StyleguideCarouselSection
	})()

	var ProductFeedCarouselSection = /*#__PURE__*/ (function () {
		function ProductFeedCarouselSection(element) {
			_classCallCheck(this, ProductFeedCarouselSection)

			this.element = element
			this.delegateElement = new domDelegate.Delegate(this.element)

			const carouselEls = this.element.querySelectorAll('.js-product-feed-carousel')
			this.tabContents = this.element.querySelectorAll('.js-product-feed-tab-content')
			this.tabContentWrapper = this.element.querySelector('.js-product-feed-content')
			this.tabProductFeedCarousel = this.element.querySelectorAll('.js-tabs-product-feed-carousel')

			if (this.tabProductFeedCarousel && this.tabProductFeedCarousel.length > 0) {
				this.tabProductFeedCarousel.forEach(element => {
					const dataOptionTabs = element.getAttribute('data-swiper-config')

					if (dataOptionTabs) {
						const tabsSwiper = new Swiper(element, JSON.parse(dataOptionTabs))
					}
				});
			}

			carouselEls.forEach((el, index) => {
				const carouselItem = new Carousel(el, {})

				if (index === 0 && this.tabContentWrapper) {
					setTimeout(() => {
						carouselItem.resize()
						this.resize(index, carouselItem)
					}, 1000)
				}

				document.addEventListener('change-tab', (value) => {
					if (value?.detail === index && this.tabContentWrapper) {
						setTimeout(() => {
							carouselItem.resize()
							this.resize(index, carouselItem)
						}, 100)
					}
				})

				window.addEventListener("resize", () => {
					this.resize(index, carouselItem)
				})
			})

			this._changeTab()
		}	

		_createClass(ProductFeedCarouselSection, [
			{
				key: '_changeTab',
				value: function _changeTab() {
					this.tabContents.forEach((content, index) => {
						if (index !== 0) {
							content.classList.add('product-feed__tabs-content--hidden')
						}

						const button = content.querySelector('.js-product-feed-button')

						button?.classList.add('product-feed__content-bottom--active')
					})

					if (this.tabProductFeedCarousel && this.tabProductFeedCarousel.length > 0) {
						this.tabProductFeedCarousel.forEach(element => {
							const tabTitleButtons = element.querySelectorAll('.js-product-feed-tab-title')

							tabTitleButtons.forEach((title, titleIndex) => {
								title.addEventListener('click', () => {
									tabTitleButtons.forEach(el => el.classList.remove('product-feed__tabs-title--active'))

									title.classList.add('product-feed__tabs-title--active')

									this.tabContents.forEach((content, contentIndex) => {
										if (titleIndex === contentIndex) {
											content.classList.remove('product-feed__tabs-content--hidden')
										} else {
											content.classList.add('product-feed__tabs-content--hidden')
										}
									})

									document.dispatchEvent(new CustomEvent('change-tab', { detail: titleIndex}))
								})
							})
						})
					}
				}
			},
			{
				key: 'resize',
				value: function resize(index, carousel) {
					if (!this.tabContents[index].classList.contains('product-feed__tabs-content--hidden')) {
						const imageEl = this.tabContents[index].querySelector('.ProductItem__ImageWrapper')
						const prevNextButtonEls = this.tabContents[index].querySelectorAll('.flickity-prev-next-button')
						prevNextButtonEls.forEach(buttonEl => {
							buttonEl.style.opacity = 1
						}) 
						
						const buttonContent = this.tabContents[index].querySelector('.js-product-feed-button')
						const heightButton = buttonContent?.getBoundingClientRect().height || 0
						
						// The following code has been commented out due to causing padding issues on iPhone, has been tested on multiple screen resolutions and seems to be fine now. But this is just a hotfix
						// this.tabContentWrapper.style.height = carousel.getFlickityInstance().maxCellHeight + heightButton + 'px'
					}
				}
			}
		])

		return ProductFeedCarouselSection
	})()

	var ServiceSection = /*#__PURE__*/ (function () {
		function ServiceSection(element) {
			_classCallCheck(this, ServiceSection)

			this.parentElement = element.closest('.shopify-section')
			this.element = element
			this.delegateElement = new domDelegate.Delegate(this.element)

			const nextSection = this.parentElement.nextElementSibling
			if (!nextSection) return

			const viewportHeight = window.innerHeight

			if (window.innerWidth >= 768) {
				document.documentElement.style.setProperty('--viewport-height', `-${viewportHeight * 0.3}px`)
			}

			window.addEventListener('scroll', () => {
				const nextSectionRect = nextSection.getBoundingClientRect()

				if (nextSectionRect.top <= 0) {
					this.element.classList.add('parallax-section--invisible')
					this.element.classList.remove('parallax-section--visible')
				} else {
					this.element.classList.add('parallax-section--visible')
					this.element.classList.remove('parallax-section--invisible')
				}
			})

			if (window.innerWidth >= 768) {
				const productEl = this.element.querySelector('.service__product')
				const productObserver = new IntersectionObserver(elements => {
					if (elements[0].isIntersecting) {
						elements[0].target.classList.add('service__product--animate')
					}
				})
	
				productObserver.observe(productEl)
			}
		}

		_createClass(ServiceSection, [])

		return ServiceSection
	})()

	var PriceRange = /*#__PURE__*/ (function (_HTMLElement) {
		_inherits(PriceRange, _HTMLElement)

		var _super = _createSuper(PriceRange)

		function PriceRange() {
			_classCallCheck(this, PriceRange)

			return _super.apply(this, arguments)
		}

		_createClass(PriceRange, [
			{
				key: 'connectedCallback',
				value: function connectedCallback() {
					var _this = this

					this.rangeLowerBound = this.querySelector('.price-range__range-group input:first-child')
					this.rangeHigherBound = this.querySelector('.price-range__range-group input:last-child')
					this.textInputLowerBound = this.querySelector('.price-range__input:first-child input')
					this.textInputHigherBound = this.querySelector('.price-range__input:last-child input') // Select whole text on focus for text field to improve user experience

					this.textInputLowerBound.addEventListener('focus', function () {
						return _this.textInputLowerBound.select()
					})
					this.textInputHigherBound.addEventListener('focus', function () {
						return _this.textInputHigherBound.select()
					}) // Keep in sync the range with the text input fields

					this.textInputLowerBound.addEventListener('change', function (event) {
						event.target.value = Math.max(
							Math.min(
								parseInt(event.target.value),
								parseInt(_this.textInputHigherBound.value || event.target.max) - 1,
							),
							event.target.min,
						)
						_this.rangeLowerBound.value = event.target.value

						_this.rangeLowerBound.parentElement.style.setProperty(
							'--range-min',
							''.concat(
								(parseInt(_this.rangeLowerBound.value) / parseInt(_this.rangeLowerBound.max)) * 100,
								'%',
							),
						)
					})
					this.textInputHigherBound.addEventListener('change', function (event) {
						event.target.value = Math.min(
							Math.max(
								parseInt(event.target.value),
								parseInt(_this.textInputLowerBound.value || event.target.min) + 1,
							),
							event.target.max,
						)
						_this.rangeHigherBound.value = event.target.value

						_this.rangeHigherBound.parentElement.style.setProperty(
							'--range-max',
							''.concat(
								(parseInt(_this.rangeHigherBound.value) / parseInt(_this.rangeHigherBound.max)) *
									100,
								'%',
							),
						)
					})
					this.rangeLowerBound.addEventListener('change', function (event) {
						_this.textInputLowerBound.value = event.target.value

						_this.textInputLowerBound.dispatchEvent(
							new Event('change', {
								bubbles: true,
							}),
						)
					})
					this.rangeHigherBound.addEventListener('change', function (event) {
						_this.textInputHigherBound.value = event.target.value

						_this.textInputHigherBound.dispatchEvent(
							new Event('change', {
								bubbles: true,
							}),
						)
					}) // We also have to bound the two range sliders

					this.rangeLowerBound.addEventListener('input', function (event) {
						event.target.value = Math.min(
							parseInt(event.target.value),
							parseInt(_this.textInputHigherBound.value || event.target.max) - 1,
						) // Bound the value

						event.target.parentElement.style.setProperty(
							'--range-min',
							''.concat((parseInt(event.target.value) / parseInt(event.target.max)) * 100, '%'),
						)
						_this.textInputLowerBound.value = event.target.value
					})
					this.rangeHigherBound.addEventListener('input', function (event) {
						event.target.value = Math.max(
							parseInt(event.target.value),
							parseInt(_this.textInputLowerBound.value || event.target.min) + 1,
						) // Bound the value

						event.target.parentElement.style.setProperty(
							'--range-max',
							''.concat((parseInt(event.target.value) / parseInt(event.target.max)) * 100, '%'),
						)
						_this.textInputHigherBound.value = event.target.value
					})
				},
			},
		])

		return PriceRange
	})(/*#__PURE__*/ _wrapNativeSuper(HTMLElement))
	window.customElements.define('price-range', PriceRange)

	function pageLoaded(firstPageLoad) {
		if (firstPageLoad) {
			// First, we register all plugins that are used for all pages
			new Collapsible()
			new Modal()
			new Responsive()
		}

		sections.register('header', HeaderSection)
		sections.register('footer', FooterSection)
		sections.register('sidebar-menu', SidebarMenuSection)
		sections.register('mega-menu', MegaMenuSection)
		sections.register('header-search', HeaderSearchSection)
		sections.register('cart', CartSection)
		sections.register('newsletter-popup', NewsletterPopupSection) // Sections used on index

		sections.register('usps', USPsSection)
		sections.register('text-with-image', TextWithImageSection)

		sections.register('feature-product-2d-builder', FeatureProduct2DBuilderSection)
		sections.register('product', ProductSection)
		sections.register('product-recommendations', ProductRecommendationsSection) // Sections used on collection page

		sections.register('collection', CollectionSection)
		sections.register('collection-ticker', CollectionTickerSection)

		sections.register('article', ArticleSection) // Sections used on content pages

		sections.register('faq', FaqSection) // Sections used on login page

		sections.register('login', LoginSection) // Sections used on addresses page

		sections.register('addresses', AddressesSection) // Sections used on gift card page

		sections.register('gift-card', GiftCardSection) // Sections used on different pages

		sections.register('recently-viewed-products', RecentlyViewedProductsSection)
		sections.register('shop-now', ShopNowSection)
		sections.register('shop-the-look-carousel', ShopTheLookCarouselSection)

		sections.register('styleguide-carousel', StyleguideCarouselSection)
		sections.register('product-feed', ProductFeedCarouselSection)

		sections.register('service', ServiceSection)

		_lazyVideoObserve()

		/**
		 * ----------------------------------------------------------------------------
		 * FLICKITY
		 *
		 * Starting from iOS 11, Safari on iOS is experiencing a bug that prevents
		 * event.preventDefault to be called on dynamically added listeners, which is
		 * what Flickity is using.
		 *
		 * The bug is coming from iOS but it impacts indirectly Flickity. A temporary
		 * fix has been suggested here: https://github.com/metafizzy/flickity/issues/740
		 * and that we are using here as a temporary workaround, that should be removed
		 * once the bug is fixed on iOS
		 * ----------------------------------------------------------------------------
		 */

		if (firstPageLoad) {
			Flickity.defaults.dragThreshold = 7

			;(function () {
				var touchingCarousel = false,
					touchStartCoords
				document.body.addEventListener('touchstart', function (e) {
					if (e.target.closest('.flickity-slider')) {
						touchingCarousel = true
					} else {
						touchingCarousel = false
						return
					}

					touchStartCoords = {
						x: e.touches[0].pageX,
						y: e.touches[0].pageY,
					}
				})
				document.body.addEventListener(
					'touchmove',
					function (e) {
						if (!(touchingCarousel && e.cancelable)) {
							return
						}

						var moveVector = {
							x: e.touches[0].pageX - touchStartCoords.x,
							y: e.touches[0].pageY - touchStartCoords.y,
						}
						if (Math.abs(moveVector.x) > Flickity.defaults.dragThreshold) e.preventDefault()
					},
					{
						passive: false,
					},
				)
			})()
		}
		/**
		 * ----------------------------------------------------------------------------
		 * FLICKITY 2
		 *
		 * Starting from iOS 15, Safari on iOS automatically starts to expand/collapse
		 * the bottom bar as soon as you do even a minor diagonal movement. This is causing
		 * a performance issue on iOS15 as it does a lot of reflow. We therefore have to
		 * patch Flickity to make sure they re-size the carousel only when the width is
		 * changed, by ignoring the height
		 * ----------------------------------------------------------------------------
		 */

		if (firstPageLoad) {
			function iOSversion() {
				if (/iP(hone|od|ad)/.test(navigator.platform)) {
					var v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/)
					return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)]
				}
			}

			var ver = iOSversion()

			if (ver && ver[0] >= 15) {
				;(function () {
					if (window.Flickity) {
						var originalResizeMethod = window.Flickity.prototype.resize,
							lastWidth = window.innerWidth

						window.Flickity.prototype.resize = function () {
							if (window.innerWidth === lastWidth && this.maxCellHeight > 0) {
								return
							}

							lastWidth = window.innerWidth
							originalResizeMethod.apply(this, arguments) // Call original method
						}
					}
				})()
			}
		}
		/**
		 * ----------------------------------------------------------------------------
		 * RTE
		 * ----------------------------------------------------------------------------
		 */

		;(function () {
			// We wrap each RTE table by a specific class to allow wrapping
			Dom.nodeListToArray(document.querySelectorAll('.Rte table')).forEach(function (table) {
				table.outerHTML = '<div class="TableWrapper">' + table.outerHTML + '</div>'
			})
			Dom.nodeListToArray(document.querySelectorAll('.Rte iframe')).forEach(function (iframe) {
				// We scope the wrapping only for YouTube and Vimeo
				if (
					iframe.src.indexOf('youtube') !== -1 ||
					iframe.src.indexOf('youtu.be') !== -1 ||
					iframe.src.indexOf('vimeo') !== -1
				) {
					iframe.outerHTML = '<div class="VideoWrapper">' + iframe.outerHTML + '</div>' // Re-set the src attribute on each iframe after page load for Chrome's "incorrect iFrame content on 'back'" bug.
					// https://code.google.com/p/chromium/issues/detail?id=395791. Need to specifically target video and admin bar

					iframe.src = iframe.src
				}
			})
		})()

		if (firstPageLoad) {
			/**
			 * ----------------------------------------------------------------------------
			 * UTILS
			 * ----------------------------------------------------------------------------
			 */
			function smoothScrollTo({target, duration, offset}) {
				const targetPosition = typeof target === 'number' 
					? target 
					: target.getBoundingClientRect().top + window.pageYOffset;
				
				const startPosition = window.pageYOffset;
				const distance = targetPosition - startPosition - offset;
				let startTime = null;

				function animation(currentTime) {
					if (startTime === null) startTime = currentTime;
					const timeElapsed = currentTime - startTime;
					const run = ease(timeElapsed, startPosition, distance, duration);
					window.scrollTo(0, run);
					if (timeElapsed < duration) requestAnimationFrame(animation);
				}

				function ease(t, b, c, d) {
					t /= d / 2;
					if (t < 1) return c / 2 * t * t + b;
					t--;
					return -c / 2 * (t * (t - 2) - 1) + b;
				}

				requestAnimationFrame(animation);
			}

			;(function () {
				var documentDelegate = new domDelegate.Delegate(document.body),
					announcementBar = document.querySelector('.AnnouncementBar')
				documentDelegate.on('click', '[href^="#"], [data-href]', function (event, target) {
					event.preventDefault()
					var selector = target.hasAttribute('data-section')
						? target.getAttribute('data-section')
						: target.getAttribute('data-href')

					if (selector === '#' || selector === '#main') {
						return
					}

					var element = document.querySelector(`.${selector}`),
					offset = parseInt(target.getAttribute('data-offset') || 0)

					if (element) {
						if (announcementBar) {
							offset -= announcementBar.clientHeight
						}
	
						if (target.hasAttribute('data-focus-on-click')) {
							var prevScrollY = window.pageYOffset
							element.focus({
								preventScroll: true,
							}) // hack to fix scroll jump after focus
	
							if (window.pageYOffset !== prevScrollY) {
								window.scrollTo(window.pageXOffset, prevScrollY)
							}
	
							element.focus()
						}
						smoothScrollTo({
							target: element,
							duration: 1000,
							offset
						})
					}
				})
			})()
		}

		if (firstPageLoad) {
			;(function () {
				var windowWidth = window.innerWidth
				// TODO: remove later
				window.addEventListener('resize', function () {
					var newWidth = -1
					fastdom.measure(function () {
						newWidth = window.innerWidth
					})
					fastdom.mutate(function () {
						if (newWidth === windowWidth) {
							return
						}

						windowWidth = newWidth
						document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px')

						if (document.querySelector('.Product__InfoWrapper.Right')) {
							document.documentElement.style.setProperty(
								'--side-bar-width',
								document.querySelector('.Product__InfoWrapper.Right').getBoundingClientRect()
									.width + 'px',
							)
						}
					})
				})
			})()
		}

		if (document.location.pathname == '/challenge') {
			if (document.referrer.includes('/collections/archive-sale')) {
				document
					.querySelector('.shopify-challenge__container > form')
					.appendChild('<input type="hidden" name="return_to" value="/collections/archive-sale">')
			}
		}

		;(function () {
			function handleFirstTab(event) {
				if (event.keyCode === 9) {
					document.body.classList.add('is-tabbing')
					window.removeEventListener('keydown', handleFirstTab)
				}
			}

			window.addEventListener('keydown', handleFirstTab)
		})()

		if (document.querySelector('.Product__InfoWrapper.Right')) {
			var newSideBarWidth =
				document.querySelector('.Product__InfoWrapper.Right').getBoundingClientRect().width + 'px'
			document.documentElement.style.setProperty('--side-bar-width', newSideBarWidth)
		} else {
			document.documentElement.style.setProperty('--side-bar-width', '35%')
		}
		/**
		 * ----------------------------------------------------------------------------
		 * ANIMATION
		 *
		 * Important: this has to be at the very end of the file
		 * ----------------------------------------------------------------------------
		 */

		if (window.theme.showPageTransition) {
			PageTransition.getInstance()
		}
	}

	var sections = new SectionContainer()
	pageLoaded(true)

	document.addEventListener('new:element:loaded', function (event) {
		_lazyVideoObserve()
	})

	document.addEventListener('new:page:loaded', function (event) {
		event.detail.container.querySelectorAll('.shopify-section').forEach((el) => {
			var sectionId = el.id.replace('shopify-section-', '').replace('section-', '')
			document.documentElement.dispatchEvent(
				new CustomEvent('shopify:section:unload', {
					bubbles: true,
					detail: {
						sectionId: sectionId,
					},
				}),
			)
		})

		if (event.detail.removeFrom) {
			event.detail.container.remove()
		}

		Dom.nodeListToArray(document.querySelectorAll('.Image--lazyLoading')).forEach(function (item) {
			item.classList.remove('.Image--lazyLoading')
			item.classList.add('.Image--lazyLoad')
		})

		pageLoaded(false)
	})

	document.body.addEventListener('click', (e) => {
		const closeBtn = document.querySelector('.klaviyo-close-form')

		if (closeBtn?.contains(e.target)) {
			const flyoutPopup = document.querySelector('[aria-label="FLYOUT Form"]')
			flyoutPopup?.parentElement?.remove()
		}
	})

 /** Accordion function **/
  const accordionItemHeaders = document.querySelectorAll('.accordion-item__heading')
  const previewAccordionSections = document.querySelectorAll('.accordion-section.preview-enabled')
  const truncateCanvas = document.createElement('canvas')
  const truncateCanvasContext = truncateCanvas.getContext('2d')

  function getParagraphFont(style) {
    if (style.font) {
      return style.font
    }

		const fontStyle = style.fontStyle || 'normal'
    const fontVariant = style.fontVariant || 'normal'
    const fontWeight = style.fontWeight || '400'
    const fontSize = style.fontSize || '16px'
    const lineHeight = style.lineHeight && style.lineHeight !== 'normal' ? style.lineHeight : 'normal'
    const fontFamily = style.fontFamily || 'sans-serif'

    return `${fontStyle} ${fontVariant} ${fontWeight} ${fontSize} / ${lineHeight} ${fontFamily}`
  }

  function getResponsiveMaxChars(p) {
		const MOBILE_WIDTH_FACTOR = 0.94
		const DESKTOP_WIDTH_FACTOR = 0.56
    const content = p.closest('.accordion-item__content') || p
    const width = content.clientWidth || p.clientWidth || 0
    const isMobile = window.matchMedia('(max-width: 767px)').matches
    const widthFactor = isMobile ? MOBILE_WIDTH_FACTOR : DESKTOP_WIDTH_FACTOR
    const targetWidth = width * widthFactor
    const style = window.getComputedStyle(p)
    const sample = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
		const fontSizePx = parseFloat(style.fontSize) || 16
    let averageCharWidth = fontSizePx * 0.5

    if (truncateCanvasContext) {
      truncateCanvasContext.font = getParagraphFont(style)
      const sampleWidth = truncateCanvasContext.measureText(sample).width
      averageCharWidth = sampleWidth > 0 ? sampleWidth / sample.length : averageCharWidth
    }

    const computedMaxChars = Math.floor(targetWidth / Math.max(averageCharWidth, 1))

    return Math.max(20, computedMaxChars)
  }

  // Function to apply truncation at word boundaries
  function applyTruncation(p) {
    const originalText = p.dataset.originalText

    if (!originalText) {
			console.warn('applyTruncation: missing data-original-text on element', p)
      return
    }

    const normalizedText = originalText.replace(/\s+/g, ' ').trim()
    const maxChars = getResponsiveMaxChars(p)

    if (normalizedText.length <= maxChars) {
      p.textContent = originalText
      return
    }

    const cut = normalizedText.slice(0, maxChars)
    const lastSpaceIndex = cut.lastIndexOf(' ')

    if (lastSpaceIndex > 0) {
      p.textContent = cut.slice(0, lastSpaceIndex) + '…'
    } else {
      p.textContent = cut + '…'
    }
  }

  // Function to restore original text
  function restoreText(p) {
    if (!p.dataset.originalHtml) {
      return
    }

    p.innerHTML = p.dataset.originalHtml
  }

  function applyPreviewTextState() {
    previewAccordionSections.forEach((section) => {
      const accordionItems = section.querySelectorAll('.accordion-item')

      accordionItems.forEach((item) => {
        const paragraphs = item.querySelectorAll('.accordion-item__content p')

        paragraphs.forEach((p) => {
          if (!p.dataset.originalText || !p.dataset.originalHtml) {
            p.dataset.originalText = p.textContent
            p.dataset.originalHtml = p.innerHTML
          }

          if (item.classList.contains('active')) {
            restoreText(p)
          } else {
            applyTruncation(p)
          }
        })
      })
    })
  }

  accordionItemHeaders.forEach((accordionItemHeader) => {
    const accordionItemBody = accordionItemHeader.parentElement.nextElementSibling
    const accordionItem = accordionItemHeader?.closest('.accordion-item')

    if (accordionItem?.classList.contains('active')) {
      accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + 'px'
    } else {
      accordionItemBody.style.maxHeight = '0px'
    }

    accordionItemHeader.addEventListener('click', () => {
      accordionItemHeaders.forEach((item) => {
        item.setAttribute('aria-expanded', 'false')
      })

      const currentlyActiveAccordionItemHeader = document.querySelector('.accordion-item.active .accordion-item__heading')
      const currentlyActiveAccordionItem = currentlyActiveAccordionItemHeader?.closest('.accordion-item')
      if (currentlyActiveAccordionItemHeader && currentlyActiveAccordionItemHeader !== accordionItemHeader) {
        currentlyActiveAccordionItem.classList.toggle('active')
        const body = currentlyActiveAccordionItem.querySelector('.accordion-item__content')
        if (body) {
          body.style.maxHeight = '0px'
          body.addEventListener('transitionend', function handler() {
            const paragraphs = currentlyActiveAccordionItem.querySelectorAll('.accordion-item__content p')
            paragraphs.forEach((p) => applyTruncation(p))
            body.removeEventListener('transitionend', handler)
          })
        }
      }

      accordionItem.classList.toggle('active')
      const accordionItemBody = accordionItemHeader.parentElement.nextElementSibling

      if (accordionItem.classList.contains('active')) {
        // Expanding: restore text first, then set height
        const paragraphs = accordionItem.querySelectorAll('.accordion-item__content p')
        paragraphs.forEach(p => restoreText(p))
        accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + 'px'
        accordionItemHeader.setAttribute('aria-expanded', 'true')
      } else {
        // Collapsing: set height to 0, then truncate after transition
        accordionItemBody.style.maxHeight = '0px'
        accordionItemHeader.setAttribute('aria-expanded', 'false')
        accordionItemBody.addEventListener('transitionend', function handler() {
          const paragraphs = accordionItem.querySelectorAll('.accordion-item__content p')
          paragraphs.forEach((p) => applyTruncation(p))
          accordionItemBody.removeEventListener('transitionend', handler)
        })
      }
    })
  })

  // Apply preview text truncation based on element width.
  applyPreviewTextState()

  let accordionResizeTimeout
  const accordionResizeObserver = new ResizeObserver(() => {
    clearTimeout(accordionResizeTimeout)
    accordionResizeTimeout = setTimeout(() => {
      applyPreviewTextState()
    }, 150)
  })

  accordionResizeObserver.observe(document.documentElement)
  // Expose a teardown function so the resize observer can be cleaned up
  // when the accordion functionality is unloaded.
  window.destroyAccordionPreviewTextListener = function () {
    accordionResizeObserver.disconnect()
    if (accordionResizeTimeout) {
      clearTimeout(accordionResizeTimeout)
      accordionResizeTimeout = null
    }
  }

	class BrandVoice extends HTMLElement {
		constructor() {
			super()

			this.attachEvent()
		}
		attachEvent = () => {
			const brandVoiceTitle = document.querySelectorAll(".js-brand-voice");

			if (brandVoiceTitle) {
				brandVoiceTitle.forEach((item) => {
					const str = item.dataset.title
					const color = item.dataset.titleColor
					const opacity = item.dataset.titleOpacity
					const speedLetters = Number(item.dataset?.animationSpeedLetters ?? 2000)
					const speedWords = Number(item.dataset?.animationSpeedWords ?? 50)

					let strAfterHtml = `<span>${str.split(/([' ',!,?,.])/).join('</span><span class="js-animation">')}</span>`
					if (str.includes('[more]')) {
						const strBefore = str.split('[more]')[0]
						const strAfter = str.split('[more]')[1]
						const strBeforeHtml = `<span>${strBefore}</span>`

						strAfterHtml = `<span>${strAfter.split(/([' ',!,?,.])/).join('</span><span class="js-animation">')}</span>`
						$(strBeforeHtml).appendTo('.js-brand-voice__title')
					}
					$(strAfterHtml).appendTo('.js-brand-voice__title')
					const spanItem= item.querySelectorAll('.js-animation')

					$(spanItem).each(function (i) {
						if (!$(this).hasClass('active')) {
							$(this).css({
								display: 'inline',
								opacity: opacity,
								color: color
							})
						}
					})

					document.addEventListener('scroll', (e) => {
						if (!item) return
						const topOfItem = $(item).offset().top
						const bottomOfItem = topOfItem + item.offsetHeight
						const topOfScreen = window.scrollY
						const bottomOfScreen = topOfScreen + window.innerHeight

						if ((bottomOfScreen > bottomOfItem) && (topOfScreen < topOfItem)) {
							$(spanItem).each(function (i) {
								if (!$(this).hasClass('active')) {
									$(this).delay(speedWords * i).animate({
										opacity: 1
									}, { duration: speedLetters, queue: true, complete: function(e){
										$(this).addClass('active')
									}})
								}
							});
						} else {
							$(spanItem).stop()
						}
					})
				})
			}
		}
	}
	if (!customElements.get('brand-voice')) {
		customElements.define('brand-voice', BrandVoice)
	}
	/** END Brand Voice function **/


	const newsletterFormBtn = document.querySelector('#newsletterForm')

	if (newsletterFormBtn) {
	newsletterFormBtn.addEventListener('click', () => {
		newsletterFormBtn.style.display='none'
		document.querySelector('.js-newsletter-icon-loading').style.display = "block"
	})
	}

	class ProductCard extends HTMLElement {
		constructor() {
			super()
			
			this.carouselEl = this.querySelector('[data-flickity-config]')
			this.carouselImage = null
		}

		connectedCallback() {
			this.carouselImage = this.carouselEl && new Carousel(this.carouselEl, {})

			document.addEventListener('change-tab', () => {
				this.carouselImage?.resize()
			})
		}
	}

	if (!customElements.get('product-card')) {
		customElements.define('product-card', ProductCard)
	}

	class CollectionList extends HTMLElement {
		constructor() {
			super()

			this.titleItems = this.querySelectorAll('.js-collection-list-title-item')
			this.imageItems = this.querySelectorAll('.js-collection-list-image-item')
			this.featureImage = this.querySelector('.js-feature-image')
			this.selectedIndexInit = null

			this.attachEvent()
		}

		attachEvent() {
			this.titleItems?.forEach((title, index) => {
				title.addEventListener('mouseenter', () => this.toogleActive(true, index))
				title.addEventListener('mouseleave', () => this.toogleActive(false, index))
			})
		}

		toogleActive(isActive, index) {
			this.featureImage?.classList.toggle('collection-list__feature-image--hidden', isActive);
			this.querySelector('.collection-list__content').classList.toggle('collection-list__content--hover', isActive)

			this.titleItems.forEach((item, idx) => {
				item.classList.toggle('collection-list__title--active', isActive && idx === index);
			});
	
			this.imageItems?.forEach((item, idx) => {
				item.classList.toggle('collection-list__image-item--active', isActive && idx === index);
			});
		}

		handleImage(carousel) {
			if (!carousel) {
				return
			}

			const cells = carousel.cells
			const selectedIndex = carousel.selectedIndex
			const prevIndex = selectedIndex - 1
			const nextIndex = selectedIndex + 1

			
			cells?.forEach((cell, index) => {
				const cellEl = cells[index].element
				const imageEl = cells[index].element.querySelector('.js-collection-list-item-image')
				const ortherSelectedEl = cells.find((cell, index) => cells[index].element.classList.contains('is-selected'))
				const imageOther = ortherSelectedEl.element.querySelector('.js-collection-list-item-image')
				const translateSpacing = cells[index].size.width - 10 - imageOther?.getBoundingClientRect().width

				if (!imageEl) {
					return
				}

				if (index === prevIndex) {
					imageEl.style.marginRight = `-${translateSpacing / 2}px`
					imageEl.style.marginLeft = `${translateSpacing / 2}px`
				} else if (index === nextIndex) {
					imageEl.style.marginLeft = `-${translateSpacing / 2}px`
					imageEl.style.marginRight = `${translateSpacing / 2}px`
				} else if (cellEl.classList.contains('is-selected')) {
					imageEl.style.marginRight = '0'
					imageEl.style.marginLeft = '0'
				}
			})
		}
	}

	if (!customElements.get('collection-lists')) {
		customElements.define('collection-lists', CollectionList)
	}

  class AccountFormTab extends HTMLElement {
    constructor() {
      super()
			this.timelineLite = new TimelineLite()
			this.isSlideout = JSON.parse(this.dataset.isSlideout)

			this.attachEvent()
		}

    attachEvent = () => {
			window.customElements.whenDefined('account-slideout').then(() => {
				setTimeout(() => {
					this.tabButtons = this.querySelectorAll('[data-button-type]')
					this.tabContent = this.querySelectorAll('[data-section-type]')
	
					this.isSlideout && this.tabButtons.forEach((button) => {
						button.addEventListener('click', (e) => {
							e.preventDefault()
	
							this.handleButtonClick(button)
						})
					})
				}, 500)
			})

      window.onpopstate = (event) => {
        const buttonType = event.state ? event.state.buttonType : null
        this.handleActiveElements(buttonType)
      }

			setTimeout(() => {
				const buttonToggleRecoverForm = this.querySelectorAll('[data-action="toggle-recover-form"]')
				const customerLoginForm = this.querySelector('#customer_login')
				const recoverPasswordForm = this.querySelector('#recover_customer_password')

				this.isSlideout && buttonToggleRecoverForm &&
				buttonToggleRecoverForm.forEach(button => {
					button.addEventListener('click', () => {
						var isLoginActive = customerLoginForm.style.display === 'block'
						if (isLoginActive) {
							this.timelineLite
								.fromTo(
									customerLoginForm,
									0.5,
									{
										autoAlpha: 1,
										display: 'block',
										y: 0,
									},
									{
										autoAlpha: 0,
										y: 20,
										display: 'none',
									},
								)
								.fromTo(
									recoverPasswordForm,
									0.5,
									{
										autoAlpha: 0,
										display: 'none',
										y: 20,
									},
									{
										autoAlpha: 1,
										display: 'block',
										y: 0,
										delay: 0.25,
									},
								)
						} else {
							this.timelineLite
								.fromTo(
									recoverPasswordForm,
									0.5,
									{
										autoAlpha: 1,
										display: 'block',
										y: 0,
									},
									{
										autoAlpha: 0,
										y: 20,
										display: 'none',
									},
								)
								.fromTo(
									customerLoginForm,
									0.5,
									{
										autoAlpha: 0,
										display: 'none',
										y: 20,
									},
									{
										autoAlpha: 1,
										display: 'block',
										y: 0,
										delay: 0.25,
									},
								)
							}
					})
				})
			}, 500);
		const urlParams = new URLSearchParams(window.location.search)
		const handleFormParam = urlParams.get('form') || false

		if (handleFormParam) {
			this.tabContent = this.querySelectorAll('[data-section-type]')

			this.tabContent.forEach((content) => {
				content.classList.toggle('is-active', content.dataset.sectionType === handleFormParam)
			})
		}
    }

    handleButtonClick = (button) => {
      const buttonType = button.dataset.buttonType
      const newURL = `/account/${buttonType}`
	  let valueReturnTo = sessionStorage.getItem('returnTo')
	  const returnToEl = document.querySelector('.js-return-to[data-is-register="true"')

	  if (buttonType === 'register') {
		valueReturnTo = valueReturnTo + `&form=${buttonType}`

		if (returnToEl) {
			returnToEl.value = valueReturnTo || '/'
		}
	  } else {
		if (returnToEl) {
			returnToEl.value = valueReturnTo || '/'
		}
	  }

			if (this.dataset.isSlideout === 'false') {
				history.pushState({ buttonType }, document.title, newURL)
			}

      this.handleActiveElements(buttonType)
    }

    handleActiveElements = (data) => {
      this.handleActiveButton(data)
      this.handleActiveContent(data)
    }

    handleActiveButton = (data) => {
      this.tabButtons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.buttonType === data)
      })
    }

    handleActiveContent = (data) => {
      this.tabContent.forEach((content) => {
        content.classList.toggle('is-active', content.dataset.sectionType === data)
      })
    }
  }

  if (!customElements.get('account-form-tab')) {
    customElements.define('account-form-tab', AccountFormTab)
  }
  if (!window.location.href.includes('footer-newsletter')) {
	document.body.style.scrollBehavior = 'smooth';
  }

	class FullbleedImage extends HTMLElement {
		constructor() {
			super()
			
			this.carouselEl = this.querySelector('[data-flickity-config]')
			this.carouselImage = null
		}

		connectedCallback() {
			new Carousel(this.carouselEl, {})
		}
	}

	if (!customElements.get('fullbleed-image')) {
		customElements.define('fullbleed-image', FullbleedImage)
	}

	class BlogLandingHero extends HTMLElement {
		constructor() {
			super()
			this.carouselEl = this.querySelector('[data-flickity-config]')
		}
		connectedCallback() {
			new Carousel(this.carouselEl, {})
		}
	}
	if (!customElements.get('blog-landing-hero')) {
		customElements.define('blog-landing-hero', BlogLandingHero)
	}

	class FourUp extends HTMLElement {
		constructor() {
			super()
			
			this.carouselEl = this.querySelector('[data-flickity-config]')
			this.carouselImage = null
		}

		handleResize() {
			const cardQuantity = this.querySelectorAll('.four-up__card').length

			const shouldInitCarousel = (cardQuantity === 4 && window.innerWidth < 768) || (cardQuantity < 4 && window.innerWidth < 1024)

			if (shouldInitCarousel) {
				if (!this.carouselInstance) {
					this.carouselInstance = new Carousel(this.carouselEl)
				}
			} else {
				if (this.carouselInstance) {
					this.carouselInstance.destroy()
					this.carouselInstance = null
				}
			}
		}

		connectedCallback() {
			this.handleResize()
			window.addEventListener('resize', this.handleResize.bind(this))
		}
	}

	if (!customElements.get('four-up')) {
		customElements.define('four-up', FourUp)
	}

	class ImagesCarousel extends HTMLElement {
		constructor() {
			super()
			this.carouselEl = this.querySelector('[data-flickity-config]')
			this.carouselInstance = null
			this.scrollDirection = null
			this.startScrollTop = window.scrollY
			this.handleResize = this.handleResize.bind(this)
			this.handleScroll = this.handleScroll.bind(this)
		}

		handleResize() {
			const cardQuantity = this.querySelectorAll('.images-carousel__item')?.length
			const shouldInitCarousel = (cardQuantity > 1 && window.innerWidth <= 768) || (cardQuantity === 3 && window.innerWidth > 768)

			if (shouldInitCarousel) {
				if (!this.carouselInstance) {
					this.carouselInstance = new Carousel(this.carouselEl)
				}
			} else {
				if (this.carouselInstance) {
					this.carouselInstance.destroy()
					this.carouselInstance = null
				}

				this.carouselEl.classList.add('images-carousel__grid')
			}

			if (window.innerWidth < 1024) {
				window.addEventListener('scroll', () => {
					const rect = this.getBoundingClientRect()
					const viewportHeight = window.innerHeight
		
					const visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
					const elementHeight = rect.height;

					if (visibleHeight >= 0.8 * elementHeight) {
						this.handleScroll();
					}
				})
			}
		}

		handleScroll() {
			const currentScrollTop = window.scrollY

			if (currentScrollTop > this.startScrollTop) {
				this.scrollDirection = 'down'
			} else if (currentScrollTop < this.startScrollTop) {
				this.scrollDirection = 'up'
			}

			this.startScrollTop = currentScrollTop

			if (this.carouselInstance) {
				if (this.scrollDirection === 'down') {
					this.carouselInstance.next(true)
				} else if (this.scrollDirection === 'up') {
					this.carouselInstance.previous(true)
				}
			}
		}

		handleMouseEnter() {
			window.addEventListener('scroll', this.handleScroll)
		}

		handleMouseLeave() {
			window.removeEventListener('scroll', this.handleScroll)
		}

		connectedCallback() {
			this.handleResize()
			window.addEventListener('resize', this.handleResize)
			this.addEventListener('mouseenter', this.handleMouseEnter)
			this.addEventListener('mouseleave', this.handleMouseLeave)
		}

		disconnectedCallback() {
			window.removeEventListener('resize', this.handleResize)
			window.removeEventListener('scroll', this.handleScroll)
			this.removeEventListener('mouseenter', this.handleMouseEnter)
			this.removeEventListener('mouseleave', this.handleMouseLeave)
		}
	}

	if (!customElements.get('images-carousel')) {
		customElements.define('images-carousel', ImagesCarousel)
	}

	class Main404 extends HTMLElement {
		constructor() {
			super()
			this.carouselEl = this.querySelector('[data-flickity-config]')
			this.carouselInstance = null

			this.initCarousel()
		}

		connectedCallback() {
			window.addEventListener('resize', () => {
				this.initCarousel()
			})
		}

		initCarousel () {
			if (window.innerWidth < 1024) {
				this.carouselInstance = new Carousel(this.carouselEl, {})
			} else {
				if (this.carouselInstance) {
					this.carouselInstance.destroy()
					this.carouselInstance = null
				}
			}
		}
	}

	if (!customElements.get('main-404')) {
		customElements.define('main-404', Main404)
	}
	
	class AccountPage extends HTMLElement {
		constructor() {
			super()
			this.orderEl = this.querySelector('.js-account-order')
			this.profileEl = this.querySelector('.js-account-profile')
			this.orderHeadingEl = document.querySelector('.js-heading-order')
			this.profileHeadingEl = document.querySelector('.js-heading-profile')
		}

		connectedCallback() {
			this.handleContent()
			this.handleProvince ()

			window.addEventListener('hashchange', this.handleContent.bind(this))
		}

		handleContent() {
			if (!this.orderEl || !this.profileEl || !this.orderHeadingEl || !this.profileHeadingEl) return

			const href = window.location.href
			const isProfileActive = href.includes('/account#profile')
		
			this.profileEl.classList.toggle('active', isProfileActive)
			this.orderEl.classList.toggle('active', !isProfileActive)
			this.profileHeadingEl.classList.toggle('active', isProfileActive)
			this.orderHeadingEl.classList.toggle('active', !isProfileActive)
		}

		handleProvince () {
			this.countrySelectors = []
			
			Dom.nodeListToArray(document.querySelectorAll('.Modal--address')).forEach((modal) => {
				this.countrySelectors.push(
					new CountrySelector(
						modal.querySelector('[name="address[country]"]'),
						modal.querySelector('[name="address[province]"]'),
					)
				)
			})
		}
	}

	if (!customElements.get('account-page')) {
		customElements.define('account-page', AccountPage)
	}

	class AccountSidebar extends HTMLElement {
		constructor() {
			super()
			this.menuItemEls = this.querySelectorAll('.js-account-menu-item')
			this.currentTextEl = this.querySelector('.js-sidebar-current-text')
			this.itemActiveEl = this.querySelector('.js-account-menu-item.active')
			this.buttonToggleSidebarEL = this.querySelector('.js-sidebar-current')
			this.menuSidebarEl = this.querySelector('.js-menu-sidebar')
		}

		connectedCallback() {
			this.handleActiveMenuProfile()

			window.addEventListener('hashchange', this.handleActiveMenuProfile.bind(this))
			this.buttonToggleSidebarEL && this.buttonToggleSidebarEL.addEventListener('click', this.toggleSidebar.bind(this))
			if(window.innerWidth < 1024) {
				document.addEventListener('click', (e) => {
					if (e.target !== this.menuSidebarEl && e.target !== this.buttonToggleSidebarEL && this.menuSidebarEl.clientHeight > 0 ) {
						this.hiddenSideBar()
					}
				})
			}
		}

		handleActiveMenuProfile() {
			const href = window.location.href

			if(href.includes('/account#profile') || href.includes('/account/addresses')) {
				this.menuItemEls && this.menuItemEls.forEach(menuItem => {
					const dataHref = menuItem.getAttribute('href')

					menuItem.classList.remove('active')

					if(dataHref === '/account#profile') {
						menuItem.classList.add('active')
						this.itemActiveEl = menuItem
					}
				})
			} 

			this.setCurrentItem()
		}

		setCurrentItem() {
			if (this.itemActiveEl && this.currentTextEl) {
				this.currentTextEl.innerHTML = this.itemActiveEl.innerHTML
			}
		}

		toggleSidebar() {
			if(this.buttonToggleSidebarEL && this.menuSidebarEl) {
				const isActive = this.buttonToggleSidebarEL.classList.toggle('active')
				this.buttonToggleSidebarEL.setAttribute('aria-expanded', isActive)
				this.menuSidebarEl.style.height = isActive ? `${this.menuSidebarEl.scrollHeight}px` : '0px'
			}
		}

		hiddenSideBar() {
			this.menuSidebarEl.style.height = '0px'
			this.buttonToggleSidebarEL.setAttribute('aria-expanded', 'false')
			this.buttonToggleSidebarEL.classList.remove('active')
		}
	}

	if (!customElements.get('account-sidebar')) {
		customElements.define('account-sidebar', AccountSidebar)
	}

	class AccountOrderCustom extends HTMLElement {
		constructor() {
			super()

			this.buttonLoadMore = this.querySelector('.js-button-order-loadmore')
			this.ordersLoadMore = this.querySelector('.js-orders-load-more')
			this.attackEvent()
		}

		attackEvent() {
			if (!this.buttonLoadMore) return

			this.buttonLoadMore.addEventListener('click', () => {
				const isActive = this.buttonLoadMore.classList.contains('active')
				const maxHeight = this.ordersLoadMore.querySelector('.js-orders-inner').scrollHeight

				if (isActive) {
					this.ordersLoadMore.style.maxHeight = 0
					this.buttonLoadMore.classList.remove('active')
					this.buttonLoadMore.innerText = 'View More'
				} else {
					this.ordersLoadMore.style.maxHeight = `${maxHeight}px`
					this.buttonLoadMore.classList.add('active')
					this.buttonLoadMore.innerText = 'View Less'
				}
			})
		}
	}

	if (!customElements.get('account-order-custom')) {
		customElements.define('account-order-custom', AccountOrderCustom)
	}

	class AccountAddress extends HTMLElement {
		constructor() {
			super()
	
			this.buttonNewAddress = this.querySelector('.js-button-add-address')
			this.emptyAddress = this.querySelector('.js-empty-address')
			this.addressNew = this.querySelector('.js-content-address-new')
			this.cancelAddress = this.querySelector('.js-button-cancel-address')
			this.editButtons = this.querySelectorAll('.js-button-edit-address')
			this.editModals = this.querySelectorAll('.js-content-address-edit')
			this.contentAddress = this.querySelectorAll('.js-content-address-wrap')
			this.cancelAddressEdit = this.querySelectorAll('.js-button-cancel-address-edit')
	
			this.attachEvents()
		}
	
		attachEvents() {
			if (!this.buttonNewAddress || !this.addressNew || !this.cancelAddress || !this.editButtons || !this.editModals || !this.contentAddress || !this.cancelAddressEdit) return
	
			this.buttonNewAddress.addEventListener('click', () => {
				this.addressNew.classList.add('active')
				this.buttonNewAddress.classList.add('hidden')
				this.emptyAddress.classList.add('hidden')
				this.handlePaddingHeading()
			})
	
			this.cancelAddress.addEventListener('click', (event) => {
				event.preventDefault()
				this.addressNew.classList.remove('active')
				this.buttonNewAddress.classList.remove('hidden')
				this.emptyAddress.classList.remove('hidden')
				this.handlePaddingHeading()
			})
	
			this.editButtons.forEach(button => {
				button.addEventListener('click', (event) => {
					const modalId = event.target.getAttribute('aria-controls')
					this.addressNew.classList.remove('active')
					this.openEditModal(modalId)
					this.handlePaddingHeading()
				})
			})
	
			this.cancelAddressEdit.forEach(button => {
				button.addEventListener('click', (event) => {
					this.cancelEditModal(event)
				})
			})
		}
	
		openEditModal(modalId) {
			this.contentAddress.forEach(address => address.classList.remove('hidden'))
			this.editModals.forEach(modal => modal.classList.remove('active'))
			this.buttonNewAddress.classList.add('hidden')
	
			const targetModal = this.querySelector(`#${modalId}`)
			if (targetModal) {
				targetModal.classList.add('active')
				const addressId = modalId.split('-')[1]
				const addressWrap = this.querySelector(`#modal-wrap-${addressId}`)
				if (addressWrap) {
					addressWrap.classList.add('hidden')
				}
			}
		}

		cancelEditModal(event) {
			const modal = event.target.closest('.js-content-address-edit')

			if (modal) {
				modal.classList.remove('active')
				const addressId = modal.id.split('-')[1]
				const addressWrap = this.querySelector(`#modal-wrap-${addressId}`)
				if (addressWrap) {
					addressWrap.classList.remove('hidden')
				}
			}
			this.buttonNewAddress.classList.remove('hidden')
			this.handlePaddingHeading()
		}

		handlePaddingHeading() {
			const accountAddressHeading = this.querySelector('.account-address')

			if (this.querySelector('.js-content-address-new.active') || this.querySelector('.js-content-address-edit.active')) {
				accountAddressHeading?.classList.add('account-address__padding--large')
			} else {
				accountAddressHeading?.classList.remove('account-address__padding--large')
			}
		}
	}
	
	if (!customElements.get('customer-address')) {
		customElements.define('customer-address', AccountAddress)
	}

	class AccountAddressDefault extends HTMLElement {
		constructor() {
			super()

			this.editDefault = this.querySelector('.js-button-address-default')
			this.modalAddressDefault = this.querySelector('.js-modal-address-default')
			this.contentAddressDefault = this.querySelector('.js-content-address-default')
			this.cancelDefault = this.querySelector('.js-button-cancel-address-default')
			this.attachEvents()
		}

		attachEvents() {
			if (!this.editDefault || !this.modalAddressDefault || !this.contentAddressDefault || !this.cancelDefault) return

			this.editDefault.addEventListener('click', () => {
				this.modalAddressDefault.classList.add('active')
				this.contentAddressDefault.classList.add('hidden')
			})

			this.cancelDefault.addEventListener('click', () => {
				this.modalAddressDefault.classList.remove('active')
				this.contentAddressDefault.classList.remove('hidden')
			})
		}
	}

	if (!customElements.get('account-address-default')) {
		customElements.define('account-address-default', AccountAddressDefault)
	}	

	class CartHeaderItem extends HTMLElement {
		constructor() {
			super()
			
			this.element = this.querySelector('.Header__Cart-Item')
			this.bagDot = this.querySelector('.js-bag-dot')
			this.hideMessageTimeout = null
			this.resetMessageTimeout = null
		}

		showEmptyMessage(clickedElement) {
			const headerEl = clickedElement.closest('.Header__Wrapper') ?? clickedElement.closest('.Header') ?? clickedElement.closest('.Header--transparent')

			if (!headerEl) return

			let messageEl = headerEl.querySelector('.Header__Cart-Message')

			if (messageEl) {
				messageEl.style.opacity = 1
				messageEl.style.zIndex = 1
			} else {
				messageEl = document.createElement('div')
				messageEl.classList.add('Header__Cart-Message')
				messageEl.textContent = 'You have no items in the bag'
				headerEl.appendChild(messageEl)
			}
			
			headerEl.classList.add('Header__Cart-Message-Active')

			this.hideMessageTimeout = setTimeout(() => { messageEl.style.opacity = 0 }, 4000)
			this.resetMessageTimeout = setTimeout(() => {
				messageEl.style.zIndex = -1
				headerEl.classList.remove('Header__Cart-Message-Active')
			}, 5000)
		}

		handleClickBag(event) {
			const isEmptyCart = !(this.bagDot.offsetWidth > 0 && this.bagDot.offsetHeight > 0)

			if (isEmptyCart) {
				event.preventDefault()
				event.stopPropagation()

				this.showEmptyMessage(event.target)
			}
		}

		connectedCallback() {
			this.element.addEventListener('click', this.handleClickBag.bind(this))
			window.addEventListener('cart:empty', this.showEmptyMessage.bind(this))
		}
	}

	if (!customElements.get('cart-header-item')) {
		customElements.define('cart-header-item', CartHeaderItem)
	}

	class GiftWrapToggle extends HTMLElement {
		constructor() {
			super()

			this.toggleEl = this.querySelector('.Form__Toggle')
			this.giftLinkEl = this.querySelector('.CartItem__GiftLink')
			this.isChecked = this.toggleEl.checked
			
			this.handleToggleClickBound = this.handleToggleClick.bind(this)
		}

		handleToggleClick(event) {
			if (event.target.checked) {
				this.giftLinkEl.style.display = 'block'
				this.giftLinkEl.click()
			} else {
				this.giftLinkEl.style.display = 'none'

				const dataLineId = this.giftLinkEl.getAttribute('data-line-id')
				const buttonClear = document.querySelector(`.GiftWrap__Link[data-line-id="${dataLineId}"]`)
				buttonClear && buttonClear.click()
			}
		}

		connectedCallback() {
			this.giftLinkEl.style.display = this.isChecked ? 'block' : 'none'
			this.toggleEl.addEventListener('change', this.handleToggleClickBound)
		}

		disconnectedCallback() {
			this.toggleEl.removeEventListener('change', this.handleToggleClickBound)
		}
	}

	if (!customElements.get('gift-wrap-toggle')) {
		customElements.define('gift-wrap-toggle', GiftWrapToggle)
	}

	class QuantityInput extends HTMLElement {
		constructor() {
			super()

			this.cartItem = this.closest('.CartItemWrapper')
			this.wrapperEl = this.querySelector('.Quantity__Wrapper')
			this.minusButton = this.querySelector('.Quantity__Minus')
			this.plusButton = this.querySelector('.Quantity__Plus')
			this.input = this.querySelector('.Quantity__Input')
			this.messageEl = this.querySelector('.Quantity__Message')
			this.maxAvailable = Number(this.input.getAttribute('max'))
		}

		getCart() {
			return fetch(''.concat(window.routes.cartUrl, '.js'), {
				credentials: 'same-origin',
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'XMLHttpRequest',
				},
			}).then(function (response) {
				return response.json()
			})
		}

		updateCart(data, updatedValue) {
			const _this = this

			_this.wrapperEl.classList.add('Quantity__Wrapper--loading')
	
			fetch(''.concat(window.routes.cartUpdateUrl, '.js'), {
				body: JSON.stringify(data),
				credentials: 'same-origin',
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
				},
			}).then(() => {
				document.documentElement.dispatchEvent(
					new CustomEvent('cart:refresh', {
						bubbles: true,
					}),
				)

				_this.input.value = updatedValue
				_this.wrapperEl.classList.remove('Quantity__Wrapper--loading')
			})
		}

		validateQuantity(value) {
			let message = ''

			if (value > this.maxAvailable) {
				if (this.maxAvailable === 1) message = 'We have only 1 item'
				else message = `We have only ${this.maxAvailable} items`

				this.input.value = this.maxAvailable
			} else {
				if (value < 0) {
					message = 'Enter a positive number'
				}
				
				if (value === this.maxAvailable) {
					this.plusButton.classList.add('Quantity__Plus--disabled')
				} else {
					this.plusButton.classList.remove('Quantity__Plus--disabled')
				}
			}

			this.messageEl.innerText = message

			return message ? false : true
		}
 
		async handleInputChange(event) {
			const newValue = Number(event.target.value === '' ? 1 : event.target.value)

			if (this.validateQuantity(newValue)) {
				const cart = await this.getCart()
				const uniqueTimeStamp = this.dataset.timestamp
				let updates = {}
		
				if (cart.items.length > 0) {
					cart.items.forEach((cartItem) => {
						if (
							cartItem.key === this.dataset.itemKey ||
							(cartItem.properties?._uniqueTimeStamp && cartItem.properties._uniqueTimeStamp.toString() === uniqueTimeStamp) ||
							(cartItem.properties?._uniqueItem && cartItem.properties._uniqueItem.toString() === uniqueTimeStamp)
						) {
							updates[cartItem.key] = newValue
						}
					})

					this.updateCart({ updates }, newValue)
				}
			}
		}

		async handleClickButton(type) {
			const curentValue = Number(this.input.value)
	
			const updatedValue = type === 'minus' ? curentValue - 1 : curentValue + 1

			if (this.validateQuantity(updatedValue)) {	
				const cart = await this.getCart()
				const uniqueTimeStamp = this.dataset.timestamp
				let updates = {}

				if (cart.items.length > 0) {
					cart.items.forEach((cartItem) => {
						if (
							cartItem.key === this.dataset.itemKey ||
							(cartItem.properties?._uniqueTimeStamp && cartItem.properties._uniqueTimeStamp.toString() === uniqueTimeStamp) ||
							(cartItem.properties?._uniqueItem && cartItem.properties._uniqueItem.toString() === uniqueTimeStamp)
						) {
							updates[cartItem.key] = updatedValue
						}
					})

					this.updateCart({ updates }, updatedValue)
				}
			}
		}

		connectedCallback() {
			this.minusButton.addEventListener('click', this.handleClickButton.bind(this, 'minus'))
			this.plusButton.addEventListener('click', this.handleClickButton.bind(this, 'plus'))
			this.input.addEventListener('change', this.handleInputChange.bind(this))
		}
	}

	if (!customElements.get('quantity-input')) {
		customElements.define('quantity-input', QuantityInput)
	}

	class CustomFormEnquire extends HTMLElement {
		constructor() {
			super()

			this.form = this.querySelector('form')
			this.validateForm = this.querySelector('custom-validate-form')
		}

		connectedCallback() {
			this.validate = this.validateForm.initValidate(this.form, true)
			this.validate.onSuccess((event) => {
				event.preventDefault()

				this.onSubmitForm()
			})
		}

		async onSubmitForm() {
			var _this = this
			this.formSubmitButton = this.form.querySelector('.Form__Submit')
			this.formSuccess = this.form.querySelector('.js-form--success')
			this.submitCopy = this.formSubmitButton.innerText
			this.formSubmitButton.setAttribute('disabled', 'disabled')
			var eventType = this.formSubmitButton.getAttribute('data-action')

			window.dataLayer = window.dataLayer || []
			window.dataLayer.push({
				event: 'form_submission',
				formType: eventType,
			})

			var formData = {}

			Dom.nodeListToArray(this.form.querySelectorAll('input, textarea')).forEach(function (
				inputElement,
				index,
			) {
				formData[inputElement.getAttribute('aria-label')] = inputElement.value
			})

			if (eventType == 'enquire') {
				var _learnq = window._learnq || []

				_learnq.push([
					'identify',
					{
					$email: formData.Email,
					},
				])

				setTimeout(function () {
					_learnq.push(['track', 'Bespoke Enquiry', formData])
				}, 500)
			}

			this.formSuccess.innerText = 'Thank You For Your Submission'
			this.formSuccess.removeAttribute('style')
			this.form.querySelectorAll('input, textarea').forEach(function (
				inputElement,
				index,
			) {
				inputElement.value = ''
			})

			setTimeout(function () {
				_this.formSubmitButton.innerText = _this.submitCopy
				_this.formSubmitButton.removeAttribute('disabled')
				_this.formSuccess.style.display = 'none'
			}, 3000)
		}
	}

	if (!customElements.get('custom-form-enquire')) {
		customElements.define('custom-form-enquire', CustomFormEnquire)
	}

});
/** Set height to fullview port **/
document.addEventListener('DOMContentLoaded', function() {
	if (window.scrollY === 0 && window.innerWidth < 1024) {
		const heroFullViewportEls = document.querySelectorAll('.js-full-viewport-inner')
		const headerBarHeight = document.getElementById('shopify-section-announcement')?.getBoundingClientRect().height.toFixed(2) || 0
		const headerMainHeight = document.getElementById('shopify-section-header').offsetHeight

		if (heroFullViewportEls.length > 0) {
			heroFullViewportEls.forEach((hero) => {
				const heroEl = hero.querySelector('.hero__inner')
				const main404El = hero.querySelector('.main-404')
				const twoUpWrapEl = hero.querySelector('.two-up__wrap')

				if (heroEl) {
					heroEl.style.height = `${window.innerHeight}px`	
				}

				if (main404El) {
					main404El.style.height = `${window.innerHeight}px`	
				}

				if (twoUpWrapEl) {
					twoUpWrapEl.style.height = `${window.innerHeight - headerBarHeight - headerMainHeight}px`
				}
			});
		}
	}

	if (window.scrollY === 0) {
		resizeWiewport()
	}

	window.addEventListener('resize', function() {
		if (window.scrollY === 0) {
			resizeWiewport()
		}
	})

	function resizeWiewport() {
		const heroFullViewportEls = document.querySelectorAll('.js-hero-full-viewport')
		const headerBarHeight = document.getElementById('shopify-section-announcement')?.getBoundingClientRect().height.toFixed(2) || 0
		const headerMainHeight = document.getElementById('shopify-section-header').offsetHeight

		if (heroFullViewportEls.length > 0) {
			heroFullViewportEls.forEach((hero) => {
				const updateHeight = (el) => {
					if (el) {
						if (window.innerWidth <= 768) {
							el.style.height = `${window.innerHeight - headerBarHeight - headerMainHeight}px`
						} else {
							el.style.removeProperty('height')
						}
					}
				}
			
				updateHeight(hero.querySelector('.two-up__wrap'))
				updateHeight(hero.querySelector('.two-up-hero__wrap'))
			})
		}
	}
});

/** Fix cache input selected variant product **/
const productTemplateIgnore = [...GM_STATE.wishlist.productTemplates.ignore, ...GM_STATE.wishlist.productTemplates.redirect]
const productSuffixTemplate = window.theme.templatePage?.replace('product.', '') || 'default'

if (window.theme.pageType === 'product' && !productTemplateIgnore.includes(productSuffixTemplate)) {
	window.addEventListener('pageshow', (event) => {
		if (!event.persisted) {
			const variantItems = Array.from(document.querySelectorAll('.js-product-variant .SizeSwatch__Radio'))
			
			if (variantItems.length > 0 && !event.persisted) {
				const variantsRadioSelected = variantItems.filter((variant) => variant.checked)

				if (variantsRadioSelected.length > 0) {
					variantsRadioSelected.forEach((variant) => {
						variant.checked = false
					})
				}
			}
		}
  })
}

/** Animation Page Loading **/
// @TODO: Refactor
if (window.theme.pageType === 'index') {
	history.scrollRestoration = "manual"

	window.addEventListener('DOMContentLoaded', () => {
		const logoLoadingEl = window.theme.preloaderEnabled
			? document.querySelector('.page-loading')
			: null
		const animationEls = document.querySelectorAll('.js-animation-loading')
		const heroEls = document.querySelectorAll('.js-loading-hero')
		const bodyEl = document.querySelector('body')

		if (window.scrollY > 0) window.scrollTo(0, 0);

		const handleAnimation = () => {
			if (logoLoadingEl) {
				logoLoadingEl.classList.add('animation-fade-out')
			}

			if (animationEls.length > 0) {
				animationEls.forEach((item) => {
					item.classList.add('animation-fade-in')
					item.classList.remove('animation-fade-out')
				})
			}
		}

		setTimeout(() => {
			if (heroEls.length > 0) {
				heroEls.forEach((item) => {
					const videoEl = item.querySelector('.hero__video')
					if (!videoEl) {
						handleAnimation()
					}
				})
			} else {
				handleAnimation()
			}

			document.documentElement.classList.remove('no-scroll', 'scroll-up')
			bodyEl.classList.remove('is-loading')

			if (logoLoadingEl) {
				setTimeout(() => logoLoadingEl.classList.add('hidden'), 1500);
			}
		}, 1000);
	})
}

/*
Inspiration:
1. https://dribbble.com/shots/20496031-Discover-rare-Indian-treasure-NFTs-Landing-Page
*/

const swiper = new Swiper(".js-menu-slideout-image-carousel", {
	slidesPerView: "auto"
})

const swiper1 = new Swiper(".js-menu-slideout-image-carousel-lv2", {
	slidesPerView: "auto"
})

const swiper2 = new Swiper(".js-menu-slideout-tabs-swiper", {
	slidesPerView: 2.6
})

let galleryObserver = null;

const handleGalleryProdgessBar = () => {
	const slider = document.querySelector('.js-product-gallery.Product__Slideshow')
	if (!slider) return

	const slides = slider.querySelectorAll('.Product__SlideItem')
	if (!slides.length) return

	const isIOSDevice = /iP(hone|od|ad)/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
	if (!isIOSDevice) return

	const productGalleryList = document.querySelector('.Product-Gallery__list')
	productGalleryList.style = "scrollbar-width: none"

	if (galleryObserver) {
		slides.forEach(slide => {
			galleryObserver.unobserve(slide)
		})
		galleryObserver.disconnect()
		galleryObserver = null
	}

	const options = {
		root: slider,
		rootMargin: '0 0 0 0',
		threshold: 0.5
	};

	galleryObserver = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				const visibleSlide = entry.target
				const slideIndex = Array.from(slides).indexOf(visibleSlide)

				const scroll = document.querySelector('.Product-Gallery__scroll')
				if (!scroll) return

				if (!slider.classList.contains('hide-scrollbar')) {
					slider.classList.add('hide-scrollbar')
				}
				const length = slides.length
				const width = length <= 1 ? 0 : (100 / length).toFixed(5)
				const minWidthInPx = 50
				const minWidthInPercent = minWidthInPx / window.innerWidth * 100
				const minWidth = width ? Math.max(minWidthInPercent, width) : width
				scroll.style.width = `${minWidth}%`
				const step = (100 - minWidth) / (length - 1)
				scroll.style.left = `${slideIndex * step}%`
			}
		})
	}, options)

	slides.forEach(slide => {
		galleryObserver.observe(slide)
	})
}

const handleStickyHero = () => {
	const initStickyBackground = (element) => {
    const scrollingElement = element.querySelector('.sticky-hero__content')
    const backgroundElement = element.querySelector('.sticky-hero__media')

    const stickyCallback = (entries) => {
			entries.forEach(entry => {
				const intersectionRatio = entry.intersectionRatio / 2
				backgroundElement.style.setProperty('--opacity', String(intersectionRatio.toFixed(2)));
			})
		}

		const observer = new IntersectionObserver(stickyCallback, {
			root: null,
			threshold: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
		})

		observer.observe(scrollingElement)
	}

	const stickyBackgroundElements = document.querySelectorAll('.js-sticky-hero')

	if (stickyBackgroundElements.length) {
		stickyBackgroundElements.forEach((element) => {
			initStickyBackground(element)
		})
	}
}

const handleNavigationGuideAnimation = () => {
	const navigationGuide = document.querySelector('.navigation-guide');
	const trigger = document.querySelector('.navigation-guide__header');

	if (!trigger) return;
	trigger.addEventListener('click', () => {
		if (!navigationGuide.classList.contains('open')) {
			navigationGuide.classList.remove('navigation-guide--hidden-list')
			setTimeout(() => {
				navigationGuide.classList.add('open')
			});
		} else {
			navigationGuide.classList.add('closing')
			setTimeout(() => {
				navigationGuide.classList.remove('open', 'closing')
				navigationGuide.classList.add('navigation-guide--hidden-list')
			}, 600);
		}
	})
}

const handleNavigationGuideLinks = () => {
	const navigationGuide = document.querySelector('.navigation-guide');
	const links = document.querySelectorAll('.navigation-guide__link');
	if (!navigationGuide || !links.length) return;

	links.forEach(link => {
		link.addEventListener('click', () => {
			navigationGuide.classList.add('closing')
			setTimeout(() => {
				navigationGuide.classList.remove('open', 'closing')
				navigationGuide.classList.add('navigation-guide--hidden-list')
			}, 600);
		})
	})
}

const handleNavigationGuideObservers = () => {
	const getStateData = () => {
		const navigationGuide = document.querySelector('.navigation-guide');
		if (!navigationGuide) return [];

		try {
			const stateData = navigationGuide.dataset.state;
			return stateData ? JSON.parse(stateData) : [];
		} catch (error) {
			console.error('Error parsing state data:', error);
			return [];
		}
	};

	const getElementsToObserve = (linksData) => {
		const elements = [];

		linksData.forEach(item => {
			if (item.link) {
				const linkClass = item.link.trim();
				const foundElements = document.querySelectorAll(`.${linkClass}`);

				foundElements.forEach(element => {
					elements.push({
						element,
						linkClass,
						linkLabel: item.link_label || ''
					});
				});
			}
		});

		return elements;
	};

	const handleIntersect = (entries) => {
		let mostVisibleEntry = null;
		let maxRatio = 0;

		entries.forEach(entry => {
			if (entry.isIntersecting && entry.intersectionRatio > maxRatio) {
				maxRatio = entry.intersectionRatio;
				mostVisibleEntry = entry;
			}
		});

		const navigationGuide = document.querySelector('.navigation-guide');
		if (!navigationGuide) return;

		const stateData = navigationGuide.dataset.state;
		const formattedData = stateData ? JSON.parse(stateData) : [];

		if (mostVisibleEntry && maxRatio > 0.1) {
			const { linkLabel } = mostVisibleEntry.target.observerData;
			const links = formattedData.filter(({link_label}) => link_label != linkLabel);
			handleNavigationGuideContent({linkLabel, links});
		} else {
			// Temporary disable element hidding, it doesnt work correctly
			// TODO: Investigate and fix it
			// handleNavigationGuideContent({linkLabel: null});
		}
	};

	const createObserver = () => {
		const options = {
			root: null,
			rootMargin: '0px',
			threshold: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
		};

		return new IntersectionObserver(handleIntersect, options);
	};

	const initNavigationObserver = () => {
		const linksData = getStateData();
		const elementsToObserve = getElementsToObserve(linksData);

		if (elementsToObserve.length === 0) {
			console.warn('No elements found for observation');
			return null;
		}

		const observer = createObserver();

		elementsToObserve.forEach(({ element, linkClass, linkLabel }) => {
			element.observerData = { linkClass, element, linkLabel };
			observer.observe(element);
		});

		return () => {
			observer.disconnect();

			elementsToObserve.forEach(({ element }) => {
				delete element.observerData;
			});
		};
	};

	initNavigationObserver()
}

const hideElement = (element) => {
	if (element.classList.contains('open')) {
		element.click();
	};
	setTimeout(() => {
		element.style.opacity = '0';
	}, 500)
	setTimeout(() => {
		element.classList.add('hidden')
	}, 800)
}

const showElement = (element) => {
	element.classList.remove('hidden');
	setTimeout(() => {
		element.style.opacity = '1';
	})
}

const handleNavigationGuideContent = ({linkLabel, links}) => {
	const navigationGuide = document.querySelector('.navigation-guide');
	if (!navigationGuide) return;

	const currentLabel = navigationGuide.querySelector('.navigation-guide__header span').textContent;

	if (!linkLabel) {
		hideElement(navigationGuide);
	} else {
		showElement(navigationGuide);
	}

	if (!linkLabel) return;

	const button = document.querySelector('.navigation-guide__header');
	if (!button) return;
	button.querySelector('span').textContent = linkLabel;
	
	if (!links.length) return;
	const items = document.querySelectorAll('.navigation-guide__item');
	items.forEach((item, index) => {
		item.querySelector('span').textContent = links[index].link_label;
		item.querySelector('a').dataset.section = links[index].link;
	})
}

const handleNavigationGuide = () => {
	handleNavigationGuideAnimation();
	handleNavigationGuideObservers();
	handleNavigationGuideLinks();
}

const handleAnimationCards = () => {
	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			const container = entry.target;
			const subContainer = container.querySelector('.animated-cards__sub-container');

			if (entry.isIntersecting) {
				if (container.classList.contains('animated-cards__container') && subContainer) {
					applyStylesWithDelay(container, subContainer);
				} else if (container.classList.contains('animated-cards-mobile__pair')) {
					applyStylesWithDelay(container, container);
				};
			}
		});
	}, {
		root: null,
		threshold: [0.8, 1]
	});

	const containers = document.querySelectorAll('.animated-cards__container, .animated-cards-mobile__pair');

	containers.forEach(container => {
		observer.observe(container);
	});
}

const applyStylesWithDelay = (container, subContainer) => {
	if (container.classList.contains('animated')) return;
	
	container.classList.add('animated');
	container.style.setProperty('--track-large', '1fr');
	container.style.setProperty('--translate-large', '10px');

	setTimeout(() => {
		subContainer.style.setProperty('--track-small', '1fr');
	}, 500);
	setTimeout(() => {
		subContainer.style.setProperty('--text-opacity', '1');
	}, 1000)
}

const handlePosClass = () => {
	const urlParams = new URLSearchParams(window.location.search);

	if (urlParams.has("pos")) {
		document.querySelector("body")?.classList.add("pos")
	}
}

const handleBuilderScroll = () => {
	const createScrollDots = () => {
		const selectors = ['.builder', '.builder-gallery__item']
		const elementsArray = selectors.reduce((array, selector) => {
			return array.concat(Array.from(document.querySelectorAll(selector)));
		}, [])

		const scroll = document.querySelector('.builder-scroll')
		if (!scroll) return;
		scroll.innerHTML = ''

    for (let i = 0; i < elementsArray.length; i++) {
			const dot = document.createElement('div')
			dot.classList.add('builder-scroll__line')
			scroll.appendChild(dot)
			dot.addEventListener('click', () => {
				const headerMainHeight = document.getElementById('shopify-section-header').offsetHeight
				const elementTop = elementsArray[i].getBoundingClientRect().top + window.pageYOffset;
				window.scrollTo({
					top: elementTop - headerMainHeight,
					behavior: 'smooth'
				})
			})
    }
	}

	createScrollDots()

	const handleIntersect = (entries) => {
		let mostVisibleEntry = null;
		let maxRatio = 0;

		entries.forEach(entry => {
			if (entry.isIntersecting && entry.intersectionRatio > maxRatio) {
				maxRatio = entry.intersectionRatio;
				mostVisibleEntry = entry;
			}
		});

		if (mostVisibleEntry && maxRatio > 0.75) {
			const scrollDots = document.querySelectorAll('.builder-scroll > div')
			const targetIndex = mostVisibleEntry.target.observerData.index
			scrollDots.forEach((dot, index) => {
				const targetIndex = mostVisibleEntry.target.observerData.index
				dot.classList.toggle("builder-scroll__line--active", index === targetIndex)
			})
		}
	};

	const createObserver = () => {
		const options = {
			root: null,
			rootMargin: '0px',
			threshold: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
		};

		return new IntersectionObserver(handleIntersect, options);
	};

	const initBuilderObserver = () => {
		const selectors = ['.builder', '.builder-gallery__item']

		const observer = createObserver();

		selectors.forEach((selector, index) => {
			const elements = document.querySelectorAll(selector)
			elements.forEach((element, index1) => {
				element.observerData = { index: index + index1 }
				observer.observe(element)
			})
		});

		return () => {
			observer.disconnect();
		};
	};

	initBuilderObserver()
}

const handlePersonalisationQuiz = () => {
  const quizSteps = document.querySelectorAll('.quiz-step')
  const quizButtons = document.querySelectorAll('.quiz-button')
  const backButtons = document.querySelectorAll('.quiz-back-button')
  const progressLines = document.querySelectorAll('.progress-line')

  const handleButtonClick = (button) => {
    const buttonId = button.dataset.buttonId
    const nextStepId = button.dataset.nextStep
    const currentStep = button.closest('.quiz-step')
    const currentStepId = currentStep.dataset.stepId

    if (nextStepId) {
      navigateToStep(nextStepId)

      const targetStep = document.querySelector(`[data-step-id="${nextStepId}"]`)
      if (targetStep) {
        const stepIndex = parseInt(targetStep.dataset.stepIndex)
        updateProgress(stepIndex)
      }
    } else {
      const nextStep = findNextStep(currentStep)
      if (nextStep) {
        navigateToStep(nextStep.dataset.stepId)
        
        const stepIndex = parseInt(nextStep.dataset.stepIndex)
        updateProgress(stepIndex)
      }
    }
  }

  const handleBackButtonClick = (button) => {
    const prevStepId = button.dataset.prevStep
    if (prevStepId) {
      navigateToStep(prevStepId)

      const prevStep = document.querySelector(`[data-step-id="${prevStepId}"]`)
      if (prevStep) {
        const stepIndex = parseInt(prevStep.dataset.stepIndex)
        updateProgress(stepIndex)
      }
    } else {
      const currentStep = button.closest('.quiz-step')
      const prevStep = findPrevStep(currentStep)
      if (prevStep) {
        navigateToStep(prevStep.dataset.stepId)

        const stepIndex = parseInt(prevStep.dataset.stepIndex)
        updateProgress(stepIndex)
      }
    }
  }

  const navigateToStep = stepId => {
    quizSteps.forEach(step => {
      step.classList.remove('block')
      step.classList.add('hidden')
    })

    const targetStep = document.querySelector(`[data-step-id="${stepId}"]`)
    if (targetStep) {
      targetStep.classList.remove('hidden')
      targetStep.classList.add('block')
    }
  }

  const findNextStep = currentStep => {
    const stepsArray = Array.from(quizSteps)
    const currentIndex = stepsArray.indexOf(currentStep)
    if (currentIndex < stepsArray.length - 1) {
      return stepsArray[currentIndex + 1]
    }
    return null
  }

  const findPrevStep = currentStep => {
    const stepsArray = Array.from(quizSteps)
    const currentIndex = stepsArray.indexOf(currentStep)
    if (currentIndex > 0) {
      return stepsArray[currentIndex - 1]
    }
    return null
  }

  const updateProgress = stepIndex => {
    let maxStepIndex = 0
    quizSteps.forEach(step => {
      const index = parseInt(step.dataset.stepIndex)
      if (index > maxStepIndex) {
        maxStepIndex = index
      }
    })

    progressLines.forEach(line => {
      const lineIndex = parseInt(line.dataset.stepIndex)

      if (lineIndex === stepIndex) {
        line.classList.add('progress-line--active')
        line.classList.remove('opacity-40', 'bg-[#707070]', 'w-5')
        line.classList.add('opacity-100', 'bg-black', 'w-[50px]')
      } else {
        line.classList.remove('progress-line--active')
        line.classList.remove('opacity-100', 'bg-black', 'w-[50px]')
        line.classList.add('opacity-40', 'bg-[#707070]', 'w-5')
      }
    })
  }

  const addAnimationClasses = () => {
    quizSteps.forEach(step => {
      step.classList.add('transition-opacity', 'duration-500', 'ease-in-out')
    })
  }

	updateProgress(1)
	quizButtons.forEach(b => b.addEventListener('click', () => handleButtonClick(b)))
  backButtons.forEach(b => b.addEventListener('click', () => handleBackButtonClick(b)))
  addAnimationClasses()
}

const handleHightlightsScrolling = () => {
	const highlightBlocks = document.querySelectorAll('[data-highlight]');
	const stickyWrappers = document.querySelectorAll('.product-highlight__sticky-wrapper');
	const root = document.documentElement;
	let isTicking = false;

	if (!highlightBlocks.length && !stickyWrappers.length) return;

	const getHeaderMidpoint = () => {
		const headerHeightValue = getComputedStyle(root).getPropertyValue('--header-height').trim();
		const headerHeight = parseFloat(headerHeightValue) || 0;

		return {
			headerHeight,
			headerMidpoint: headerHeight / 3,
		};
	};

	const updateStickyWrapperVisibility = () => {
		const { headerHeight, headerMidpoint } = getHeaderMidpoint();

		if (headerHeight <= 0) {
			stickyWrappers.forEach((stickyWrapper) => {
				stickyWrapper.classList.remove('is-hidden-by-header-mid');
			});

			isTicking = false;
			return;
		}

		stickyWrappers.forEach((stickyWrapper) => {
			const { top } = stickyWrapper.getBoundingClientRect();
			const isAtOrAboveHeaderMidpoint = top <= headerMidpoint;

			stickyWrapper.classList.toggle('is-hidden-by-header-mid', isAtOrAboveHeaderMidpoint);
		});

		isTicking = false;
	};

	const scheduleStickyWrapperVisibility = () => {
		if (isTicking) return;

		isTicking = true;
		window.requestAnimationFrame(updateStickyWrapperVisibility);
	};

	if (stickyWrappers.length) {
		updateStickyWrapperVisibility();
		window.addEventListener('scroll', scheduleStickyWrapperVisibility, { passive: true });
		window.addEventListener('load', updateStickyWrapperVisibility, { once: true });
	}

	const isTouchDevice = () => {
		return 'ontouchstart' in window || 
					navigator.maxTouchPoints > 0 || 
					navigator.msMaxTouchPoints > 0;
	};

	if (!highlightBlocks.length || !isTouchDevice()) return;

	document.addEventListener('touchstart', (e) => {
		const touchedHighlight = e.target.closest('[data-highlight]');
		if (touchedHighlight) {
			touchedHighlight.classList.add('is-scrolling');
		}
	}, { passive: true });

	document.addEventListener('touchend', () => {
		highlightBlocks.forEach(b => b.classList.remove('is-scrolling'));
	}, { passive: true });

	document.addEventListener('touchcancel', () => {
		highlightBlocks.forEach(b => b.classList.remove('is-scrolling'));
	}, { passive: true });
}

const updateFixedLogoBottomEdge = () => {
	const fixedLogo = document.querySelector('.fixed-logo');
	if (!fixedLogo) {
		return;
	}
	const fixedLogoInner = fixedLogo.querySelector('div');
	if (!fixedLogoInner) {
		return;
	}

	const finishSectionIndex = parseInt(fixedLogoInner.dataset.finishSection, 10) || 0;

	const sectionsWrapper = main.querySelector('[class^="PageType_"]');
	if (!sectionsWrapper) {
		return;
	}

	const sections = Array.from(sectionsWrapper.children);
	const finishSection = sections[finishSectionIndex - 1];
	if (!finishSection) {
		return;
	}

	const bottomEdge = finishSection.offsetTop + finishSection.offsetHeight;
	fixedLogo.style.height = `${bottomEdge}px`
}

const handleFixedLogo = () => {
	const fixedLogo = document.querySelector('.fixed-logo');
	if (!fixedLogo) {
		return;
	}
	const fixedLogoInner = fixedLogo.querySelector('div');
	if (!fixedLogoInner) {
		return;
	}

	updateFixedLogoBottomEdge();
	// bad hack to update bottom edge while content is loading
	for (let i = 1; i <= 20; i++) {
		setTimeout(() => updateFixedLogoBottomEdge(), i * 1000)
	}

	const mainLogos = document.querySelectorAll('.Header__Logo');
	if (!mainLogos.length) return;

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				mainLogos.forEach(logo => {
					logo.classList.add('opacity-0', 'transition-opacity', 'duration-300');
					logo.classList.remove('opacity-100');
				});
			} else {
				mainLogos.forEach(logo => {
					logo.classList.add('opacity-100')
					logo.classList.remove('opacity-0')
				});
			}
		});
	}, {
    rootMargin: '-55px 0px 0px 0px'
	});

	observer.observe(fixedLogoInner);
};

const handleShopTheCollection = () => {
	const targets = document.querySelectorAll('.shop-the-collection__text');
	if (!targets.length) {
		return;
	}

	targets.forEach((target) => {
		const detector = document.createElement('div');
		detector.classList.add('shop-the-collection__detector');
		detector.setAttribute('aria-hidden', 'true');
		target.parentNode.insertBefore(detector, target);

		const observer = new IntersectionObserver(
			([entry]) => {
				const isMobile = window.matchMedia('screen and (max-width: 767px)').matches;
				const top = entry.boundingClientRect.top;
				if (!isMobile && top < 0) {
					target.classList.add('shop-the-collection__text--at-top');
					const firstListEl = target.querySelector('ul li');
					firstListEl?.scrollIntoView({ block: 'nearest', inline: 'center' });
				} else {
					target.classList.remove('shop-the-collection__text--at-top');
				}
			},
			{
				root: null,
				threshold: [0, 0.1, .25, .5, .75, 0.9, 1],
			}
		);
		observer.observe(detector);
	});
}

document.addEventListener('DOMContentLoaded', () => {
	handleStickyHero()
	handleNavigationGuide()
	handleAnimationCards()
	handleGalleryProdgessBar()
	handlePosClass()
	handleBuilderScroll()
	handlePersonalisationQuiz()
	handleHightlightsScrolling()
	handleFixedLogo()
	handleShopTheCollection()
});
